import { observable, action } from "mobx";

function remove_tree_node(object,id){
    object.children = object.children.filter(item =>item._id!=id);
    object.children.forEach(item=>remove_tree_node(item,id));
    return object;
  
  }
function getnotelistitemcopy(copyname){
  return[
    {name:copyname+"摘抄一",id:1},
    {name:copyname+"摘抄二",id:2},
    {name:copyname+"摘抄三",id:3},
    {name:copyname+"摘抄四",id:4},
    {name:copyname+"摘抄五",id:5},
    {name:copyname+"摘抄六",id:6},
    {name:copyname+"摘抄七",id:7},
    {name:copyname+"摘抄八",id:8},
    {name:copyname+"摘抄九",id:9},
    {name:copyname+"摘抄十",id:10},

        ];
 }

 function getnotelistitemfollow(copyname){
  return[
    {name:copyname+"仿写一",id:1},
    {name:copyname+"仿写二",id:2},
    {name:copyname+"仿写三",id:3},
    {name:copyname+"仿写四",id:4},
    {name:copyname+"仿写五",id:5},
    {name:copyname+"仿写六",id:6},
    {name:copyname+"仿写七",id:7},
    {name:copyname+"仿写八",id:8},
    {name:copyname+"仿写九",id:9},
    {name:copyname+"仿写十",id:10},

        ];
 }

 function getnotelistitemwrite(copyname){
  return[
    {name:copyname+"练习一",id:1},
    {name:copyname+"练习二",id:2},
    {name:copyname+"练习三",id:3},
    {name:copyname+"练习四",id:4},
    {name:copyname+"练习五",id:5},
    {name:copyname+"练习六",id:6},
    {name:copyname+"练习七",id:7},
    {name:copyname+"练习八",id:8},
    {name:copyname+"练习九",id:9},
    {name:copyname+"练习十",id:10},

        ];
 }

function  getnodelist(_nodePath){

    let notemessage=[
                     
    ];
    switch(_nodePath[0]){
        case 0 :

              switch(_nodePath[1]){
              //人物[0,1]
              case 1 :

                
                switch(_nodePath[2]){
                    //[0,1,0]人物夙愿
                      case 0 :
                        notemessage.notelist= [
                          {name:"平民逃生",id:1},
                          {name:"王子复仇",id:2},
                          {name:"救援亲人",id:3},
                          {name:"攀上高枝",id:4},
                          {name:"追求挚爱",id:5},
                          {name:"自定愿望",id:6},
                      ];
                      break;

                      //[0,1,1]格格不入
                      case 1 :
                        notemessage.notelist= [
                          {name:"在逃公主",id:1},
                          {name:"刘姥姥进园",id:2},
                          {name:"穿越过去",id:3},
                          {name:"外星之旅",id:4},
                          {name:"书呆子劫难",id:5},
                          {name:"傻瓜中举",id:6},
                          {name:"女儿国奇遇",id:7},
                          {name:"自定际遇",id:8},
                      ];
                      break;

                       //[0,1,2]敌对关系
                       case 2 :
                        notemessage.notelist= [
                          {name:"继女庶女",id:1},
                          {name:"副总之争",id:2},
                          {name:"杀父之仇",id:3},
                          {name:"误会越深",id:4},
                          {name:"欠债还钱",id:5},
                          {name:"情敌争锋",id:6},
                          {name:"刺客受命",id:7},
                          {name:"保镖劫难",id:8},
                          {name:"自定冤仇",id:9},
                      ];
                      break;


                       //[0,1,3]爱而不得
                       case 3 :
                        notemessage.notelist= [
                          {name:"家族不合",id:1},
                          {name:"战争之隔",id:2},
                          {name:"病痛分离",id:3},
                          {name:"权力斗争",id:4},
                          {name:"已有家室",id:5},
                          {name:"门户不当",id:6},
                          {name:"一方有隐",id:7},
                          {name:"使命背离",id:8},
                          {name:"自定障碍",id:9},
                      ];
                      break;











                                    }
              break;
              //情节[0,2]
              case 2 :
                switch(_nodePath[2]){

                         //[0,2,0]忽起变化
                      case 0 :
                        notemessage.notelist= [
                          {name:"破产风波",id:1},
                          {name:"不速之客",id:2},
                          {name:"风暴来袭",id:3},
                          {name:"撞破秘密",id:4},
                          {name:"超能力者",id:5},
                          {name:"LGBT",id:6},
                          {name:"自定变化",id:7},
                      ];
                      break;

                        //[0,2,1]寻宝故事
                      case 1 :
                        notemessage.notelist= [
                          {name:"拯救公主",id:1},
                          {name:"寻不死药",id:2},
                          {name:"盗墓笔记",id:3},
                          {name:"西天取经",id:4},
                          {name:"找寻自己",id:5},
                          {name:"自定宝藏",id:7},
                      ];
                      break;

                    //[0,2,2]未解之谜
                      case 2 :
                        notemessage.notelist= [
                          {name:"寻找凶手",id:1},
                          {name:"谁是卧底",id:2},
                          {name:"旧事惨案",id:3},
                          {name:"遗书谜团",id:4},
                          {name:"宝藏真假",id:5},
                          {name:"神秘仪式",id:6},
                          {name:"自定谜团",id:7},
                      ];
                      break;

                      //[0,2,3]如愿以偿
                      case 3 :
                        notemessage.notelist= [
                          {name:"一夜暴富",id:1},
                          {name:"忽然成名",id:2},
                          {name:"旧爱回头",id:3},
                          {name:"人生重来",id:4},
                          {name:"如愿登顶",id:5},
                          {name:"武功秘籍",id:6},
                          {name:"自定愿望",id:7},
                      ];
                      break;


                      //[0,2,4]天降横祸
                      case 4 :
                        notemessage.notelist= [
                          {name:"被人陷害",id:1},
                          {name:"替罪羔羊",id:2},
                          {name:"重病缠身",id:3},
                          {name:"病娇情人",id:4},
                          {name:"科学实验",id:5},
                          {name:"成为猎物",id:6},
                          {name:"自定灾祸",id:7},
                      ];
                      break;

                }
              break;

              //环境[0,3]
              case 3 :
                switch(_nodePath[2]){
                        
                         //[0,3,0]临近崩塌
                      case 0 :
                        notemessage.notelist= [
                          {name:"将破之城",id:1},
                          {name:"孤岛破屋",id:2},
                          {name:"血脉独苗",id:3},
                          {name:"争斗王室",id:4},
                          {name:"危机公司",id:5},
                          {name:"家庭出轨",id:6},
                          {name:"自定危机",id:7},
                      ];
                      break;

                
                        //[0,3,1]入侵破坏
                        case 1 :
                                notemessage.notelist= [
                                  {name:"刺杀帝王",id:1},
                                  {name:"挑逗旧爱",id:2},
                                  {name:"抢劫银行",id:3},
                                  {name:"夺取高位",id:4},
                                  {name:"英雄救美",id:5},
                                  {name:"自定破坏",id:6},
                             
                              ];
                              break;

                         //[0,3,2]屋中怪物
                         case 2 :
                                notemessage.notelist= [
                                  {name:"大白鲨鱼",id:1},
                                  {name:"鬼魂索命",id:2},
                                  {name:"残忍君主",id:3},
                                  {name:"无名凶手",id:4},
                                  {name:"外星坏蛋",id:5},
                                  {name:"自定怪物",id:6},
                             
                              ];
                              break;

                         //[0,3,3]竞技赛场
                         case 3 :
                                notemessage.notelist= [
                                  {name:"比赛舞台",id:1},
                                  {name:"权谋王室",id:2},
                                  {name:"孤岛生存",id:3},
                                  {name:"比武招亲",id:4},
                                  {name:"独裁王国",id:5},
                                  {name:"自定赛场",id:6},
                                  
                             
                              ];
                              break;

                        //[0,3,4]异国他乡
                        case 4 :
                                notemessage.notelist= [
                                  {name:"沙漠村落",id:1},
                                  {name:"地底洞穴",id:2},
                                  {name:"闺房之训",id:3},
                                  {name:"战场求生",id:4},
                                  {name:"种族歧视",id:5},
                                  {name:"自定他乡",id:6},
                                  
                             
                              ];
                              break;

                         //[0,3,5]乌合之众
                         case 5 :
                                notemessage.notelist= [
                                  {name:"狂热宗教",id:1},
                                  {name:"封建迷信",id:2},
                                  {name:"迷幻奇药",id:3},
                                  {name:"灾难预言",id:4},
                                  {name:"黑帮成员",id:5},
                                  {name:"自定众人",id:6},
                                  
                             
                              ];
                              break;

                }
              break;


              //[0,4]三题作文
              case 4 :
                notemessage.notelist= [
                    {name:"狡猾，泳装，鲁迅全集",id:1},
                    {name:"无尽的，秦淮河，下雪",id:2},
                    {name:"坏掉的，漂浮，打报告",id:3},
                    {name:"传纸条，狐狸，流浪",id:4},
                    {name:"老鼠，退位，月光",id:5},
                    {name:"魔法师，一战，蓝色的",id:6},
                    {name:"桔梗，未成年，破破烂烂",id:7},
                    {name:"晕车，海盗，花语",id:8},
                    {name:"大钟，亡灵，亲吻",id:9},
                    {name:"文艺青年，麦田，比目鱼",id:10},
                ];

                
            /*  this.props.store.current_note_list = [
                  {name:"狡猾，泳装，鲁迅全集",id:1},
                  {name:"2222",id:2}
              ];*/
              break;
              //[0,5]轻小说开头
              case 5 :
                notemessage.notelist= [
                    {name:"同班同学的吸血鬼之旅",id:1},
                    {name:"说谎的委员长变成我的专属女仆",id:2},
                    {name:"其中一个弟弟是侵略者？！",id:3},
                    {name:"我的奶奶来自异世界",id:4},
                    {name:"只有神知道的王子的消失",id:5},
                    {name:"左眼的勇者大人爱被吐槽",id:6},
                    {name:"传说中的社长出任务",id:7},
                    {name:"蔷薇的偶像杀人事件",id:8},
                    {name:"中年总统的忧郁",id:9},
                    {name:"坏掉的儿子读了彼得拉克的管理学",id:10},
                ];
              break;
                 //[0,6]戏剧化开头
              case 6 :
                notemessage.notelist= [
                    {name:"死后的朋友",id:1},
                    {name:"善良的超级反派",id:2},
                    {name:"纹身帮派斗争",id:3},
                    {name:"怪异排名",id:4},
                    {name:"超自然监护人",id:5},
                    {name:"时间旅行者",id:6},
                    {name:"被召唤的恶魔",id:7},
                    {name:"爱人或犯人",id:8},
                    {name:"不死女王",id:9},
                    {name:"你的母语",id:10},
                    {name:"另一物种",id:11},
                ];
              break;

              default:
                notemessage.notelist = [
                     
                  ];
                  break;
              }
        break;

        //[1]文笔篇
        case 1:

                switch(_nodePath[1]){
                //[1,0]场景描写
                case 0 :
                        switch(_nodePath[2]){
                        //[1,0,1]场景摘抄
                        case 1 :
                                notemessage.notelist= [
                                {name:"场景摘抄一",id:1},
                                {name:"场景摘抄二",id:2},
                                {name:"场景摘抄三",id:3},
                                {name:"场景摘抄四",id:4},
                                {name:"场景摘抄五",id:5},
                                {name:"场景摘抄六",id:6},
                                {name:"场景摘抄七",id:7},
                                {name:"场景摘抄八",id:8},
                                {name:"场景摘抄九",id:9},
                                {name:"场景摘抄十",id:10},
                        
                                    ];
                        break;

                        //[1,0,2]场景仿写
                        case 2 :
                                notemessage.notelist= [
                                {name:"场景仿写一",id:1},
                                {name:"场景仿写二",id:2},
                                {name:"场景仿写三",id:3},
                                {name:"场景仿写四",id:4},
                                {name:"场景仿写五",id:5},
                                {name:"场景仿写六",id:6},
                                {name:"场景仿写七",id:7},
                                {name:"场景仿写八",id:8},
                                {name:"场景仿写九",id:9},
                                {name:"场景仿写十",id:10},
                        
                                    ];
                        break;

                         //[1,0,3]场景练习
                         case 3 :
                                notemessage.notelist= [
                                {name:"场景练习一",id:1},
                                {name:"场景练习二",id:2},
                                {name:"场景练习三",id:3},
                                {name:"场景练习四",id:4},
                                {name:"场景练习五",id:5},
                                {name:"场景练习六",id:6},
                                {name:"场景练习七",id:7},
                                {name:"场景练习八",id:8},
                                {name:"场景练习九",id:9},
                                {name:"场景练习十",id:10},
                        
                                    ];
                        break;

                        //[1,0,4]要素判断
                        case 4 :
                                notemessage.notelist= [
                                {name:"幻世青衣抄",id:1},
                                {name:"天之落英",id:2},
                                {name:"全世界的妹我只控一个",id:3},
                                {name:"螭龙传",id:4},
                                {name:"女大学生的校园日常",id:5},
                                {name:"桃花债",id:6},
                                {name:"三生三世十里桃花",id:7},
                                {name:"香蜜沉沉烬如霜",id:8},
                                {name:"禁代夏微寒",id:9},
                        
                                    ];
                        break;

                         //[1,0,5]要素增减
                         case 5 :
                                notemessage.notelist= [
                                {name:"要素增减一",id:1},
                                {name:"要素增减二",id:2},
                                {name:"要素增减三",id:3},
                                {name:"要素增减四",id:4},
                                {name:"要素增减五",id:5},
                                {name:"要素增减六",id:6},
                                {name:"要素增减七",id:7},
                                {name:"要素增减八",id:8},
                                {name:"要素增减九",id:9},
                                {name:"要素增减十",id:10},
                        
                                    ];
                        break;


                        //[1,0,6]顺序判断
                        case 6 :
                                notemessage.notelist= [
                                {name:"螭龙传顺序",id:1},
                                {name:"变成女孩的我不可能这么可爱顺序",id:2},
                                {name:"天之落英顺序",id:3},
                                {name:"时间旅人顺序",id:4},
                                {name:"天之落英2顺序",id:5},
                                {name:"天之落英3顺序",id:6},
                                {name:"禁代心医师顺序",id:7},
                                {name:"禁代夏微寒顺序",id:8},
                                {name:"幻世青衣抄顺序",id:9},
                                {name:"祝死顺序",id:10},
                        
                                    ];
                        break;

                         //[1,0,7]更改顺序
                         case 7 :
                                notemessage.notelist= [
                                {name:"更改顺序一",id:1},
                                {name:"更改顺序二",id:2},
                                {name:"更改顺序三",id:3},
                                {name:"更改顺序四",id:4},
                                {name:"更改顺序五",id:5},
                                {name:"更改顺序六",id:6},
                                {name:"更改顺序七",id:7},
                                {name:"更改顺序八",id:8},
                                {name:"更改顺序九",id:9},
                                {name:"更改顺序十",id:10},
                        
                                    ];
                        break;

                          //[1,0,8]场景切换
                          case 8 :
                                notemessage.notelist= [
                                {name:"场景切换一",id:1},
                                {name:"场景切换二",id:2},
                                {name:"场景切换三",id:3},
                                {name:"场景切换四",id:4},
                                {name:"场景切换五",id:5},
                                {name:"场景切换六",id:6},
                                {name:"场景切换七",id:7},
                                {name:"场景切换八",id:8},
                                {name:"场景切换九",id:9},
                                {name:"场景切换十",id:10},
                        
                                    ];
                        break;



                        
                        }
                break;
                 //[1,1]外貌描写
                case 1 :
                        switch(_nodePath[2]){
                                //[1,1,1]外貌摘抄
                                case 1 :
                                        notemessage.notelist= [
                                        {name:"外貌摘抄一",id:1},
                                        {name:"外貌摘抄二",id:2},
                                        {name:"外貌摘抄三",id:3},
                                        {name:"外貌摘抄四",id:4},
                                        {name:"外貌摘抄五",id:5},
                                        {name:"外貌摘抄六",id:6},
                                        {name:"外貌摘抄七",id:7},
                                        {name:"外貌摘抄八",id:8},
                                        {name:"外貌摘抄九",id:9},
                                        {name:"外貌摘抄十",id:10},
                                
                                            ];
                                break;

                                 //[1,1,2]外貌仿写
                                 case 2 :
                                        notemessage.notelist= [
                                        {name:"外貌仿写一",id:1},
                                        {name:"外貌仿写二",id:2},
                                        {name:"外貌仿写三",id:3},
                                        {name:"外貌仿写四",id:4},
                                        {name:"外貌仿写五",id:5},
                                        {name:"外貌仿写六",id:6},
                                        {name:"外貌仿写七",id:7},
                                        {name:"外貌仿写八",id:8},
                                        {name:"外貌仿写九",id:9},
                                        {name:"外貌仿写十",id:10},
                                
                                            ];
                                break;


                                //[1,1,3]外貌练习
                                case 3 :
                                        notemessage.notelist= [
                                        {name:"外貌练习一",id:1},
                                        {name:"外貌练习二",id:2},
                                        {name:"外貌练习三",id:3},
                                        {name:"外貌练习四",id:4},
                                        {name:"外貌练习五",id:5},
                                        {name:"外貌练习六",id:6},
                                        {name:"外貌练习七",id:7},
                                        {name:"外貌练习八",id:8},
                                        {name:"外貌练习九",id:9},
                                        {name:"外貌练习十",id:10},
                                
                                            ];
                                break;


                                //[1,1,4]要素判断
                                case 4 :
                                        notemessage.notelist= [
                                        {name:"神雕侠侣",id:1},
                                        {name:"倚天屠龙记",id:2},
                                        {name:"红楼梦",id:3},
                                        {name:"羊脂球",id:4},
                                        {name:"边城",id:5},
                                        {name:"一念永恒",id:6},
                                        {name:"玄界之门",id:7},
                                        {name:"禁代夏微寒-外貌",id:8},
                                        {name:"天之落英-外貌",id:9},
                                        {name:"禁代心医师-外貌",id:10},
                                
                                            ];
                                break;


                                 //[1,1,5]要素增减
                                 case 5 :
                                        notemessage.notelist= [
                                        {name:"外貌要素增减一",id:1},
                                        {name:"外貌要素增减二",id:2},
                                        {name:"外貌要素增减三",id:3},
                                        {name:"外貌要素增减四",id:4},
                                        {name:"外貌要素增减五",id:5},
                                        {name:"外貌要素增减六",id:6},
                                        {name:"外貌要素增减七",id:7},
                                        {name:"外貌要素增减八",id:8},
                                        {name:"外貌要素增减九",id:9},
                                        {name:"外貌要素增减十",id:10},
                                
                                            ];
                                break;


                                 //[1,1,6]特征选择
                                 case 6 :
                                        notemessage.notelist= [
                                        {name:"特增选择一",id:1},
                                        {name:"特增选择二",id:2},
                                        {name:"特增选择三",id:3},
                                        {name:"特增选择四",id:4},
                                        {name:"特增选择五",id:5},
                                        {name:"特增选择六",id:6},
                                        {name:"特增选择七",id:7},
                                        {name:"特增选择八",id:8},
                                        {name:"特增选择九",id:9},
                                        {name:"特增选择十",id:10},
                                
                                            ];
                                break;

                                //[1,1,7]特征选择
                                case 7 :
                                        notemessage.notelist= [
                                        {name:"群像练习一",id:1},
                                        {name:"群像练习二",id:2},
                                        {name:"群像练习三",id:3},
                                        {name:"群像练习四",id:4},
                                        {name:"群像练习五",id:5},
                                        {name:"群像练习六",id:6},
                                        {name:"群像练习七",id:7},
                                        {name:"群像练习八",id:8},
                                        {name:"群像练习九",id:9},
                                        {name:"群像练习十",id:10},
                                
                                            ];
                                break;

                                }
                break;
                 //[1,2]服饰描写
                case 2 :
                        switch(_nodePath[2]){
                                //[1,2,1]服饰摘抄
                                case 1 :
                                        notemessage.notelist= [
                                        {name:"服饰摘抄一",id:1},
                                        {name:"服饰摘抄二",id:2},
                                        {name:"服饰摘抄三",id:3},
                                        {name:"服饰摘抄四",id:4},
                                        {name:"服饰摘抄五",id:5},
                                        {name:"服饰摘抄六",id:6},
                                        {name:"服饰摘抄七",id:7},
                                        {name:"服饰摘抄八",id:8},
                                        {name:"服饰摘抄九",id:9},
                                        {name:"服饰摘抄十",id:10},
                                
                                            ];
                                break;

                                  //[1,2,2]服饰仿写
                                  case 2 :
                                        notemessage.notelist= [
                                        {name:"服饰仿写一",id:1},
                                        {name:"服饰仿写二",id:2},
                                        {name:"服饰仿写三",id:3},
                                        {name:"服饰仿写四",id:4},
                                        {name:"服饰仿写五",id:5},
                                        {name:"服饰仿写六",id:6},
                                        {name:"服饰仿写七",id:7},
                                        {name:"服饰仿写八",id:8},
                                        {name:"服饰仿写九",id:9},
                                        {name:"服饰仿写十",id:10},
                                
                                            ];
                                break;

                                 //[1,2,3]服饰练习
                                 case 3 :
                                        notemessage.notelist= [
                                        {name:"服饰练习一",id:1},
                                        {name:"服饰练习二",id:2},
                                        {name:"服饰练习三",id:3},
                                        {name:"服饰练习四",id:4},
                                        {name:"服饰练习五",id:5},
                                        {name:"服饰练习六",id:6},
                                        {name:"服饰练习七",id:7},
                                        {name:"服饰练习八",id:8},
                                        {name:"服饰练习九",id:9},
                                        {name:"服饰练习十",id:10},
                                
                                            ];
                                break;

                                //[1,2,4]配件搭配
                                case 4 :
                                        notemessage.notelist= [
                                        {name:"清纯少女",id:1},
                                        {name:"活力男生",id:2},
                                        {name:"不良少年",id:3},
                                        {name:"霸道御姐",id:4},
                                        {name:"邋遢懒汉",id:5},
                                        {name:"新暴发户",id:6},
                                        {name:"皇家公主",id:7},
                                        {name:"白马王子",id:8},
                                        {name:"临终老人",id:9},
                                        {name:"八岁小孩",id:10},
                                
                                            ];
                                break;

                                //[1,2,5]要素判断
                                case 5 :
                                        notemessage.notelist= [
                                                {name:"服饰要素一",id:1},
                                                {name:"服饰要素二",id:2},
                                                {name:"服饰要素三",id:3},
                                                {name:"服饰要素四",id:4},
                                                {name:"服饰要素五",id:5},
                                                {name:"服饰要素六",id:6},
                                                {name:"服饰要素七",id:7},
                                                {name:"服饰要素八",id:8},
                                                {name:"服饰要素九",id:9},
                                                {name:"服饰要素十",id:10},
                                        
                                                    ];
                                break;

                                //[1,2,6]要素增减
                                case 6 :
                                        notemessage.notelist= [
                                                {name:"服饰增减一",id:1},
                                                {name:"服饰增减二",id:2},
                                                {name:"服饰增减三",id:3},
                                                {name:"服饰增减四",id:4},
                                                {name:"服饰增减五",id:5},
                                                {name:"服饰增减六",id:6},
                                                {name:"服饰增减七",id:7},
                                                {name:"服饰增减八",id:8},
                                                {name:"服饰增减九",id:9},
                                                {name:"服饰增减十",id:10},
                                        
                                                    ];
                                break;


                                //[1,2,7]区别身份
                                case 7 :
                                        notemessage.notelist= [
                                                {name:"学生校服",id:1},
                                                {name:"军队制服",id:2},
                                                {name:"医院制服",id:3},
                                                {name:"警官制服",id:4},
                                                {name:"空乘制服",id:5},
                                                {name:"监狱囚服",id:6},
                                                {name:"运动队服",id:7},
                                                {name:"民族服饰",id:8},
                                                {name:"贵族打扮",id:9},
                                                {name:"自定身份",id:10},
                                        
                                                    ];
                                break;
                                
                                 //[1,2,8]区别场合
                                case 8 :
                                        notemessage.notelist= [
                                                {name:"日常打扮",id:1},
                                                {name:"居家睡衣",id:2},
                                                {name:"重要会见",id:3},
                                                {name:"职业正装",id:4},
                                                {name:"葬礼丧服",id:5},
                                                {name:"华丽礼服",id:6},
                                                {name:"婚礼婚纱",id:7},
                                                {name:"潮流服饰",id:8},
                                                {name:"cosplay",id:9},
                                                {name:"自定场合",id:10},
                                        
                                                    ];
                                break;

                                //[1,2,9]塑造人物
                                case 9 :
                                        notemessage.notelist= [
                                                {name:"洁癖死板",id:1},
                                                {name:"懒散邋遢",id:2},
                                                {name:"性格懦弱",id:3},
                                                {name:"热情如火",id:4},
                                                {name:"内敛自闭",id:5},
                                                {name:"嚣张跋扈",id:6},
                                                {name:"虚伪套路",id:7},
                                                {name:"天真清纯",id:8},
                                                {name:"老谋深算",id:9},
                                                {name:"神经兮兮",id:10},
                                                {name:"自定性格",id:11},
                                        
                                                    ];
                                break;


                                  //[1,2,10]体现风格
                                  case 10 :
                                        notemessage.notelist= [
                                                {name:"现代都市",id:1},
                                                {name:"古风古韵",id:2},
                                                {name:"太空歌剧",id:3},
                                                {name:"魔法世界",id:4},
                                                {name:"童话故事",id:5},
                                                {name:"异域风情",id:6},
                                                {name:"玄幻架空",id:7},
                                                {name:"武侠仙侠",id:8},
                                                {name:"西方奇幻",id:9},
                                                {name:"自定风格",id:10},
                                               
                                        
                                                    ];
                                break;
                        }

                break;

                  //[1,3]战斗描写
                case 3 :

                        switch(_nodePath[2]){
                                //[1,3,1]战斗摘抄
                                case 1 :
                                        notemessage.notelist= [
                                        {name:"战斗摘抄一",id:1},
                                        {name:"战斗摘抄二",id:2},
                                        {name:"战斗摘抄三",id:3},
                                        {name:"战斗摘抄四",id:4},
                                        {name:"战斗摘抄五",id:5},
                                        {name:"战斗摘抄六",id:6},
                                        {name:"战斗摘抄七",id:7},
                                        {name:"战斗摘抄八",id:8},
                                        {name:"战斗摘抄九",id:9},
                                        {name:"战斗摘抄十",id:10},
                                
                                            ];
                                break;

                                 //[1,3,2]战斗仿写
                                case 2 :
                                        notemessage.notelist= [
                                        {name:"战斗仿写一",id:1},
                                        {name:"战斗仿写二",id:2},
                                        {name:"战斗仿写三",id:3},
                                        {name:"战斗仿写四",id:4},
                                        {name:"战斗仿写五",id:5},
                                        {name:"战斗仿写六",id:6},
                                        {name:"战斗仿写七",id:7},
                                        {name:"战斗仿写八",id:8},
                                        {name:"战斗仿写九",id:9},
                                        {name:"战斗仿写十",id:10},
                                
                                            ];
                                break;

                                 //[1,3,3]战斗练习
                                 case 3 :
                                        notemessage.notelist= [
                                        {name:"大获全胜",id:1},
                                        {name:"一败涂地",id:2},
                                        {name:"势均力敌",id:3},
                                        {name:"偷袭成功",id:4},
                                        {name:"且战且退",id:5},
                                        {name:"越战越勇",id:6},
                                        {name:"点到为止",id:7},
                                        {name:"聚众群殴",id:8},
                                        {name:"师徒教学",id:9},
                                        {name:"车轮战斗",id:10},
                                
                                            ];
                                break;

                                //[1,3,4]要素判断
                                case 4 :
                                        notemessage.notelist= [
                                        {name:"战斗要素一",id:1},
                                        {name:"战斗要素二",id:2},
                                        {name:"战斗要素三",id:3},
                                        {name:"战斗要素四",id:4},
                                        {name:"战斗要素五",id:5},
                                        {name:"战斗要素六",id:6},
                                        {name:"战斗要素七",id:7},
                                        {name:"战斗要素八",id:8},
                                        {name:"战斗要素九",id:9},
                                        {name:"战斗要素十",id:10},
                                
                                            ];
                                break;

                                //[1,3,5]要素增减
                                case 5 :
                                        notemessage.notelist= [
                                        {name:"战斗增减一",id:1},
                                        {name:"战斗增减二",id:2},
                                        {name:"战斗增减三",id:3},
                                        {name:"战斗增减四",id:4},
                                        {name:"战斗增减五",id:5},
                                        {name:"战斗增减六",id:6},
                                        {name:"战斗增减七",id:7},
                                        {name:"战斗增减八",id:8},
                                        {name:"战斗增减九",id:9},
                                        {name:"战斗增减十",id:10},
                                
                                            ];
                                break;

                                //[1,3,6]战斗速度
                                case 6 :
                                        notemessage.notelist= [
                                        {name:"战斗速度一",id:1},
                                        {name:"战斗速度二",id:2},
                                        {name:"战斗速度三",id:3},
                                        {name:"战斗速度四",id:4},
                                        {name:"战斗速度五",id:5},
                                        {name:"战斗速度六",id:6},
                                        {name:"战斗速度七",id:7},
                                        {name:"战斗速度八",id:8},
                                        {name:"战斗速度九",id:9},
                                        {name:"战斗速度十",id:10},
                                
                                            ];
                                break;

                                 //[1,3,7]战斗速度
                                 case 7 :
                                        notemessage.notelist= [
                                        {name:"速度更改一",id:1},
                                        {name:"速度更改二",id:2},
                                        {name:"速度更改三",id:3},
                                        {name:"速度更改四",id:4},
                                        {name:"速度更改五",id:5},
                                        {name:"速度更改六",id:6},
                                        {name:"速度更改七",id:7},
                                        {name:"速度更改八",id:8},
                                        {name:"速度更改九",id:9},
                                        {name:"速度更改十",id:10},
                                
                                            ];
                                break;

                                 //[1,3,8]虚实判断
                                 case 8 :
                                        notemessage.notelist= [
                                        {name:"虚实判断一",id:1},
                                        {name:"虚实判断二",id:2},
                                        {name:"虚实判断三",id:3},
                                        {name:"虚实判断四",id:4},
                                        {name:"虚实判断五",id:5},
                                        {name:"虚实判断六",id:6},
                                        {name:"虚实判断七",id:7},
                                        {name:"虚实判断八",id:8},
                                        {name:"虚实判断九",id:9},
                                        {name:"虚实判断十",id:10},
                                
                                            ];
                                break;


                                //[1,3,9]虚实选择
                                case 9 :
                                        notemessage.notelist= [
                                        {name:"虚实选择一",id:1},
                                        {name:"虚实选择二",id:2},
                                        {name:"虚实选择三",id:3},
                                        {name:"虚实选择四",id:4},
                                        {name:"虚实选择五",id:5},
                                        {name:"虚实选择六",id:6},
                                        {name:"虚实选择七",id:7},
                                        {name:"虚实选择八",id:8},
                                        {name:"虚实选择九",id:9},
                                        {name:"虚实选择十",id:10},
                                
                                            ];
                                break;


                                 //[1,3,10]转场判断
                                 case 10 :
                                        notemessage.notelist= [
                                        {name:"转场判断一",id:1},
                                        {name:"转场判断二",id:2},
                                        {name:"转场判断三",id:3},
                                        {name:"转场判断四",id:4},
                                        {name:"转场判断五",id:5},
                                        {name:"转场判断六",id:6},
                                        {name:"转场判断七",id:7},
                                        {name:"转场判断八",id:8},
                                        {name:"转场判断九",id:9},
                                        {name:"转场判断十",id:10},
                                
                                            ];
                                break;

                                //[1,3,11]转场练习
                                case 11 :
                                        notemessage.notelist= [
                                        {name:"转场练习一",id:1},
                                        {name:"转场练习二",id:2},
                                        {name:"转场练习三",id:3},
                                        {name:"转场练习四",id:4},
                                        {name:"转场练习五",id:5},
                                        {name:"转场练习六",id:6},
                                        {name:"转场练习七",id:7},
                                        {name:"转场练习八",id:8},
                                        {name:"转场练习九",id:9},
                                        {name:"转场练习十",id:10},
                                
                                            ];
                                break;


                                }

                break;
                //[1,4]心理描写
                case 4 :
                        switch(_nodePath[2]){
                                //[1,4,1]心理摘抄
                                case 1 :
                                        notemessage.notelist= [
                                        {name:"心理摘抄一",id:1},
                                        {name:"心理摘抄二",id:2},
                                        {name:"心理摘抄三",id:3},
                                        {name:"心理摘抄四",id:4},
                                        {name:"心理摘抄五",id:5},
                                        {name:"心理摘抄六",id:6},
                                        {name:"心理摘抄七",id:7},
                                        {name:"心理摘抄八",id:8},
                                        {name:"心理摘抄九",id:9},
                                        {name:"心理摘抄十",id:10},
                                
                                            ];
                                break;

                                 //[1,4,2]心理仿写
                                case 2 :
                                        notemessage.notelist= [
                                        {name:"心理仿写一",id:1},
                                        {name:"心理仿写二",id:2},
                                        {name:"心理仿写三",id:3},
                                        {name:"心理仿写四",id:4},
                                        {name:"心理仿写五",id:5},
                                        {name:"心理仿写六",id:6},
                                        {name:"心理仿写七",id:7},
                                        {name:"心理仿写八",id:8},
                                        {name:"心理仿写九",id:9},
                                        {name:"心理仿写十",id:10},
                                
                                            ];
                                break;

                                 //[1,4,3]情绪类型
                                 case 3 :
                                        notemessage.notelist= [
                                        {name:"情绪类型一",id:1},
                                        {name:"情绪类型二",id:2},
                                        {name:"情绪类型三",id:3},
                                        {name:"情绪类型四",id:4},
                                        {name:"情绪类型五",id:5},
                                        {name:"情绪类型六",id:6},
                                        {name:"情绪类型七",id:7},
                                        {name:"情绪类型八",id:8},
                                        {name:"情绪类型九",id:9},
                                        {name:"情绪类型十",id:10},
                                
                                            ];
                                break;

                                //[1,4,4]心理练习
                                case 4 :
                                        notemessage.notelist= [
                                        {name:"心理练习一",id:1},
                                        {name:"心理练习二",id:2},
                                        {name:"心理练习三",id:3},
                                        {name:"心理练习四",id:4},
                                        {name:"心理练习五",id:5},
                                        {name:"心理练习六",id:6},
                                        {name:"心理练习七",id:7},
                                        {name:"心理练习八",id:8},
                                        {name:"心理练习九",id:9},
                                        {name:"心理练习十",id:10},
                                
                                            ];
                                break;


                                //[1,4,5]要素判断
                                case 5 :
                                        notemessage.notelist= [
                                        {name:"心理要素一",id:1},
                                        {name:"心理要素二",id:2},
                                        {name:"心理要素三",id:3},
                                        {name:"心理要素四",id:4},
                                        {name:"心理要素五",id:5},
                                        {name:"心理要素六",id:6},
                                        {name:"心理要素七",id:7},
                                        {name:"心理要素八",id:8},
                                        {name:"心理要素九",id:9},
                                        {name:"心理要素十",id:10},
                                
                                            ];
                                break;

                                 //[1,4,6]要素增减
                                 case 6 :
                                    notemessage.notelist= [
                                    {name:"心理增减一",id:1},
                                    {name:"心理增减二",id:2},
                                    {name:"心理增减三",id:3},
                                    {name:"心理增减四",id:4},
                                    {name:"心理增减五",id:5},
                                    {name:"心理增减六",id:6},
                                    {name:"心理增减七",id:7},
                                    {name:"心理增减八",id:8},
                                    {name:"心理增减九",id:9},
                                    {name:"心理增减十",id:10},
                            
                                        ];
                            break;




                                }

                break;

                //[1,5]展示
                case 5 :
                  switch(_nodePath[2]){
                        //[1,5,1]展示判断
                        case 1 :
                                notemessage.notelist= [
                                {name:"展示判断一",id:1},
                                {name:"展示判断二",id:2},
                                {name:"展示判断三",id:3},
                                {name:"展示判断四",id:4},
                                {name:"展示判断五",id:5},
                                {name:"展示判断六",id:6},
                                {name:"展示判断七",id:7},
                                {name:"展示判断八",id:8},
                                {name:"展示判断九",id:9},
                                {name:"展示判断十",id:10},
                        
                                    ];
                        break;

                         //[1,5,2]展示练习
                         case 2 :
                              notemessage.notelist= [
                              {name:"展示练习一",id:1},
                              {name:"展示练习二",id:2},
                              {name:"展示练习三",id:3},
                              {name:"展示练习四",id:4},
                              {name:"展示练习五",id:5},
                              {name:"展示练习六",id:6},
                              {name:"展示练习七",id:7},
                              {name:"展示练习八",id:8},
                              {name:"展示练习九",id:9},
                              {name:"展示练习十",id:10},
                      
                                  ];
                      break;

                       //[1,5,3]展示选择
                       case 3 :
                        notemessage.notelist= [
                        {name:"展示选择一",id:1},
                        {name:"展示选择二",id:2},
                        {name:"展示选择三",id:3},
                        {name:"展示选择四",id:4},
                        {name:"展示选择五",id:5},
                        {name:"展示选择六",id:6},
                        {name:"展示选择七",id:7},
                        {name:"展示选择八",id:8},
                        {name:"展示选择九",id:9},
                        {name:"展示选择十",id:10},
                
                            ];
                         break;
                              }
                break;

                //[1,6]对话
                case 6 :

                  switch(_nodePath[2]){
                        //[1,6,1]偷听工程
                        case 1 :
                                notemessage.notelist= [
                                {name:"偷听工程一",id:1},
                                {name:"偷听工程二",id:2},
                                {name:"偷听工程三",id:3},
                                {name:"偷听工程四",id:4},
                                {name:"偷听工程五",id:5},
                                {name:"偷听工程六",id:6},
                                {name:"偷听工程七",id:7},
                                {name:"偷听工程八",id:8},
                                {name:"偷听工程九",id:9},
                                {name:"偷听工程十",id:10},
                        
                                    ];
                        break;

                        //[1,6,2]对话练习
                        case 2 :
                                notemessage.notelist= [
                                {name:"对话练习一",id:1},
                                {name:"对话练习二",id:2},
                                {name:"对话练习三",id:3},
                                {name:"对话练习四",id:4},
                                {name:"对话练习五",id:5},
                                {name:"对话练习六",id:6},
                                {name:"对话练习七",id:7},
                                {name:"对话练习八",id:8},
                                {name:"对话练习九",id:9},
                                {name:"对话练习十",id:10},
                        
                                    ];
                        break;

                         //[1,6,3]口语练习
                         case 3 :
                              notemessage.notelist= [
                              {name:"口语练习一",id:1},
                              {name:"口语练习二",id:2},
                              {name:"口语练习三",id:3},
                              {name:"口语练习四",id:4},
                              {name:"口语练习五",id:5},
                              {name:"口语练习六",id:6},
                              {name:"口语练习七",id:7},
                              {name:"口语练习八",id:8},
                              {name:"口语练习九",id:9},
                              {name:"口语练习十",id:10},
                      
                                  ];
                      break;


                      //[1,6,4]对话精炼
                      case 4 :
                        notemessage.notelist= [
                        {name:"对话精炼一",id:1},
                        {name:"对话精炼二",id:2},
                        {name:"对话精炼三",id:3},
                        {name:"对话精炼四",id:4},
                        {name:"对话精炼五",id:5},
                        {name:"对话精炼六",id:6},
                        {name:"对话精炼七",id:7},
                        {name:"对话精炼八",id:8},
                        {name:"对话精炼九",id:9},
                        {name:"对话精炼十",id:10},
                
                            ];
                break;

                              }

                break;

                 //[1,7]画面感
                case 7:

                  switch(_nodePath[2]){
                        //[1,7,1]画面练习
                        case 1 :
                                notemessage.notelist= [
                                {name:"画面练习一",id:1},
                                {name:"画面练习二",id:2},
                                {name:"画面练习三",id:3},
                                {name:"画面练习四",id:4},
                                {name:"画面练习五",id:5},
                                {name:"画面练习六",id:6},
                                {name:"画面练习七",id:7},
                                {name:"画面练习八",id:8},
                                {name:"画面练习九",id:9},
                                {name:"画面练习十",id:10},
                        
                                    ];
                        break;

                        //[1,7,2]色彩练习
                        case 2 :
                                notemessage.notelist= [
                                {name:"色彩练习一",id:1},
                                {name:"色彩练习二",id:2},
                                {name:"色彩练习三",id:3},
                                {name:"色彩练习四",id:4},
                                {name:"色彩练习五",id:5},
                                {name:"色彩练习六",id:6},
                                {name:"色彩练习七",id:7},
                                {name:"色彩练习八",id:8},
                                {name:"色彩练习九",id:9},
                                {name:"色彩练习十",id:10},
                        
                                    ];
                        break;

                        //[1,7,3]形状练习
                        case 3 :
                                notemessage.notelist= [
                                {name:"形状练习一",id:1},
                                {name:"形状练习二",id:2},
                                {name:"形状练习三",id:3},
                                {name:"形状练习四",id:4},
                                {name:"形状练习五",id:5},
                                {name:"形状练习六",id:6},
                                {name:"形状练习七",id:7},
                                {name:"形状练习八",id:8},
                                {name:"形状练习九",id:9},
                                {name:"形状练习十",id:10},
                        
                                    ];
                        break;

                        //[1,7,4]光影练习
                        case 4 :
                                notemessage.notelist= [
                                {name:"光影练习一",id:1},
                                {name:"光影练习二",id:2},
                                {name:"光影练习三",id:3},
                                {name:"光影练习四",id:4},
                                {name:"光影练习五",id:5},
                                {name:"光影练习六",id:6},
                                {name:"光影练习七",id:7},
                                {name:"光影练习八",id:8},
                                {name:"光影练习九",id:9},
                                {name:"光影练习十",id:10},
                        
                                    ];
                        break;

                         //[1,7,5]画面选择
                         case 5 :
                              notemessage.notelist= [
                              {name:"画面选择一",id:1},
                              {name:"画面选择二",id:2},
                              {name:"画面选择三",id:3},
                              {name:"画面选择四",id:4},
                              {name:"画面选择五",id:5},
                              {name:"画面选择六",id:6},
                              {name:"画面选择七",id:7},
                              {name:"画面选择八",id:8},
                              {name:"画面选择九",id:9},
                              {name:"画面选择十",id:10},
                      
                                  ];
                      break;

                              }
                break;

                 //[1,8]叙事
                case 8 :

                  switch(_nodePath[2]){
                        //[1,8,1]叙事要素分辨
                        case 1 :
                                notemessage.notelist= [
                                {name:"叙事要素一",id:1},
                                {name:"叙事要素二",id:2},
                                {name:"叙事要素三",id:3},
                                {name:"叙事要素四",id:4},
                                {name:"叙事要素五",id:5},
                                {name:"叙事要素六",id:6},
                                {name:"叙事要素七",id:7},
                                {name:"叙事要素八",id:8},
                                {name:"叙事要素九",id:9},
                                {name:"叙事要素十",id:10},
                        
                                    ];
                        break;

                        //[1,8,2]单纯讲事
                        case 2 :
                                notemessage.notelist= [
                                {name:"单纯讲事一",id:1},
                                {name:"单纯讲事二",id:2},
                                {name:"单纯讲事三",id:3},
                                {name:"单纯讲事四",id:4},
                                {name:"单纯讲事五",id:5},
                                {name:"单纯讲事六",id:6},
                                {name:"单纯讲事七",id:7},
                                {name:"单纯讲事八",id:8},
                                {name:"单纯讲事九",id:9},
                                {name:"单纯讲事十",id:10},
                        
                                    ];
                        break;


                        //[1,8,3]叙事增减
                        case 3 :
                                notemessage.notelist= [
                                {name:"叙事增减一",id:1},
                                {name:"叙事增减二",id:2},
                                {name:"叙事增减三",id:3},
                                {name:"叙事增减四",id:4},
                                {name:"叙事增减五",id:5},
                                {name:"叙事增减六",id:6},
                                {name:"叙事增减七",id:7},
                                {name:"叙事增减八",id:8},
                                {name:"叙事增减九",id:9},
                                {name:"叙事增减十",id:10},
                        
                                    ];
                        break;

                              }
                break;

                //[1,9]节奏
                case 9 :
                              
                  switch(_nodePath[2]){
                    //[1,8,1]叙事要素分辨
                    case 1 :
                            notemessage.notelist= [
                            {name:"音长分析一",id:1},
                            {name:"音长分析二",id:2},
                            {name:"音长分析三",id:3},
                            {name:"音长分析四",id:4},
                            {name:"音长分析五",id:5},
                            {name:"音长分析六",id:6},
                            {name:"音长分析七",id:7},
                            {name:"音长分析八",id:8},
                            {name:"音长分析九",id:9},
                            {name:"音长分析十",id:10},
                    
                                ];
                    break;

                     //[1,8,2]叙事要素分辨
                     case 2 :
                      notemessage.notelist= [
                      {name:"音强分析一",id:1},
                      {name:"音强分析二",id:2},
                      {name:"音强分析三",id:3},
                      {name:"音强分析四",id:4},
                      {name:"音强分析五",id:5},
                      {name:"音强分析六",id:6},
                      {name:"音强分析七",id:7},
                      {name:"音强分析八",id:8},
                      {name:"音强分析九",id:9},
                      {name:"音强分析十",id:10},
              
                          ];
              break;


               //[1,8,3]案例模仿
               case 3 :
                notemessage.notelist= [
                {name:"案例模仿一",id:1},
                {name:"案例模仿二",id:2},
                {name:"案例模仿三",id:3},
                {name:"案例模仿四",id:4},
                {name:"案例模仿五",id:5},
                {name:"案例模仿六",id:6},
                {name:"案例模仿七",id:7},
                {name:"案例模仿八",id:8},
                {name:"案例模仿九",id:9},
                {name:"案例模仿十",id:10},
        
                    ];
        break;

                    }
                break;

                //[1,10]象征
                case 10 :
                  switch(_nodePath[2]){
                    //[1,10,1]象征练习
                    case 1 :
                            notemessage.notelist= [
                            {name:"象征练习一",id:1},
                            {name:"象征练习二",id:2},
                            {name:"象征练习三",id:3},
                            {name:"象征练习四",id:4},
                            {name:"象征练习五",id:5},
                            {name:"象征练习六",id:6},
                            {name:"象征练习七",id:7},
                            {name:"象征练习八",id:8},
                            {name:"象征练习九",id:9},
                            {name:"象征练习十",id:10},
                    
                                ];
                    break;
                              }

                break;

                }
        break;
        //套路篇
        case 2 :
          switch(_nodePath[1]){
            //[2,0]爽文套路
            case 0 :
                      switch(_nodePath[2]){
                      //[2,0,1]显摆
                      case 1:
                            switch(_nodePath[3]){
                              //[2,0,1,1]显摆摘抄
                                case 1 :
                                  notemessage.notelist= [
                                    {name:"显摆摘抄一",id:1},
                                    {name:"显摆摘抄二",id:2},
                                    {name:"显摆摘抄三",id:3},
                                    {name:"显摆摘抄四",id:4},
                                    {name:"显摆摘抄五",id:5},
                                    {name:"显摆摘抄六",id:6},
                                    {name:"显摆摘抄七",id:7},
                                    {name:"显摆摘抄八",id:8},
                                    {name:"显摆摘抄九",id:9},
                                    {name:"显摆摘抄十",id:10},
                            
                                        ];
                                  break;

                                  //[2,0,1,2]显摆仿写
                                case 2 :
                                  notemessage.notelist= [
                                    {name:"显摆仿写一",id:1},
                                    {name:"显摆仿写二",id:2},
                                    {name:"显摆仿写三",id:3},
                                    {name:"显摆仿写四",id:4},
                                    {name:"显摆仿写五",id:5},
                                    {name:"显摆仿写六",id:6},
                                    {name:"显摆仿写七",id:7},
                                    {name:"显摆仿写八",id:8},
                                    {name:"显摆仿写九",id:9},
                                    {name:"显摆仿写十",id:10},
                            
                                        ];
                                  break;

                                   //[2,0,1,3]显摆练习
                                case 3 :
                                  notemessage.notelist= [
                                    {name:"显摆练习一",id:1},
                                    {name:"显摆练习二",id:2},
                                    {name:"显摆练习三",id:3},
                                    {name:"显摆练习四",id:4},
                                    {name:"显摆练习五",id:5},
                                    {name:"显摆练习六",id:6},
                                    {name:"显摆练习七",id:7},
                                    {name:"显摆练习八",id:8},
                                    {name:"显摆练习九",id:9},
                                    {name:"显摆练习十",id:10},
                            
                                        ];
                                  break;

                            }
                      break;

                       //[2,0,2]获得
                       case 2:
                        switch(_nodePath[3]){
                          //[2,0,2,1]获得摘抄
                            case 1 :
                              notemessage.notelist= [
                                {name:"获得摘抄一",id:1},
                                {name:"获得摘抄二",id:2},
                                {name:"获得摘抄三",id:3},
                                {name:"获得摘抄四",id:4},
                                {name:"获得摘抄五",id:5},
                                {name:"获得摘抄六",id:6},
                                {name:"获得摘抄七",id:7},
                                {name:"获得摘抄八",id:8},
                                {name:"获得摘抄九",id:9},
                                {name:"获得摘抄十",id:10},
                        
                                    ];
                              break;

                              //[2,0,2,2]获得仿写
                            case 2 :
                              notemessage.notelist= [
                                {name:"获得仿写一",id:1},
                                {name:"获得仿写二",id:2},
                                {name:"获得仿写三",id:3},
                                {name:"获得仿写四",id:4},
                                {name:"获得仿写五",id:5},
                                {name:"获得仿写六",id:6},
                                {name:"获得仿写七",id:7},
                                {name:"获得仿写八",id:8},
                                {name:"获得仿写九",id:9},
                                {name:"获得仿写十",id:10},
                        
                                    ];
                              break;

                               //[2,0,2,3]获得练习
                            case 3 :
                              notemessage.notelist= [
                                {name:"获得练习一",id:1},
                                {name:"获得练习二",id:2},
                                {name:"获得练习三",id:3},
                                {name:"获得练习四",id:4},
                                {name:"获得练习五",id:5},
                                {name:"获得练习六",id:6},
                                {name:"获得练习七",id:7},
                                {name:"获得练习八",id:8},
                                {name:"获得练习九",id:9},
                                {name:"获得练习十",id:10},
                        
                                    ];
                              break;

                        }
                  break;

                   //[2,0,3]打脸
                   case 3:
                    switch(_nodePath[3]){
                      //[2,0,3,1]打脸摘抄
                        case 1 :
                          notemessage.notelist= [
                            {name:"打脸摘抄一",id:1},
                            {name:"打脸摘抄二",id:2},
                            {name:"打脸摘抄三",id:3},
                            {name:"打脸摘抄四",id:4},
                            {name:"打脸摘抄五",id:5},
                            {name:"打脸摘抄六",id:6},
                            {name:"打脸摘抄七",id:7},
                            {name:"打脸摘抄八",id:8},
                            {name:"打脸摘抄九",id:9},
                            {name:"打脸摘抄十",id:10},
                    
                                ];
                          break;

                          //[2,0,3,2]打脸仿写
                        case 2 :
                          notemessage.notelist= [
                            {name:"打脸仿写一",id:1},
                            {name:"打脸仿写二",id:2},
                            {name:"打脸仿写三",id:3},
                            {name:"打脸仿写四",id:4},
                            {name:"打脸仿写五",id:5},
                            {name:"打脸仿写六",id:6},
                            {name:"打脸仿写七",id:7},
                            {name:"打脸仿写八",id:8},
                            {name:"打脸仿写九",id:9},
                            {name:"打脸仿写十",id:10},
                    
                                ];
                          break;

                           //[2,0,3,3]打脸练习
                        case 3 :
                          notemessage.notelist= [
                            {name:"打脸练习一",id:1},
                            {name:"打脸练习二",id:2},
                            {name:"打脸练习三",id:3},
                            {name:"打脸练习四",id:4},
                            {name:"打脸练习五",id:5},
                            {name:"打脸练习六",id:6},
                            {name:"打脸练习七",id:7},
                            {name:"打脸练习八",id:8},
                            {name:"打脸练习九",id:9},
                            {name:"打脸练习十",id:10},
                    
                                ];
                          break;

                    }
              break;


                                 //[2,0,4]英雄救美
                                 case 4:
                                  switch(_nodePath[3]){
                                    //[2,0,4,1]英雄救美摘抄
                                      case 1 :
                                        notemessage.notelist= [
                                          {name:"英雄救美摘抄一",id:1},
                                          {name:"英雄救美摘抄二",id:2},
                                          {name:"英雄救美摘抄三",id:3},
                                          {name:"英雄救美摘抄四",id:4},
                                          {name:"英雄救美摘抄五",id:5},
                                          {name:"英雄救美摘抄六",id:6},
                                          {name:"英雄救美摘抄七",id:7},
                                          {name:"英雄救美摘抄八",id:8},
                                          {name:"英雄救美摘抄九",id:9},
                                          {name:"英雄救美摘抄十",id:10},
                                  
                                              ];
                                        break;
              
                                        //[2,0,4,2]英雄救美仿写
                                      case 2 :
                                        notemessage.notelist= [
                                          {name:"英雄救美仿写一",id:1},
                                          {name:"英雄救美仿写二",id:2},
                                          {name:"英雄救美仿写三",id:3},
                                          {name:"英雄救美仿写四",id:4},
                                          {name:"英雄救美仿写五",id:5},
                                          {name:"英雄救美仿写六",id:6},
                                          {name:"英雄救美仿写七",id:7},
                                          {name:"英雄救美仿写八",id:8},
                                          {name:"英雄救美仿写九",id:9},
                                          {name:"英雄救美仿写十",id:10},
                                  
                                              ];
                                        break;
              
                                         //[2,0,4,3]英雄救美练习
                                      case 3 :
                                        notemessage.notelist= [
                                          {name:"英雄救美练习一",id:1},
                                          {name:"英雄救美练习二",id:2},
                                          {name:"英雄救美练习三",id:3},
                                          {name:"英雄救美练习四",id:4},
                                          {name:"英雄救美练习五",id:5},
                                          {name:"英雄救美练习六",id:6},
                                          {name:"英雄救美练习七",id:7},
                                          {name:"英雄救美练习八",id:8},
                                          {name:"英雄救美练习九",id:9},
                                          {name:"英雄救美练习十",id:10},
                                  
                                              ];
                                        break;
              
                                  }
                            break;


                            
                                 //[2,0,5]两虎相争
                                 case 5:
                                  switch(_nodePath[3]){
                                    //[2,0,5,1]两虎相争摘抄
                                      case 1 :
                                        notemessage.notelist= getnotelistitemcopy("两虎相争");
                                        break;
              
                                        //[2,0,5,2]两虎相争仿写
                                      case 2 :
                                        notemessage.notelist= getnotelistitemfollow("两虎相争");
                                        break;
              
                                         //[2,0,5,3]两虎相争练习
                                      case 3 :
                                        notemessage.notelist=  getnotelistitemwrite("两虎相争");
                                        break;
              
                                  }
                            break;


                            //[2,0,6]预言
                            case 6:
                              switch(_nodePath[3]){
                                //[2,0,6,1]预言摘抄
                                  case 1 :
                                    notemessage.notelist= getnotelistitemcopy("预言");
                                    break;
          
                                    //[2,0,6,2]预言仿写
                                  case 2 :
                                    notemessage.notelist= getnotelistitemfollow("预言");
                                    break;
          
                                     //[2,0,6,3]预言练习
                                  case 3 :
                                    notemessage.notelist=  getnotelistitemwrite("预言");
                                    break;
          
                              }
                        break;


                        //[2,0,7]密谋
                        case 7:
                          switch(_nodePath[3]){
                            //[2,0,7,1]密谋摘抄
                              case 1 :
                                notemessage.notelist= getnotelistitemcopy("密谋");
                                break;
      
                                //[2,0,7,2]密谋仿写
                              case 2 :
                                notemessage.notelist= getnotelistitemfollow("密谋");
                                break;
      
                                 //[2,0,7,3]密谋练习
                              case 3 :
                                notemessage.notelist=  getnotelistitemwrite("密谋");
                                break;
      
                          }
                    break;

                     //[2,0,8]赌注
                     case 8:
                      switch(_nodePath[3]){
                        //[2,0,8,1]赌注摘抄
                          case 1 :
                            notemessage.notelist= getnotelistitemcopy("赌注");
                            break;
  
                            //[2,0,8,2]赌注仿写
                          case 2 :
                            notemessage.notelist= getnotelistitemfollow("赌注");
                            break;
  
                             //[2,0,8,3]赌注练习
                          case 3 :
                            notemessage.notelist=  getnotelistitemwrite("赌注");
                            break;
  
                      }
                break;


                   //[2,0,9]冤枉
                   case 9:
                    switch(_nodePath[3]){
                      //[2,0,9,1]冤枉摘抄
                        case 1 :
                          notemessage.notelist= getnotelistitemcopy("冤枉");
                          break;

                          //[2,0,9,2]冤枉仿写
                        case 2 :
                          notemessage.notelist= getnotelistitemfollow("冤枉");
                          break;

                           //[2,0,9,3]冤枉练习
                        case 3 :
                          notemessage.notelist=  getnotelistitemwrite("冤枉");
                          break;

                    }
              break;


                //[2,0,10]经典铺垫
                case 10:
                  switch(_nodePath[3]){
                    //[2,0,10,1]经典铺垫摘抄
                      case 1 :
                        notemessage.notelist= getnotelistitemcopy("经典铺垫");
                        break;

                        //[2,0,10,2]经典铺垫仿写
                      case 2 :
                        notemessage.notelist= getnotelistitemfollow("经典铺垫");
                        break;

                         //[2,0,10,3]经典铺垫练习
                      case 3 :
                        notemessage.notelist=  getnotelistitemwrite("经典铺垫");
                        break;

                  }
            break;

                     //[2,0,11]站上舞台
                case 11:
                  switch(_nodePath[3]){
                    //[2,0,11,1]站上舞台摘抄
                      case 1 :
                        notemessage.notelist= getnotelistitemcopy("站上舞台");
                        break;

                        //[2,0,11,2]站上舞台仿写
                      case 2 :
                        notemessage.notelist= getnotelistitemfollow("站上舞台");
                        break;

                         //[2,0,11,3]站上舞台练习
                      case 3 :
                        notemessage.notelist=  getnotelistitemwrite("站上舞台");
                        break;

                  }
            break;


                  //[2,0,12]预先提名
                  case 12:
                    switch(_nodePath[3]){
                      //[2,0,12,1]预先提名摘抄
                        case 1 :
                          notemessage.notelist= getnotelistitemcopy("预先提名");
                          break;
  
                          //[2,0,12,2]预先提名仿写
                        case 2 :
                          notemessage.notelist= getnotelistitemfollow("预先提名");
                          break;
  
                           //[2,0,12,3]预先提名练习
                        case 3 :
                          notemessage.notelist=  getnotelistitemwrite("预先提名");
                          break;
  
                    }
              break;


               //[2,0,13]先败为敬
               case 13:
                switch(_nodePath[3]){
                  //[2,0,13,1]先败为敬摘抄
                    case 1 :
                      notemessage.notelist= getnotelistitemcopy("先败为敬");
                      break;

                      //[2,0,13,2]先败为敬仿写
                    case 2 :
                      notemessage.notelist= getnotelistitemfollow("先败为敬");
                      break;

                       //[2,0,13,3]先败为敬练习
                    case 3 :
                      notemessage.notelist=  getnotelistitemwrite("先败为敬");
                      break;

                }
          break;



            //[2,0,13]倒计时
            case 14:
              switch(_nodePath[3]){
                //[2,0,14,1]倒计时摘抄
                  case 1 :
                    notemessage.notelist= getnotelistitemcopy("倒计时");
                    break;

                    //[2,0,14,2]倒计时仿写
                  case 2 :
                    notemessage.notelist= getnotelistitemfollow("倒计时");
                    break;

                     //[2,0,14,3]倒计时练习
                  case 3 :
                    notemessage.notelist=  getnotelistitemwrite("倒计时");
                    break;

              }
        break;


                        
            //[2,0,15]反常爽文
            case 15:
              switch(_nodePath[3]){
                //[2,0,15,1]反常爽文摘抄
                  case 1 :
                    notemessage.notelist= getnotelistitemcopy("反常爽文");
                    break;

                    //[2,0,15,2]反常爽文仿写
                  case 2 :
                    notemessage.notelist= getnotelistitemfollow("反常爽文");
                    break;

                     //[2,0,15,3]反常爽文练习
                  case 3 :
                    notemessage.notelist=  getnotelistitemwrite("反常爽文");
                    break;

              }
        break;


          //[2,0,16]表态
          case 16:
            switch(_nodePath[3]){
              //[2,0,16,1]表态摘抄
                case 1 :
                  notemessage.notelist= getnotelistitemcopy("表态");
                  break;

                  //[2,0,16,2]表态仿写
                case 2 :
                  notemessage.notelist= getnotelistitemfollow("表态");
                  break;

                   //[2,0,16,3]表态练习
                case 3 :
                  notemessage.notelist=  getnotelistitemwrite("表态");
                  break;

            }
      break;

                  //[2,0,17]征服
          case 17:
            switch(_nodePath[3]){
              //[2,0,17,1]征服摘抄
                case 1 :
                  notemessage.notelist= getnotelistitemcopy("征服");
                  break;

                  //[2,0,17,2]征服仿写
                case 2 :
                  notemessage.notelist= getnotelistitemfollow("征服");
                  break;

                   //[2,0,17,3]征服练习
                case 3 :
                  notemessage.notelist=  getnotelistitemwrite("征服");
                  break;

            }
      break;




                   //[2,0,18]扮猪吃虎
          case 18:
            switch(_nodePath[3]){
              //[2,0,18,1]扮猪吃虎摘抄
                case 1 :
                  notemessage.notelist= getnotelistitemcopy("扮猪吃虎");
                  break;

                  //[2,0,18,2]扮猪吃虎仿写
                case 2 :
                  notemessage.notelist= getnotelistitemfollow("扮猪吃虎");
                  break;

                   //[2,0,18,3]扮猪吃虎练习
                case 3 :
                  notemessage.notelist=  getnotelistitemwrite("扮猪吃虎");
                  break;

            }
      break;

         //[2,0,19]神器认主
         case 19:
          switch(_nodePath[3]){
            //[2,0,19,1]神器认主摘抄
              case 1 :
                notemessage.notelist= getnotelistitemcopy("神器认主");
                break;

                //[2,0,19,2]神器认主仿写
              case 2 :
                notemessage.notelist= getnotelistitemfollow("神器认主");
                break;

                 //[2,0,19,3]神器认主练习
              case 3 :
                notemessage.notelist=  getnotelistitemwrite("神器认主");
                break;

          }
    break;

      //[2,0,20]明星聚光
      case 20:
        switch(_nodePath[3]){
          //[2,0,20,1]明星聚光摘抄
            case 1 :
              notemessage.notelist= getnotelistitemcopy("明星聚光");
              break;

              //[2,0,20,2]明星聚光仿写
            case 2 :
              notemessage.notelist= getnotelistitemfollow("明星聚光");
              break;

               //[2,0,20,3]明星聚光练习
            case 3 :
              notemessage.notelist=  getnotelistitemwrite("明星聚光");
              break;

        }
  break;


                    }
            break;
            //言情套路
            case 1:
              switch(_nodePath[2]){
                //[2,1,1]在意
                case 1:
                      switch(_nodePath[3]){
                        //[2,1,1,1]在意摘抄
                          case 1 :
                            notemessage.notelist=  getnotelistitemcopy("在意");
                            break;

                            //[2,1,1,2]在意仿写
                          case 2 :
                            notemessage.notelist= getnotelistitemfollow("在意");
                            break;

                             //[2,1,1,3]在意练习
                          case 3 :
                            notemessage.notelist= getnotelistitemwrite("在意");
                            break;

                      }
                break;

                //[2,1,2]欣赏
                case 2:
                      switch(_nodePath[3]){
                        //[2,1,2,1]欣赏摘抄
                          case 1 :
                            notemessage.notelist=  getnotelistitemcopy("欣赏");
                            break;

                            //[2,1,2,2]欣赏仿写
                          case 2 :
                            notemessage.notelist= getnotelistitemfollow("欣赏");
                            break;

                             //[2,1,2,3]欣赏练习
                          case 3 :
                            notemessage.notelist= getnotelistitemwrite("欣赏");
                            break;

                      }
                break;


                //[2,1,3]长情
                case 3:
                      switch(_nodePath[3]){
                        //[2,1,3,1]长情摘抄
                          case 1 :
                            notemessage.notelist=  getnotelistitemcopy("长情");
                            break;

                            //[2,1,3,2]长情仿写
                          case 2 :
                            notemessage.notelist= getnotelistitemfollow("长情");
                            break;

                             //[2,1,3,3]长情练习
                          case 3 :
                            notemessage.notelist= getnotelistitemwrite("长情");
                            break;

                      }
                break;


                 //[2,1,4]竞争
                 case 4:
                  switch(_nodePath[3]){
                    //[2,1,4,1]竞争摘抄
                      case 1 :
                        notemessage.notelist=  getnotelistitemcopy("竞争");
                        break;

                        //[2,1,4,2]竞争仿写
                      case 2 :
                        notemessage.notelist= getnotelistitemfollow("竞争");
                        break;

                         //[2,1,4,3]竞争练习
                      case 3 :
                        notemessage.notelist= getnotelistitemwrite("竞争");
                        break;

                  }
            break;


             //[2,1,5]吹嘘
             case 5:
              switch(_nodePath[3]){
                //[2,1,5,1]吹嘘摘抄
                  case 1 :
                    notemessage.notelist=  getnotelistitemcopy("吹嘘");
                    break;

                    //[2,1,5,2]吹嘘仿写
                  case 2 :
                    notemessage.notelist= getnotelistitemfollow("吹嘘");
                    break;

                     //[2,1,5,3]吹嘘练习
                  case 3 :
                    notemessage.notelist= getnotelistitemwrite("吹嘘");
                    break;

              }
        break;


         //[2,1,6]占有欲
         case 6:
          switch(_nodePath[3]){
            //[2,1,6,1]占有欲摘抄
              case 1 :
                notemessage.notelist=  getnotelistitemcopy("占有欲");
                break;

                //[2,1,6,2]占有欲仿写
              case 2 :
                notemessage.notelist= getnotelistitemfollow("占有欲");
                break;

                 //[2,1,6,3]占有欲练习
              case 3 :
                notemessage.notelist= getnotelistitemwrite("占有欲");
                break;

          }
    break;


    //[2,1,7]言情英雄救美
    case 7:
      switch(_nodePath[3]){
        //[2,1,7,1]言情英雄救美摘抄
          case 1 :
            notemessage.notelist=  getnotelistitemcopy("言情英雄救美");
            break;

            //[2,1,7,2]言情英雄救美仿写
          case 2 :
            notemessage.notelist= getnotelistitemfollow("言情英雄救美");
            break;

             //[2,1,7,3]言情英雄救美练习
          case 3 :
            notemessage.notelist= getnotelistitemwrite("言情英雄救美");
            break;

      }
break;


        //[2,1,8]共度危机
    case 8:
      switch(_nodePath[3]){
        //[2,1,8,1]共度危机摘抄
          case 1 :
            notemessage.notelist=  getnotelistitemcopy("共度危机");
            break;

            //[2,1,8,2]共度危机仿写
          case 2 :
            notemessage.notelist= getnotelistitemfollow("共度危机");
            break;

             //[2,1,8,3]共度危机练习
          case 3 :
            notemessage.notelist= getnotelistitemwrite("共度危机");
            break;

      }
break;


        //[2,1,9]禁忌
    case 9:
      switch(_nodePath[3]){
        //[2,1,9,1]禁忌摘抄
          case 1 :
            notemessage.notelist=  getnotelistitemcopy("禁忌");
            break;

            //[2,1,9,2]禁忌仿写
          case 2 :
            notemessage.notelist= getnotelistitemfollow("禁忌");
            break;

             //[2,1,9,3]禁忌练习
          case 3 :
            notemessage.notelist= getnotelistitemwrite("禁忌");
            break;

      }
break;

        //[2,1,10]契约
    case 10:
      switch(_nodePath[3]){
        //[2,1,10,1]契约摘抄
          case 1 :
            notemessage.notelist=  getnotelistitemcopy("契约");
            break;

            //[2,1,10,2]契约仿写
          case 2 :
            notemessage.notelist= getnotelistitemfollow("契约");
            break;

             //[2,1,10,3]契约练习
          case 3 :
            notemessage.notelist= getnotelistitemwrite("契约");
            break;

      }
break;

        //[2,1,11]误会
    case 11:
      switch(_nodePath[3]){
        //[2,1,11,1]误会摘抄
          case 1 :
            notemessage.notelist=  getnotelistitemcopy("误会");
            break;

            //[2,1,11,2]误会仿写
          case 2 :
            notemessage.notelist= getnotelistitemfollow("误会");
            break;

             //[2,1,11,3]误会练习
          case 3 :
            notemessage.notelist= getnotelistitemwrite("误会");
            break;

      }
break;


           //[2,1,12]秘密
    case 12:
      switch(_nodePath[3]){
        //[2,1,12,1]秘密摘抄
          case 1 :
            notemessage.notelist=  getnotelistitemcopy("秘密");
            break;

            //[2,1,12,2]秘密仿写
          case 2 :
            notemessage.notelist= getnotelistitemfollow("秘密");
            break;

             //[2,1,12,3]秘密练习
          case 3 :
            notemessage.notelist= getnotelistitemwrite("秘密");
            break;

      }
break;

            //[2,1,13]黯然神伤
    case 13:
      switch(_nodePath[3]){
        //[2,1,13,1]黯然神伤摘抄
          case 1 :
            notemessage.notelist=  getnotelistitemcopy("黯然神伤");
            break;

            //[2,1,13,2]黯然神伤仿写
          case 2 :
            notemessage.notelist= getnotelistitemfollow("黯然神伤");
            break;

             //[2,1,13,3]黯然神伤练习
          case 3 :
            notemessage.notelist= getnotelistitemwrite("黯然神伤");
            break;

      }
break;


         //[2,1,14]牺牲
    case 14:
      switch(_nodePath[3]){
        //[2,1,14,1]牺牲摘抄
          case 1 :
            notemessage.notelist=  getnotelistitemcopy("牺牲");
            break;

            //[2,1,14,2]牺牲仿写
          case 2 :
            notemessage.notelist= getnotelistitemfollow("牺牲");
            break;

             //[2,1,14,3]牺牲练习
          case 3 :
            notemessage.notelist= getnotelistitemwrite("牺牲");
            break;

      }
break;


             //[2,1,15]神秘
    case 15:
      switch(_nodePath[3]){
        //[2,1,15,1]神秘摘抄
          case 1 :
            notemessage.notelist=  getnotelistitemcopy("神秘");
            break;

            //[2,1,15,2]神秘仿写
          case 2 :
            notemessage.notelist= getnotelistitemfollow("神秘");
            break;

             //[2,1,15,3]神秘练习
          case 3 :
            notemessage.notelist= getnotelistitemwrite("神秘");
            break;

      }
break;

            //[2,1,16]身体接触
    case 16:
      switch(_nodePath[3]){
        //[2,1,16,1]身体接触摘抄
          case 1 :
            notemessage.notelist=  getnotelistitemcopy("身体接触");
            break;

            //[2,1,16,2]身体接触仿写
          case 2 :
            notemessage.notelist= getnotelistitemfollow("身体接触");
            break;

             //[2,1,16,3]身体接触练习
          case 3 :
            notemessage.notelist= getnotelistitemwrite("身体接触");
            break;

      }
break;


                 //[2,1,17]告白
    case 17:
      switch(_nodePath[3]){
        //[2,1,17,1]告白摘抄
          case 1 :
            notemessage.notelist=  getnotelistitemcopy("告白");
            break;

            //[2,1,17,2]告白仿写
          case 2 :
            notemessage.notelist= getnotelistitemfollow("告白");
            break;

             //[2,1,17,3]告白练习
          case 3 :
            notemessage.notelist= getnotelistitemwrite("告白");
            break;

      }
break;


              //[2,1,18]失而复得
    case 18:
      switch(_nodePath[3]){
        //[2,1,18,1]失而复得摘抄
          case 1 :
            notemessage.notelist=  getnotelistitemcopy("失而复得");
            break;

            //[2,1,18,2]失而复得仿写
          case 2 :
            notemessage.notelist= getnotelistitemfollow("失而复得");
            break;

             //[2,1,18,3]失而复得练习
          case 3 :
            notemessage.notelist= getnotelistitemwrite("失而复得");
            break;

      }
break;

           //[2,1,19]意料之外
    case 19:
      switch(_nodePath[3]){
        //[2,1,19,1]意料之外摘抄
          case 1 :
            notemessage.notelist=  getnotelistitemcopy("意料之外");
            break;

            //[2,1,19,2]意料之外仿写
          case 2 :
            notemessage.notelist= getnotelistitemfollow("意料之外");
            break;

             //[2,1,19,3]意料之外练习
          case 3 :
            notemessage.notelist= getnotelistitemwrite("意料之外");
            break;

      }
break;



           //[2,1,20]对你与众不同
    case 20:
      switch(_nodePath[3]){
        //[2,1,20,1]对你与众不同摘抄
          case 1 :
            notemessage.notelist=  getnotelistitemcopy("对你与众不同");
            break;

            //[2,1,20,2]对你与众不同仿写
          case 2 :
            notemessage.notelist= getnotelistitemfollow("对你与众不同");
            break;

             //[2,1,20,3]对你与众不同练习
          case 3 :
            notemessage.notelist= getnotelistitemwrite("对你与众不同");
            break;

      }
break;


















                    }

            break;
            //恐惧
            case 2 :
              switch(_nodePath[2]){
                //[2,2,1]恐惧摘抄
                  case 1 :
                    notemessage.notelist=  getnotelistitemcopy("恐惧");
                    break;
        
                    //[2,2,2]恐惧分析
                  case 2 :
                    notemessage.notelist= [
                      {name:"恐惧分析一",id:1},
                      {name:"恐惧分析二",id:2},
                      {name:"恐惧分析三",id:3},
                      {name:"恐惧分析四",id:4},
                      {name:"恐惧分析五",id:5},
                      {name:"恐惧分析六",id:6},
                      {name:"恐惧分析七",id:7},
                      {name:"恐惧分析八",id:8},
                      {name:"恐惧分析九",id:9},
                      {name:"恐惧分析十",id:10},
              
                          ];
                    break;
        
                     //[2,2,3]恐惧练习
                  case 3 :
                    notemessage.notelist= getnotelistitemwrite("恐惧");
                    break;
        
              }
            break;


              //愤怒
            case 3 :
              switch(_nodePath[2]){
                //[2,3,1]愤怒摘抄
                  case 1 :
                    notemessage.notelist=  getnotelistitemcopy("愤怒");
                    break;
        
                    //[2,3,2]愤怒分析
                  case 2 :
                    notemessage.notelist= [
                      {name:"愤怒分析一",id:1},
                      {name:"愤怒分析二",id:2},
                      {name:"愤怒分析三",id:3},
                      {name:"愤怒分析四",id:4},
                      {name:"愤怒分析五",id:5},
                      {name:"愤怒分析六",id:6},
                      {name:"愤怒分析七",id:7},
                      {name:"愤怒分析八",id:8},
                      {name:"愤怒分析九",id:9},
                      {name:"愤怒分析十",id:10},
              
                          ];
                    break;
        
                     //[2,3,3]愤怒练习
                  case 3 :
                    notemessage.notelist= getnotelistitemwrite("愤怒");
                    break;
        
              }
            break;


            //泪点
            case 4 :
              switch(_nodePath[2]){
                //[2,4,1]泪点摘抄
                  case 1 :
                    notemessage.notelist=  getnotelistitemcopy("泪点");
                    break;
        
                    //[2,4,2]泪点分析
                  case 2 :
                    notemessage.notelist= [
                      {name:"泪点分析一",id:1},
                      {name:"泪点分析二",id:2},
                      {name:"泪点分析三",id:3},
                      {name:"泪点分析四",id:4},
                      {name:"泪点分析五",id:5},
                      {name:"泪点分析六",id:6},
                      {name:"泪点分析七",id:7},
                      {name:"泪点分析八",id:8},
                      {name:"泪点分析九",id:9},
                      {name:"泪点分析十",id:10},
              
                          ];
                    break;
        
                     //[2,4,3]泪点练习
                  case 3 :
                    notemessage.notelist= getnotelistitemwrite("泪点");
                    break;
        
              }
            break;


            //笑点
            case 5 :
              switch(_nodePath[2]){
                //[2,5,1]笑点摘抄
                  case 1 :
                    notemessage.notelist=  getnotelistitemcopy("笑点");
                    break;
        
                    //[2,5,2]笑点分析
                  case 2 :
                    notemessage.notelist= [
                      {name:"笑点分析一",id:1},
                      {name:"笑点分析二",id:2},
                      {name:"笑点分析三",id:3},
                      {name:"笑点分析四",id:4},
                      {name:"笑点分析五",id:5},
                      {name:"笑点分析六",id:6},
                      {name:"笑点分析七",id:7},
                      {name:"笑点分析八",id:8},
                      {name:"笑点分析九",id:9},
                      {name:"笑点分析十",id:10},
              
                          ];
                    break;
        
                     //[2,5,3]笑点练习
                  case 3 :
                    notemessage.notelist= getnotelistitemwrite("笑点");
                    break;
        
              }
            break;



          }




        break;
        //结构篇
        case 3 :

          switch(_nodePath[1]){
            //[3,0]事件
            case 0 :
                    switch(_nodePath[2]){
                    //[3,0,1]事件分析
                    case 1 :
                            notemessage.notelist= [
                            {name:"事件分析一",id:1},
                            {name:"事件分析二",id:2},
                            {name:"事件分析三",id:3},
                            {name:"事件分析四",id:4},
                            {name:"事件分析五",id:5},
                            {name:"事件分析六",id:6},
                            {name:"事件分析七",id:7},
                            {name:"事件分析八",id:8},
                            {name:"事件分析九",id:9},
                            {name:"事件分析十",id:10},
                    
                                ];
                    break;
                    
                    //[3,0,2]事件写作
                    case 2 :
                            notemessage.notelist= [
                            {name:"事件写作一",id:1},
                            {name:"事件写作二",id:2},
                            {name:"事件写作三",id:3},
                            {name:"事件写作四",id:4},
                            {name:"事件写作五",id:5},
                            {name:"事件写作六",id:6},
                            {name:"事件写作七",id:7},
                            {name:"事件写作八",id:8},
                            {name:"事件写作九",id:9},
                            {name:"事件写作十",id:10},
                    
                                ];
                    break;

                    }

        break;
         //[3,1]故事线
         case 1 :
          switch(_nodePath[2]){
          //[3,1,1]故事线归纳
          case 1 :
                  notemessage.notelist= [
                  {name:"故事线归纳一",id:1},
                  {name:"故事线归纳二",id:2},
                  {name:"故事线归纳三",id:3},
                  {name:"故事线归纳四",id:4},
                  {name:"故事线归纳五",id:5},
                  {name:"故事线归纳六",id:6},
                  {name:"故事线归纳七",id:7},
                  {name:"故事线归纳八",id:8},
                  {name:"故事线归纳九",id:9},
                  {name:"故事线归纳十",id:10},
          
                      ];
          break;
          
          //[3,1,2]故事线分析
          case 2 :
                  notemessage.notelist= [
                  {name:"故事线分析一",id:1},
                  {name:"故事线分析二",id:2},
                  {name:"故事线分析三",id:3},
                  {name:"故事线分析四",id:4},
                  {name:"故事线分析五",id:5},
                  {name:"故事线分析六",id:6},
                  {name:"故事线分析七",id:7},
                  {name:"故事线分析八",id:8},
                  {name:"故事线分析九",id:9},
                  {name:"故事线分析十",id:10},
          
                      ];
          break;

          //[3,1,3]故事线写作
          case 3 :
                  notemessage.notelist= [
                  {name:"故事线写作一",id:1},
                  {name:"故事线写作二",id:2},
                  {name:"故事线写作三",id:3},
                  {name:"故事线写作四",id:4},
                  {name:"故事线写作五",id:5},
                  {name:"故事线写作六",id:6},
                  {name:"故事线写作七",id:7},
                  {name:"故事线写作八",id:8},
                  {name:"故事线写作九",id:9},
                  {name:"故事线写作十",id:10},
          
                      ];
          break;

          }
          break;

          //[3,2]人物功能
          case 2:
            switch(_nodePath[2]){
              //[3,2,1]功能收集
              case 1 :
                      notemessage.notelist= [
                      {name:"主角收集",id:1},
                      {name:"辅佐收集",id:2},
                      {name:"小怪收集",id:3},
                      {name:"boss收集",id:4},
                      {name:"双面人收集",id:5},
                      {name:"镜子收集",id:6},
                      {name:"衬托收集",id:7},
                      {name:"系统收集",id:8},

              
                          ];
              break;

               //[3,2,2]功能分析
              case 2 :
                  notemessage.notelist= [
                  {name:"功能分析一",id:1},
                  {name:"功能分析二",id:2},
                  {name:"功能分析三",id:3},
                  {name:"功能分析四",id:4},
                  {name:"功能分析五",id:5},
                  {name:"功能分析六",id:6},
                  {name:"功能分析七",id:7},
                  {name:"功能分析八",id:8},
                
          
                      ];
          break;

            //[3,2,3]人物设定
            case 3 :
              notemessage.notelist= [
              {name:"主角设定",id:1},
              {name:"辅佐设定",id:2},
              {name:"小怪设定",id:3},
              {name:"boss设定",id:4},
              {name:"双面人设定",id:5},
              {name:"镜子设定",id:6},
              {name:"衬托设定",id:7},
              {name:"系统设定",id:8},

      
                  ];
      break;

             

              }
          break;

           //[3,3]代入感
           case 3:
            switch(_nodePath[2]){
              //[3,2,1]人物收集
              case 1 :
                notemessage.notelist= [
                  {name:"人物收集一",id:1},
                  {name:"人物收集二",id:2},
                  {name:"人物收集三",id:3},
                  {name:"人物收集四",id:4},
                  {name:"人物收集五",id:5},
                  {name:"人物收集六",id:6},
                  {name:"人物收集七",id:7},
                  {name:"人物收集八",id:8},
                  {name:"人物收集九",id:9},
                  {name:"人物收集十",id:10},

              
                          ];
              break;

                //[3,2,2]人物分析
                case 2 :
                  notemessage.notelist= [
                    {name:"人物分析一",id:1},
                    {name:"人物分析二",id:2},
                    {name:"人物分析三",id:3},
                    {name:"人物分析四",id:4},
                    {name:"人物分析五",id:5},
                    {name:"人物分析六",id:6},
                    {name:"人物分析七",id:7},
                    {name:"人物分析八",id:8},
                    {name:"人物分析九",id:9},
                    {name:"人物分析十",id:10},
  
                
                            ];
                break;

                 //[3,2,3]人物分析
                 case 3 :
                  notemessage.notelist= [
                    {name:"人物设定一",id:1},
                    {name:"人物设定二",id:2},
                    {name:"人物设定三",id:3},
                    {name:"人物设定四",id:4},
                    {name:"人物设定五",id:5},
                    {name:"人物设定六",id:6},
                    {name:"人物设定七",id:7},
                    {name:"人物设定八",id:8},
                    {name:"人物设定九",id:9},
                    {name:"人物设定十",id:10},
  
                
                            ];
                break;

              }
          break;

          //[3,4]人称与视角
          case 4:
            switch(_nodePath[2]){
              //[3,4,1]视角分析
              case 1 :
                notemessage.notelist= [
                  {name:"视角分析一",id:1},
                  {name:"视角分析二",id:2},
                  {name:"视角分析三",id:3},
                  {name:"视角分析四",id:4},
                  {name:"视角分析五",id:5},
                  {name:"视角分析六",id:6},
                  {name:"视角分析七",id:7},
                  {name:"视角分析八",id:8},
                  {name:"视角分析九",id:9},
                  {name:"视角分析十",id:10},

              
                          ];
              break;

               //[3,4,2]人物收集
               case 2 :
                notemessage.notelist= [
                  {name:"视角更改一",id:1},
                  {name:"视角更改二",id:2},
                  {name:"视角更改三",id:3},
                  {name:"视角更改四",id:4},
                  {name:"视角更改五",id:5},
                  {name:"视角更改六",id:6},
                  {name:"视角更改七",id:7},
                  {name:"视角更改八",id:8},
                  {name:"视角更改九",id:9},
                  {name:"视角更改十",id:10},

              
                          ];
              break;

              }
              break;

                //[3,5]对话
          case 5:
            switch(_nodePath[2]){
              //[3,4,1]作用分析
              case 1 :
                notemessage.notelist= [
                  {name:"作用分析一",id:1},
                  {name:"作用分析二",id:2},
                  {name:"作用分析三",id:3},
                  {name:"作用分析四",id:4},
                  {name:"作用分析五",id:5},
                  {name:"作用分析六",id:6},
                  {name:"作用分析七",id:7},
                  {name:"作用分析八",id:8},
                  {name:"作用分析九",id:9},
                  {name:"作用分析十",id:10},

              
                          ];
              break;

               //[3,5,2]潜台词
               case 2 :
                notemessage.notelist= [
                  {name:"增加潜台词一",id:1},
                  {name:"增加潜台词二",id:2},
                  {name:"增加潜台词三",id:3},
                  {name:"增加潜台词四",id:4},
                  {name:"增加潜台词五",id:5},
                  {name:"增加潜台词六",id:6},
                  {name:"增加潜台词七",id:7},
                  {name:"增加潜台词八",id:8},
                  {name:"增加潜台词九",id:9},
                  {name:"增加潜台词十",id:10},

              
                          ];
              break;

               //[3,5,3]问题诊断
               case 3 :
                notemessage.notelist= [
                  {name:"问题诊断一",id:1},
                  {name:"问题诊断二",id:2},
                  {name:"问题诊断三",id:3},
                  {name:"问题诊断四",id:4},
                  {name:"问题诊断五",id:5},
                  {name:"问题诊断六",id:6},
                  {name:"问题诊断七",id:7},
                  {name:"问题诊断八",id:8},
                  {name:"问题诊断九",id:9},
                  {name:"问题诊断十",id:10},

              
                          ];
              break;

              }
              break;


               //[3,6]冲突
          case 6:
            switch(_nodePath[2]){
              //[3,6,1]冲突分析
              case 1 :
                notemessage.notelist= [
                  {name:"冲突分析一",id:1},
                  {name:"冲突分析二",id:2},
                  {name:"冲突分析三",id:3},
                  {name:"冲突分析四",id:4},
                  {name:"冲突分析五",id:5},
                  {name:"冲突分析六",id:6},
                  {name:"冲突分析七",id:7},
                  {name:"冲突分析八",id:8},
                  {name:"冲突分析九",id:9},
                  {name:"冲突分析十",id:10},

              
                          ];
              break;

               //[3,5,2]增加冲突
               case 2 :
                notemessage.notelist= [
                  {name:"增加冲突一",id:1},
                  {name:"增加冲突二",id:2},
                  {name:"增加冲突三",id:3},
                  {name:"增加冲突四",id:4},
                  {name:"增加冲突五",id:5},
                  {name:"增加冲突六",id:6},
                  {name:"增加冲突七",id:7},
                  {name:"增加冲突八",id:8},
                  {name:"增加冲突九",id:9},
                  {name:"增加冲突十",id:10},

              
                          ];
              break;

             

              }
              break;

              //[3,7]开头
          case 7:
            switch(_nodePath[2]){
              //[3,7,1]开头摘抄
              case 1 :
                notemessage.notelist= [
                  {name:"开头摘抄一",id:1},
                  {name:"开头摘抄二",id:2},
                  {name:"开头摘抄三",id:3},
                  {name:"开头摘抄四",id:4},
                  {name:"开头摘抄五",id:5},
                  {name:"开头摘抄六",id:6},
                  {name:"开头摘抄七",id:7},
                  {name:"开头摘抄八",id:8},
                  {name:"开头摘抄九",id:9},
                  {name:"开头摘抄十",id:10},

              
                          ];
              break;

               //[3,5,2]开头分析
               case 2 :
                notemessage.notelist= [
                  {name:"开头分析一",id:1},
                  {name:"开头分析二",id:2},
                  {name:"开头分析三",id:3},
                  {name:"开头分析四",id:4},
                  {name:"开头分析五",id:5},
                  {name:"开头分析六",id:6},
                  {name:"开头分析七",id:7},
                  {name:"开头分析八",id:8},
                  {name:"开头分析九",id:9},
                  {name:"开头分析十",id:10},

              
                          ];
              break;

              //[3,5,3]开头仿写
              case 3 :
                notemessage.notelist= [
                  {name:"开头仿写一",id:1},
                  {name:"开头仿写二",id:2},
                  {name:"开头仿写三",id:3},
                  {name:"开头仿写四",id:4},
                  {name:"开头仿写五",id:5},
                  {name:"开头仿写六",id:6},
                  {name:"开头仿写七",id:7},
                  {name:"开头仿写八",id:8},
                  {name:"开头仿写九",id:9},
                  {name:"开头仿写十",id:10},

              
                          ];
              break;

             

              }
              break;



               //[3,8]铺垫
          case 8:
            switch(_nodePath[2]){
              //[3,8,1]铺垫摘抄
              case 1 :
                notemessage.notelist= [
                  {name:"铺垫摘抄一",id:1},
                  {name:"铺垫摘抄二",id:2},
                  {name:"铺垫摘抄三",id:3},
                  {name:"铺垫摘抄四",id:4},
                  {name:"铺垫摘抄五",id:5},
                  {name:"铺垫摘抄六",id:6},
                  {name:"铺垫摘抄七",id:7},
                  {name:"铺垫摘抄八",id:8},
                  {name:"铺垫摘抄九",id:9},
                  {name:"铺垫摘抄十",id:10},

              
                          ];
              break;

               //[3,5,2]铺垫分析
               case 2 :
                notemessage.notelist= [
                  {name:"铺垫分析一",id:1},
                  {name:"铺垫分析二",id:2},
                  {name:"铺垫分析三",id:3},
                  {name:"铺垫分析四",id:4},
                  {name:"铺垫分析五",id:5},
                  {name:"铺垫分析六",id:6},
                  {name:"铺垫分析七",id:7},
                  {name:"铺垫分析八",id:8},
                  {name:"铺垫分析九",id:9},
                  {name:"铺垫分析十",id:10},

              
                          ];
              break;

              //[3,5,3]铺垫练习
              case 3 :
                notemessage.notelist= [
                  {name:"铺垫练习一",id:1},
                  {name:"铺垫练习二",id:2},
                  {name:"铺垫练习三",id:3},
                  {name:"铺垫练习四",id:4},
                  {name:"铺垫练习五",id:5},
                  {name:"铺垫练习六",id:6},
                  {name:"铺垫练习七",id:7},
                  {name:"铺垫练习八",id:8},
                  {name:"铺垫练习九",id:9},
                  {name:"铺垫练习十",id:10},

              
                          ];
              break;

             

              }
              break;



                 //[3,9]反常
          case 9:
            switch(_nodePath[2]){
              //[3,8,1]反常摘抄
              case 1 :
                notemessage.notelist= [
                  {name:"反常摘抄一",id:1},
                  {name:"反常摘抄二",id:2},
                  {name:"反常摘抄三",id:3},
                  {name:"反常摘抄四",id:4},
                  {name:"反常摘抄五",id:5},
                  {name:"反常摘抄六",id:6},
                  {name:"反常摘抄七",id:7},
                  {name:"反常摘抄八",id:8},
                  {name:"反常摘抄九",id:9},
                  {name:"反常摘抄十",id:10},

              
                          ];
              break;

               //[3,8,2]铺垫分析
               case 2 :
                notemessage.notelist= [
                  {name:"反常分析一",id:1},
                  {name:"反常分析二",id:2},
                  {name:"反常分析三",id:3},
                  {name:"反常分析四",id:4},
                  {name:"反常分析五",id:5},
                  {name:"反常分析六",id:6},
                  {name:"反常分析七",id:7},
                  {name:"反常分析八",id:8},
                  {name:"反常分析九",id:9},
                  {name:"反常分析十",id:10},

              
                          ];
              break;

              //[3,8,3]反常练习
              case 3 :
                notemessage.notelist= [
                  {name:"反常练习一",id:1},
                  {name:"反常练习二",id:2},
                  {name:"反常练习三",id:3},
                  {name:"反常练习四",id:4},
                  {name:"反常练习五",id:5},
                  {name:"反常练习六",id:6},
                  {name:"反常练习七",id:7},
                  {name:"反常练习八",id:8},
                  {name:"反常练习九",id:9},
                  {name:"反常练习十",id:10},

              
                          ];
              break;

             

              }
              break;


              //[3,10]悬疑
          case 10:
            switch(_nodePath[2]){
              //[3,10,1]悬疑摘抄
              case 1 :
                notemessage.notelist= [
                  {name:"悬疑摘抄一",id:1},
                  {name:"悬疑摘抄二",id:2},
                  {name:"悬疑摘抄三",id:3},
                  {name:"悬疑摘抄四",id:4},
                  {name:"悬疑摘抄五",id:5},
                  {name:"悬疑摘抄六",id:6},
                  {name:"悬疑摘抄七",id:7},
                  {name:"悬疑摘抄八",id:8},
                  {name:"悬疑摘抄九",id:9},
                  {name:"悬疑摘抄十",id:10},

              
                          ];
              break;

               //[3,10,2]悬疑分析
               case 2 :
                notemessage.notelist= [
                  {name:"悬疑分析一",id:1},
                  {name:"悬疑分析二",id:2},
                  {name:"悬疑分析三",id:3},
                  {name:"悬疑分析四",id:4},
                  {name:"悬疑分析五",id:5},
                  {name:"悬疑分析六",id:6},
                  {name:"悬疑分析七",id:7},
                  {name:"悬疑分析八",id:8},
                  {name:"悬疑分析九",id:9},
                  {name:"悬疑分析十",id:10},

              
                          ];
              break;

              //[3,10,3]悬疑练习
              case 3 :
                notemessage.notelist= [
                  {name:"悬疑练习一",id:1},
                  {name:"悬疑练习二",id:2},
                  {name:"悬疑练习三",id:3},
                  {name:"悬疑练习四",id:4},
                  {name:"悬疑练习五",id:5},
                  {name:"悬疑练习六",id:6},
                  {name:"悬疑练习七",id:7},
                  {name:"悬疑练习八",id:8},
                  {name:"悬疑练习九",id:9},
                  {name:"悬疑练习十",id:10},

              
                          ];
              break;

             

              }
              break;


              //[3,11]节奏
          case 11:
            switch(_nodePath[2]){
              //[3,11,1]节奏分析
              case 1 :
                notemessage.notelist= [
                  {name:"节奏分析一",id:1},
                  {name:"节奏分析二",id:2},
                  {name:"节奏分析三",id:3},
                  {name:"节奏分析四",id:4},
                  {name:"节奏分析五",id:5},
                  {name:"节奏分析六",id:6},
                  {name:"节奏分析七",id:7},
                  {name:"节奏分析八",id:8},
                  {name:"节奏分析九",id:9},
                  {name:"节奏分析十",id:10},

              
                          ];
              break;

               //[3,11,2]节奏设置
               case 2 :
                notemessage.notelist= [
                  {name:"节奏设置一",id:1},
                  {name:"节奏设置二",id:2},
                  {name:"节奏设置三",id:3},
                  {name:"节奏设置四",id:4},
                  {name:"节奏设置五",id:5},
                  {name:"节奏设置六",id:6},
                  {name:"节奏设置七",id:7},
                  {name:"节奏设置八",id:8},
                  {name:"节奏设置九",id:9},
                  {name:"节奏设置十",id:10},

              
                          ];
              break;

            

             

              }
              break;



                //[3,12]鸿沟
          case 12:
            switch(_nodePath[2]){
              //[3,12,1]节奏分析
              case 1 :
                notemessage.notelist= [
                  {name:"鸿沟分析一",id:1},
                  {name:"鸿沟分析二",id:2},
                  {name:"鸿沟分析三",id:3},
                  {name:"鸿沟分析四",id:4},
                  {name:"鸿沟分析五",id:5},
                  {name:"鸿沟分析六",id:6},
                  {name:"鸿沟分析七",id:7},
                  {name:"鸿沟分析八",id:8},
                  {name:"鸿沟分析九",id:9},
                  {name:"鸿沟分析十",id:10},

              
                          ];
              break;

               //[3,12,2]鸿沟练习
               case 2 :
                notemessage.notelist= [
                  {name:"鸿沟练习一",id:1},
                  {name:"鸿沟练习二",id:2},
                  {name:"鸿沟练习三",id:3},
                  {name:"鸿沟练习四",id:4},
                  {name:"鸿沟练习五",id:5},
                  {name:"鸿沟练习六",id:6},
                  {name:"鸿沟练习七",id:7},
                  {name:"鸿沟练习八",id:8},
                  {name:"鸿沟练习九",id:9},
                  {name:"鸿沟练习十",id:10},

              
                          ];
              break;

            

             

              }
              break;

            //[3,13]信息扣押
          case 13:
            switch(_nodePath[2]){
              //[3,13,1]扣押练习
              case 1 :
                notemessage.notelist= [
                  {name:"扣押练习一",id:1},
                  {name:"扣押练习二",id:2},
                  {name:"扣押练习三",id:3},
                  {name:"扣押练习四",id:4},
                  {name:"扣押练习五",id:5},
                  {name:"扣押练习六",id:6},
                  {name:"扣押练习七",id:7},
                  {name:"扣押练习八",id:8},
                  {name:"扣押练习九",id:9},
                  {name:"扣押练习十",id:10},

              
                          ];
              break;

               

            

             

              }
              break;




























        }
        break;

        default:
            notemessage.notelist = [
                     
          ];
            break;

        
    }

    if(notemessage.notelist!=null){
      notemessage.notenumber = notemessage.notelist.length;
    notemessage.notelistname =  notemessage.notelist.map((item)=>item.name);

    }
    
    return notemessage;
  }

  



class AppState
{
    @observable appname = "Cookie";
    @observable nodepath = [0,0];
    @observable is_editing = false;
    @observable is_title = 0;
    @observable isrecommend = false;
    @observable view_type = 0;//0 = show all
    @observable savepath = "";
    @observable starchange = 0 ;
    

  @action  getnodepagereadycopy(copyname,nodeitemname){
         
    //英雄救美摘抄
    switch(nodeitemname){
         case copyname+"摘抄一" :
         this.current_note_markdown = `
    请在此摘抄你看过的`+copyname+`套路
         `;
    
         this.is_title = 1;
         if( this.view_type == 2 ) this.view_type = 3;
         break;
    
         case copyname+"摘抄二" :
         this.current_note_markdown = `
    请在此摘抄你看过的`+copyname+`套路
         `;
    
         this.is_title = 1;
         if( this.view_type == 2 ) this.view_type = 3;
         break;
    
         case copyname+"摘抄三" :
         this.current_note_markdown = `
    请在此摘抄你看过的`+copyname+`套路
         `;
    
         this.is_title = 1;
         if( this.view_type == 2 ) this.view_type = 3;
         break;
    
         case copyname+"摘抄四" :
         this.current_note_markdown = `
    请在此摘抄你看过的`+copyname+`套路
         `;
    
         this.is_title = 1;
         if( this.view_type == 2 ) this.view_type = 3;
         break;
    
         case copyname+"摘抄五" :
         this.current_note_markdown = `
    请在此摘抄你看过的`+copyname+`套路
         `;
    
         this.is_title = 1;
         if( this.view_type == 2 ) this.view_type = 3;
         break;
    
         case copyname+"摘抄六" :
         this.current_note_markdown = `
    请在此摘抄你看过的`+copyname+`套路
         `;
         
    
         this.is_title = 1;
         if( this.view_type == 2 ) this.view_type = 3;
         break;
    
         case copyname+"摘抄七" :
         this.current_note_markdown = `
    请在此摘抄你看过的`+copyname+`套路
         `;
    
         this.is_title = 1;
         if( this.view_type == 2 ) this.view_type = 3;
         break;
    
         case copyname+"摘抄八" :
         this.current_note_markdown = `
    请在此摘抄你看过的`+copyname+`套路
         `;
    
         this.is_title = 1;
         if( this.view_type == 2 ) this.view_type = 3;
         break;
    
         case copyname+"摘抄九" :
         this.current_note_markdown = `
    请在此摘抄你看过的`+copyname+`套路
         `;
    
         this.is_title = 1;
         if( this.view_type == 2 ) this.view_type = 3;
         break;
    
         case copyname+"摘抄十" :
         this.current_note_markdown = `
    请在此摘抄你看过的`+copyname+`套路
         `;
    
         this.is_title = 1;
         if( this.view_type == 2 ) this.view_type = 3;
         break;
        }
  }

  @action  getnodepagereadyfollow(copyname,nodeitemname){
      //英雄救美仿写
      switch(nodeitemname){
     case copyname+"仿写一" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem(copyname+"摘抄一")!=null){
       this.current_note_markdown+=localStorage.getItem(copyname+"摘抄一");
     }
     else{
       this.current_note_markdown+=`
       但`+copyname+`摘抄一还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case copyname+"仿写二" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem(copyname+"摘抄二")!=null){
       this.current_note_markdown+=localStorage.getItem(copyname+"摘抄二");
     }
     else{
       this.current_note_markdown+=`
       但`+copyname+`摘抄二还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case copyname+"仿写三" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem(copyname+"摘抄三")!=null){
       this.current_note_markdown+=localStorage.getItem(copyname+"摘抄三");
     }
     else{
       this.current_note_markdown+=`
       但`+copyname+`摘抄三还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case copyname+"仿写四" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem(copyname+"摘抄四")!=null){
       this.current_note_markdown+=localStorage.getItem(copyname+"摘抄四");
     }
     else{
       this.current_note_markdown+=`
       但`+copyname+`摘抄四还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case copyname+"仿写五" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem(copyname+"摘抄五")!=null){
       this.current_note_markdown+=localStorage.getItem(copyname+"摘抄五");
     }
     else{
       this.current_note_markdown+=`
       但`+copyname+`摘抄五还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case copyname+"仿写六" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem(copyname+"摘抄六")!=null){
       this.current_note_markdown+=localStorage.getItem(copyname+"摘抄六");
     }
     else{
       this.current_note_markdown+=`
       但`+copyname+`摘抄六还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case copyname+"仿写七" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem(copyname+"摘抄七")!=null){
       this.current_note_markdown+=localStorage.getItem(copyname+"摘抄七");
     }
     else{
       this.current_note_markdown+=`
       但`+copyname+`摘抄七还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case copyname+"仿写八" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem(copyname+"摘抄八")!=null){
       this.current_note_markdown+=localStorage.getItem(copyname+"摘抄八");
     }
     else{
       this.current_note_markdown+=`
       但`+copyname+`摘抄八还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case copyname+"仿写九" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem(copyname+"摘抄九")!=null){
       this.current_note_markdown+=localStorage.getItem(copyname+"摘抄九");
     }
     else{
       this.current_note_markdown+=`
       但`+copyname+`摘抄九还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case copyname+"仿写十" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem(copyname+"摘抄十")!=null){
       this.current_note_markdown+=localStorage.getItem(copyname+"摘抄十");
     }
     else{
       this.current_note_markdown+=`
       但`+copyname+`摘抄十还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;
    }

  }

  @action  getnodepagereadywrite(copyname,nodeitemname){
      //英雄救美练习
    switch(nodeitemname){
    case copyname+"练习一" :
      this.current_note_markdown = `
请自行设定背景，写出一个`+copyname+`套路
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case copyname+"练习二":
this.current_note_markdown = `
请自行设定背景，写出一个`+copyname+`套路
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case copyname+"练习三":
this.current_note_markdown = `
请自行设定背景，写出一个`+copyname+`套路
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case copyname+"练习四":
this.current_note_markdown = `
请自行设定背景，写出一个`+copyname+`套路
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case copyname+"练习五":
this.current_note_markdown = `
请自行设定背景，写出一个`+copyname+`套路
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case copyname+"练习六" :
this.current_note_markdown = `
请自行设定背景，写出一个`+copyname+`套路
`;


this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case copyname+"练习七" :
this.current_note_markdown = `
请自行设定背景，写出一个`+copyname+`套路
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case copyname+"练习八" :
this.current_note_markdown = `
请自行设定背景，写出一个`+copyname+`套路
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case copyname+"练习九" :
this.current_note_markdown = `
请自行设定背景，写出一个`+copyname+`套路
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case copyname+"练习十" :
this.current_note_markdown = `
请自行设定背景，写出一个`+copyname+`套路

`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;
}
  }


    @action getnotelistitem(_nodePath){
     this.current_note_list= getnodelist(_nodePath).notelist;
    }

    @action getnotelistnumber(_nodePath){
      let number =  getnodelist(_nodePath).notenumber;
      return number;
     }

     @action getnotelistname(_nodePath){
       let name = getnodelist(_nodePath).notelistname;
       return name;
     }

     @action getnotepageready(notelistname){

        switch(this.nodepath[0]){
          //套路篇
            case 2 :
              switch(this.nodepath[1]){
                //爽文套路
                case 0 :
                  switch(this.nodepath[2]){
                    //两虎相争
                    case 5:
                      switch(this.nodepath[3]){
                        case 1 :
                          this.getnodepagereadycopy("两虎相争",notelistname);
                        break;
                        case 2 :
                          this.getnodepagereadyfollow("两虎相争",notelistname);
                        break;
                        case 3 :
                          this.getnodepagereadywrite("两虎相争",notelistname);
                        break;
                      }
                      break;
                      //预言
                      case 6:
                        switch(this.nodepath[3]){
                          case 1 :
                            this.getnodepagereadycopy("预言",notelistname);
                          break;
                          case 2 :
                            this.getnodepagereadyfollow("预言",notelistname);
                          break;
                          case 3 :
                            this.getnodepagereadywrite("预言",notelistname);
                          break;
                        }
                        break;


                        //密谋
                      case 7:
                        switch(this.nodepath[3]){
                          case 1 :
                            this.getnodepagereadycopy("密谋",notelistname);
                          break;
                          case 2 :
                            this.getnodepagereadyfollow("密谋",notelistname);
                          break;
                          case 3 :
                            this.getnodepagereadywrite("密谋",notelistname);
                          break;
                        }
                        break;

                          //赌注
                      case 8:
                        switch(this.nodepath[3]){
                          case 1 :
                            this.getnodepagereadycopy("赌注",notelistname);
                          break;
                          case 2 :
                            this.getnodepagereadyfollow("赌注",notelistname);
                          break;
                          case 3 :
                            this.getnodepagereadywrite("赌注",notelistname);
                          break;
                        }
                        break;

                         //冤枉
                      case 9:
                        switch(this.nodepath[3]){
                          case 1 :
                            this.getnodepagereadycopy("冤枉",notelistname);
                          break;
                          case 2 :
                            this.getnodepagereadyfollow("冤枉",notelistname);
                          break;
                          case 3 :
                            this.getnodepagereadywrite("冤枉",notelistname);
                          break;
                        }
                        break;

                             //经典铺垫
                      case 10:
                        switch(this.nodepath[3]){
                          case 1 :
                            this.getnodepagereadycopy("经典铺垫",notelistname);
                          break;
                          case 2 :
                            this.getnodepagereadyfollow("经典铺垫",notelistname);
                          break;
                          case 3 :
                            this.getnodepagereadywrite("经典铺垫",notelistname);
                          break;
                        }
                        break;

                         //站上舞台
                      case 11:
                        switch(this.nodepath[3]){
                          case 1 :
                            this.getnodepagereadycopy("站上舞台",notelistname);
                          break;
                          case 2 :
                            this.getnodepagereadyfollow("站上舞台",notelistname);
                          break;
                          case 3 :
                            this.getnodepagereadywrite("站上舞台",notelistname);
                          break;
                        }
                        break;

                          //预先提名
                      case 12:
                        switch(this.nodepath[3]){
                          case 1 :
                            this.getnodepagereadycopy("预先提名",notelistname);
                          break;
                          case 2 :
                            this.getnodepagereadyfollow("预先提名",notelistname);
                          break;
                          case 3 :
                            this.getnodepagereadywrite("预先提名",notelistname);
                          break;
                        }
                        break;

                        //先败为敬
                      case 13:
                        switch(this.nodepath[3]){
                          case 1 :
                            this.getnodepagereadycopy("先败为敬",notelistname);
                          break;
                          case 2 :
                            this.getnodepagereadyfollow("先败为敬",notelistname);
                          break;
                          case 3 :
                            this.getnodepagereadywrite("先败为敬",notelistname);
                          break;
                        }
                        break;


                          //倒计时
                      case 14:
                        switch(this.nodepath[3]){
                          case 1 :
                            this.getnodepagereadycopy("倒计时",notelistname);
                          break;
                          case 2 :
                            this.getnodepagereadyfollow("倒计时",notelistname);
                          break;
                          case 3 :
                            this.getnodepagereadywrite("倒计时",notelistname);
                          break;
                        }
                        break;

                         //反常爽文
                      case 15:
                        switch(this.nodepath[3]){
                          case 1 :
                            this.getnodepagereadycopy("反常爽文",notelistname);
                          break;
                          case 2 :
                            this.getnodepagereadyfollow("反常爽文",notelistname);
                          break;
                          case 3 :
                            this.getnodepagereadywrite("反常爽文",notelistname);
                          break;
                        }
                        break;

                         //表态
                      case 16:
                        switch(this.nodepath[3]){
                          case 1 :
                            this.getnodepagereadycopy("表态",notelistname);
                          break;
                          case 2 :
                            this.getnodepagereadyfollow("表态",notelistname);
                          break;
                          case 3 :
                            this.getnodepagereadywrite("表态",notelistname);
                          break;
                        }
                        break;

                        //征服
                      case 17:
                        switch(this.nodepath[3]){
                          case 1 :
                            this.getnodepagereadycopy("征服",notelistname);
                          break;
                          case 2 :
                            this.getnodepagereadyfollow("征服",notelistname);
                          break;
                          case 3 :
                            this.getnodepagereadywrite("征服",notelistname);
                          break;
                        }
                        break;


                          //扮猪吃虎
                      case 18:
                        switch(this.nodepath[3]){
                          case 1 :
                            this.getnodepagereadycopy("扮猪吃虎",notelistname);
                          break;
                          case 2 :
                            this.getnodepagereadyfollow("扮猪吃虎",notelistname);
                          break;
                          case 3 :
                            this.getnodepagereadywrite("扮猪吃虎",notelistname);
                          break;
                        }
                        break;


                           //神器认主
                      case 19:
                        switch(this.nodepath[3]){
                          case 1 :
                            this.getnodepagereadycopy("神器认主",notelistname);
                          break;
                          case 2 :
                            this.getnodepagereadyfollow("神器认主",notelistname);
                          break;
                          case 3 :
                            this.getnodepagereadywrite("神器认主",notelistname);
                          break;
                        }
                        break;

                         //明星聚光
                      case 20:
                        switch(this.nodepath[3]){
                          case 1 :
                            this.getnodepagereadycopy("明星聚光",notelistname);
                          break;
                          case 2 :
                            this.getnodepagereadyfollow("明星聚光",notelistname);
                          break;
                          case 3 :
                            this.getnodepagereadywrite("明星聚光",notelistname);
                          break;
                        }
                        break;









                  }
                  break;
                  //言情套路
                  case 1 :

                    switch(this.nodepath[2]){
                      //在意
                      case 1:
                        switch(this.nodepath[3]){
                          case 1 :
                            this.getnodepagereadycopy("在意",notelistname);
                          break;
                          case 2 :
                            this.getnodepagereadyfollow("在意",notelistname);
                          break;
                          case 3 :
                            this.getnodepagereadywrite("在意",notelistname);
                          break;
                        }
                        break;

                         //欣赏
                      case 2:
                        switch(this.nodepath[3]){
                          case 1 :
                            this.getnodepagereadycopy("欣赏",notelistname);
                          break;
                          case 2 :
                            this.getnodepagereadyfollow("欣赏",notelistname);
                          break;
                          case 3 :
                            this.getnodepagereadywrite("欣赏",notelistname);
                          break;
                        }
                        break;

                        //长情
                      case 3:
                        switch(this.nodepath[3]){
                          case 1 :
                            this.getnodepagereadycopy("长情",notelistname);
                          break;
                          case 2 :
                            this.getnodepagereadyfollow("长情",notelistname);
                          break;
                          case 3 :
                            this.getnodepagereadywrite("长情",notelistname);
                          break;
                        }
                        break;

                        //竞争
                      case 4:
                        switch(this.nodepath[3]){
                          case 1 :
                            this.getnodepagereadycopy("竞争",notelistname);
                          break;
                          case 2 :
                            this.getnodepagereadyfollow("竞争",notelistname);
                          break;
                          case 3 :
                            this.getnodepagereadywrite("竞争",notelistname);
                          break;
                        }
                        break;


                          //吹嘘
                      case 5:
                        switch(this.nodepath[3]){
                          case 1 :
                            this.getnodepagereadycopy("吹嘘",notelistname);
                          break;
                          case 2 :
                            this.getnodepagereadyfollow("吹嘘",notelistname);
                          break;
                          case 3 :
                            this.getnodepagereadywrite("吹嘘",notelistname);
                          break;
                        }
                        break;

                          //占有欲
                      case 6:
                        switch(this.nodepath[3]){
                          case 1 :
                            this.getnodepagereadycopy("占有欲",notelistname);
                          break;
                          case 2 :
                            this.getnodepagereadyfollow("占有欲",notelistname);
                          break;
                          case 3 :
                            this.getnodepagereadywrite("占有欲",notelistname);
                          break;
                        }
                        break;

                         //言情英雄救美
                      case 7:
                        switch(this.nodepath[3]){
                          case 1 :
                            this.getnodepagereadycopy("言情英雄救美",notelistname);
                          break;
                          case 2 :
                            this.getnodepagereadyfollow("言情英雄救美",notelistname);
                          break;
                          case 3 :
                            this.getnodepagereadywrite("言情英雄救美",notelistname);
                          break;
                        }
                        break;

                         //共度危机
                      case 8:
                        switch(this.nodepath[3]){
                          case 1 :
                            this.getnodepagereadycopy("共度危机",notelistname);
                          break;
                          case 2 :
                            this.getnodepagereadyfollow("共度危机",notelistname);
                          break;
                          case 3 :
                            this.getnodepagereadywrite("共度危机",notelistname);
                          break;
                        }
                        break;

                           //禁忌
                      case 9:
                        switch(this.nodepath[3]){
                          case 1 :
                            this.getnodepagereadycopy("禁忌",notelistname);
                          break;
                          case 2 :
                            this.getnodepagereadyfollow("禁忌",notelistname);
                          break;
                          case 3 :
                            this.getnodepagereadywrite("禁忌",notelistname);
                          break;
                        }
                        break;

                         //契约
                      case 10:
                        switch(this.nodepath[3]){
                          case 1 :
                            this.getnodepagereadycopy("契约",notelistname);
                          break;
                          case 2 :
                            this.getnodepagereadyfollow("契约",notelistname);
                          break;
                          case 3 :
                            this.getnodepagereadywrite("契约",notelistname);
                          break;
                        }
                        break;

                         //误会
                      case 11:
                        switch(this.nodepath[3]){
                          case 1 :
                            this.getnodepagereadycopy("误会",notelistname);
                          break;
                          case 2 :
                            this.getnodepagereadyfollow("误会",notelistname);
                          break;
                          case 3 :
                            this.getnodepagereadywrite("误会",notelistname);
                          break;
                        }
                        break;


                         //秘密
                      case 12:
                        switch(this.nodepath[3]){
                          case 1 :
                            this.getnodepagereadycopy("秘密",notelistname);
                          break;
                          case 2 :
                            this.getnodepagereadyfollow("秘密",notelistname);
                          break;
                          case 3 :
                            this.getnodepagereadywrite("秘密",notelistname);
                          break;
                        }
                        break;

                          //黯然神伤
                      case 13:
                        switch(this.nodepath[3]){
                          case 1 :
                            this.getnodepagereadycopy("黯然神伤",notelistname);
                          break;
                          case 2 :
                            this.getnodepagereadyfollow("黯然神伤",notelistname);
                          break;
                          case 3 :
                            this.getnodepagereadywrite("黯然神伤",notelistname);
                          break;
                        }
                        break;


                         //牺牲
                      case 14:
                        switch(this.nodepath[3]){
                          case 1 :
                            this.getnodepagereadycopy("牺牲",notelistname);
                          break;
                          case 2 :
                            this.getnodepagereadyfollow("牺牲",notelistname);
                          break;
                          case 3 :
                            this.getnodepagereadywrite("牺牲",notelistname);
                          break;
                        }
                        break;

                         //神秘
                      case 15:
                        switch(this.nodepath[3]){
                          case 1 :
                            this.getnodepagereadycopy("神秘",notelistname);
                          break;
                          case 2 :
                            this.getnodepagereadyfollow("神秘",notelistname);
                          break;
                          case 3 :
                            this.getnodepagereadywrite("神秘",notelistname);
                          break;
                        }
                        break;


                        //身体接触
                      case 16:
                        switch(this.nodepath[3]){
                          case 1 :
                            this.getnodepagereadycopy("身体接触",notelistname);
                          break;
                          case 2 :
                            this.getnodepagereadyfollow("身体接触",notelistname);
                          break;
                          case 3 :
                            this.getnodepagereadywrite("身体接触",notelistname);
                          break;
                        }
                        break;

                         //告白
                      case 17:
                        switch(this.nodepath[3]){
                          case 1 :
                            this.getnodepagereadycopy("告白",notelistname);
                          break;
                          case 2 :
                            this.getnodepagereadyfollow("告白",notelistname);
                          break;
                          case 3 :
                            this.getnodepagereadywrite("告白",notelistname);
                          break;
                        }
                        break;

                         //失而复得
                      case 18:
                        switch(this.nodepath[3]){
                          case 1 :
                            this.getnodepagereadycopy("失而复得",notelistname);
                          break;
                          case 2 :
                            this.getnodepagereadyfollow("失而复得",notelistname);
                          break;
                          case 3 :
                            this.getnodepagereadywrite("失而复得",notelistname);
                          break;
                        }
                        break;


                        //意料之外
                      case 19:
                        switch(this.nodepath[3]){
                          case 1 :
                            this.getnodepagereadycopy("意料之外",notelistname);
                          break;
                          case 2 :
                            this.getnodepagereadyfollow("意料之外",notelistname);
                          break;
                          case 3 :
                            this.getnodepagereadywrite("意料之外",notelistname);
                          break;
                        }
                        break;

                         //对你与众不同
                      case 20:
                        switch(this.nodepath[3]){
                          case 1 :
                            this.getnodepagereadycopy("对你与众不同",notelistname);
                          break;
                          case 2 :
                            this.getnodepagereadyfollow("对你与众不同",notelistname);
                          break;
                          case 3 :
                            this.getnodepagereadywrite("对你与众不同",notelistname);
                          break;
                        }
                        break;













                        }
                        

                  //言情套路结束
                  break;
              }
            break;

        }
    

       switch(notelistname){



//笑点练习
case"笑点练习一" :
this.current_note_markdown = `
请努力写出一个让人想笑的段落
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"笑点练习二" :
this.current_note_markdown = `
请努力写出一个让人想笑的段落
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"笑点练习三" :
this.current_note_markdown = `
请努力写出一个让人想笑的段落
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"笑点练习四" :
this.current_note_markdown = `
请努力写出一个让人想笑的段落
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"笑点练习五" :
this.current_note_markdown = `
请努力写出一个让人想笑的段落
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"笑点练习六" :
this.current_note_markdown = `
请努力写出一个让人想笑的段落
`;


this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"笑点练习七" :
this.current_note_markdown = `
请努力写出一个让人想笑的段落
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"笑点练习八" :
this.current_note_markdown = `
请努力写出一个让人想笑的段落
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"笑点练习九" :
this.current_note_markdown = `
请努力写出一个让人想笑的段落
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"笑点练习十" :
this.current_note_markdown = `
请努力写出一个让人想笑的段落

`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;



 //笑点分析
 case"笑点分析一" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人想笑


 `;
 if(localStorage.getItem("笑点摘抄一")!=null){
   this.current_note_markdown+=localStorage.getItem("笑点摘抄一");
 }
 else{
   this.current_note_markdown+=`
   但笑点摘抄一还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"笑点分析二" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人想笑


 `;
 if(localStorage.getItem("笑点摘抄二")!=null){
   this.current_note_markdown+=localStorage.getItem("笑点摘抄二");
 }
 else{
   this.current_note_markdown+=`
   但笑点摘抄二还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"笑点分析三" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人想笑


 `;
 if(localStorage.getItem("笑点摘抄三")!=null){
   this.current_note_markdown+=localStorage.getItem("笑点摘抄三");
 }
 else{
   this.current_note_markdown+=`
   但笑点摘抄三还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"笑点分析四" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人想笑


 `;
 if(localStorage.getItem("笑点摘抄四")!=null){
   this.current_note_markdown+=localStorage.getItem("笑点摘抄四");
 }
 else{
   this.current_note_markdown+=`
   但笑点摘抄四还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;


 case"笑点分析五" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人想笑


 `;
 if(localStorage.getItem("笑点摘抄五")!=null){
   this.current_note_markdown+=localStorage.getItem("笑点摘抄五");
 }
 else{
   this.current_note_markdown+=`
   但笑点摘抄五还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"笑点分析六" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人想笑


 `;
 if(localStorage.getItem("笑点摘抄六")!=null){
   this.current_note_markdown+=localStorage.getItem("笑点摘抄六");
 }
 else{
   this.current_note_markdown+=`
   但笑点摘抄六还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"笑点分析七" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人想笑


 `;
 if(localStorage.getItem("笑点摘抄七")!=null){
   this.current_note_markdown+=localStorage.getItem("笑点摘抄七");
 }
 else{
   this.current_note_markdown+=`
   但笑点摘抄七还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"笑点分析八" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人想笑


 `;
 if(localStorage.getItem("笑点摘抄八")!=null){
   this.current_note_markdown+=localStorage.getItem("笑点摘抄八");
 }
 else{
   this.current_note_markdown+=`
   但笑点摘抄八还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"笑点分析九" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人想笑


 `;
 if(localStorage.getItem("笑点摘抄九")!=null){
   this.current_note_markdown+=localStorage.getItem("笑点摘抄九");
 }
 else{
   this.current_note_markdown+=`
   但笑点摘抄九还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"笑点分析十" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人想笑


 `;
 if(localStorage.getItem("笑点摘抄十")!=null){
   this.current_note_markdown+=localStorage.getItem("笑点摘抄十");
 }
 else{
   this.current_note_markdown+=`
   但笑点摘抄十还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;




        //笑点摘抄
        case"笑点摘抄一" :
        this.current_note_markdown = `
   请在此摘抄能让你感到想笑的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"笑点摘抄二" :
        this.current_note_markdown = `
   请在此摘抄能让你感到想笑的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"笑点摘抄三" :
        this.current_note_markdown = `
   请在此摘抄能让你感到想笑的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"笑点摘抄四" :
        this.current_note_markdown = `
   请在此摘抄能让你感到想笑的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"笑点摘抄五" :
        this.current_note_markdown = `
   请在此摘抄能让你感到想笑的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"笑点摘抄六" :
        this.current_note_markdown = `
   请在此摘抄能让你感到想笑的段落
        `;
        
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"笑点摘抄七" :
        this.current_note_markdown = `
   请在此摘抄能让你感到想笑的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"笑点摘抄八" :
        this.current_note_markdown = `
   请在此摘抄能让你感到想笑的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"笑点摘抄九" :
        this.current_note_markdown = `
   请在此摘抄能让你感到想笑的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"笑点摘抄十" :
        this.current_note_markdown = `
   请在此摘抄能让你感到想笑的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;




//泪点练习
case"泪点练习一" :
this.current_note_markdown = `
请努力写出一个让人想哭的段落
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"泪点练习二" :
this.current_note_markdown = `
请努力写出一个让人想哭的段落
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"泪点练习三" :
this.current_note_markdown = `
请努力写出一个让人想哭的段落
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"泪点练习四" :
this.current_note_markdown = `
请努力写出一个让人想哭的段落
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"泪点练习五" :
this.current_note_markdown = `
请努力写出一个让人想哭的段落
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"泪点练习六" :
this.current_note_markdown = `
请努力写出一个让人想哭的段落
`;


this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"泪点练习七" :
this.current_note_markdown = `
请努力写出一个让人想哭的段落
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"泪点练习八" :
this.current_note_markdown = `
请努力写出一个让人想哭的段落
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"泪点练习九" :
this.current_note_markdown = `
请努力写出一个让人想哭的段落
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"泪点练习十" :
this.current_note_markdown = `
请努力写出一个让人想哭的段落

`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;



 //泪点分析
 case"泪点分析一" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人想哭


 `;
 if(localStorage.getItem("泪点摘抄一")!=null){
   this.current_note_markdown+=localStorage.getItem("泪点摘抄一");
 }
 else{
   this.current_note_markdown+=`
   但泪点摘抄一还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"泪点分析二" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人想哭


 `;
 if(localStorage.getItem("泪点摘抄二")!=null){
   this.current_note_markdown+=localStorage.getItem("泪点摘抄二");
 }
 else{
   this.current_note_markdown+=`
   但泪点摘抄二还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"泪点分析三" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人想哭


 `;
 if(localStorage.getItem("泪点摘抄三")!=null){
   this.current_note_markdown+=localStorage.getItem("泪点摘抄三");
 }
 else{
   this.current_note_markdown+=`
   但泪点摘抄三还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"泪点分析四" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人想哭


 `;
 if(localStorage.getItem("泪点摘抄四")!=null){
   this.current_note_markdown+=localStorage.getItem("泪点摘抄四");
 }
 else{
   this.current_note_markdown+=`
   但泪点摘抄四还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;


 case"泪点分析五" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人想哭


 `;
 if(localStorage.getItem("泪点摘抄五")!=null){
   this.current_note_markdown+=localStorage.getItem("泪点摘抄五");
 }
 else{
   this.current_note_markdown+=`
   但泪点摘抄五还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"泪点分析六" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人想哭


 `;
 if(localStorage.getItem("泪点摘抄六")!=null){
   this.current_note_markdown+=localStorage.getItem("泪点摘抄六");
 }
 else{
   this.current_note_markdown+=`
   但泪点摘抄六还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"泪点分析七" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人想哭


 `;
 if(localStorage.getItem("泪点摘抄七")!=null){
   this.current_note_markdown+=localStorage.getItem("泪点摘抄七");
 }
 else{
   this.current_note_markdown+=`
   但泪点摘抄七还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"泪点分析八" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人想哭


 `;
 if(localStorage.getItem("泪点摘抄八")!=null){
   this.current_note_markdown+=localStorage.getItem("泪点摘抄八");
 }
 else{
   this.current_note_markdown+=`
   但泪点摘抄八还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"泪点分析九" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人想哭


 `;
 if(localStorage.getItem("泪点摘抄九")!=null){
   this.current_note_markdown+=localStorage.getItem("泪点摘抄九");
 }
 else{
   this.current_note_markdown+=`
   但泪点摘抄九还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"泪点分析十" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人想哭


 `;
 if(localStorage.getItem("泪点摘抄十")!=null){
   this.current_note_markdown+=localStorage.getItem("泪点摘抄十");
 }
 else{
   this.current_note_markdown+=`
   但泪点摘抄十还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;




        //泪点摘抄
        case"泪点摘抄一" :
        this.current_note_markdown = `
   请在此摘抄能让你感到想哭的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"泪点摘抄二" :
        this.current_note_markdown = `
   请在此摘抄能让你感到想哭的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"泪点摘抄三" :
        this.current_note_markdown = `
   请在此摘抄能让你感到想哭的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"泪点摘抄四" :
        this.current_note_markdown = `
   请在此摘抄能让你感到想哭的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"泪点摘抄五" :
        this.current_note_markdown = `
   请在此摘抄能让你感到想哭的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"泪点摘抄六" :
        this.current_note_markdown = `
   请在此摘抄能让你感到想哭的段落
        `;
        
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"泪点摘抄七" :
        this.current_note_markdown = `
   请在此摘抄能让你感到想哭的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"泪点摘抄八" :
        this.current_note_markdown = `
   请在此摘抄能让你感到想哭的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"泪点摘抄九" :
        this.current_note_markdown = `
   请在此摘抄能让你感到想哭的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"泪点摘抄十" :
        this.current_note_markdown = `
   请在此摘抄能让你感到想哭的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;



//愤怒练习
case"愤怒练习一" :
this.current_note_markdown = `
请努力写出一个让人愤怒的段落
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"愤怒练习二" :
this.current_note_markdown = `
请努力写出一个让人愤怒的段落
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"愤怒练习三" :
this.current_note_markdown = `
请努力写出一个让人愤怒的段落
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"愤怒练习四" :
this.current_note_markdown = `
请努力写出一个让人愤怒的段落
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"愤怒练习五" :
this.current_note_markdown = `
请努力写出一个让人愤怒的段落
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"愤怒练习六" :
this.current_note_markdown = `
请努力写出一个让人愤怒的段落
`;


this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"愤怒练习七" :
this.current_note_markdown = `
请努力写出一个让人愤怒的段落
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"愤怒练习八" :
this.current_note_markdown = `
请努力写出一个让人愤怒的段落
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"愤怒练习九" :
this.current_note_markdown = `
请努力写出一个让人愤怒的段落
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"愤怒练习十" :
this.current_note_markdown = `
请努力写出一个让人愤怒的段落

`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;



 //愤怒分析
 case"愤怒分析一" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人愤怒


 `;
 if(localStorage.getItem("愤怒摘抄一")!=null){
   this.current_note_markdown+=localStorage.getItem("愤怒摘抄一");
 }
 else{
   this.current_note_markdown+=`
   但愤怒摘抄一还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"愤怒分析二" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人愤怒


 `;
 if(localStorage.getItem("愤怒摘抄二")!=null){
   this.current_note_markdown+=localStorage.getItem("愤怒摘抄二");
 }
 else{
   this.current_note_markdown+=`
   但愤怒摘抄二还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"愤怒分析三" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人愤怒


 `;
 if(localStorage.getItem("愤怒摘抄三")!=null){
   this.current_note_markdown+=localStorage.getItem("愤怒摘抄三");
 }
 else{
   this.current_note_markdown+=`
   但愤怒摘抄三还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"愤怒分析四" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人愤怒


 `;
 if(localStorage.getItem("愤怒摘抄四")!=null){
   this.current_note_markdown+=localStorage.getItem("愤怒摘抄四");
 }
 else{
   this.current_note_markdown+=`
   但愤怒摘抄四还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;


 case"愤怒分析五" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人愤怒


 `;
 if(localStorage.getItem("愤怒摘抄五")!=null){
   this.current_note_markdown+=localStorage.getItem("愤怒摘抄五");
 }
 else{
   this.current_note_markdown+=`
   但愤怒摘抄五还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"愤怒分析六" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人愤怒


 `;
 if(localStorage.getItem("愤怒摘抄六")!=null){
   this.current_note_markdown+=localStorage.getItem("愤怒摘抄六");
 }
 else{
   this.current_note_markdown+=`
   但愤怒摘抄六还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"愤怒分析七" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人愤怒


 `;
 if(localStorage.getItem("愤怒摘抄七")!=null){
   this.current_note_markdown+=localStorage.getItem("愤怒摘抄七");
 }
 else{
   this.current_note_markdown+=`
   但愤怒摘抄七还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"愤怒分析八" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人愤怒


 `;
 if(localStorage.getItem("愤怒摘抄八")!=null){
   this.current_note_markdown+=localStorage.getItem("愤怒摘抄八");
 }
 else{
   this.current_note_markdown+=`
   但愤怒摘抄八还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"愤怒分析九" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人愤怒


 `;
 if(localStorage.getItem("愤怒摘抄九")!=null){
   this.current_note_markdown+=localStorage.getItem("愤怒摘抄九");
 }
 else{
   this.current_note_markdown+=`
   但愤怒摘抄九还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"愤怒分析十" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人愤怒


 `;
 if(localStorage.getItem("愤怒摘抄十")!=null){
   this.current_note_markdown+=localStorage.getItem("愤怒摘抄十");
 }
 else{
   this.current_note_markdown+=`
   但愤怒摘抄十还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;




        //愤怒摘抄
        case"愤怒摘抄一" :
        this.current_note_markdown = `
   请在此摘抄能让你感到愤怒的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"愤怒摘抄二" :
        this.current_note_markdown = `
   请在此摘抄能让你感到愤怒的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"愤怒摘抄三" :
        this.current_note_markdown = `
   请在此摘抄能让你感到愤怒的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"愤怒摘抄四" :
        this.current_note_markdown = `
   请在此摘抄能让你感到愤怒的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"愤怒摘抄五" :
        this.current_note_markdown = `
   请在此摘抄能让你感到愤怒的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"愤怒摘抄六" :
        this.current_note_markdown = `
   请在此摘抄能让你感到愤怒的段落
        `;
        
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"愤怒摘抄七" :
        this.current_note_markdown = `
   请在此摘抄能让你感到愤怒的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"愤怒摘抄八" :
        this.current_note_markdown = `
   请在此摘抄能让你感到愤怒的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"愤怒摘抄九" :
        this.current_note_markdown = `
   请在此摘抄能让你感到愤怒的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"愤怒摘抄十" :
        this.current_note_markdown = `
   请在此摘抄能让你感到愤怒的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;





//恐惧练习
case"恐惧练习一" :
this.current_note_markdown = `
请努力写出一个让人恐惧的段落
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"恐惧练习二" :
this.current_note_markdown = `
请努力写出一个让人恐惧的段落
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"恐惧练习三" :
this.current_note_markdown = `
请努力写出一个让人恐惧的段落
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"恐惧练习四" :
this.current_note_markdown = `
请努力写出一个让人恐惧的段落
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"恐惧练习五" :
this.current_note_markdown = `
请努力写出一个让人恐惧的段落
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"恐惧练习六" :
this.current_note_markdown = `
请努力写出一个让人恐惧的段落
`;


this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"恐惧练习七" :
this.current_note_markdown = `
请努力写出一个让人恐惧的段落
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"恐惧练习八" :
this.current_note_markdown = `
请努力写出一个让人恐惧的段落
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"恐惧练习九" :
this.current_note_markdown = `
请努力写出一个让人恐惧的段落
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"恐惧练习十" :
this.current_note_markdown = `
请努力写出一个让人恐惧的段落

`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;



 //恐惧分析
 case"恐惧分析一" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人恐惧


 `;
 if(localStorage.getItem("恐惧摘抄一")!=null){
   this.current_note_markdown+=localStorage.getItem("恐惧摘抄一");
 }
 else{
   this.current_note_markdown+=`
   但恐惧摘抄一还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"恐惧分析二" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人恐惧


 `;
 if(localStorage.getItem("恐惧摘抄二")!=null){
   this.current_note_markdown+=localStorage.getItem("恐惧摘抄二");
 }
 else{
   this.current_note_markdown+=`
   但恐惧摘抄二还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"恐惧分析三" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人恐惧


 `;
 if(localStorage.getItem("恐惧摘抄三")!=null){
   this.current_note_markdown+=localStorage.getItem("恐惧摘抄三");
 }
 else{
   this.current_note_markdown+=`
   但恐惧摘抄三还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"恐惧分析四" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人恐惧


 `;
 if(localStorage.getItem("恐惧摘抄四")!=null){
   this.current_note_markdown+=localStorage.getItem("恐惧摘抄四");
 }
 else{
   this.current_note_markdown+=`
   但恐惧摘抄四还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;


 case"恐惧分析五" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人恐惧


 `;
 if(localStorage.getItem("恐惧摘抄五")!=null){
   this.current_note_markdown+=localStorage.getItem("恐惧摘抄五");
 }
 else{
   this.current_note_markdown+=`
   但恐惧摘抄五还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"恐惧分析六" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人恐惧


 `;
 if(localStorage.getItem("恐惧摘抄六")!=null){
   this.current_note_markdown+=localStorage.getItem("恐惧摘抄六");
 }
 else{
   this.current_note_markdown+=`
   但恐惧摘抄六还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"恐惧分析七" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人恐惧


 `;
 if(localStorage.getItem("恐惧摘抄七")!=null){
   this.current_note_markdown+=localStorage.getItem("恐惧摘抄七");
 }
 else{
   this.current_note_markdown+=`
   但恐惧摘抄七还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"恐惧分析八" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人恐惧


 `;
 if(localStorage.getItem("恐惧摘抄八")!=null){
   this.current_note_markdown+=localStorage.getItem("恐惧摘抄八");
 }
 else{
   this.current_note_markdown+=`
   但恐惧摘抄八还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"恐惧分析九" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人恐惧


 `;
 if(localStorage.getItem("恐惧摘抄九")!=null){
   this.current_note_markdown+=localStorage.getItem("恐惧摘抄九");
 }
 else{
   this.current_note_markdown+=`
   但恐惧摘抄九还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"恐惧分析十" :
 this.current_note_markdown = `
请分析你摘抄过的段落，为什么会让人恐惧


 `;
 if(localStorage.getItem("恐惧摘抄十")!=null){
   this.current_note_markdown+=localStorage.getItem("恐惧摘抄十");
 }
 else{
   this.current_note_markdown+=`
   但恐惧摘抄十还没有完成。
         `;
 }

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;




        //恐惧摘抄
        case"恐惧摘抄一" :
        this.current_note_markdown = `
   请在此摘抄能让你感到恐惧的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"恐惧摘抄二" :
        this.current_note_markdown = `
   请在此摘抄能让你感到恐惧的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"恐惧摘抄三" :
        this.current_note_markdown = `
   请在此摘抄能让你感到恐惧的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"恐惧摘抄四" :
        this.current_note_markdown = `
   请在此摘抄能让你感到恐惧的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"恐惧摘抄五" :
        this.current_note_markdown = `
   请在此摘抄能让你感到恐惧的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"恐惧摘抄六" :
        this.current_note_markdown = `
   请在此摘抄能让你感到恐惧的段落
        `;
        
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"恐惧摘抄七" :
        this.current_note_markdown = `
   请在此摘抄能让你感到恐惧的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"恐惧摘抄八" :
        this.current_note_markdown = `
   请在此摘抄能让你感到恐惧的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"恐惧摘抄九" :
        this.current_note_markdown = `
   请在此摘抄能让你感到恐惧的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
   
        case"恐惧摘抄十" :
        this.current_note_markdown = `
   请在此摘抄能让你感到恐惧的段落
        `;
   
        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;



//英雄救美练习
case"英雄救美练习一" :
this.current_note_markdown = `
请自行设定背景，写出一个英雄救美套路
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"英雄救美练习二" :
this.current_note_markdown = `
请自行设定背景，写出一个英雄救美套路
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"英雄救美练习三" :
this.current_note_markdown = `
请自行设定背景，写出一个英雄救美套路
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"英雄救美练习四" :
this.current_note_markdown = `
请自行设定背景，写出一个英雄救美套路
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"英雄救美练习五" :
this.current_note_markdown = `
请自行设定背景，写出一个英雄救美套路
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"英雄救美练习六" :
this.current_note_markdown = `
请自行设定背景，写出一个英雄救美套路
`;


this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"英雄救美练习七" :
this.current_note_markdown = `
请自行设定背景，写出一个英雄救美套路
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"英雄救美练习八" :
this.current_note_markdown = `
请自行设定背景，写出一个英雄救美套路
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"英雄救美练习九" :
this.current_note_markdown = `
请自行设定背景，写出一个英雄救美套路
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"英雄救美练习十" :
this.current_note_markdown = `
请自行设定背景，写出一个英雄救美套路

`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;



     //英雄救美仿写
     case"英雄救美仿写一" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("英雄救美摘抄一")!=null){
       this.current_note_markdown+=localStorage.getItem("英雄救美摘抄一");
     }
     else{
       this.current_note_markdown+=`
       但英雄救美摘抄一还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"英雄救美仿写二" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("英雄救美摘抄二")!=null){
       this.current_note_markdown+=localStorage.getItem("英雄救美摘抄二");
     }
     else{
       this.current_note_markdown+=`
       但英雄救美摘抄二还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"英雄救美仿写三" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("英雄救美摘抄三")!=null){
       this.current_note_markdown+=localStorage.getItem("英雄救美摘抄三");
     }
     else{
       this.current_note_markdown+=`
       但英雄救美摘抄三还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"英雄救美仿写四" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("英雄救美摘抄四")!=null){
       this.current_note_markdown+=localStorage.getItem("英雄救美摘抄四");
     }
     else{
       this.current_note_markdown+=`
       但英雄救美摘抄四还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"英雄救美仿写五" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("英雄救美摘抄五")!=null){
       this.current_note_markdown+=localStorage.getItem("英雄救美摘抄五");
     }
     else{
       this.current_note_markdown+=`
       但英雄救美摘抄五还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"英雄救美仿写六" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("英雄救美摘抄六")!=null){
       this.current_note_markdown+=localStorage.getItem("英雄救美摘抄六");
     }
     else{
       this.current_note_markdown+=`
       但英雄救美摘抄六还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"英雄救美仿写七" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("英雄救美摘抄七")!=null){
       this.current_note_markdown+=localStorage.getItem("英雄救美摘抄七");
     }
     else{
       this.current_note_markdown+=`
       但英雄救美摘抄七还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"英雄救美仿写八" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("英雄救美摘抄八")!=null){
       this.current_note_markdown+=localStorage.getItem("英雄救美摘抄八");
     }
     else{
       this.current_note_markdown+=`
       但英雄救美摘抄八还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"英雄救美仿写九" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("英雄救美摘抄九")!=null){
       this.current_note_markdown+=localStorage.getItem("英雄救美摘抄九");
     }
     else{
       this.current_note_markdown+=`
       但英雄救美摘抄九还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"英雄救美仿写十" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("英雄救美摘抄十")!=null){
       this.current_note_markdown+=localStorage.getItem("英雄救美摘抄十");
     }
     else{
       this.current_note_markdown+=`
       但英雄救美摘抄十还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     //英雄救美摘抄
     case"英雄救美摘抄一" :
     this.current_note_markdown = `
请在此摘抄你看过的英雄救美套路
     `;

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"英雄救美摘抄二" :
     this.current_note_markdown = `
请在此摘抄你看过的英雄救美套路
     `;

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"英雄救美摘抄三" :
     this.current_note_markdown = `
请在此摘抄你看过的英雄救美套路
     `;

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"英雄救美摘抄四" :
     this.current_note_markdown = `
请在此摘抄你看过的英雄救美套路
     `;

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"英雄救美摘抄五" :
     this.current_note_markdown = `
请在此摘抄你看过的英雄救美套路
     `;

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"英雄救美摘抄六" :
     this.current_note_markdown = `
请在此摘抄你看过的英雄救美套路
     `;
     

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"英雄救美摘抄七" :
     this.current_note_markdown = `
请在此摘抄你看过的英雄救美套路
     `;

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"英雄救美摘抄八" :
     this.current_note_markdown = `
请在此摘抄你看过的英雄救美套路
     `;

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"英雄救美摘抄九" :
     this.current_note_markdown = `
请在此摘抄你看过的英雄救美套路
     `;

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"英雄救美摘抄十" :
     this.current_note_markdown = `
请在此摘抄你看过的英雄救美套路
     `;

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;




//打脸练习
case"打脸练习一" :
this.current_note_markdown = `
请自行设定背景，写出一个打脸套路
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"打脸练习二" :
this.current_note_markdown = `
请自行设定背景，写出一个打脸套路
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"打脸练习三" :
this.current_note_markdown = `
请自行设定背景，写出一个打脸套路
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"打脸练习四" :
this.current_note_markdown = `
请自行设定背景，写出一个打脸套路
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"打脸练习五" :
this.current_note_markdown = `
请自行设定背景，写出一个打脸套路
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"打脸练习六" :
this.current_note_markdown = `
请自行设定背景，写出一个打脸套路
`;


this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"打脸练习七" :
this.current_note_markdown = `
请自行设定背景，写出一个打脸套路
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"打脸练习八" :
this.current_note_markdown = `
请自行设定背景，写出一个打脸套路
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"打脸练习九" :
this.current_note_markdown = `
请自行设定背景，写出一个打脸套路
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"打脸练习十" :
this.current_note_markdown = `
请自行设定背景，写出一个打脸套路

`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;



     //打脸仿写
     case"打脸仿写一" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("打脸摘抄一")!=null){
       this.current_note_markdown+=localStorage.getItem("打脸摘抄一");
     }
     else{
       this.current_note_markdown+=`
       但打脸摘抄一还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"打脸仿写二" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("打脸摘抄二")!=null){
       this.current_note_markdown+=localStorage.getItem("打脸摘抄二");
     }
     else{
       this.current_note_markdown+=`
       但打脸摘抄二还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"打脸仿写三" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("打脸摘抄三")!=null){
       this.current_note_markdown+=localStorage.getItem("打脸摘抄三");
     }
     else{
       this.current_note_markdown+=`
       但打脸摘抄三还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"打脸仿写四" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("打脸摘抄四")!=null){
       this.current_note_markdown+=localStorage.getItem("打脸摘抄四");
     }
     else{
       this.current_note_markdown+=`
       但打脸摘抄四还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"打脸仿写五" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("打脸摘抄五")!=null){
       this.current_note_markdown+=localStorage.getItem("打脸摘抄五");
     }
     else{
       this.current_note_markdown+=`
       但打脸摘抄五还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"打脸仿写六" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("打脸摘抄六")!=null){
       this.current_note_markdown+=localStorage.getItem("打脸摘抄六");
     }
     else{
       this.current_note_markdown+=`
       但打脸摘抄六还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"打脸仿写七" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("打脸摘抄七")!=null){
       this.current_note_markdown+=localStorage.getItem("打脸摘抄七");
     }
     else{
       this.current_note_markdown+=`
       但打脸摘抄七还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"打脸仿写八" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("打脸摘抄八")!=null){
       this.current_note_markdown+=localStorage.getItem("打脸摘抄八");
     }
     else{
       this.current_note_markdown+=`
       但打脸摘抄八还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"打脸仿写九" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("打脸摘抄九")!=null){
       this.current_note_markdown+=localStorage.getItem("打脸摘抄九");
     }
     else{
       this.current_note_markdown+=`
       但打脸摘抄九还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"打脸仿写十" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("打脸摘抄十")!=null){
       this.current_note_markdown+=localStorage.getItem("打脸摘抄十");
     }
     else{
       this.current_note_markdown+=`
       但打脸摘抄十还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     //打脸摘抄
     case"打脸摘抄一" :
     this.current_note_markdown = `
请在此摘抄你看过的打脸套路
     `;

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"打脸摘抄二" :
     this.current_note_markdown = `
请在此摘抄你看过的打脸套路
     `;

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"打脸摘抄三" :
     this.current_note_markdown = `
请在此摘抄你看过的打脸套路
     `;

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"打脸摘抄四" :
     this.current_note_markdown = `
请在此摘抄你看过的打脸套路
     `;

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"打脸摘抄五" :
     this.current_note_markdown = `
请在此摘抄你看过的打脸套路
     `;

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"打脸摘抄六" :
     this.current_note_markdown = `
请在此摘抄你看过的打脸套路
     `;
     

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"打脸摘抄七" :
     this.current_note_markdown = `
请在此摘抄你看过的打脸套路
     `;

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"打脸摘抄八" :
     this.current_note_markdown = `
请在此摘抄你看过的打脸套路
     `;

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"打脸摘抄九" :
     this.current_note_markdown = `
请在此摘抄你看过的打脸套路
     `;

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"打脸摘抄十" :
     this.current_note_markdown = `
请在此摘抄你看过的打脸套路
     `;

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;




//获得练习
case"获得练习一" :
this.current_note_markdown = `
请自行设定背景，写出一个获得套路
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"获得练习二" :
this.current_note_markdown = `
请自行设定背景，写出一个获得套路
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"获得练习三" :
this.current_note_markdown = `
请自行设定背景，写出一个获得套路
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"获得练习四" :
this.current_note_markdown = `
请自行设定背景，写出一个获得套路
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"获得练习五" :
this.current_note_markdown = `
请自行设定背景，写出一个获得套路
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"获得练习六" :
this.current_note_markdown = `
请自行设定背景，写出一个获得套路
`;


this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"获得练习七" :
this.current_note_markdown = `
请自行设定背景，写出一个获得套路
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"获得练习八" :
this.current_note_markdown = `
请自行设定背景，写出一个获得套路
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"获得练习九" :
this.current_note_markdown = `
请自行设定背景，写出一个获得套路
`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"获得练习十" :
this.current_note_markdown = `
请自行设定背景，写出一个获得套路

`;

this.is_title = 1;
if( this.view_type == 2 ) this.view_type = 3;
break;



     //获得仿写
     case"获得仿写一" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("获得摘抄一")!=null){
       this.current_note_markdown+=localStorage.getItem("获得摘抄一");
     }
     else{
       this.current_note_markdown+=`
       但获得摘抄一还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"获得仿写二" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("获得摘抄二")!=null){
       this.current_note_markdown+=localStorage.getItem("获得摘抄二");
     }
     else{
       this.current_note_markdown+=`
       但获得摘抄二还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"获得仿写三" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("获得摘抄三")!=null){
       this.current_note_markdown+=localStorage.getItem("获得摘抄三");
     }
     else{
       this.current_note_markdown+=`
       但获得摘抄三还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"获得仿写四" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("获得摘抄四")!=null){
       this.current_note_markdown+=localStorage.getItem("获得摘抄四");
     }
     else{
       this.current_note_markdown+=`
       但获得摘抄四还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"获得仿写五" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("获得摘抄五")!=null){
       this.current_note_markdown+=localStorage.getItem("获得摘抄五");
     }
     else{
       this.current_note_markdown+=`
       但获得摘抄五还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"获得仿写六" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("获得摘抄六")!=null){
       this.current_note_markdown+=localStorage.getItem("获得摘抄六");
     }
     else{
       this.current_note_markdown+=`
       但获得摘抄六还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"获得仿写七" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("获得摘抄七")!=null){
       this.current_note_markdown+=localStorage.getItem("获得摘抄七");
     }
     else{
       this.current_note_markdown+=`
       但获得摘抄七还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"获得仿写八" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("获得摘抄八")!=null){
       this.current_note_markdown+=localStorage.getItem("获得摘抄八");
     }
     else{
       this.current_note_markdown+=`
       但获得摘抄八还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"获得仿写九" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("获得摘抄九")!=null){
       this.current_note_markdown+=localStorage.getItem("获得摘抄九");
     }
     else{
       this.current_note_markdown+=`
       但获得摘抄九还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"获得仿写十" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("获得摘抄十")!=null){
       this.current_note_markdown+=localStorage.getItem("获得摘抄十");
     }
     else{
       this.current_note_markdown+=`
       但获得摘抄十还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     //获得摘抄
     case"获得摘抄一" :
     this.current_note_markdown = `
请在此摘抄你看过的获得套路
     `;

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"获得摘抄二" :
     this.current_note_markdown = `
请在此摘抄你看过的获得套路
     `;

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"获得摘抄三" :
     this.current_note_markdown = `
请在此摘抄你看过的获得套路
     `;

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"获得摘抄四" :
     this.current_note_markdown = `
请在此摘抄你看过的获得套路
     `;

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"获得摘抄五" :
     this.current_note_markdown = `
请在此摘抄你看过的获得套路
     `;

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"获得摘抄六" :
     this.current_note_markdown = `
请在此摘抄你看过的获得套路
     `;
     

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"获得摘抄七" :
     this.current_note_markdown = `
请在此摘抄你看过的获得套路
     `;

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"获得摘抄八" :
     this.current_note_markdown = `
请在此摘抄你看过的获得套路
     `;

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"获得摘抄九" :
     this.current_note_markdown = `
请在此摘抄你看过的获得套路
     `;

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"获得摘抄十" :
     this.current_note_markdown = `
请在此摘抄你看过的获得套路
     `;

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;



 //显摆练习
 case"显摆练习一" :
 this.current_note_markdown = `
请自行设定背景，写出一个显摆套路
 `;

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"显摆练习二" :
 this.current_note_markdown = `
请自行设定背景，写出一个显摆套路
 `;

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"显摆练习三" :
 this.current_note_markdown = `
请自行设定背景，写出一个显摆套路
 `;

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"显摆练习四" :
 this.current_note_markdown = `
请自行设定背景，写出一个显摆套路
 `;

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"显摆练习五" :
 this.current_note_markdown = `
请自行设定背景，写出一个显摆套路
 `;

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"显摆练习六" :
 this.current_note_markdown = `
请自行设定背景，写出一个显摆套路
 `;
 

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"显摆练习七" :
 this.current_note_markdown = `
请自行设定背景，写出一个显摆套路
 `;

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"显摆练习八" :
 this.current_note_markdown = `
请自行设定背景，写出一个显摆套路
 `;

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"显摆练习九" :
 this.current_note_markdown = `
请自行设定背景，写出一个显摆套路
 `;

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"显摆练习十" :
 this.current_note_markdown = `
请自行设定背景，写出一个显摆套路

 `;

 this.is_title = 1;
 if( this.view_type == 2 ) this.view_type = 3;
 break;



      //显摆仿写
      case"显摆仿写一" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("显摆摘抄一")!=null){
        this.current_note_markdown+=localStorage.getItem("显摆摘抄一");
      }
      else{
        this.current_note_markdown+=`
        但显摆摘抄一还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"显摆仿写二" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("显摆摘抄二")!=null){
        this.current_note_markdown+=localStorage.getItem("显摆摘抄二");
      }
      else{
        this.current_note_markdown+=`
        但显摆摘抄二还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"显摆仿写三" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("显摆摘抄三")!=null){
        this.current_note_markdown+=localStorage.getItem("显摆摘抄三");
      }
      else{
        this.current_note_markdown+=`
        但显摆摘抄三还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"显摆仿写四" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("显摆摘抄四")!=null){
        this.current_note_markdown+=localStorage.getItem("显摆摘抄四");
      }
      else{
        this.current_note_markdown+=`
        但显摆摘抄四还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"显摆仿写五" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("显摆摘抄五")!=null){
        this.current_note_markdown+=localStorage.getItem("显摆摘抄五");
      }
      else{
        this.current_note_markdown+=`
        但显摆摘抄五还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"显摆仿写六" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("显摆摘抄六")!=null){
        this.current_note_markdown+=localStorage.getItem("显摆摘抄六");
      }
      else{
        this.current_note_markdown+=`
        但显摆摘抄六还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"显摆仿写七" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("显摆摘抄七")!=null){
        this.current_note_markdown+=localStorage.getItem("显摆摘抄七");
      }
      else{
        this.current_note_markdown+=`
        但显摆摘抄七还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"显摆仿写八" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("显摆摘抄八")!=null){
        this.current_note_markdown+=localStorage.getItem("显摆摘抄八");
      }
      else{
        this.current_note_markdown+=`
        但显摆摘抄八还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"显摆仿写九" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("显摆摘抄九")!=null){
        this.current_note_markdown+=localStorage.getItem("显摆摘抄九");
      }
      else{
        this.current_note_markdown+=`
        但显摆摘抄九还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"显摆仿写十" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("显摆摘抄十")!=null){
        this.current_note_markdown+=localStorage.getItem("显摆摘抄十");
      }
      else{
        this.current_note_markdown+=`
        但显摆摘抄十还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      //显摆摘抄
      case"显摆摘抄一" :
      this.current_note_markdown = `
请在此摘抄你看过的显摆套路
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"显摆摘抄二" :
      this.current_note_markdown = `
请在此摘抄你看过的显摆套路
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"显摆摘抄三" :
      this.current_note_markdown = `
请在此摘抄你看过的显摆套路
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"显摆摘抄四" :
      this.current_note_markdown = `
请在此摘抄你看过的显摆套路
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"显摆摘抄五" :
      this.current_note_markdown = `
请在此摘抄你看过的显摆套路
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"显摆摘抄六" :
      this.current_note_markdown = `
请在此摘抄你看过的显摆套路
      `;
      

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"显摆摘抄七" :
      this.current_note_markdown = `
请在此摘抄你看过的显摆套路
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"显摆摘抄八" :
      this.current_note_markdown = `
请在此摘抄你看过的显摆套路
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"显摆摘抄九" :
      this.current_note_markdown = `
请在此摘抄你看过的显摆套路
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"显摆摘抄十" :
      this.current_note_markdown = `
请在此摘抄你看过的显摆套路
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


   //扣押练习
   case"扣押练习一" :
   this.current_note_markdown = `
请更改你写过的事件，把可以扣押的信息都扣住，并且计划一下什么时候放出来


   `;
   if(localStorage.getItem("事件写作一")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作一");
   }
   else{
     this.current_note_markdown+=`
     但事件写作一还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"扣押练习二" :
   this.current_note_markdown = `
请更改你写过的事件，把可以扣押的信息都扣住，并且计划一下什么时候放出来


   `;
   if(localStorage.getItem("事件写作二")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作二");
   }
   else{
     this.current_note_markdown+=`
     但事件写作二还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"扣押练习三" :
   this.current_note_markdown = `
请更改你写过的事件，把可以扣押的信息都扣住，并且计划一下什么时候放出来


   `;
   if(localStorage.getItem("事件写作三")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作三");
   }
   else{
     this.current_note_markdown+=`
     但事件写作三还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"扣押练习四" :
   this.current_note_markdown = `
请更改你写过的事件，把可以扣押的信息都扣住，并且计划一下什么时候放出来


   `;
   if(localStorage.getItem("事件写作四")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作四");
   }
   else{
     this.current_note_markdown+=`
     但事件写作四还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;


   case"扣押练习五" :
   this.current_note_markdown = `
请更改你写过的事件，把可以扣押的信息都扣住，并且计划一下什么时候放出来


   `;
   if(localStorage.getItem("事件写作五")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作五");
   }
   else{
     this.current_note_markdown+=`
     但事件写作五还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"扣押练习六" :
   this.current_note_markdown = `
请更改你写过的事件，把可以扣押的信息都扣住，并且计划一下什么时候放出来


   `;
   if(localStorage.getItem("事件写作六")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作六");
   }
   else{
     this.current_note_markdown+=`
     但事件写作六还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"扣押练习七" :
   this.current_note_markdown = `
请更改你写过的事件，把可以扣押的信息都扣住，并且计划一下什么时候放出来


   `;
   if(localStorage.getItem("事件写作七")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作七");
   }
   else{
     this.current_note_markdown+=`
     但事件写作七还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"扣押练习八" :
   this.current_note_markdown = `
请更改你写过的事件，把可以扣押的信息都扣住，并且计划一下什么时候放出来


   `;
   if(localStorage.getItem("事件写作八")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作八");
   }
   else{
     this.current_note_markdown+=`
     但事件写作八还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"扣押练习九" :
   this.current_note_markdown = `
请更改你写过的事件，把可以扣押的信息都扣住，并且计划一下什么时候放出来


   `;
   if(localStorage.getItem("事件写作九")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作九");
   }
   else{
     this.current_note_markdown+=`
     但事件写作九还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"扣押练习十" :
   this.current_note_markdown = `
请更改你写过的事件，把可以扣押的信息都扣住，并且计划一下什么时候放出来


   `;
   if(localStorage.getItem("事件写作十")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作十");
   }
   else{
     this.current_note_markdown+=`
     但事件写作十还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;





   //鸿沟练习
   case"鸿沟练习一" :
   this.current_note_markdown = `
请更改你写过的事件，让它的每个节拍都裂开鸿沟


   `;
   if(localStorage.getItem("事件写作一")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作一");
   }
   else{
     this.current_note_markdown+=`
     但事件写作一还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"鸿沟练习二" :
   this.current_note_markdown = `
请更改你写过的事件，让它的每个节拍都裂开鸿沟


   `;
   if(localStorage.getItem("事件写作二")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作二");
   }
   else{
     this.current_note_markdown+=`
     但事件写作二还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"鸿沟练习三" :
   this.current_note_markdown = `
请更改你写过的事件，让它的每个节拍都裂开鸿沟


   `;
   if(localStorage.getItem("事件写作三")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作三");
   }
   else{
     this.current_note_markdown+=`
     但事件写作三还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"鸿沟练习四" :
   this.current_note_markdown = `
请更改你写过的事件，让它的每个节拍都裂开鸿沟


   `;
   if(localStorage.getItem("事件写作四")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作四");
   }
   else{
     this.current_note_markdown+=`
     但事件写作四还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;


   case"鸿沟练习五" :
   this.current_note_markdown = `
请更改你写过的事件，让它的每个节拍都裂开鸿沟


   `;
   if(localStorage.getItem("事件写作五")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作五");
   }
   else{
     this.current_note_markdown+=`
     但事件写作五还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"鸿沟练习六" :
   this.current_note_markdown = `
请更改你写过的事件，让它的每个节拍都裂开鸿沟


   `;
   if(localStorage.getItem("事件写作六")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作六");
   }
   else{
     this.current_note_markdown+=`
     但事件写作六还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"鸿沟练习七" :
   this.current_note_markdown = `
请更改你写过的事件，让它的每个节拍都裂开鸿沟


   `;
   if(localStorage.getItem("事件写作七")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作七");
   }
   else{
     this.current_note_markdown+=`
     但事件写作七还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"鸿沟练习八" :
   this.current_note_markdown = `
请更改你写过的事件，让它的每个节拍都裂开鸿沟


   `;
   if(localStorage.getItem("事件写作八")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作八");
   }
   else{
     this.current_note_markdown+=`
     但事件写作八还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"鸿沟练习九" :
   this.current_note_markdown = `
请更改你写过的事件，让它的每个节拍都裂开鸿沟


   `;
   if(localStorage.getItem("事件写作九")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作九");
   }
   else{
     this.current_note_markdown+=`
     但事件写作九还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"鸿沟练习十" :
   this.current_note_markdown = `
请更改你写过的事件，让它的每个节拍都裂开鸿沟


   `;
   if(localStorage.getItem("事件写作十")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作十");
   }
   else{
     this.current_note_markdown+=`
     但事件写作十还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;




   //鸿沟分析
   case"鸿沟分析一" :
   this.current_note_markdown = `
请分析你写过的事件，它的节拍如何，节拍之间有没有列开鸿沟


   `;
   if(localStorage.getItem("事件写作一")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作一");
   }
   else{
     this.current_note_markdown+=`
     但事件写作一还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"鸿沟分析二" :
   this.current_note_markdown = `
请分析你写过的事件，它的节拍如何，节拍之间有没有列开鸿沟


   `;
   if(localStorage.getItem("事件写作二")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作二");
   }
   else{
     this.current_note_markdown+=`
     但事件写作二还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"鸿沟分析三" :
   this.current_note_markdown = `
请分析你写过的事件，它的节拍如何，节拍之间有没有列开鸿沟


   `;
   if(localStorage.getItem("事件写作三")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作三");
   }
   else{
     this.current_note_markdown+=`
     但事件写作三还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"鸿沟分析四" :
   this.current_note_markdown = `
请分析你写过的事件，它的节拍如何，节拍之间有没有列开鸿沟


   `;
   if(localStorage.getItem("事件写作四")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作四");
   }
   else{
     this.current_note_markdown+=`
     但事件写作四还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;


   case"鸿沟分析五" :
   this.current_note_markdown = `
请分析你写过的事件，它的节拍如何，节拍之间有没有列开鸿沟


   `;
   if(localStorage.getItem("事件写作五")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作五");
   }
   else{
     this.current_note_markdown+=`
     但事件写作五还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"鸿沟分析六" :
   this.current_note_markdown = `
请分析你写过的事件，它的节拍如何，节拍之间有没有列开鸿沟


   `;
   if(localStorage.getItem("事件写作六")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作六");
   }
   else{
     this.current_note_markdown+=`
     但事件写作六还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"鸿沟分析七" :
   this.current_note_markdown = `
请分析你写过的事件，它的节拍如何，节拍之间有没有列开鸿沟


   `;
   if(localStorage.getItem("事件写作七")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作七");
   }
   else{
     this.current_note_markdown+=`
     但事件写作七还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"鸿沟分析八" :
   this.current_note_markdown = `
请分析你写过的事件，它的节拍如何，节拍之间有没有列开鸿沟


   `;
   if(localStorage.getItem("事件写作八")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作八");
   }
   else{
     this.current_note_markdown+=`
     但事件写作八还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"鸿沟分析九" :
   this.current_note_markdown = `
请分析你写过的事件，它的节拍如何，节拍之间有没有列开鸿沟


   `;
   if(localStorage.getItem("事件写作九")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作九");
   }
   else{
     this.current_note_markdown+=`
     但事件写作九还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"鸿沟分析十" :
   this.current_note_markdown = `
请分析你写过的事件，它的节拍如何，节拍之间有没有列开鸿沟


   `;
   if(localStorage.getItem("事件写作十")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作十");
   }
   else{
     this.current_note_markdown+=`
     但事件写作十还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;


   //节奏设置
   case"节奏设置一" :
   this.current_note_markdown = `
请更改你归纳过的故事线，让它在故事节奏上更和谐。然后将它写成故事，注意把握故事节奏


   `;
   if(localStorage.getItem("故事线归纳一")!=null){
     this.current_note_markdown+=localStorage.getItem("故事线归纳一");
   }
   else{
     this.current_note_markdown+=`
     但故事线归纳一还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"节奏设置二" :
   this.current_note_markdown = `
请更改你归纳过的故事线，让它在故事节奏上更和谐。然后将它写成故事，注意把握故事节奏


   `;
   if(localStorage.getItem("故事线归纳二")!=null){
     this.current_note_markdown+=localStorage.getItem("故事线归纳二");
   }
   else{
     this.current_note_markdown+=`
     但故事线归纳二还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"节奏设置三" :
   this.current_note_markdown = `
请更改你归纳过的故事线，让它在故事节奏上更和谐。然后将它写成故事，注意把握故事节奏


   `;
   if(localStorage.getItem("故事线归纳三")!=null){
     this.current_note_markdown+=localStorage.getItem("故事线归纳三");
   }
   else{
     this.current_note_markdown+=`
     但故事线归纳三还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"节奏设置四" :
   this.current_note_markdown = `
请更改你归纳过的故事线，让它在故事节奏上更和谐。然后将它写成故事，注意把握故事节奏


   `;
   if(localStorage.getItem("故事线归纳四")!=null){
     this.current_note_markdown+=localStorage.getItem("故事线归纳四");
   }
   else{
     this.current_note_markdown+=`
     但故事线归纳四还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;


   case"节奏设置五" :
   this.current_note_markdown = `
请更改你归纳过的故事线，让它在故事节奏上更和谐。然后将它写成故事，注意把握故事节奏


   `;
   if(localStorage.getItem("故事线归纳五")!=null){
     this.current_note_markdown+=localStorage.getItem("故事线归纳五");
   }
   else{
     this.current_note_markdown+=`
     但故事线归纳五还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"节奏设置六" :
   this.current_note_markdown = `
请更改你归纳过的故事线，让它在故事节奏上更和谐。然后将它写成故事，注意把握故事节奏


   `;
   if(localStorage.getItem("故事线归纳六")!=null){
     this.current_note_markdown+=localStorage.getItem("故事线归纳六");
   }
   else{
     this.current_note_markdown+=`
     但故事线归纳六还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"节奏设置七" :
   this.current_note_markdown = `
请更改你归纳过的故事线，让它在故事节奏上更和谐。然后将它写成故事，注意把握故事节奏


   `;
   if(localStorage.getItem("故事线归纳七")!=null){
     this.current_note_markdown+=localStorage.getItem("故事线归纳七");
   }
   else{
     this.current_note_markdown+=`
     但故事线归纳七还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"节奏设置八" :
   this.current_note_markdown = `
请更改你归纳过的故事线，让它在故事节奏上更和谐。然后将它写成故事，注意把握故事节奏


   `;
   if(localStorage.getItem("故事线归纳八")!=null){
     this.current_note_markdown+=localStorage.getItem("故事线归纳八");
   }
   else{
     this.current_note_markdown+=`
     但故事线归纳八还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"节奏设置九" :
   this.current_note_markdown = `
请更改你归纳过的故事线，让它在故事节奏上更和谐。然后将它写成故事，注意把握故事节奏


   `;
   if(localStorage.getItem("故事线归纳九")!=null){
     this.current_note_markdown+=localStorage.getItem("故事线归纳九");
   }
   else{
     this.current_note_markdown+=`
     但故事线归纳九还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"节奏设置十" :
   this.current_note_markdown = `
请更改你归纳过的故事线，让它在故事节奏上更和谐。然后将它写成故事，注意把握故事节奏


   `;
   if(localStorage.getItem("故事线归纳十")!=null){
     this.current_note_markdown+=localStorage.getItem("故事线归纳十");
   }
   else{
     this.current_note_markdown+=`
     但故事线归纳十还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;


   //节奏分析
   case"节奏分析一" :
   this.current_note_markdown = `
请分析你归纳过的故事线，它故事线的节奏如何？故事线写成故事后的节奏又如何？


   `;
   if(localStorage.getItem("故事线归纳一")!=null){
     this.current_note_markdown+=localStorage.getItem("故事线归纳一");
   }
   else{
     this.current_note_markdown+=`
     但故事线归纳一还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"节奏分析二" :
   this.current_note_markdown = `
请分析你归纳过的故事线，它故事线的节奏如何？故事线写成故事后的节奏又如何？


   `;
   if(localStorage.getItem("故事线归纳二")!=null){
     this.current_note_markdown+=localStorage.getItem("故事线归纳二");
   }
   else{
     this.current_note_markdown+=`
     但故事线归纳二还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"节奏分析三" :
   this.current_note_markdown = `
请分析你归纳过的故事线，它故事线的节奏如何？故事线写成故事后的节奏又如何？


   `;
   if(localStorage.getItem("故事线归纳三")!=null){
     this.current_note_markdown+=localStorage.getItem("故事线归纳三");
   }
   else{
     this.current_note_markdown+=`
     但故事线归纳三还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"节奏分析四" :
   this.current_note_markdown = `
请分析你归纳过的故事线，它故事线的节奏如何？故事线写成故事后的节奏又如何？


   `;
   if(localStorage.getItem("故事线归纳四")!=null){
     this.current_note_markdown+=localStorage.getItem("故事线归纳四");
   }
   else{
     this.current_note_markdown+=`
     但故事线归纳四还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;


   case"节奏分析五" :
   this.current_note_markdown = `
请分析你归纳过的故事线，它故事线的节奏如何？故事线写成故事后的节奏又如何？


   `;
   if(localStorage.getItem("故事线归纳五")!=null){
     this.current_note_markdown+=localStorage.getItem("故事线归纳五");
   }
   else{
     this.current_note_markdown+=`
     但故事线归纳五还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"节奏分析六" :
   this.current_note_markdown = `
请分析你归纳过的故事线，它故事线的节奏如何？故事线写成故事后的节奏又如何？


   `;
   if(localStorage.getItem("故事线归纳六")!=null){
     this.current_note_markdown+=localStorage.getItem("故事线归纳六");
   }
   else{
     this.current_note_markdown+=`
     但故事线归纳六还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"节奏分析七" :
   this.current_note_markdown = `
请分析你归纳过的故事线，它故事线的节奏如何？故事线写成故事后的节奏又如何？


   `;
   if(localStorage.getItem("故事线归纳七")!=null){
     this.current_note_markdown+=localStorage.getItem("故事线归纳七");
   }
   else{
     this.current_note_markdown+=`
     但故事线归纳七还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"节奏分析八" :
   this.current_note_markdown = `
请分析你归纳过的故事线，它故事线的节奏如何？故事线写成故事后的节奏又如何？


   `;
   if(localStorage.getItem("故事线归纳八")!=null){
     this.current_note_markdown+=localStorage.getItem("故事线归纳八");
   }
   else{
     this.current_note_markdown+=`
     但故事线归纳八还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"节奏分析九" :
   this.current_note_markdown = `
请分析你归纳过的故事线，它故事线的节奏如何？故事线写成故事后的节奏又如何？


   `;
   if(localStorage.getItem("故事线归纳九")!=null){
     this.current_note_markdown+=localStorage.getItem("故事线归纳九");
   }
   else{
     this.current_note_markdown+=`
     但故事线归纳九还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"节奏分析十" :
   this.current_note_markdown = `
请分析你归纳过的故事线，它故事线的节奏如何？故事线写成故事后的节奏又如何？


   `;
   if(localStorage.getItem("故事线归纳十")!=null){
     this.current_note_markdown+=localStorage.getItem("故事线归纳十");
   }
   else{
     this.current_note_markdown+=`
     但故事线归纳十还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;



      //悬疑练习
      case"悬疑练习一" :
      this.current_note_markdown = `
请自己尝试写出一个悬疑
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"悬疑练习二" :
      this.current_note_markdown = `
请自己尝试写出一个悬疑
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"悬疑练习三" :
      this.current_note_markdown = `
请自己尝试写出一个悬疑
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"悬疑练习四" :
      this.current_note_markdown = `
请自己尝试写出一个悬疑
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"悬疑练习五" :
      this.current_note_markdown = `
请自己尝试写出一个悬疑
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"悬疑练习六" :
      this.current_note_markdown = `
请自己尝试写出一个悬疑
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"悬疑练习七" :
      this.current_note_markdown = `
请自己尝试写出一个悬疑
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"悬疑练习八" :
      this.current_note_markdown = `
请自己尝试写出一个悬疑
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"悬疑练习九" :
      this.current_note_markdown = `
请自己尝试写出一个悬疑
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"悬疑练习十" :
      this.current_note_markdown = `
请自己尝试写出一个悬疑
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


   //悬疑分析
   case"悬疑分析一" :
   this.current_note_markdown = `
请分析你摘抄的悬疑，它带来了怎样的效果，效果明显吗？有办法增强它的效果吗？能拉长悬的时间吗？


   `;
   if(localStorage.getItem("悬疑摘抄一")!=null){
     this.current_note_markdown+=localStorage.getItem("悬疑摘抄一");
   }
   else{
     this.current_note_markdown+=`
     但悬疑摘抄一还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"悬疑分析二" :
   this.current_note_markdown = `
请分析你摘抄的悬疑，它带来了怎样的效果，效果明显吗？有办法增强它的效果吗？能拉长悬的时间吗？


   `;
   if(localStorage.getItem("悬疑摘抄二")!=null){
     this.current_note_markdown+=localStorage.getItem("悬疑摘抄二");
   }
   else{
     this.current_note_markdown+=`
     但悬疑摘抄二还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"悬疑分析三" :
   this.current_note_markdown = `
请分析你摘抄的悬疑，它带来了怎样的效果，效果明显吗？有办法增强它的效果吗？能拉长悬的时间吗？


   `;
   if(localStorage.getItem("悬疑摘抄三")!=null){
     this.current_note_markdown+=localStorage.getItem("悬疑摘抄三");
   }
   else{
     this.current_note_markdown+=`
     但悬疑摘抄三还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"悬疑分析四" :
   this.current_note_markdown = `
请分析你摘抄的悬疑，它带来了怎样的效果，效果明显吗？有办法增强它的效果吗？能拉长悬的时间吗？


   `;
   if(localStorage.getItem("悬疑摘抄四")!=null){
     this.current_note_markdown+=localStorage.getItem("悬疑摘抄四");
   }
   else{
     this.current_note_markdown+=`
     但悬疑摘抄四还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;


   case"悬疑分析五" :
   this.current_note_markdown = `
请分析你摘抄的悬疑，它带来了怎样的效果，效果明显吗？有办法增强它的效果吗？能拉长悬的时间吗？


   `;
   if(localStorage.getItem("悬疑摘抄五")!=null){
     this.current_note_markdown+=localStorage.getItem("悬疑摘抄五");
   }
   else{
     this.current_note_markdown+=`
     但悬疑摘抄五还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"悬疑分析六" :
   this.current_note_markdown = `
请分析你摘抄的悬疑，它带来了怎样的效果，效果明显吗？有办法增强它的效果吗？能拉长悬的时间吗？


   `;
   if(localStorage.getItem("悬疑摘抄六")!=null){
     this.current_note_markdown+=localStorage.getItem("悬疑摘抄六");
   }
   else{
     this.current_note_markdown+=`
     但悬疑摘抄六还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"悬疑分析七" :
   this.current_note_markdown = `
请分析你摘抄的悬疑，它带来了怎样的效果，效果明显吗？有办法增强它的效果吗？能拉长悬的时间吗？


   `;
   if(localStorage.getItem("悬疑摘抄七")!=null){
     this.current_note_markdown+=localStorage.getItem("悬疑摘抄七");
   }
   else{
     this.current_note_markdown+=`
     但悬疑摘抄七还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"悬疑分析八" :
   this.current_note_markdown = `
请分析你摘抄的悬疑，它带来了怎样的效果，效果明显吗？有办法增强它的效果吗？能拉长悬的时间吗？


   `;
   if(localStorage.getItem("悬疑摘抄八")!=null){
     this.current_note_markdown+=localStorage.getItem("悬疑摘抄八");
   }
   else{
     this.current_note_markdown+=`
     但悬疑摘抄八还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"悬疑分析九" :
   this.current_note_markdown = `
请分析你摘抄的悬疑，它带来了怎样的效果，效果明显吗？有办法增强它的效果吗？能拉长悬的时间吗？


   `;
   if(localStorage.getItem("悬疑摘抄九")!=null){
     this.current_note_markdown+=localStorage.getItem("悬疑摘抄九");
   }
   else{
     this.current_note_markdown+=`
     但悬疑摘抄九还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"悬疑分析十" :
   this.current_note_markdown = `
请分析你摘抄的悬疑，它带来了怎样的效果，效果明显吗？有办法增强它的效果吗？能拉长悬的时间吗？


   `;
   if(localStorage.getItem("悬疑摘抄十")!=null){
     this.current_note_markdown+=localStorage.getItem("悬疑摘抄十");
   }
   else{
     this.current_note_markdown+=`
     但悬疑摘抄十还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;


      //悬疑摘抄
      case"悬疑摘抄一" :
      this.current_note_markdown = `
请在此摘抄你在小说中看到过的悬疑
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"悬疑摘抄二" :
      this.current_note_markdown = `
请在此摘抄你在小说中看到过的悬疑
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"悬疑摘抄三" :
      this.current_note_markdown = `
请在此摘抄你在小说中看到过的悬疑
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"悬疑摘抄四" :
      this.current_note_markdown = `
请在此摘抄你在小说中看到过的悬疑
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"悬疑摘抄五" :
      this.current_note_markdown = `
请在此摘抄你在小说中看到过的悬疑
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"悬疑摘抄六" :
      this.current_note_markdown = `
请在此摘抄你在小说中看到过的悬疑
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"悬疑摘抄七" :
      this.current_note_markdown = `
请在此摘抄你在小说中看到过的悬疑
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"悬疑摘抄八" :
      this.current_note_markdown = `
请在此摘抄你在小说中看到过的悬疑
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"悬疑摘抄九" :
      this.current_note_markdown = `
请在此摘抄你在小说中看到过的悬疑
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"悬疑摘抄十" :
      this.current_note_markdown = `
请在此摘抄你在小说中看到过的悬疑
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;



      //反常练习
      case"反常练习一" :
      this.current_note_markdown = `
请自己尝试写出一个反常
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"反常练习二" :
      this.current_note_markdown = `
请自己尝试写出一个反常
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"反常练习三" :
      this.current_note_markdown = `
请自己尝试写出一个反常
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"反常练习四" :
      this.current_note_markdown = `
请自己尝试写出一个反常
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"反常练习五" :
      this.current_note_markdown = `
请自己尝试写出一个反常
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"反常练习六" :
      this.current_note_markdown = `
请自己尝试写出一个反常
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"反常练习七" :
      this.current_note_markdown = `
请自己尝试写出一个反常
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"反常练习八" :
      this.current_note_markdown = `
请自己尝试写出一个反常
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"反常练习九" :
      this.current_note_markdown = `
请自己尝试写出一个反常
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"反常练习十" :
      this.current_note_markdown = `
请自己尝试写出一个反常
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;



   //反常分析
   case"反常分析一" :
   this.current_note_markdown = `
请分析你摘抄的反常，它是哪种反常，带来了怎么样的效果，效果明显吗？有办法增加它的效果吗


   `;
   if(localStorage.getItem("反常摘抄一")!=null){
     this.current_note_markdown+=localStorage.getItem("反常摘抄一");
   }
   else{
     this.current_note_markdown+=`
     但反常摘抄一还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"反常分析二" :
   this.current_note_markdown = `
请分析你摘抄的反常，它是哪种反常，带来了怎么样的效果，效果明显吗？有办法增加它的效果吗


   `;
   if(localStorage.getItem("反常摘抄二")!=null){
     this.current_note_markdown+=localStorage.getItem("反常摘抄二");
   }
   else{
     this.current_note_markdown+=`
     但反常摘抄二还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"反常分析三" :
   this.current_note_markdown = `
请分析你摘抄的反常，它是哪种反常，带来了怎么样的效果，效果明显吗？有办法增加它的效果吗


   `;
   if(localStorage.getItem("反常摘抄三")!=null){
     this.current_note_markdown+=localStorage.getItem("反常摘抄三");
   }
   else{
     this.current_note_markdown+=`
     但反常摘抄三还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"反常分析四" :
   this.current_note_markdown = `
请分析你摘抄的反常，它是哪种反常，带来了怎么样的效果，效果明显吗？有办法增加它的效果吗


   `;
   if(localStorage.getItem("反常摘抄四")!=null){
     this.current_note_markdown+=localStorage.getItem("反常摘抄四");
   }
   else{
     this.current_note_markdown+=`
     但反常摘抄四还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;


   case"反常分析五" :
   this.current_note_markdown = `
请分析你摘抄的反常，它是哪种反常，带来了怎么样的效果，效果明显吗？有办法增加它的效果吗


   `;
   if(localStorage.getItem("反常摘抄五")!=null){
     this.current_note_markdown+=localStorage.getItem("反常摘抄五");
   }
   else{
     this.current_note_markdown+=`
     但反常摘抄五还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"反常分析六" :
   this.current_note_markdown = `
请分析你摘抄的反常，它是哪种反常，带来了怎么样的效果，效果明显吗？有办法增加它的效果吗


   `;
   if(localStorage.getItem("反常摘抄六")!=null){
     this.current_note_markdown+=localStorage.getItem("反常摘抄六");
   }
   else{
     this.current_note_markdown+=`
     但反常摘抄六还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"反常分析七" :
   this.current_note_markdown = `
请分析你摘抄的反常，它是哪种反常，带来了怎么样的效果，效果明显吗？有办法增加它的效果吗


   `;
   if(localStorage.getItem("反常摘抄七")!=null){
     this.current_note_markdown+=localStorage.getItem("反常摘抄七");
   }
   else{
     this.current_note_markdown+=`
     但反常摘抄七还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"反常分析八" :
   this.current_note_markdown = `
请分析你摘抄的反常，它是哪种反常，带来了怎么样的效果，效果明显吗？有办法增加它的效果吗


   `;
   if(localStorage.getItem("反常摘抄八")!=null){
     this.current_note_markdown+=localStorage.getItem("反常摘抄八");
   }
   else{
     this.current_note_markdown+=`
     但反常摘抄八还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"反常分析九" :
   this.current_note_markdown = `
请分析你摘抄的反常，它是哪种反常，带来了怎么样的效果，效果明显吗？有办法增加它的效果吗


   `;
   if(localStorage.getItem("反常摘抄九")!=null){
     this.current_note_markdown+=localStorage.getItem("反常摘抄九");
   }
   else{
     this.current_note_markdown+=`
     但反常摘抄九还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"反常分析十" :
   this.current_note_markdown = `
请分析你摘抄的反常，它是哪种反常，带来了怎么样的效果，效果明显吗？有办法增加它的效果吗


   `;
   if(localStorage.getItem("反常摘抄十")!=null){
     this.current_note_markdown+=localStorage.getItem("反常摘抄十");
   }
   else{
     this.current_note_markdown+=`
     但反常摘抄十还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;


      //反常摘抄
      case"反常摘抄一" :
      this.current_note_markdown = `
请在此摘抄你在小说中看过的反常
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"反常摘抄二" :
      this.current_note_markdown = `
请在此摘抄你在小说中看过的反常
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"反常摘抄三" :
      this.current_note_markdown = `
请在此摘抄你在小说中看过的反常
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"反常摘抄四" :
      this.current_note_markdown = `
请在此摘抄你在小说中看过的反常
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"反常摘抄五" :
      this.current_note_markdown = `
请在此摘抄你在小说中看过的反常
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"反常摘抄六" :
      this.current_note_markdown = `
请在此摘抄你在小说中看过的反常
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"反常摘抄七" :
      this.current_note_markdown = `
请在此摘抄你在小说中看过的反常
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"反常摘抄八" :
      this.current_note_markdown = `
请在此摘抄你在小说中看过的反常
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"反常摘抄九" :
      this.current_note_markdown = `
请在此摘抄你在小说中看过的反常
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"反常摘抄十" :
      this.current_note_markdown = `
请在此摘抄你在小说中看过的反常
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;



      //铺垫练习
      case"铺垫练习一" :
      this.current_note_markdown = `
请设定一个故事结局，并用不同的方式，在故事中间铺垫它
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"铺垫练习二" :
      this.current_note_markdown = `
请设定一个故事结局，并用不同的方式，在故事中间铺垫它
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"铺垫练习三" :
      this.current_note_markdown = `
请设定一个故事结局，并用不同的方式，在故事中间铺垫它
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"铺垫练习四" :
      this.current_note_markdown = `
请设定一个故事结局，并用不同的方式，在故事中间铺垫它
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"铺垫练习五" :
      this.current_note_markdown = `
请设定一个故事结局，并用不同的方式，在故事中间铺垫它
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"铺垫练习六" :
      this.current_note_markdown = `
请设定一个故事结局，并用不同的方式，在故事中间铺垫它
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"铺垫练习七" :
      this.current_note_markdown = `
请设定一个故事结局，并用不同的方式，在故事中间铺垫它
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"铺垫练习八" :
      this.current_note_markdown = `
请设定一个故事结局，并用不同的方式，在故事中间铺垫它
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"铺垫练习九" :
      this.current_note_markdown = `
请设定一个故事结局，并用不同的方式，在故事中间铺垫它
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"铺垫练习十" :
      this.current_note_markdown = `
请设定一个故事结局，并用不同的方式，在故事中间铺垫它
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;



   //铺垫分析
   case"铺垫分析一" :
   this.current_note_markdown = `
请分析你摘抄的铺垫，它铺垫了什么，用什么方式铺垫的


   `;
   if(localStorage.getItem("铺垫摘抄一")!=null){
     this.current_note_markdown+=localStorage.getItem("铺垫摘抄一");
   }
   else{
     this.current_note_markdown+=`
     但铺垫摘抄一还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"铺垫分析二" :
   this.current_note_markdown = `
请分析你摘抄的铺垫，它铺垫了什么，用什么方式铺垫的


   `;
   if(localStorage.getItem("铺垫摘抄二")!=null){
     this.current_note_markdown+=localStorage.getItem("铺垫摘抄二");
   }
   else{
     this.current_note_markdown+=`
     但铺垫摘抄二还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"铺垫分析三" :
   this.current_note_markdown = `
请分析你摘抄的铺垫，它铺垫了什么，用什么方式铺垫的


   `;
   if(localStorage.getItem("铺垫摘抄三")!=null){
     this.current_note_markdown+=localStorage.getItem("铺垫摘抄三");
   }
   else{
     this.current_note_markdown+=`
     但铺垫摘抄三还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"铺垫分析四" :
   this.current_note_markdown = `
请分析你摘抄的铺垫，它铺垫了什么，用什么方式铺垫的


   `;
   if(localStorage.getItem("铺垫摘抄四")!=null){
     this.current_note_markdown+=localStorage.getItem("铺垫摘抄四");
   }
   else{
     this.current_note_markdown+=`
     但铺垫摘抄四还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;


   case"铺垫分析五" :
   this.current_note_markdown = `
请分析你摘抄的铺垫，它铺垫了什么，用什么方式铺垫的


   `;
   if(localStorage.getItem("铺垫摘抄五")!=null){
     this.current_note_markdown+=localStorage.getItem("铺垫摘抄五");
   }
   else{
     this.current_note_markdown+=`
     但铺垫摘抄五还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"铺垫分析六" :
   this.current_note_markdown = `
请分析你摘抄的铺垫，它铺垫了什么，用什么方式铺垫的


   `;
   if(localStorage.getItem("铺垫摘抄六")!=null){
     this.current_note_markdown+=localStorage.getItem("铺垫摘抄六");
   }
   else{
     this.current_note_markdown+=`
     但铺垫摘抄六还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"铺垫分析七" :
   this.current_note_markdown = `
请分析你摘抄的铺垫，它铺垫了什么，用什么方式铺垫的


   `;
   if(localStorage.getItem("铺垫摘抄七")!=null){
     this.current_note_markdown+=localStorage.getItem("铺垫摘抄七");
   }
   else{
     this.current_note_markdown+=`
     但铺垫摘抄七还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"铺垫分析八" :
   this.current_note_markdown = `
请分析你摘抄的铺垫，它铺垫了什么，用什么方式铺垫的


   `;
   if(localStorage.getItem("铺垫摘抄八")!=null){
     this.current_note_markdown+=localStorage.getItem("铺垫摘抄八");
   }
   else{
     this.current_note_markdown+=`
     但铺垫摘抄八还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"铺垫分析九" :
   this.current_note_markdown = `
请分析你摘抄的铺垫，它铺垫了什么，用什么方式铺垫的


   `;
   if(localStorage.getItem("铺垫摘抄九")!=null){
     this.current_note_markdown+=localStorage.getItem("铺垫摘抄九");
   }
   else{
     this.current_note_markdown+=`
     但铺垫摘抄九还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"铺垫分析十" :
   this.current_note_markdown = `
请分析你摘抄的铺垫，它铺垫了什么，用什么方式铺垫的


   `;
   if(localStorage.getItem("铺垫摘抄十")!=null){
     this.current_note_markdown+=localStorage.getItem("铺垫摘抄十");
   }
   else{
     this.current_note_markdown+=`
     但铺垫摘抄十还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

        
        


      //铺垫摘抄
      case"铺垫摘抄一" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的小说铺垫。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"铺垫摘抄二" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的小说铺垫。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"铺垫摘抄三" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的小说铺垫。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"铺垫摘抄四" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的小说铺垫。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"铺垫摘抄五" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的小说铺垫。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"铺垫摘抄六" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的小说铺垫。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"铺垫摘抄七" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的小说铺垫。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"铺垫摘抄八" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的小说铺垫。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"铺垫摘抄九" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的小说铺垫。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"铺垫摘抄十" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的小说铺垫。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

        



  //开头仿写
  case"开头仿写一" :
  this.current_note_markdown = `
请仿照你摘抄过的开头，模仿它的优点写一个自己的开头


  `;
  if(localStorage.getItem("开头摘抄一")!=null){
    this.current_note_markdown+=localStorage.getItem("开头摘抄一");
  }
  else{
    this.current_note_markdown+=`
    但开头摘抄一还没有完成。
          `;
  }

  this.is_title = 1;
  if( this.view_type == 2 ) this.view_type = 3;
  break;

  case"开头仿写二" :
  this.current_note_markdown = `
请仿照你摘抄过的开头，模仿它的优点写一个自己的开头


  `;
  if(localStorage.getItem("开头摘抄二")!=null){
    this.current_note_markdown+=localStorage.getItem("开头摘抄二");
  }
  else{
    this.current_note_markdown+=`
    但开头摘抄二还没有完成。
          `;
  }

  this.is_title = 1;
  if( this.view_type == 2 ) this.view_type = 3;
  break;

  case"开头仿写三" :
  this.current_note_markdown = `
请仿照你摘抄过的开头，模仿它的优点写一个自己的开头


  `;
  if(localStorage.getItem("开头摘抄三")!=null){
    this.current_note_markdown+=localStorage.getItem("开头摘抄三");
  }
  else{
    this.current_note_markdown+=`
    但开头摘抄三还没有完成。
          `;
  }

  this.is_title = 1;
  if( this.view_type == 2 ) this.view_type = 3;
  break;

  case"开头仿写四" :
  this.current_note_markdown = `
请仿照你摘抄过的开头，模仿它的优点写一个自己的开头


  `;
  if(localStorage.getItem("开头摘抄四")!=null){
    this.current_note_markdown+=localStorage.getItem("开头摘抄四");
  }
  else{
    this.current_note_markdown+=`
    但开头摘抄四还没有完成。
          `;
  }

  this.is_title = 1;
  if( this.view_type == 2 ) this.view_type = 3;
  break;


  case"开头仿写五" :
  this.current_note_markdown = `
请仿照你摘抄过的开头，模仿它的优点写一个自己的开头


  `;
  if(localStorage.getItem("开头摘抄五")!=null){
    this.current_note_markdown+=localStorage.getItem("开头摘抄五");
  }
  else{
    this.current_note_markdown+=`
    但开头摘抄五还没有完成。
          `;
  }

  this.is_title = 1;
  if( this.view_type == 2 ) this.view_type = 3;
  break;

  case"开头仿写六" :
  this.current_note_markdown = `
请仿照你摘抄过的开头，模仿它的优点写一个自己的开头


  `;
  if(localStorage.getItem("开头摘抄六")!=null){
    this.current_note_markdown+=localStorage.getItem("开头摘抄六");
  }
  else{
    this.current_note_markdown+=`
    但开头摘抄六还没有完成。
          `;
  }

  this.is_title = 1;
  if( this.view_type == 2 ) this.view_type = 3;
  break;

  case"开头仿写七" :
  this.current_note_markdown = `
请仿照你摘抄过的开头，模仿它的优点写一个自己的开头


  `;
  if(localStorage.getItem("开头摘抄七")!=null){
    this.current_note_markdown+=localStorage.getItem("开头摘抄七");
  }
  else{
    this.current_note_markdown+=`
    但开头摘抄七还没有完成。
          `;
  }

  this.is_title = 1;
  if( this.view_type == 2 ) this.view_type = 3;
  break;

  case"开头仿写八" :
  this.current_note_markdown = `
请仿照你摘抄过的开头，模仿它的优点写一个自己的开头


  `;
  if(localStorage.getItem("开头摘抄八")!=null){
    this.current_note_markdown+=localStorage.getItem("开头摘抄八");
  }
  else{
    this.current_note_markdown+=`
    但开头摘抄八还没有完成。
          `;
  }

  this.is_title = 1;
  if( this.view_type == 2 ) this.view_type = 3;
  break;

  case"开头仿写九" :
  this.current_note_markdown = `
请仿照你摘抄过的开头，模仿它的优点写一个自己的开头


  `;
  if(localStorage.getItem("开头摘抄九")!=null){
    this.current_note_markdown+=localStorage.getItem("开头摘抄九");
  }
  else{
    this.current_note_markdown+=`
    但开头摘抄九还没有完成。
          `;
  }

  this.is_title = 1;
  if( this.view_type == 2 ) this.view_type = 3;
  break;

  case"开头仿写十" :
  this.current_note_markdown = `
请仿照你摘抄过的开头，模仿它的优点写一个自己的开头


  `;
  if(localStorage.getItem("开头摘抄十")!=null){
    this.current_note_markdown+=localStorage.getItem("开头摘抄十");
  }
  else{
    this.current_note_markdown+=`
    但开头摘抄十还没有完成。
          `;
  }

  this.is_title = 1;
  if( this.view_type == 2 ) this.view_type = 3;
  break;



   //开头分析
   case"开头分析一" :
   this.current_note_markdown = `
请分析你摘抄的开头，是哪里让你觉得它是个好开头


   `;
   if(localStorage.getItem("开头摘抄一")!=null){
     this.current_note_markdown+=localStorage.getItem("开头摘抄一");
   }
   else{
     this.current_note_markdown+=`
     但开头摘抄一还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"开头分析二" :
   this.current_note_markdown = `
请分析你摘抄的开头，是哪里让你觉得它是个好开头


   `;
   if(localStorage.getItem("开头摘抄二")!=null){
     this.current_note_markdown+=localStorage.getItem("开头摘抄二");
   }
   else{
     this.current_note_markdown+=`
     但开头摘抄二还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"开头分析三" :
   this.current_note_markdown = `
请分析你摘抄的开头，是哪里让你觉得它是个好开头


   `;
   if(localStorage.getItem("开头摘抄三")!=null){
     this.current_note_markdown+=localStorage.getItem("开头摘抄三");
   }
   else{
     this.current_note_markdown+=`
     但开头摘抄三还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"开头分析四" :
   this.current_note_markdown = `
请分析你摘抄的开头，是哪里让你觉得它是个好开头


   `;
   if(localStorage.getItem("开头摘抄四")!=null){
     this.current_note_markdown+=localStorage.getItem("开头摘抄四");
   }
   else{
     this.current_note_markdown+=`
     但开头摘抄四还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;


   case"开头分析五" :
   this.current_note_markdown = `
请分析你摘抄的开头，是哪里让你觉得它是个好开头


   `;
   if(localStorage.getItem("开头摘抄五")!=null){
     this.current_note_markdown+=localStorage.getItem("开头摘抄五");
   }
   else{
     this.current_note_markdown+=`
     但开头摘抄五还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"开头分析六" :
   this.current_note_markdown = `
请分析你摘抄的开头，是哪里让你觉得它是个好开头


   `;
   if(localStorage.getItem("开头摘抄六")!=null){
     this.current_note_markdown+=localStorage.getItem("开头摘抄六");
   }
   else{
     this.current_note_markdown+=`
     但开头摘抄六还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"开头分析七" :
   this.current_note_markdown = `
请分析你摘抄的开头，是哪里让你觉得它是个好开头


   `;
   if(localStorage.getItem("开头摘抄七")!=null){
     this.current_note_markdown+=localStorage.getItem("开头摘抄七");
   }
   else{
     this.current_note_markdown+=`
     但开头摘抄七还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"开头分析八" :
   this.current_note_markdown = `
请分析你摘抄的开头，是哪里让你觉得它是个好开头


   `;
   if(localStorage.getItem("开头摘抄八")!=null){
     this.current_note_markdown+=localStorage.getItem("开头摘抄八");
   }
   else{
     this.current_note_markdown+=`
     但开头摘抄八还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"开头分析九" :
   this.current_note_markdown = `
请分析你摘抄的开头，是哪里让你觉得它是个好开头


   `;
   if(localStorage.getItem("开头摘抄九")!=null){
     this.current_note_markdown+=localStorage.getItem("开头摘抄九");
   }
   else{
     this.current_note_markdown+=`
     但开头摘抄九还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"开头分析十" :
   this.current_note_markdown = `
请分析你摘抄的开头，是哪里让你觉得它是个好开头


   `;
   if(localStorage.getItem("开头摘抄十")!=null){
     this.current_note_markdown+=localStorage.getItem("开头摘抄十");
   }
   else{
     this.current_note_markdown+=`
     但开头摘抄十还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

        

      //开头摘抄
      case"开头摘抄一" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的小说开头。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"开头摘抄二" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的小说开头。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"开头摘抄三" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的小说开头。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"开头摘抄四" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的小说开头。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"开头摘抄五" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的小说开头。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"开头摘抄六" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的小说开头。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"开头摘抄七" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的小说开头。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"开头摘抄八" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的小说开头。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"开头摘抄九" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的小说开头。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"开头摘抄十" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的小说开头。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;



   //增加冲突
   case"增加冲突一" :
   this.current_note_markdown = `
请想办法让事件的冲突更加激烈，持续时间更长


   `;
   if(localStorage.getItem("事件写作一")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作一");
   }
   else{
     this.current_note_markdown+=`
     但事件写作一还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"增加冲突二" :
   this.current_note_markdown = `
请想办法让事件的冲突更加激烈，持续时间更长


   `;
   if(localStorage.getItem("事件写作二")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作二");
   }
   else{
     this.current_note_markdown+=`
     但事件写作二还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"增加冲突三" :
   this.current_note_markdown = `
请想办法让事件的冲突更加激烈，持续时间更长


   `;
   if(localStorage.getItem("事件写作三")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作三");
   }
   else{
     this.current_note_markdown+=`
     但事件写作三还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"增加冲突四" :
   this.current_note_markdown = `
请想办法让事件的冲突更加激烈，持续时间更长


   `;
   if(localStorage.getItem("事件写作四")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作四");
   }
   else{
     this.current_note_markdown+=`
     但事件写作四还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;


   case"增加冲突五" :
   this.current_note_markdown = `
请想办法让事件的冲突更加激烈，持续时间更长


   `;
   if(localStorage.getItem("事件写作五")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作五");
   }
   else{
     this.current_note_markdown+=`
     但事件写作五还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"增加冲突六" :
   this.current_note_markdown = `
请想办法让事件的冲突更加激烈，持续时间更长


   `;
   if(localStorage.getItem("事件写作六")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作六");
   }
   else{
     this.current_note_markdown+=`
     但事件写作六还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"增加冲突七" :
   this.current_note_markdown = `
请想办法让事件的冲突更加激烈，持续时间更长


   `;
   if(localStorage.getItem("事件写作七")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作七");
   }
   else{
     this.current_note_markdown+=`
     但事件写作七还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"增加冲突八" :
   this.current_note_markdown = `
请想办法让事件的冲突更加激烈，持续时间更长


   `;
   if(localStorage.getItem("事件写作八")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作八");
   }
   else{
     this.current_note_markdown+=`
     但事件写作八还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"增加冲突九" :
   this.current_note_markdown = `
请想办法让事件的冲突更加激烈，持续时间更长


   `;
   if(localStorage.getItem("事件写作九")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作九");
   }
   else{
     this.current_note_markdown+=`
     但事件写作九还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"增加冲突十" :
   this.current_note_markdown = `
请想办法让事件的冲突更加激烈，持续时间更长


   `;
   if(localStorage.getItem("事件写作十")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作十");
   }
   else{
     this.current_note_markdown+=`
     但事件写作十还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;


   //冲突分析
   case"冲突分析一" :
   this.current_note_markdown = `
请分析你所写的事件中，是否有冲突，如果有，是什么和什么的冲突，冲突激烈吗？如果没有，请想一想如何增加冲突。


   `;
   if(localStorage.getItem("事件写作一")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作一");
   }
   else{
     this.current_note_markdown+=`
     但事件写作一还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"冲突分析二" :
   this.current_note_markdown = `
请分析你所写的事件中，是否有冲突，如果有，是什么和什么的冲突，冲突激烈吗？如果没有，请想一想如何增加冲突。


   `;
   if(localStorage.getItem("事件写作二")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作二");
   }
   else{
     this.current_note_markdown+=`
     但事件写作二还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"冲突分析三" :
   this.current_note_markdown = `
请分析你所写的事件中，是否有冲突，如果有，是什么和什么的冲突，冲突激烈吗？如果没有，请想一想如何增加冲突。


   `;
   if(localStorage.getItem("事件写作三")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作三");
   }
   else{
     this.current_note_markdown+=`
     但事件写作三还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"冲突分析四" :
   this.current_note_markdown = `
请分析你所写的事件中，是否有冲突，如果有，是什么和什么的冲突，冲突激烈吗？如果没有，请想一想如何增加冲突。


   `;
   if(localStorage.getItem("事件写作四")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作四");
   }
   else{
     this.current_note_markdown+=`
     但事件写作四还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;


   case"冲突分析五" :
   this.current_note_markdown = `
请分析你所写的事件中，是否有冲突，如果有，是什么和什么的冲突，冲突激烈吗？如果没有，请想一想如何增加冲突。


   `;
   if(localStorage.getItem("事件写作五")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作五");
   }
   else{
     this.current_note_markdown+=`
     但事件写作五还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"冲突分析六" :
   this.current_note_markdown = `
请分析你所写的事件中，是否有冲突，如果有，是什么和什么的冲突，冲突激烈吗？如果没有，请想一想如何增加冲突。


   `;
   if(localStorage.getItem("事件写作六")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作六");
   }
   else{
     this.current_note_markdown+=`
     但事件写作六还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"冲突分析七" :
   this.current_note_markdown = `
请分析你所写的事件中，是否有冲突，如果有，是什么和什么的冲突，冲突激烈吗？如果没有，请想一想如何增加冲突。


   `;
   if(localStorage.getItem("事件写作七")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作七");
   }
   else{
     this.current_note_markdown+=`
     但事件写作七还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"冲突分析八" :
   this.current_note_markdown = `
请分析你所写的事件中，是否有冲突，如果有，是什么和什么的冲突，冲突激烈吗？如果没有，请想一想如何增加冲突。


   `;
   if(localStorage.getItem("事件写作八")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作八");
   }
   else{
     this.current_note_markdown+=`
     但事件写作八还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"冲突分析九" :
   this.current_note_markdown = `
请分析你所写的事件中，是否有冲突，如果有，是什么和什么的冲突，冲突激烈吗？如果没有，请想一想如何增加冲突。


   `;
   if(localStorage.getItem("事件写作九")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作九");
   }
   else{
     this.current_note_markdown+=`
     但事件写作九还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"冲突分析十" :
   this.current_note_markdown = `
请分析你所写的事件中，是否有冲突，如果有，是什么和什么的冲突，冲突激烈吗？如果没有，请想一想如何增加冲突。


   `;
   if(localStorage.getItem("事件写作十")!=null){
     this.current_note_markdown+=localStorage.getItem("事件写作十");
   }
   else{
     this.current_note_markdown+=`
     但事件写作十还没有完成。
           `;
   }

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;




    //问题诊断
    case"问题诊断一" :
    this.current_note_markdown = `
请诊断你的对话练习中，是否有内容空洞、情绪激动、知道太多、自动洞悉太深的问题


    `;
    if(localStorage.getItem("增加潜台词一")!=null){
      this.current_note_markdown+=localStorage.getItem("增加潜台词一");
    }
    else{
      this.current_note_markdown+=`
      但增加潜台词一还没有完成。
            `;
    }

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"问题诊断二" :
    this.current_note_markdown = `
请诊断你的对话练习中，是否有内容空洞、情绪激动、知道太多、自动洞悉太深的问题


    `;
    if(localStorage.getItem("增加潜台词二")!=null){
      this.current_note_markdown+=localStorage.getItem("增加潜台词二");
    }
    else{
      this.current_note_markdown+=`
      但增加潜台词二还没有完成。
            `;
    }

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"问题诊断三" :
    this.current_note_markdown = `
请诊断你的对话练习中，是否有内容空洞、情绪激动、知道太多、自动洞悉太深的问题


    `;
    if(localStorage.getItem("增加潜台词三")!=null){
      this.current_note_markdown+=localStorage.getItem("增加潜台词三");
    }
    else{
      this.current_note_markdown+=`
      但增加潜台词三还没有完成。
            `;
    }

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"问题诊断四" :
    this.current_note_markdown = `
请诊断你的对话练习中，是否有内容空洞、情绪激动、知道太多、自动洞悉太深的问题


    `;
    if(localStorage.getItem("增加潜台词四")!=null){
      this.current_note_markdown+=localStorage.getItem("增加潜台词四");
    }
    else{
      this.current_note_markdown+=`
      但增加潜台词四还没有完成。
            `;
    }

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"问题诊断五" :
    this.current_note_markdown = `
请诊断你的对话练习中，是否有内容空洞、情绪激动、知道太多、自动洞悉太深的问题


    `;
    if(localStorage.getItem("增加潜台词五")!=null){
      this.current_note_markdown+=localStorage.getItem("增加潜台词五");
    }
    else{
      this.current_note_markdown+=`
      但增加潜台词五还没有完成。
            `;
    }

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"问题诊断六" :
    this.current_note_markdown = `
请诊断你的对话练习中，是否有内容空洞、情绪激动、知道太多、自动洞悉太深的问题


    `;
    if(localStorage.getItem("增加潜台词六")!=null){
      this.current_note_markdown+=localStorage.getItem("增加潜台词六");
    }
    else{
      this.current_note_markdown+=`
      但增加潜台词六还没有完成。
            `;
    }

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"问题诊断七" :
    this.current_note_markdown = `
请诊断你的对话练习中，是否有内容空洞、情绪激动、知道太多、自动洞悉太深的问题


    `;
    if(localStorage.getItem("增加潜台词七")!=null){
      this.current_note_markdown+=localStorage.getItem("增加潜台词七");
    }
    else{
      this.current_note_markdown+=`
      但增加潜台词七还没有完成。
            `;
    }

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"问题诊断八" :
    this.current_note_markdown = `
请诊断你的对话练习中，是否有内容空洞、情绪激动、知道太多、自动洞悉太深的问题


    `;
    if(localStorage.getItem("增加潜台词八")!=null){
      this.current_note_markdown+=localStorage.getItem("增加潜台词八");
    }
    else{
      this.current_note_markdown+=`
      但增加潜台词八还没有完成。
            `;
    }

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"问题诊断九" :
    this.current_note_markdown = `
请诊断你的对话练习中，是否有内容空洞、情绪激动、知道太多、自动洞悉太深的问题


    `;
    if(localStorage.getItem("增加潜台词九")!=null){
      this.current_note_markdown+=localStorage.getItem("增加潜台词九");
    }
    else{
      this.current_note_markdown+=`
      但增加潜台词九还没有完成。
            `;
    }

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"问题诊断十" :
    this.current_note_markdown = `
请诊断你的对话练习中，是否有内容空洞、情绪激动、知道太多、自动洞悉太深的问题


    `;
    if(localStorage.getItem("增加潜台词十")!=null){
      this.current_note_markdown+=localStorage.getItem("增加潜台词十");
    }
    else{
      this.current_note_markdown+=`
      但增加潜台词十还没有完成。
            `;
    }

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;




    //增加潜台词
    case"增加潜台词一" :
    this.current_note_markdown = `
请为你做过的对话练习增加潜台词，让对话内容不要那么直白，而是富有深意


    `;
    if(localStorage.getItem("对话精炼一")!=null){
      this.current_note_markdown+=localStorage.getItem("对话精炼一");
    }
    else{
      this.current_note_markdown+=`
      但文笔篇的对话精炼练习一还没有完成。
            `;
    }

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"增加潜台词二" :
    this.current_note_markdown = `
请为你做过的对话练习增加潜台词，让对话内容不要那么直白，而是富有深意


    `;
    if(localStorage.getItem("对话精炼二")!=null){
      this.current_note_markdown+=localStorage.getItem("对话精炼二");
    }
    else{
      this.current_note_markdown+=`
      但文笔篇的对话精炼练习二还没有完成。
            `;
    }

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"增加潜台词三" :
    this.current_note_markdown = `
请为你做过的对话练习增加潜台词，让对话内容不要那么直白，而是富有深意


    `;
    if(localStorage.getItem("对话精炼三")!=null){
      this.current_note_markdown+=localStorage.getItem("对话精炼三");
    }
    else{
      this.current_note_markdown+=`
      但文笔篇的对话精炼练习三还没有完成。
            `;
    }

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"增加潜台词四" :
    this.current_note_markdown = `
请为你做过的对话练习增加潜台词，让对话内容不要那么直白，而是富有深意


    `;
    if(localStorage.getItem("对话精炼四")!=null){
      this.current_note_markdown+=localStorage.getItem("对话精炼四");
    }
    else{
      this.current_note_markdown+=`
      但文笔篇的对话精炼练习四还没有完成。
            `;
    }

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"增加潜台词五" :
    this.current_note_markdown = `
请为你做过的对话练习增加潜台词，让对话内容不要那么直白，而是富有深意


    `;
    if(localStorage.getItem("对话精炼五")!=null){
      this.current_note_markdown+=localStorage.getItem("对话精炼五");
    }
    else{
      this.current_note_markdown+=`
      但文笔篇的对话精炼练习五还没有完成。
            `;
    }

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"增加潜台词六" :
    this.current_note_markdown = `
请为你做过的对话练习增加潜台词，让对话内容不要那么直白，而是富有深意


    `;
    if(localStorage.getItem("对话精炼六")!=null){
      this.current_note_markdown+=localStorage.getItem("对话精炼六");
    }
    else{
      this.current_note_markdown+=`
      但文笔篇的对话精炼练习六还没有完成。
            `;
    }

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"增加潜台词七" :
    this.current_note_markdown = `
请为你做过的对话练习增加潜台词，让对话内容不要那么直白，而是富有深意


    `;
    if(localStorage.getItem("对话精炼七")!=null){
      this.current_note_markdown+=localStorage.getItem("对话精炼七");
    }
    else{
      this.current_note_markdown+=`
      但文笔篇的对话精炼练习七还没有完成。
            `;
    }

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"增加潜台词八" :
    this.current_note_markdown = `
请为你做过的对话练习增加潜台词，让对话内容不要那么直白，而是富有深意


    `;
    if(localStorage.getItem("对话精炼八")!=null){
      this.current_note_markdown+=localStorage.getItem("对话精炼八");
    }
    else{
      this.current_note_markdown+=`
      但文笔篇的对话精炼练习八还没有完成。
            `;
    }

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"增加潜台词九" :
    this.current_note_markdown = `
请为你做过的对话练习增加潜台词，让对话内容不要那么直白，而是富有深意


    `;
    if(localStorage.getItem("对话精炼九")!=null){
      this.current_note_markdown+=localStorage.getItem("对话精炼九");
    }
    else{
      this.current_note_markdown+=`
      但文笔篇的对话精炼练习九还没有完成。
            `;
    }

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"增加潜台词十" :
    this.current_note_markdown = `
请为你做过的对话练习增加潜台词，让对话内容不要那么直白，而是富有深意


    `;
    if(localStorage.getItem("对话精炼十")!=null){
      this.current_note_markdown+=localStorage.getItem("对话精炼十");
    }
    else{
      this.current_note_markdown+=`
      但文笔篇的对话精炼练习十还没有完成。
            `;
    }

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


     //作用分析
     case"作用分析一" :
     this.current_note_markdown = `
请分析你做过的对话练习，指出这场对话起了释放信息，塑造人物和推动剧情的哪种作用。起得作用重要吗，有没有办法加深某种作用？


     `;
     if(localStorage.getItem("对话精炼一")!=null){
       this.current_note_markdown+=localStorage.getItem("对话精炼一");
     }
     else{
       this.current_note_markdown+=`
       但文笔篇的对话精炼练习一还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"作用分析二" :
     this.current_note_markdown = `
请分析你做过的对话练习，指出这场对话起了释放信息，塑造人物和推动剧情的哪种作用。起得作用重要吗，有没有办法加深某种作用？


     `;
     if(localStorage.getItem("对话精炼二")!=null){
       this.current_note_markdown+=localStorage.getItem("对话精炼二");
     }
     else{
       this.current_note_markdown+=`
       但文笔篇的对话精炼练习二还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"作用分析三" :
     this.current_note_markdown = `
请分析你做过的对话练习，指出这场对话起了释放信息，塑造人物和推动剧情的哪种作用。起得作用重要吗，有没有办法加深某种作用？


     `;
     if(localStorage.getItem("对话精炼三")!=null){
       this.current_note_markdown+=localStorage.getItem("对话精炼三");
     }
     else{
       this.current_note_markdown+=`
       但文笔篇的对话精炼练习三还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"作用分析四" :
     this.current_note_markdown = `
请分析你做过的对话练习，指出这场对话起了释放信息，塑造人物和推动剧情的哪种作用。起得作用重要吗，有没有办法加深某种作用？


     `;
     if(localStorage.getItem("对话精炼四")!=null){
       this.current_note_markdown+=localStorage.getItem("对话精炼四");
     }
     else{
       this.current_note_markdown+=`
       但文笔篇的对话精炼练习四还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"作用分析五" :
     this.current_note_markdown = `
请分析你做过的对话练习，指出这场对话起了释放信息，塑造人物和推动剧情的哪种作用。起得作用重要吗，有没有办法加深某种作用？


     `;
     if(localStorage.getItem("对话精炼五")!=null){
       this.current_note_markdown+=localStorage.getItem("对话精炼五");
     }
     else{
       this.current_note_markdown+=`
       但文笔篇的对话精炼练习五还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"作用分析六" :
     this.current_note_markdown = `
请分析你做过的对话练习，指出这场对话起了释放信息，塑造人物和推动剧情的哪种作用。起得作用重要吗，有没有办法加深某种作用？


     `;
     if(localStorage.getItem("对话精炼六")!=null){
       this.current_note_markdown+=localStorage.getItem("对话精炼六");
     }
     else{
       this.current_note_markdown+=`
       但文笔篇的对话精炼练习六还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"作用分析七" :
     this.current_note_markdown = `
请分析你做过的对话练习，指出这场对话起了释放信息，塑造人物和推动剧情的哪种作用。起得作用重要吗，有没有办法加深某种作用？


     `;
     if(localStorage.getItem("对话精炼七")!=null){
       this.current_note_markdown+=localStorage.getItem("对话精炼七");
     }
     else{
       this.current_note_markdown+=`
       但文笔篇的对话精炼练习七还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"作用分析八" :
     this.current_note_markdown = `
请分析你做过的对话练习，指出这场对话起了释放信息，塑造人物和推动剧情的哪种作用。起得作用重要吗，有没有办法加深某种作用？


     `;
     if(localStorage.getItem("对话精炼八")!=null){
       this.current_note_markdown+=localStorage.getItem("对话精炼八");
     }
     else{
       this.current_note_markdown+=`
       但文笔篇的对话精炼练习八还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"作用分析九" :
     this.current_note_markdown = `
请分析你做过的对话练习，指出这场对话起了释放信息，塑造人物和推动剧情的哪种作用。起得作用重要吗，有没有办法加深某种作用？


     `;
     if(localStorage.getItem("对话精炼九")!=null){
       this.current_note_markdown+=localStorage.getItem("对话精炼九");
     }
     else{
       this.current_note_markdown+=`
       但文笔篇的对话精炼练习九还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"作用分析十" :
     this.current_note_markdown = `
请分析你做过的对话练习，指出这场对话起了释放信息，塑造人物和推动剧情的哪种作用。起得作用重要吗，有没有办法加深某种作用？


     `;
     if(localStorage.getItem("对话精炼十")!=null){
       this.current_note_markdown+=localStorage.getItem("对话精炼十");
     }
     else{
       this.current_note_markdown+=`
       但文笔篇的对话精炼练习十还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;



    //视角更改
    case"视角更改一" :
    this.current_note_markdown = `
请更改下列段落中的视角，用不同视角写出同样的内容来

段落如下：

随着交流会的结束，人群熙熙攘攘的从教室中流出，不少人追着颜茹雨，还在不停的问着各种问题。

这个时候，这些问题可就跟交流会没什么关系了。

“平常都找不到你耶，学长你不住宿舍吗？”

“那个金茶奖是不是很难拿啊，听说有史以来，我们学校只拿到过三个！”

“听说赵老师把实验室的钥匙给了你一份……呃，我有个比较紧急的研究，能不能……”

但是吵吵嚷嚷中，问的多，回答得少。颜茹雨几乎没有回答任何问题，苏婉儿都能想象到他那种不耐烦的神情。她不由得长叹了一口气。


    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"视角更改二" :
    this.current_note_markdown = `
请更改下列段落中的视角，用不同视角写出同样的内容来

段落如下：

那是一个下雪的早晨，我躺在床上，听见一群野画眉在窗子边声声叫唤。

姐姐轻巧地坐在檀木桌前，用红焰笔写着信。笔尖的火焰丝丝的跳动着，耀着姐姐明亮闪烁的眼和嘴角那一抹醉人的笑意，让她好像画师画中的那些美人般，拥有夺目的花容月貌。

“你醒了？”姐姐感到了我的目光，熄了笔焰站起身来。

“是呢。”我晃晃脑袋，觉得有些恍惚，窗外的雪太过亮眼了。“姐，我还有一块赤石可吃呢？”

姐姐点着我的脑瓜，笑将起来：“光惦记着赤石了，可不问问自己昏睡了几天？”

我砸吧砸吧嘴，便也乖乖地问道：“今日可是‘寒露’？”

姐姐扑哧一声笑出来，“‘立冬’都过了！你已睡了一个月啦！”


    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"视角更改三" :
    this.current_note_markdown = `
请更改下列段落中的视角，用不同视角写出同样的内容来

段落如下：

英花历3780年，又逢双十整数年。新年喜庆的气氛，还弥漫在张灯结彩的烟花和丝带中，天之落英，就迎来了新一波的降生潮。

每逢二十年一次的降生潮，在地广人稀的天之落英，一向都是个大日子。这一天，联通冥鬼界的冥海，将给这个世界带来新的生命。


    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"视角更改四" :
    this.current_note_markdown = `
请更改下列段落中的视角，用不同视角写出同样的内容来

段落如下：

“我活了七百三十八年，从没见到过你这样的资质。”

想起测试导师说过的话，纸蓉长长的叹了口气，拉上了窗帘。

鹰羽星河出现，就是领受礼前夕。

该来的总是要来，不管纸蓉她多不想面对。


    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"视角更改五" :
    this.current_note_markdown = `
请更改下列段落中的视角，用不同视角写出同样的内容来

段落如下：

提奥，你可以成为比特斯蒂格更好的人。当我刚认识他时，特斯蒂格比现在要好。当时，他才成为一个大人物不久，而且刚结婚。但现在，他被困住了，他会对越来越多的事情有所隐瞒，而且回想起来，会有许多遗憾。他已经这样了，但问题是你，提奥，我的兄弟，不要让任何人绑住你的手，即使绑住手的链子是镀金的。我不得不说，系着金链子的特斯蒂格看起来非常漂亮，但任何一个自由的，看出他手上链子的人，都不会羡慕他。因此，艺术家是更健康的，虽然金钱上的困难是最大的忧虑。我再说一遍，作为一个风景画家，你会比我更快的克服金钱上的困难，而我，也终有一天会渡过难关。如果你马上开始，你很快就会超过我。因为人物画很复杂，需要更长的时间。

你知道，我说这些是认真的。


    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"视角更改六" :
    this.current_note_markdown = `
请更改下列段落中的视角，用不同视角写出同样的内容来

段落如下：

　　
这是一个阳光灿烂、万里无云的下午，金灿灿的阳光洒在了院子里，好像给干净的水泥地镶上了一层闪亮的金边。天气热得很，太阳火辣辣地烤着地面，让人喘不过气来，


    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"视角更改七" :
    this.current_note_markdown = `
请更改下列段落中的视角，用不同视角写出同样的内容来

段落如下：

我悠闲地躺在凉快树荫下的躺椅上，看着院子里的树叶摇摇摆摆。树影晃动，阳光透过树缝洒下斑驳的影子，调皮的光斑在我脸上不停地跳来跳去

我时不时拿起放在桌子上的冰镇果汁喝一口。加了许多块晶莹透亮的冰块的，冰冰凉凉的果汁使我从头舒服到脚，真的是爽呆了。


    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"视角更改八" :
    this.current_note_markdown = `
请更改下列段落中的视角，用不同视角写出同样的内容来

段落如下：

“又是这么一天了。”学士舞说着，仰起头来，看了看碧蓝色的天空。明朗的阳光下，零迷堡一片肃穆。四处飘舞着带着黑花边的白丝带。只剩祭坛中间的几束鲜花，孤零零的开着，在黑白的海洋中鲜艳得有些刺眼。


    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"视角更改九" :
    this.current_note_markdown = `
请更改下列段落中的视角，用不同视角写出同样的内容来

段落如下：

我是一个医生，这个故事从一家医院开始。

说是医生，其实只是个看管人员。

说是医院，其实只是一个简陋的休养院。

这几年来，我一直待在灰白的围墙里，照管那些不算太危险的精神病人。没有制服，没有休假，没有奖金。有的只是一眼望不到头的走廊和时光。也许是因为支付不起医药费，又或者是疗养院比起精神病院来说，听起来不那么令人恐惧及使人厌恶。病人们从精神病院转来这里治疗，然而我个人觉得。不是什么好选择。

因为这不是个好地方。

尽管初略的看，医院除了呆板陈旧并没什么特别。然而住的久了就会发现这里，很像监狱。这里的医护和医生，更像是狱卒和警卫，而病人们……并没有被很好的对待。

比如说。从开办以来，能够痊愈出院的病人不到两位数。

再比如说，我读的专业是外科，但却顺利的进入了这家精神病治疗的医院。

因为病人们并不需要治疗。需要的只是看管。

所以我们的职责，就是看着他们活在这，直到死去。

一天又一天。一年又一年。

每一天都旧得像是浸过褐黄色油墨，毫无生气。幸好我也不是什么热爱新奇的人，也就待了下来。

今天是星期一，是36号病人洗澡的日子。

不管该庆幸还是该悲哀，日子总会来到你面前。就像是水龙头对准了你，就算多不情愿，也还是会淋得浑身是水。特别在有两个医护正制住你手脚的时候。我看着乱吼乱叫的36号病人，扯了扯嘴角。手中的水管扫过，墙上粘着的垃圾跟着水流飘向了下水道。

   `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"视角更改十" :
    this.current_note_markdown = `
请更改下列段落中的视角，用不同视角写出同样的内容来

段落如下：

剩下的日子，就像是在凌迟。

没有人叫我起床，或者给我盖被子。没有人再听我讲笑话，没有人煮好热腾腾的饭菜等我回家，没有人闹着要我陪她玩，也没有人躺在我怀里撒娇……

我开始不由自主地对着家里的物品发呆。


    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;



    //视角分析
    case"视角分析一" :
    this.current_note_markdown = `
请分析下列段落中，用了什么视角

段落如下：

随着交流会的结束，人群熙熙攘攘的从教室中流出，不少人追着颜茹雨，还在不停的问着各种问题。

这个时候，这些问题可就跟交流会没什么关系了。

“平常都找不到你耶，学长你不住宿舍吗？”

“那个金茶奖是不是很难拿啊，听说有史以来，我们学校只拿到过三个！”

“听说赵老师把实验室的钥匙给了你一份……呃，我有个比较紧急的研究，能不能……”

但是吵吵嚷嚷中，问的多，回答得少。颜茹雨几乎没有回答任何问题，苏婉儿都能想象到他那种不耐烦的神情。她不由得长叹了一口气。


    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"视角分析二" :
    this.current_note_markdown = `
请分析下列段落中，用了什么视角

段落如下：

那是一个下雪的早晨，我躺在床上，听见一群野画眉在窗子边声声叫唤。

姐姐轻巧地坐在檀木桌前，用红焰笔写着信。笔尖的火焰丝丝的跳动着，耀着姐姐明亮闪烁的眼和嘴角那一抹醉人的笑意，让她好像画师画中的那些美人般，拥有夺目的花容月貌。

“你醒了？”姐姐感到了我的目光，熄了笔焰站起身来。

“是呢。”我晃晃脑袋，觉得有些恍惚，窗外的雪太过亮眼了。“姐，我还有一块赤石可吃呢？”

姐姐点着我的脑瓜，笑将起来：“光惦记着赤石了，可不问问自己昏睡了几天？”

我砸吧砸吧嘴，便也乖乖地问道：“今日可是‘寒露’？”

姐姐扑哧一声笑出来，“‘立冬’都过了！你已睡了一个月啦！”


    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"视角分析三" :
    this.current_note_markdown = `
请分析下列段落中，用了什么视角

段落如下：

英花历3780年，又逢双十整数年。新年喜庆的气氛，还弥漫在张灯结彩的烟花和丝带中，天之落英，就迎来了新一波的降生潮。

每逢二十年一次的降生潮，在地广人稀的天之落英，一向都是个大日子。这一天，联通冥鬼界的冥海，将给这个世界带来新的生命。


    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"视角分析四" :
    this.current_note_markdown = `
请分析下列段落中，用了什么视角

段落如下：

“我活了七百三十八年，从没见到过你这样的资质。”

想起测试导师说过的话，纸蓉长长的叹了口气，拉上了窗帘。

鹰羽星河出现，就是领受礼前夕。

该来的总是要来，不管纸蓉她多不想面对。


    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"视角分析五" :
    this.current_note_markdown = `
请分析下列段落中，用了什么视角

段落如下：

提奥，你可以成为比特斯蒂格更好的人。当我刚认识他时，特斯蒂格比现在要好。当时，他才成为一个大人物不久，而且刚结婚。但现在，他被困住了，他会对越来越多的事情有所隐瞒，而且回想起来，会有许多遗憾。他已经这样了，但问题是你，提奥，我的兄弟，不要让任何人绑住你的手，即使绑住手的链子是镀金的。我不得不说，系着金链子的特斯蒂格看起来非常漂亮，但任何一个自由的，看出他手上链子的人，都不会羡慕他。因此，艺术家是更健康的，虽然金钱上的困难是最大的忧虑。我再说一遍，作为一个风景画家，你会比我更快的克服金钱上的困难，而我，也终有一天会渡过难关。如果你马上开始，你很快就会超过我。因为人物画很复杂，需要更长的时间。

你知道，我说这些是认真的。


    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"视角分析六" :
    this.current_note_markdown = `
请分析下列段落中，用了什么视角

段落如下：

　　
这是一个阳光灿烂、万里无云的下午，金灿灿的阳光洒在了院子里，好像给干净的水泥地镶上了一层闪亮的金边。天气热得很，太阳火辣辣地烤着地面，让人喘不过气来，


    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"视角分析七" :
    this.current_note_markdown = `
请分析下列段落中，用了什么视角

段落如下：

我悠闲地躺在凉快树荫下的躺椅上，看着院子里的树叶摇摇摆摆。树影晃动，阳光透过树缝洒下斑驳的影子，调皮的光斑在我脸上不停地跳来跳去

我时不时拿起放在桌子上的冰镇果汁喝一口。加了许多块晶莹透亮的冰块的，冰冰凉凉的果汁使我从头舒服到脚，真的是爽呆了。


    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"视角分析八" :
    this.current_note_markdown = `
请分析下列段落中，用了什么视角

段落如下：

“又是这么一天了。”学士舞说着，仰起头来，看了看碧蓝色的天空。明朗的阳光下，零迷堡一片肃穆。四处飘舞着带着黑花边的白丝带。只剩祭坛中间的几束鲜花，孤零零的开着，在黑白的海洋中鲜艳得有些刺眼。


    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"视角分析九" :
    this.current_note_markdown = `
请分析下列段落中，用了什么视角

段落如下：

我是一个医生，这个故事从一家医院开始。

说是医生，其实只是个看管人员。

说是医院，其实只是一个简陋的休养院。

这几年来，我一直待在灰白的围墙里，照管那些不算太危险的精神病人。没有制服，没有休假，没有奖金。有的只是一眼望不到头的走廊和时光。也许是因为支付不起医药费，又或者是疗养院比起精神病院来说，听起来不那么令人恐惧及使人厌恶。病人们从精神病院转来这里治疗，然而我个人觉得。不是什么好选择。

因为这不是个好地方。

尽管初略的看，医院除了呆板陈旧并没什么特别。然而住的久了就会发现这里，很像监狱。这里的医护和医生，更像是狱卒和警卫，而病人们……并没有被很好的对待。

比如说。从开办以来，能够痊愈出院的病人不到两位数。

再比如说，我读的专业是外科，但却顺利的进入了这家精神病治疗的医院。

因为病人们并不需要治疗。需要的只是看管。

所以我们的职责，就是看着他们活在这，直到死去。

一天又一天。一年又一年。

每一天都旧得像是浸过褐黄色油墨，毫无生气。幸好我也不是什么热爱新奇的人，也就待了下来。

今天是星期一，是36号病人洗澡的日子。

不管该庆幸还是该悲哀，日子总会来到你面前。就像是水龙头对准了你，就算多不情愿，也还是会淋得浑身是水。特别在有两个医护正制住你手脚的时候。我看着乱吼乱叫的36号病人，扯了扯嘴角。手中的水管扫过，墙上粘着的垃圾跟着水流飘向了下水道。

   `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"视角分析十" :
    this.current_note_markdown = `
请分析下列段落中，用了什么视角

段落如下：

剩下的日子，就像是在凌迟。

没有人叫我起床，或者给我盖被子。没有人再听我讲笑话，没有人煮好热腾腾的饭菜等我回家，没有人闹着要我陪她玩，也没有人躺在我怀里撒娇……

我开始不由自主地对着家里的物品发呆。


    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;



      //人物设定
      case"人物设定一" :
      this.current_note_markdown = `
请自行设定一个人物，并努力增加他的代入感
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"人物设定二" :
      this.current_note_markdown = `
请自行设定一个人物，并努力增加他的代入感
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"人物设定三" :
      this.current_note_markdown = `
请自行设定一个人物，并努力增加他的代入感
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"人物设定四" :
      this.current_note_markdown = `
请自行设定一个人物，并努力增加他的代入感
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"人物设定五" :
      this.current_note_markdown = `
请自行设定一个人物，并努力增加他的代入感
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"人物设定六" :
      this.current_note_markdown = `
请自行设定一个人物，并努力增加他的代入感
      `;
      

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"人物设定七" :
      this.current_note_markdown = `
请自行设定一个人物，并努力增加他的代入感
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"人物设定八" :
      this.current_note_markdown = `
请自行设定一个人物，并努力增加他的代入感
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"人物设定九" :
      this.current_note_markdown = `
请自行设定一个人物，并努力增加他的代入感
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"人物设定十" :
      this.current_note_markdown = `
请自行设定一个人物，并努力增加他的代入感
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;



     //人物分析
     case"人物分析一" :
     this.current_note_markdown = `
请分析你收集的人物，是什么带来了代入感


     `;
     if(localStorage.getItem("人物收集一")!=null){
       this.current_note_markdown+=localStorage.getItem("人物收集一");
     }
     else{
       this.current_note_markdown+=`
       但人物收集一还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"人物分析二" :
     this.current_note_markdown = `
请分析你收集的人物，是什么带来了代入感


     `;
     if(localStorage.getItem("人物收集二")!=null){
       this.current_note_markdown+=localStorage.getItem("人物收集二");
     }
     else{
       this.current_note_markdown+=`
       但人物收集二还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"人物分析三" :
     this.current_note_markdown = `
请分析你收集的人物，是什么带来了代入感


     `;
     if(localStorage.getItem("人物收集三")!=null){
       this.current_note_markdown+=localStorage.getItem("人物收集三");
     }
     else{
       this.current_note_markdown+=`
       但人物收集三还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"人物分析四" :
     this.current_note_markdown = `
请分析你收集的人物，是什么带来了代入感


     `;
     if(localStorage.getItem("人物收集四")!=null){
       this.current_note_markdown+=localStorage.getItem("人物收集四");
     }
     else{
       this.current_note_markdown+=`
       但人物收集四还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"人物分析五" :
     this.current_note_markdown = `
请分析你收集的人物，是什么带来了代入感


     `;
     if(localStorage.getItem("人物收集五")!=null){
       this.current_note_markdown+=localStorage.getItem("人物收集五");
     }
     else{
       this.current_note_markdown+=`
       但人物收集五还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"人物分析六" :
     this.current_note_markdown = `
请分析你收集的人物，是什么带来了代入感


     `;
     if(localStorage.getItem("人物收集六")!=null){
       this.current_note_markdown+=localStorage.getItem("人物收集六");
     }
     else{
       this.current_note_markdown+=`
       但人物收集六还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"人物分析七" :
     this.current_note_markdown = `
请分析你收集的人物，是什么带来了代入感


     `;
     if(localStorage.getItem("人物收集七")!=null){
       this.current_note_markdown+=localStorage.getItem("人物收集七");
     }
     else{
       this.current_note_markdown+=`
       但人物收集七还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"人物分析八" :
     this.current_note_markdown = `
请分析你收集的人物，是什么带来了代入感


     `;
     if(localStorage.getItem("人物收集八")!=null){
       this.current_note_markdown+=localStorage.getItem("人物收集八");
     }
     else{
       this.current_note_markdown+=`
       但人物收集八还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"人物分析九" :
     this.current_note_markdown = `
请分析你收集的人物，是什么带来了代入感


     `;
     if(localStorage.getItem("人物收集九")!=null){
       this.current_note_markdown+=localStorage.getItem("人物收集九");
     }
     else{
       this.current_note_markdown+=`
       但人物收集九还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"人物分析十" :
     this.current_note_markdown = `
请分析你收集的人物，是什么带来了代入感


     `;
     if(localStorage.getItem("人物收集十")!=null){
       this.current_note_markdown+=localStorage.getItem("人物收集十");
     }
     else{
       this.current_note_markdown+=`
       但人物收集十还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

   


      //人物收集
      case"人物收集一" :
      this.current_note_markdown = `
请收集你觉得让你非常有代入感的人物
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"人物收集二" :
      this.current_note_markdown = `
请收集你觉得让你非常有代入感的人物
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"人物收集三" :
      this.current_note_markdown = `
请收集你觉得让你非常有代入感的人物
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"人物收集四" :
      this.current_note_markdown = `
请收集你觉得让你非常有代入感的人物
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"人物收集五" :
      this.current_note_markdown = `
请收集你觉得让你非常有代入感的人物
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"人物收集六" :
      this.current_note_markdown = `
请收集你觉得让你非常有代入感的人物
      `;
      

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"人物收集七" :
      this.current_note_markdown = `
请收集你觉得让你非常有代入感的人物
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"人物收集八" :
      this.current_note_markdown = `
请收集你觉得让你非常有代入感的人物
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"人物收集九" :
      this.current_note_markdown = `
请收集你觉得让你非常有代入感的人物
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"人物收集十" :
      this.current_note_markdown = `
请收集你觉得让你非常有代入感的人物
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;



    //人物功能设定
    case"主角设定" :
    this.current_note_markdown = `
请写出设定1~3个主角角色。写出人物的背景资料，性格特点，代表的抽象品质等信息。
    `;

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

 
    case"辅佐设定" :
    this.current_note_markdown = `
请写出设定1~3个辅佐角色。写出人物的背景资料，性格特点，代表的抽象品质等信息。
    `;

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"小怪设定" :
    this.current_note_markdown = `
请写出设定1~3个小怪角色。写出人物的背景资料，性格特点，代表的抽象品质等信息。
    `;

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;



    case"boss设定" :
    this.current_note_markdown = `
请写出设定1~3个boss角色。写出人物的背景资料，性格特点，代表的抽象品质等信息。
    `;

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;




    case"双面人设定" :
    this.current_note_markdown = `
请写出设定1~3个双面人角色。写出人物的背景资料，性格特点，代表的抽象品质等信息。
    `;

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"镜子设定" :
    this.current_note_markdown = `
请写出设定1~3个镜子角色。写出人物的背景资料，性格特点，代表的抽象品质等信息。
    `;

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"衬托设定" :
    this.current_note_markdown = `
请写出设定1~3个衬托角色。写出人物的背景资料，性格特点，代表的抽象品质等信息。
    `;

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"系统设定" :
    this.current_note_markdown = `
请写出设定1~3个系统角色。写出人物的背景资料，性格特点，代表的抽象品质等信息。
    `;

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


     //功能分析
     case"功能分析一" :
     this.current_note_markdown = `
请分析你收集的人物，TA是否很好的完成了功能，如果有，他是通过什么完成的。如果没有，怎样可以更好的完成？


     `;
     if(localStorage.getItem("主角收集")!=null){
       this.current_note_markdown+=localStorage.getItem("主角收集");
     }
     else{
       this.current_note_markdown+=`
       但主角收集还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"功能分析二" :
     this.current_note_markdown = `
请分析你收集的人物，TA是否很好的完成了功能，如果有，他是通过什么完成的。如果没有，怎样可以更好的完成？


     `;
     if(localStorage.getItem("辅佐收集")!=null){
       this.current_note_markdown+=localStorage.getItem("辅佐收集");
     }
     else{
       this.current_note_markdown+=`
       但辅佐收集还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"功能分析三" :
     this.current_note_markdown = `
请分析你收集的人物，TA是否很好的完成了功能，如果有，他是通过什么完成的。如果没有，怎样可以更好的完成？


     `;
     if(localStorage.getItem("小怪收集")!=null){
       this.current_note_markdown+=localStorage.getItem("小怪收集");
     }
     else{
       this.current_note_markdown+=`
       但小怪收集还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"功能分析四" :
     this.current_note_markdown = `
请分析你收集的人物，TA是否很好的完成了功能，如果有，他是通过什么完成的。如果没有，怎样可以更好的完成？


     `;
     if(localStorage.getItem("boss收集")!=null){
       this.current_note_markdown+=localStorage.getItem("boss收集");
     }
     else{
       this.current_note_markdown+=`
       但boss收集还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"功能分析五" :
     this.current_note_markdown = `
请分析你收集的人物，TA是否很好的完成了功能，如果有，他是通过什么完成的。如果没有，怎样可以更好的完成？


     `;
     if(localStorage.getItem("双面人收集")!=null){
       this.current_note_markdown+=localStorage.getItem("双面人收集");
     }
     else{
       this.current_note_markdown+=`
       但双面人收集还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"功能分析六" :
     this.current_note_markdown = `
请分析你收集的人物，TA是否很好的完成了功能，如果有，他是通过什么完成的。如果没有，怎样可以更好的完成？


     `;
     if(localStorage.getItem("镜子收集")!=null){
       this.current_note_markdown+=localStorage.getItem("镜子收集");
     }
     else{
       this.current_note_markdown+=`
       但镜子收集还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"功能分析七" :
     this.current_note_markdown = `
请分析你收集的人物，TA是否很好的完成了功能，如果有，他是通过什么完成的。如果没有，怎样可以更好的完成？


     `;
     if(localStorage.getItem("衬托收集")!=null){
       this.current_note_markdown+=localStorage.getItem("衬托收集");
     }
     else{
       this.current_note_markdown+=`
       但衬托收集还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"功能分析八" :
     this.current_note_markdown = `
请分析你收集的人物，TA是否很好的完成了功能，如果有，他是通过什么完成的。如果没有，怎样可以更好的完成？


     `;
     if(localStorage.getItem("系统收集")!=null){
       this.current_note_markdown+=localStorage.getItem("系统收集");
     }
     else{
       this.current_note_markdown+=`
       但系统收集还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

   


      //人物功能收集
      case"主角收集" :
      this.current_note_markdown = `
请写出收集1~3个主角角色。写出人物的出场书籍，性格特点，代表的抽象品质等信息。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

   
      case"辅佐收集" :
      this.current_note_markdown = `
请写出收集1~3个辅佐角色。写出人物的出场书籍，性格特点，代表的抽象品质等信息。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"小怪收集" :
      this.current_note_markdown = `
请写出收集1~3个小怪角色。写出人物的出场书籍，性格特点，代表的抽象品质等信息。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;



      case"boss收集" :
      this.current_note_markdown = `
请写出收集1~3个boss角色。写出人物的出场书籍，性格特点，代表的抽象品质等信息。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;




      case"双面人收集" :
      this.current_note_markdown = `
请写出收集1~3个双面人角色。写出人物的出场书籍，性格特点，代表的抽象品质等信息。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"镜子收集" :
      this.current_note_markdown = `
请写出收集1~3个镜子角色。写出人物的出场书籍，性格特点，代表的抽象品质等信息。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"衬托收集" :
      this.current_note_markdown = `
请写出收集1~3个衬托角色。写出人物的出场书籍，性格特点，代表的抽象品质等信息。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"系统收集" :
      this.current_note_markdown = `
请写出收集1~3个系统角色。写出人物的出场书籍，性格特点，代表的抽象品质等信息。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      //故事线写作
      case"故事线写作一" :
      this.current_note_markdown = `
请写出一个英雄之旅的故事线
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"故事线写作二" :
      this.current_note_markdown = `
请写出一个英雄之旅的故事线
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"故事线写作三" :
      this.current_note_markdown = `
请写出一个英雄之旅的故事线
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"故事线写作四" :
      this.current_note_markdown = `
请写出一个双线穿梭的故事线
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"故事线写作五" :
      this.current_note_markdown = `
请写出一个双线穿梭的故事线
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"故事线写作六" :
      this.current_note_markdown = `
请写出一个双线穿梭的故事线
      `;
      

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"故事线写作七" :
      this.current_note_markdown = `
请写出一个三线合一的故事线
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"故事线写作八" :
      this.current_note_markdown = `
请写出一个三线合一的故事线
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"故事线写作九" :
      this.current_note_markdown = `
请写出一个串珠子的故事线
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"故事线写作十" :
      this.current_note_markdown = `
请写出一个串珠子的故事线
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


     //故事线分析
     case"故事线分析一" :
     this.current_note_markdown = `
请分析你归纳的故事线，它可以分为几个部分？每个部分都能归纳成一个事件吗？前后有什么关系。


     `;
     if(localStorage.getItem("故事线归纳一")!=null){
       this.current_note_markdown+=localStorage.getItem("故事线归纳一");
     }
     else{
       this.current_note_markdown+=`
       但故事线归纳一还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"故事线分析二" :
     this.current_note_markdown = `
请分析你归纳的故事线，它可以分为几个部分？每个部分都能归纳成一个事件吗？前后有什么关系。


     `;
     if(localStorage.getItem("故事线归纳二")!=null){
       this.current_note_markdown+=localStorage.getItem("故事线归纳二");
     }
     else{
       this.current_note_markdown+=`
       但故事线归纳二还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"故事线分析三" :
     this.current_note_markdown = `
请分析你归纳的故事线，它可以分为几个部分？每个部分都能归纳成一个事件吗？前后有什么关系。


     `;
     if(localStorage.getItem("故事线归纳三")!=null){
       this.current_note_markdown+=localStorage.getItem("故事线归纳三");
     }
     else{
       this.current_note_markdown+=`
       但故事线归纳三还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"故事线分析四" :
     this.current_note_markdown = `
请分析你归纳的故事线，它可以分为几个部分？每个部分都能归纳成一个事件吗？前后有什么关系。


     `;
     if(localStorage.getItem("故事线归纳四")!=null){
       this.current_note_markdown+=localStorage.getItem("故事线归纳四");
     }
     else{
       this.current_note_markdown+=`
       但故事线归纳四还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"故事线分析五" :
     this.current_note_markdown = `
请分析你归纳的故事线，它可以分为几个部分？每个部分都能归纳成一个事件吗？前后有什么关系。


     `;
     if(localStorage.getItem("故事线归纳五")!=null){
       this.current_note_markdown+=localStorage.getItem("故事线归纳五");
     }
     else{
       this.current_note_markdown+=`
       但故事线归纳五还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"故事线分析六" :
     this.current_note_markdown = `
请分析你归纳的故事线，它可以分为几个部分？每个部分都能归纳成一个事件吗？前后有什么关系。


     `;
     if(localStorage.getItem("故事线归纳六")!=null){
       this.current_note_markdown+=localStorage.getItem("故事线归纳六");
     }
     else{
       this.current_note_markdown+=`
       但故事线归纳六还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"故事线分析七" :
     this.current_note_markdown = `
请分析你归纳的故事线，它可以分为几个部分？每个部分都能归纳成一个事件吗？前后有什么关系。


     `;
     if(localStorage.getItem("故事线归纳七")!=null){
       this.current_note_markdown+=localStorage.getItem("故事线归纳七");
     }
     else{
       this.current_note_markdown+=`
       但故事线归纳七还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"故事线分析八" :
     this.current_note_markdown = `
请分析你归纳的故事线，它可以分为几个部分？每个部分都能归纳成一个事件吗？前后有什么关系。


     `;
     if(localStorage.getItem("故事线归纳八")!=null){
       this.current_note_markdown+=localStorage.getItem("故事线归纳八");
     }
     else{
       this.current_note_markdown+=`
       但故事线归纳八还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"故事线分析九" :
     this.current_note_markdown = `
请分析你归纳的故事线，它可以分为几个部分？每个部分都能归纳成一个事件吗？前后有什么关系。


     `;
     if(localStorage.getItem("故事线归纳九")!=null){
       this.current_note_markdown+=localStorage.getItem("故事线归纳九");
     }
     else{
       this.current_note_markdown+=`
       但故事线归纳九还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"故事线分析十" :
     this.current_note_markdown = `
请分析你归纳的故事线，它可以分为几个部分？每个部分都能归纳成一个事件吗？前后有什么关系。


     `;
     if(localStorage.getItem("故事线归纳十")!=null){
       this.current_note_markdown+=localStorage.getItem("故事线归纳十");
     }
     else{
       this.current_note_markdown+=`
       但故事线归纳十还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;




      //故事线归纳
      case"故事线归纳一" :
      this.current_note_markdown = `
请选择你喜欢的小说，归纳它的故事线
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"故事线归纳二" :
      this.current_note_markdown = `
请选择你喜欢的小说，归纳它的故事线
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"故事线归纳三" :
      this.current_note_markdown = `
请选择你喜欢的小说，归纳它的故事线
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"故事线归纳四" :
      this.current_note_markdown = `
请选择你喜欢的小说，归纳它的故事线
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"故事线归纳五" :
      this.current_note_markdown = `
请选择你喜欢的小说，归纳它的故事线
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"故事线归纳六" :
      this.current_note_markdown = `
请选择你喜欢的小说，归纳它的故事线
      `;
      

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"故事线归纳七" :
      this.current_note_markdown = `
请选择你喜欢的小说，归纳它的故事线
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"故事线归纳八" :
      this.current_note_markdown = `
请选择你喜欢的小说，归纳它的故事线
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"故事线归纳九" :
      this.current_note_markdown = `
请选择你喜欢的小说，归纳它的故事线
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"故事线归纳十" :
      this.current_note_markdown = `
请选择你喜欢的小说，归纳它的故事线
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;





//事件写作
case"事件写作一" :
this.current_note_markdown = `
请从下面的段落开始，写出接下来可能发生的事件


段落如下：

超级英雄对抗恶棍的方式是，抹掉所有人的记忆。

恶棍自己，还有其他所有知道，认识他们的人，都不再记得这些，他们将被社会重新认识，重新接纳。

但今天，你在整理旧报纸的时候突然发现

你曾经是这个世界上最厉害的超级恶棍。

`;
this.is_title = 2;
if( this.view_type == 2 ) this.view_type = 3;
break;


case"事件写作二" :
this.current_note_markdown = `
请从下面的段落开始，写出接下来可能发生的事件

段落如下：

有一天，你身边的事件忽然莫名奇妙的停止了一小会儿。

你一开始做了各种乱七八糟的尝试，但在这种事情发生了246次以后，你开始意识到

你的超能力不是停止时间，而是在世界上某个人停止时间时，还能继续活动。

而且那个人好像已经发现你了。
`;
this.is_title = 2;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"事件写作三" :
this.current_note_markdown = `
请从下面的段落开始，写出接下来可能发生的事件

段落如下：

一个精神分裂患者，对每天在头脑里喋喋不休的声音感到厌倦。

于是有一天，他跟那个声音说，如果你想要继续待在这里，就要给我付租金。

第二天早上，他在桌子上发现了一个装满现金的信封。
`;
this.is_title = 2;
if( this.view_type == 2 ) this.view_type = 3;
break;


case"事件写作四" :
this.current_note_markdown = `
请从下面的段落开始，写出接下来可能发生的事件

段落如下：

你会经常捡起地上的硬币，看看他们的日期，图案什么的。

有一天，你见到了一枚2044年的硬币，上面印着你的头像。

`;
this.is_title = 2;
if( this.view_type == 2 ) this.view_type = 3;
break;


case"事件写作五" :
this.current_note_markdown = `
请从下面的段落开始，写出接下来可能发生的事件

段落如下：

你可以隔空移物，但不能移动有生命的物体。

一天，你在清扫家里的时候，发现无法移动家里的神像。

`;
this.is_title = 2;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"事件写作六" :
this.current_note_markdown = `
请从下面的段落开始，写出接下来可能发生的事件

段落如下：

作为一个截肢了的人，你仍会有肢体存在的幻觉，也就是有幻肢。

然而某一天，你忽然意识到，你的幻肢可以一拳重击鬼魂。
`;
this.is_title = 2;
if( this.view_type == 2 ) this.view_type = 3;
break;


case"事件写作七" :
this.current_note_markdown = `
请从下面的段落开始，写出接下来可能发生的事件

段落如下：

我们做到了！我们成功实现了超光速旅行！

最开始，外星朋友看到新邻居时非常兴奋。

随后，他们就开始惊慌害怕。

因为人类，是唯一一种使用科技，而非魔法进行星际旅行的种族。

`;
this.is_title = 2;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"事件写作八" :
this.current_note_markdown = `
请从下面的段落开始，写出接下来可能发生的事件

段落如下：

你在网上买了一颗属于自己的星星之后，科学家们才发现上面有外星人。

而这些外星人居然无法否认你的购买。

现在，他们承认你是他们的领主。
`;
this.is_title = 2;
if( this.view_type == 2 ) this.view_type = 3;
break;


case"事件写作九" :
this.current_note_markdown = `
请从下面的段落开始，写出接下来可能发生的事件

段落如下：

几代之前，你所在的北极探险队全军覆没。

而你作为唯一的幸存者，被一群怪人俘虏。

他们用魔咒控制你，让你不得不服从他们的命令。

作为他们不情愿的使者，你必须每年冬天都在整个世界上游历一次。

他们叫你奴隶，或者按当地的语言，你叫“圣诞老人”
`;
this.is_title = 2;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"事件写作十" :
this.current_note_markdown = `
请从下面的段落开始，写出接下来可能发生的事件

段落如下：

在你小时候，父亲说着“去买一包烟”，然后一去不返。

十年之后，你已经成为了一个青少年。

你父亲买烟回来了。

他穿着同一件衣服，并坚定认为自己只出去了半小时。
`;
this.is_title = 2;
if( this.view_type == 2 ) this.view_type = 3;
break;



//事件分析
case"事件分析一" :
this.current_note_markdown = `
请分析下述事件的变化前，变化后、可能的变化原因以及价值反差的正价值、负价值和反差大小。


事件如下：

一觉起来，外面的街道湿了。
`;
this.is_title = 2;
if( this.view_type == 2 ) this.view_type = 3;
break;


case"事件分析二" :
this.current_note_markdown = `
请分析下述事件的变化前，变化后、可能的变化原因以及价值反差的正价值、负价值和反差大小。

事件如下：

主角把配角杀死了。
`;
this.is_title = 2;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"事件分析三" :
this.current_note_markdown = `
请分析下述事件的变化前，变化后、可能的变化原因以及价值反差的正价值、负价值和反差大小。

事件如下：

角色第一次在北方见到雪
`;
this.is_title = 2;
if( this.view_type == 2 ) this.view_type = 3;
break;


case"事件分析四" :
this.current_note_markdown = `
请分析下述事件的变化前，变化后、可能的变化原因以及价值反差的正价值、负价值和反差大小。

事件如下：

刚结婚的夫妻分居了

`;
this.is_title = 2;
if( this.view_type == 2 ) this.view_type = 3;
break;


case"事件分析五" :
this.current_note_markdown = `
请分析下述事件的变化前，变化后、可能的变化原因以及价值反差的正价值、负价值和反差大小。

事件如下：

房间的墙皮哗啦掉下来一大块，砸在暗色的地板上。伴随着36号病人低低的呜咽，我拍了拍身上脏兮兮的衣服。站在一米开外，默默的看着他。


`;
this.is_title = 2;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"事件分析六" :
this.current_note_markdown = `
请分析下述事件的变化前，变化后、可能的变化原因以及价值反差的正价值、负价值和反差大小。

事件如下：

不管该庆幸还是该悲哀，日子总会来到你面前。就像是水龙头对准了你，就算多不情愿，也还是会淋得浑身是水。特别在有两个医护正制住你手脚的时候。我看着乱吼乱叫的36号病人，扯了扯嘴角。手中的水管扫过，墙上粘着的垃圾跟着水流飘向了下水道。

房间里弥漫的臭味被消毒水盖住以后，水龙头关上了。医护们一松手，36号病人便直挺挺的倒在身下的水坑里，哆哆嗦嗦的发出难以理解的声音，似乎受了很大的委屈。
`;
this.is_title = 2;
if( this.view_type == 2 ) this.view_type = 3;
break;


case"事件分析七" :
this.current_note_markdown = `
请分析下述事件的变化前，变化后、可能的变化原因以及价值反差的正价值、负价值和反差大小。

事件如下：

远处传来隐隐约约的笑声，36号病人趴在水坑中，朝着食盘伸了伸手，他虽然双臂往前探，但脚和身子却往反方向拉扯。看起来竟然像是想要同时待在原地和往前移动。时间慢慢的过去，而他离食物的距离却丝毫没有缩减。

人如何尽力往前却又将自己禁锢在原地。

走近一步，食物发出的怪味冲进鼻腔。耳边是断断续续的怪音。

我看着它们长长的出了口气。

我无奈的摸了摸身上，拿出早上没吃完的几片面包。带着点奶油的香气就弥漫了出来，隐隐约约的混在了水汽之中。

向前走了几步，我在病人面前蹲下了身。看着他伸出的双手。除了污迹，他手上都是伤疤。颜色一块一块的，浑浊不清。把面包都放下，我看着他把食物快速塞进口里，费力的咀嚼起来。

“请正常一点啊。”我拍了拍他现在看起来还算干净的衣服说。

“咕噤呃……”伴随着病人发出的怪音，我说的话像是没有听众，消逝在病房的深处。

`;
this.is_title = 2;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"事件分析八" :
this.current_note_markdown = `
请分析下述事件的变化前，变化后、可能的变化原因以及价值反差的正价值、负价值和反差大小。

事件如下：

第二天是个阳光明媚的好天气，门铃如往常一般响起，我叼着面包去开门，边吞咽面包边拉开了房门，婉儿站在门廊的阳光里。树影的光斑，映着她的脸一片明媚。

“凌薇，早啊。”她冲我打招呼，然后仔细看了看我的黑眼圈，“又很晚睡了？”

“还好。”我拿起书包，关上房门，踏进明亮的阳光里。

`;
this.is_title = 2;
if( this.view_type == 2 ) this.view_type = 3;
break;


case"事件分析九" :
this.current_note_markdown = `
请分析下述事件的变化前，变化后、可能的变化原因以及价值反差的正价值、负价值和反差大小。

事件如下：

今天的新闻主要是关于新来的转学生。婉儿站在公交站台下，水亮的眼睛神采奕奕，“一班又转来了个男生，混血儿诶！长的超好看！”这不是第一次婉儿说一个男生好看了，貌似几周前也说过一次。合着婉儿眼里都是美男啊。我毫无兴致的打了个哈欠。

对比起我的昏昏欲睡，婉儿显得十分兴致勃勃，拉着我说：“今天我们路过一班的时候，去看看吧！”

路过一班？我抬起头，有些讶异的看了婉儿一眼。二班和一班根本不在同一层，还一个西北角，一个东北角。隔着十几级楼梯和长长的走廊。这都能路过的么？

但是迎面撞上了婉儿期待的眼神，我无言的挪了挪步伐，随意的应道：“哦，好啊。看看吧。”

然而我的这个反应还是让婉儿很不满，她瞪着我叫道：“哎？！你这是什么反应。对好看的男生花痴，是女生的天职啊。你这是失职你造吗？！”

“……”

失职大发了。原来花痴是那么正义的事儿吗。我无奈的看着婉儿说：“那你把我开除好了。”

远处电线杆上传来一两声脆脆的鸟鸣，和拍打翅膀的微响。

婉儿听到后，双手比划了个超能力的姿势，对着我叫道：“好啊，看我开除你。”说完就挥着手乱舞一气。

夏日的风悠悠的吹着。公车带着热气开进了站台，缓缓的停在了挥舞双手的婉儿面前。

“……别闹了。公车来了。”

`;
this.is_title = 2;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"事件分析十" :
this.current_note_markdown = `
请分析下述事件的变化前，变化后、可能的变化原因以及价值反差的正价值、负价值和反差大小。

事件如下：

有点透风的棚子下，在饭堂边上，S一脸不满，像看神经病一眼看着我，“你小子有病啊。带着一个丫头去怪物的房间。你不要命她还要呢。”

我愣了一下，才知道S为什么脸那么黑。36号有伤人记录，他以为是我带着27号去36号房间的。但实际上只是冲洗过后门还没来得及关，27号自己跑进来的。

“不是我带的……”我看着瞪着我的S解释，“刚好门开着…”也许是知道27号从来喜欢乱跑，也许是我的表情很诚恳，S看我的眼神缓和了一些。

“今儿算过去了。”S说道：“以后离那丫头远点。”说完他就头也不回的走了。

`;
this.is_title = 2;
if( this.view_type == 2 ) this.view_type = 3;
break;



      //象征练习
      case"象征练习一" :
      this.current_note_markdown = `
请选择你觉得需要象征的内容，在此进行象征练习
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"象征练习二" :
      this.current_note_markdown = `
请选择你觉得需要象征的内容，在此进行象征练习
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"象征练习三" :
      this.current_note_markdown = `
请选择你觉得需要象征的内容，在此进行象征练习
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"象征练习四" :
      this.current_note_markdown = `
请选择你觉得需要象征的内容，在此进行象征练习
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"象征练习五" :
      this.current_note_markdown = `
请选择你觉得需要象征的内容，在此进行象征练习
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"象征练习六" :
      this.current_note_markdown = `
请选择你觉得需要象征的内容，在此进行象征练习
      `;
      

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"象征练习七" :
      this.current_note_markdown = `
请选择你觉得需要象征的内容，在此进行象征练习
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"象征练习八" :
      this.current_note_markdown = `
请选择你觉得需要象征的内容，在此进行象征练习
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"象征练习九" :
      this.current_note_markdown = `
请选择你觉得需要象征的内容，在此进行象征练习
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"象征练习十" :
      this.current_note_markdown = `
请选择你觉得需要象征的内容，在此进行象征练习
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


//案例模仿
case"案例模仿一" :
this.current_note_markdown = `
请模仿段落中的音长和音强写出自己的段落

段落如下：

夏日炎炎，蝉声扰扰。年级大会开在体育馆里，没有空调。

同学们在小声的窃窃私语，嘈杂闷热的环境中，我一边用手抹去脸上的汗珠，一边拿着草稿纸演算数学作业中的最后一道题。

题目曲曲折折，纷繁复杂。任我怎么集中精力，还是有一个数字算不对。心中不免得有些烦闷，觉得级长在台上讲的话，更加饶人清静。

笔狠狠的在纸上划出一条分割线。重新来……我咬牙切齿的正打算再算一遍。旁边的婉儿忽然推了我一下，手一歪，划出一条斜线。

“哎！别算了。要宣布排名了。”她小声在我耳边叫道。

我一惊，从数学题中回过神来，抬起头看麦克风前的级长。果然他正经的清了清嗓子：“接下来，表扬一下本次考试成绩优异的同学。”略微的停顿了半秒，才缓缓说道：

`;
this.is_title = 2;
if( this.view_type == 2 ) this.view_type = 3;
break;


case"案例模仿二" :
this.current_note_markdown = `
请模仿段落中的音长和音强写出自己的段落

段落如下：

我刚踏进家门，就被脚底的东西绊了一跤。姿势难看的摔在地板上，我诧异的扫了一眼，发现是一堆杂乱无章的大包小包堆在门口，看上去像是妈妈出差要用的行李。

……这相隔甚远的缝隙，和难以跨越的障碍，做为陷阱实在太浑然天成了。妈妈这方面实在是有天赋。就我这样的运动神经都不免中招。实在是根骨清奇。

我正在感叹，妈妈就已经闻声跑出来了。她看到我摔在地上，心疼的过来扶我起来，连声道歉道：“凌薇对不起啊，我不是故意弄成这样的，刚刚还想着把门口清理一下，结果找衣服一下找忘了啦。”

找……衣……服……？！

我不可思议的瞪着妈妈，看着她羞愧的表情，再往房间里面一瞟，心情几乎是崩溃的。

只见妈妈的房间里，一堆白衣服，层层叠叠的乱扔在地上，房间靠墙摆着三个大衣柜，并着几个小抽屉都被翻得凌乱不堪，床上更是堆满了衣物，连被子都看不到了。一切都被雪白色的布料遮盖住了。

这实在和我预想中的不太一样，我愣愣的看着昨天才打扫干净的房间，出门时还一尘不染，回来已经是满地开花了。反差大的实在有点让我难以接受。这真是……

“真是‘忽如一夜春风来，千树万树梨花开’吧。”妈妈顺着我的眼神看过去，看着一屋子的白色，愉悦的顺口接道。

我抽了抽眼角，一阵无力感蔓上了全身。
`;
this.is_title = 2;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"案例模仿三" :
this.current_note_markdown = `
请模仿段落中的音长和音强写出自己的段落

段落如下：

妈妈是个生活废，家务一窍不通。连自己都照顾得一塌糊涂，居然忽然脑袋抽风的去领养了孩子。

理由也很莫名。她说她想要一个自己的家，暂时找不到丈夫，就先要一个孩子。

这简直不是正常女人会有的思路……

不过就算领养了孩子，妈妈的生活技能还是没有因为母爱而提升一分一毫，反倒是把我锻炼得家务全能。回忆起以前妈妈煮的稀番茄烂炒蛋混蒜头粥，我就觉得自己能长这么大真是运气昌盛。

我一边埋头在衣服堆里面寻找，一边暗暗抱怨。

找不到衣服这种事发生已经不止一次了，因为妈妈穿衣服奇葩的只喜欢穿白色。

衣柜这么大，衣服何其多。都是一个色调。这得多难找。所以这种事情已经是常态了。

我扒开表层的一堆白衣服，整个人都探进衣柜里去找衣服。跟着我走进房间的妈妈，就随便在旁边找了个地方，翘腿一坐，悠闲的看起书来。

要点脸行吗……我还在这帮你找衣服呢，要看书好歹走远一点啊……我抬头怒视老妈。

但妈妈丝毫不介意，欣慰的对我甜甜一笑。

“……”我不想说什么了。

最终我还是找到了那件衣服。一身收腰长裙，裙摆底部缀着闪亮的星形蓝色亮片。漫天华光般连成一片，绵延又不凌乱，十分精致美观。

`;
this.is_title = 2;
if( this.view_type == 2 ) this.view_type = 3;
break;


case"案例模仿四" :
this.current_note_markdown = `
请模仿段落中的音长和音强写出自己的段落

段落如下：

我怔了怔，猛然想起了那张淡色发黄的纸片，年前我整理抽屉时，从最深处把它翻了出来。上面模糊的写着一串地址，字迹幼嫩而又工整。

抓着那张纸片，我的鼻尖甚至若有若无的闻到了桂花香。这么浓烈的香气，就像是在童年的剑道馆外，那一片开得灿灿烂烂的四季桂花海。

有些事情如果不去想，就尘封在记忆的深处，像是落满了灰烬琐屑，再也想不起来。然而只要出现一个线索，就能勾起一大片的回忆来，一幕幕甚至清晰可见。

我见到他是在剑道馆。

在那一片星星点点的纯白桂花前。

时间模糊了那么多记忆，我居然还能想起那时的细节。

也许对于女孩子来说，学习剑道太过辛苦了，所以让我记忆尤深。那时的我，瘦小羸弱，一遍一遍的被打倒在地，挣扎着爬不起来。木质的地板冷冰冰的，汗水和泪水一起在脸上流淌，看着眼前的景物一片模糊。

师父曾经说过，能够一击必杀的时候，绝不要留下一丝余地。于是所有的男孩，都居高临下的看着我在地上挣扎，手上的剑停在我喉咙上，一脸轻蔑。这是对最弱者的鄙视，没有人想跟我练剑。

但是他不一样。他主动来找我。甚至对剑的时候，他会故意把招式放慢三拍，让我跟得上他的步伐。力道也会放缓三分，不轻不重的落在我身上。就算我还是被打倒，也能够很快的爬起来。而他总是弯下腰来，眼睛干净清澈的看着我，小心的问：“要休息吗？”  `;
this.is_title = 2;
if( this.view_type == 2 ) this.view_type = 3;
break;


case"案例模仿五" :
this.current_note_markdown = `
请模仿段落中的音长和音强写出自己的段落

段落如下：

安杰找来姐姐安欣帮忙，在江德福一班战友面前表现得无比体贴温柔。江德福高兴之余多喝了几杯，不料把自己每天的 “三洗”改造活动捅了出去。次日，酒醒后的江德福面对战友的各种嘲笑头痛不已。安杰怀孕了，这可把江德福高兴坏了。安杰的姐夫欧阳懿调回本地工作，安家两姐妹从小就在各种事上暗暗较劲，所以在比老公这件事情上，安杰更是严阵以待。拿到欧阳懿送来的请帖后，安杰不仅翻箱倒柜给自己找体面的裙子，更是逼江德福套上了文质彬彬的白西装，饭桌上，安泰一家人对江德福热情有加，安欣夫妇心里不免吃味。
`;
this.is_title = 2;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"案例模仿六" :
this.current_note_markdown = `
请模仿段落中的音长和音强写出自己的段落

段落如下：

但是小孩子总是残忍又健忘，当妈妈告诉我这个地方很远，要长大才能去之后，我慢慢的就把这件事淡忘了。日历一页页的翻过，时间一晃，也十年过去了。如今猛然记起来，寄去的信却没有回音。

就像是脑海中忽然盘旋起的熟悉旋律，却想不起歌名。总是会更加的绞尽脑汁去想，如同走火入魔一般。这个未完成的愿望，变成了一种执念，隐隐的沉在心里，让人很不舒服。

诚然，我是一个很在意诺言的人，但是这怎么跟龙鳞说？就为了小时候的一句话，如今翻天覆地的去找？我犹豫了一会，还是口气平淡的回答：“只是不想欠别人太多人情罢了。”

听到这个答案，龙鳞明显不满意，他幽幽的叹了口气，貌似很失望的抱怨道：“欠我人情就没关系么……好吧……那有消息再联系你吧。薇儿再见。”

跟这家伙还有人情可言？

是忘了我拔剑相助的峥嵘岁月了吗？

我挑了挑眉，“我俩啥关系啊。还有，别叫我……”

话还没说完。咔。这混蛋把电话挂了。

我望着嘟嘟响着忙音的手机，眼角一抽。最终还是看在国际长途和有求于人的份上，忍了。

`;
this.is_title = 2;
if( this.view_type == 2 ) this.view_type = 3;
break;


case"案例模仿七" :
this.current_note_markdown = `
请模仿段落中的音长和音强写出自己的段落

段落如下：

屋外风吹着树林沙沙作响。垂下手来，我看看窗外。南方沿海四季炎热，又是桂花开放的季节。若有若无的清幽香气浮沉在飘渺的夜色中。临别时的笑容还历历在目，转眼就十年。

再见面的话……会是怎么样呢。我默默的回身躺在沙发上。

完全想不到啊。
`;
this.is_title = 2;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"案例模仿八" :
this.current_note_markdown = `
请模仿段落中的音长和音强写出自己的段落

段落如下：

第二天是个阳光明媚的好天气，门铃如往常一般响起，我叼着面包去开门，边吞咽面包边拉开了房门，婉儿站在门廊的阳光里。树影的光斑，映着她的脸一片明媚。

“凌薇，早啊。”她冲我打招呼，然后仔细看了看我的黑眼圈，“又很晚睡了？”

“还好。”我拿起书包，关上房门，踏进明亮的阳光里。

`;
this.is_title = 2;
if( this.view_type == 2 ) this.view_type = 3;
break;


case"案例模仿九" :
this.current_note_markdown = `
请模仿段落中的音长和音强写出自己的段落

段落如下：

今天的新闻主要是关于新来的转学生。婉儿站在公交站台下，水亮的眼睛神采奕奕，“一班又转来了个男生，混血儿诶！长的超好看！”这不是第一次婉儿说一个男生好看了，貌似几周前也说过一次。合着婉儿眼里都是美男啊。我毫无兴致的打了个哈欠。

对比起我的昏昏欲睡，婉儿显得十分兴致勃勃，拉着我说：“今天我们路过一班的时候，去看看吧！”

路过一班？我抬起头，有些讶异的看了婉儿一眼。二班和一班根本不在同一层，还一个西北角，一个东北角。隔着十几级楼梯和长长的走廊。这都能路过的么？

但是迎面撞上了婉儿期待的眼神，我无言的挪了挪步伐，随意的应道：“哦，好啊。看看吧。”

然而我的这个反应还是让婉儿很不满，她瞪着我叫道：“哎？！你这是什么反应。对好看的男生花痴，是女生的天职啊。你这是失职你造吗？！”

“……”

失职大发了。原来花痴是那么正义的事儿吗。我无奈的看着婉儿说：“那你把我开除好了。”

远处电线杆上传来一两声脆脆的鸟鸣，和拍打翅膀的微响。

婉儿听到后，双手比划了个超能力的姿势，对着我叫道：“好啊，看我开除你。”说完就挥着手乱舞一气。

夏日的风悠悠的吹着。公车带着热气开进了站台，缓缓的停在了挥舞双手的婉儿面前。

“……别闹了。公车来了。”

`;
this.is_title = 2;
if( this.view_type == 2 ) this.view_type = 3;
break;

case"案例模仿十" :
this.current_note_markdown = `
请模仿段落中的音长和音强写出自己的段落

段落如下：

因为公车的打扰，最终我还是没被从女生行列开除出去。按照婉儿的说法，这个技能被打断了会有很长的技能冷却时间，所以只好放我一马。鉴于我暂时还是女生（我对这个说法表示了抗议）婉儿依然坚守岗位，继续给我灌输各种八卦。

于是午饭的时候，我一边咬着鸡排，一边漫不经心的听婉儿的午间新闻。婉儿吃得很少，只吃了一小碗面以后，就咬着酸奶的吸管，继续绘声绘色的跟我介绍那个男生。

据她说，新来的男生简直就是蓝颜祸水，因为长得太好，刚来没几天就引得女同学纷纷向他表白。甚至引发的学校最大团体“公主团”的内部矛盾，原本昔日姐妹情深，成为情敌翻脸不认人。

还好后来她们统统都被拒绝了，于是矛盾也就烟消云散，她们重新变成了革命好战友……

通过婉儿的科普，我知道公主团是一个女生团体，以一班的于晴为首，势力不仅在高三一班非常强大，甚至蔓延到了整个学校。

以于晴为首，嗯，看来不是什么好团体。

我因为睡得不好有点困倦，有一搭没一搭的听着。听完后我感叹着表示，这男生真是个人物，能引得公主团的内斗，实在是有本事。而且侠肝义胆，除暴安良。的确要去拜会一下，表示感谢。我还没说完，就被婉儿恶狠狠的打断了。

“凌薇，重点是这个男生很帅气啊。”婉儿扔下酸奶，气呼呼的看着我说。

“我的重点也是啊。”我很疑惑，“不然怎么能惹得她们内斗呢？” 说完，我径直起身，拿起两人吃完的饭碗，送到洗碗间。
`;
this.is_title = 2;
if( this.view_type == 2 ) this.view_type = 3;
break;




 //音强分析
 case"音强分析一" :
 this.current_note_markdown = `
请分析下列段落中的音强有多强

段落如下：

夏日炎炎，蝉声扰扰。年级大会开在体育馆里，没有空调。

同学们在小声的窃窃私语，嘈杂闷热的环境中，我一边用手抹去脸上的汗珠，一边拿着草稿纸演算数学作业中的最后一道题。

题目曲曲折折，纷繁复杂。任我怎么集中精力，还是有一个数字算不对。心中不免得有些烦闷，觉得级长在台上讲的话，更加饶人清静。

笔狠狠的在纸上划出一条分割线。重新来……我咬牙切齿的正打算再算一遍。旁边的婉儿忽然推了我一下，手一歪，划出一条斜线。

“哎！别算了。要宣布排名了。”她小声在我耳边叫道。

我一惊，从数学题中回过神来，抬起头看麦克风前的级长。果然他正经的清了清嗓子：“接下来，表扬一下本次考试成绩优异的同学。”略微的停顿了半秒，才缓缓说道：

 `;
 this.is_title = 2;
 if( this.view_type == 2 ) this.view_type = 3;
 break;


 case"音强分析二" :
 this.current_note_markdown = `
请分析下列段落中的音强有多强

段落如下：

我刚踏进家门，就被脚底的东西绊了一跤。姿势难看的摔在地板上，我诧异的扫了一眼，发现是一堆杂乱无章的大包小包堆在门口，看上去像是妈妈出差要用的行李。

……这相隔甚远的缝隙，和难以跨越的障碍，做为陷阱实在太浑然天成了。妈妈这方面实在是有天赋。就我这样的运动神经都不免中招。实在是根骨清奇。

我正在感叹，妈妈就已经闻声跑出来了。她看到我摔在地上，心疼的过来扶我起来，连声道歉道：“凌薇对不起啊，我不是故意弄成这样的，刚刚还想着把门口清理一下，结果找衣服一下找忘了啦。”

找……衣……服……？！

我不可思议的瞪着妈妈，看着她羞愧的表情，再往房间里面一瞟，心情几乎是崩溃的。

只见妈妈的房间里，一堆白衣服，层层叠叠的乱扔在地上，房间靠墙摆着三个大衣柜，并着几个小抽屉都被翻得凌乱不堪，床上更是堆满了衣物，连被子都看不到了。一切都被雪白色的布料遮盖住了。

这实在和我预想中的不太一样，我愣愣的看着昨天才打扫干净的房间，出门时还一尘不染，回来已经是满地开花了。反差大的实在有点让我难以接受。这真是……

“真是‘忽如一夜春风来，千树万树梨花开’吧。”妈妈顺着我的眼神看过去，看着一屋子的白色，愉悦的顺口接道。

我抽了抽眼角，一阵无力感蔓上了全身。
 `;
 this.is_title = 2;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"音强分析三" :
 this.current_note_markdown = `
请分析下列段落中的音强有多强

段落如下：

妈妈是个生活废，家务一窍不通。连自己都照顾得一塌糊涂，居然忽然脑袋抽风的去领养了孩子。

理由也很莫名。她说她想要一个自己的家，暂时找不到丈夫，就先要一个孩子。

这简直不是正常女人会有的思路……

不过就算领养了孩子，妈妈的生活技能还是没有因为母爱而提升一分一毫，反倒是把我锻炼得家务全能。回忆起以前妈妈煮的稀番茄烂炒蛋混蒜头粥，我就觉得自己能长这么大真是运气昌盛。

我一边埋头在衣服堆里面寻找，一边暗暗抱怨。

找不到衣服这种事发生已经不止一次了，因为妈妈穿衣服奇葩的只喜欢穿白色。

衣柜这么大，衣服何其多。都是一个色调。这得多难找。所以这种事情已经是常态了。

我扒开表层的一堆白衣服，整个人都探进衣柜里去找衣服。跟着我走进房间的妈妈，就随便在旁边找了个地方，翘腿一坐，悠闲的看起书来。

要点脸行吗……我还在这帮你找衣服呢，要看书好歹走远一点啊……我抬头怒视老妈。

但妈妈丝毫不介意，欣慰的对我甜甜一笑。

“……”我不想说什么了。

最终我还是找到了那件衣服。一身收腰长裙，裙摆底部缀着闪亮的星形蓝色亮片。漫天华光般连成一片，绵延又不凌乱，十分精致美观。

`;
 this.is_title = 2;
 if( this.view_type == 2 ) this.view_type = 3;
 break;


 case"音强分析四" :
 this.current_note_markdown = `
请分析下列段落中的音强有多强

段落如下：

我怔了怔，猛然想起了那张淡色发黄的纸片，年前我整理抽屉时，从最深处把它翻了出来。上面模糊的写着一串地址，字迹幼嫩而又工整。

抓着那张纸片，我的鼻尖甚至若有若无的闻到了桂花香。这么浓烈的香气，就像是在童年的剑道馆外，那一片开得灿灿烂烂的四季桂花海。

有些事情如果不去想，就尘封在记忆的深处，像是落满了灰烬琐屑，再也想不起来。然而只要出现一个线索，就能勾起一大片的回忆来，一幕幕甚至清晰可见。

我见到他是在剑道馆。

在那一片星星点点的纯白桂花前。

时间模糊了那么多记忆，我居然还能想起那时的细节。

也许对于女孩子来说，学习剑道太过辛苦了，所以让我记忆尤深。那时的我，瘦小羸弱，一遍一遍的被打倒在地，挣扎着爬不起来。木质的地板冷冰冰的，汗水和泪水一起在脸上流淌，看着眼前的景物一片模糊。

师父曾经说过，能够一击必杀的时候，绝不要留下一丝余地。于是所有的男孩，都居高临下的看着我在地上挣扎，手上的剑停在我喉咙上，一脸轻蔑。这是对最弱者的鄙视，没有人想跟我练剑。

但是他不一样。他主动来找我。甚至对剑的时候，他会故意把招式放慢三拍，让我跟得上他的步伐。力道也会放缓三分，不轻不重的落在我身上。就算我还是被打倒，也能够很快的爬起来。而他总是弯下腰来，眼睛干净清澈的看着我，小心的问：“要休息吗？”  `;
 this.is_title = 2;
 if( this.view_type == 2 ) this.view_type = 3;
 break;


 case"音强分析五" :
 this.current_note_markdown = `
请分析下列段落中的音强有多强

段落如下：

安杰找来姐姐安欣帮忙，在江德福一班战友面前表现得无比体贴温柔。江德福高兴之余多喝了几杯，不料把自己每天的 “三洗”改造活动捅了出去。次日，酒醒后的江德福面对战友的各种嘲笑头痛不已。安杰怀孕了，这可把江德福高兴坏了。安杰的姐夫欧阳懿调回本地工作，安家两姐妹从小就在各种事上暗暗较劲，所以在比老公这件事情上，安杰更是严阵以待。拿到欧阳懿送来的请帖后，安杰不仅翻箱倒柜给自己找体面的裙子，更是逼江德福套上了文质彬彬的白西装，饭桌上，安泰一家人对江德福热情有加，安欣夫妇心里不免吃味。
`;
 this.is_title = 2;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"音强分析六" :
 this.current_note_markdown = `
请分析下列段落中的音强有多强

段落如下：

但是小孩子总是残忍又健忘，当妈妈告诉我这个地方很远，要长大才能去之后，我慢慢的就把这件事淡忘了。日历一页页的翻过，时间一晃，也十年过去了。如今猛然记起来，寄去的信却没有回音。

就像是脑海中忽然盘旋起的熟悉旋律，却想不起歌名。总是会更加的绞尽脑汁去想，如同走火入魔一般。这个未完成的愿望，变成了一种执念，隐隐的沉在心里，让人很不舒服。

诚然，我是一个很在意诺言的人，但是这怎么跟龙鳞说？就为了小时候的一句话，如今翻天覆地的去找？我犹豫了一会，还是口气平淡的回答：“只是不想欠别人太多人情罢了。”

听到这个答案，龙鳞明显不满意，他幽幽的叹了口气，貌似很失望的抱怨道：“欠我人情就没关系么……好吧……那有消息再联系你吧。薇儿再见。”

跟这家伙还有人情可言？

是忘了我拔剑相助的峥嵘岁月了吗？

我挑了挑眉，“我俩啥关系啊。还有，别叫我……”

话还没说完。咔。这混蛋把电话挂了。

我望着嘟嘟响着忙音的手机，眼角一抽。最终还是看在国际长途和有求于人的份上，忍了。

`;
 this.is_title = 2;
 if( this.view_type == 2 ) this.view_type = 3;
 break;


 case"音强分析七" :
 this.current_note_markdown = `
请分析下列段落中的音强有多强

段落如下：

屋外风吹着树林沙沙作响。垂下手来，我看看窗外。南方沿海四季炎热，又是桂花开放的季节。若有若无的清幽香气浮沉在飘渺的夜色中。临别时的笑容还历历在目，转眼就十年。

再见面的话……会是怎么样呢。我默默的回身躺在沙发上。

完全想不到啊。
`;
 this.is_title = 2;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"音强分析八" :
 this.current_note_markdown = `
请分析下列段落中的音强有多强

段落如下：

第二天是个阳光明媚的好天气，门铃如往常一般响起，我叼着面包去开门，边吞咽面包边拉开了房门，婉儿站在门廊的阳光里。树影的光斑，映着她的脸一片明媚。

“凌薇，早啊。”她冲我打招呼，然后仔细看了看我的黑眼圈，“又很晚睡了？”

“还好。”我拿起书包，关上房门，踏进明亮的阳光里。

`;
 this.is_title = 2;
 if( this.view_type == 2 ) this.view_type = 3;
 break;


 case"音强分析九" :
 this.current_note_markdown = `
请分析下列段落中的音强有多强

段落如下：

今天的新闻主要是关于新来的转学生。婉儿站在公交站台下，水亮的眼睛神采奕奕，“一班又转来了个男生，混血儿诶！长的超好看！”这不是第一次婉儿说一个男生好看了，貌似几周前也说过一次。合着婉儿眼里都是美男啊。我毫无兴致的打了个哈欠。

对比起我的昏昏欲睡，婉儿显得十分兴致勃勃，拉着我说：“今天我们路过一班的时候，去看看吧！”

路过一班？我抬起头，有些讶异的看了婉儿一眼。二班和一班根本不在同一层，还一个西北角，一个东北角。隔着十几级楼梯和长长的走廊。这都能路过的么？

但是迎面撞上了婉儿期待的眼神，我无言的挪了挪步伐，随意的应道：“哦，好啊。看看吧。”

然而我的这个反应还是让婉儿很不满，她瞪着我叫道：“哎？！你这是什么反应。对好看的男生花痴，是女生的天职啊。你这是失职你造吗？！”

“……”

失职大发了。原来花痴是那么正义的事儿吗。我无奈的看着婉儿说：“那你把我开除好了。”

远处电线杆上传来一两声脆脆的鸟鸣，和拍打翅膀的微响。

婉儿听到后，双手比划了个超能力的姿势，对着我叫道：“好啊，看我开除你。”说完就挥着手乱舞一气。

夏日的风悠悠的吹着。公车带着热气开进了站台，缓缓的停在了挥舞双手的婉儿面前。

“……别闹了。公车来了。”

`;
 this.is_title = 2;
 if( this.view_type == 2 ) this.view_type = 3;
 break;

 case"音强分析十" :
 this.current_note_markdown = `
请分析下列段落中的音强有多强

段落如下：

因为公车的打扰，最终我还是没被从女生行列开除出去。按照婉儿的说法，这个技能被打断了会有很长的技能冷却时间，所以只好放我一马。鉴于我暂时还是女生（我对这个说法表示了抗议）婉儿依然坚守岗位，继续给我灌输各种八卦。

于是午饭的时候，我一边咬着鸡排，一边漫不经心的听婉儿的午间新闻。婉儿吃得很少，只吃了一小碗面以后，就咬着酸奶的吸管，继续绘声绘色的跟我介绍那个男生。

据她说，新来的男生简直就是蓝颜祸水，因为长得太好，刚来没几天就引得女同学纷纷向他表白。甚至引发的学校最大团体“公主团”的内部矛盾，原本昔日姐妹情深，成为情敌翻脸不认人。

还好后来她们统统都被拒绝了，于是矛盾也就烟消云散，她们重新变成了革命好战友……

通过婉儿的科普，我知道公主团是一个女生团体，以一班的于晴为首，势力不仅在高三一班非常强大，甚至蔓延到了整个学校。

以于晴为首，嗯，看来不是什么好团体。

我因为睡得不好有点困倦，有一搭没一搭的听着。听完后我感叹着表示，这男生真是个人物，能引得公主团的内斗，实在是有本事。而且侠肝义胆，除暴安良。的确要去拜会一下，表示感谢。我还没说完，就被婉儿恶狠狠的打断了。

“凌薇，重点是这个男生很帅气啊。”婉儿扔下酸奶，气呼呼的看着我说。

“我的重点也是啊。”我很疑惑，“不然怎么能惹得她们内斗呢？” 说完，我径直起身，拿起两人吃完的饭碗，送到洗碗间。
`;
 this.is_title = 2;
 if( this.view_type == 2 ) this.view_type = 3;
 break;




  //音长分析
  case"音长分析一" :
  this.current_note_markdown = `
请分析下列段落中的几种叙事音长分别是长还是短。

段落如下：

夏日炎炎，蝉声扰扰。年级大会开在体育馆里，没有空调。

同学们在小声的窃窃私语，嘈杂闷热的环境中，我一边用手抹去脸上的汗珠，一边拿着草稿纸演算数学作业中的最后一道题。

题目曲曲折折，纷繁复杂。任我怎么集中精力，还是有一个数字算不对。心中不免得有些烦闷，觉得级长在台上讲的话，更加饶人清静。

笔狠狠的在纸上划出一条分割线。重新来……我咬牙切齿的正打算再算一遍。旁边的婉儿忽然推了我一下，手一歪，划出一条斜线。

“哎！别算了。要宣布排名了。”她小声在我耳边叫道。

我一惊，从数学题中回过神来，抬起头看麦克风前的级长。果然他正经的清了清嗓子：“接下来，表扬一下本次考试成绩优异的同学。”略微的停顿了半秒，才缓缓说道：

  `;
  this.is_title = 2;
  if( this.view_type == 2 ) this.view_type = 3;
  break;

 
  case"音长分析二" :
  this.current_note_markdown = `
请分析下列段落中的几种叙事音长分别是长还是短。

段落如下：

我刚踏进家门，就被脚底的东西绊了一跤。姿势难看的摔在地板上，我诧异的扫了一眼，发现是一堆杂乱无章的大包小包堆在门口，看上去像是妈妈出差要用的行李。

……这相隔甚远的缝隙，和难以跨越的障碍，做为陷阱实在太浑然天成了。妈妈这方面实在是有天赋。就我这样的运动神经都不免中招。实在是根骨清奇。

我正在感叹，妈妈就已经闻声跑出来了。她看到我摔在地上，心疼的过来扶我起来，连声道歉道：“凌薇对不起啊，我不是故意弄成这样的，刚刚还想着把门口清理一下，结果找衣服一下找忘了啦。”

找……衣……服……？！

我不可思议的瞪着妈妈，看着她羞愧的表情，再往房间里面一瞟，心情几乎是崩溃的。

只见妈妈的房间里，一堆白衣服，层层叠叠的乱扔在地上，房间靠墙摆着三个大衣柜，并着几个小抽屉都被翻得凌乱不堪，床上更是堆满了衣物，连被子都看不到了。一切都被雪白色的布料遮盖住了。

这实在和我预想中的不太一样，我愣愣的看着昨天才打扫干净的房间，出门时还一尘不染，回来已经是满地开花了。反差大的实在有点让我难以接受。这真是……

“真是‘忽如一夜春风来，千树万树梨花开’吧。”妈妈顺着我的眼神看过去，看着一屋子的白色，愉悦的顺口接道。

我抽了抽眼角，一阵无力感蔓上了全身。
  `;
  this.is_title = 2;
  if( this.view_type == 2 ) this.view_type = 3;
  break;

  case"音长分析三" :
  this.current_note_markdown = `
请分析下列段落中的几种叙事音长分别是长还是短。

段落如下：

妈妈是个生活废，家务一窍不通。连自己都照顾得一塌糊涂，居然忽然脑袋抽风的去领养了孩子。

理由也很莫名。她说她想要一个自己的家，暂时找不到丈夫，就先要一个孩子。

这简直不是正常女人会有的思路……

不过就算领养了孩子，妈妈的生活技能还是没有因为母爱而提升一分一毫，反倒是把我锻炼得家务全能。回忆起以前妈妈煮的稀番茄烂炒蛋混蒜头粥，我就觉得自己能长这么大真是运气昌盛。

我一边埋头在衣服堆里面寻找，一边暗暗抱怨。

找不到衣服这种事发生已经不止一次了，因为妈妈穿衣服奇葩的只喜欢穿白色。

衣柜这么大，衣服何其多。都是一个色调。这得多难找。所以这种事情已经是常态了。

我扒开表层的一堆白衣服，整个人都探进衣柜里去找衣服。跟着我走进房间的妈妈，就随便在旁边找了个地方，翘腿一坐，悠闲的看起书来。

要点脸行吗……我还在这帮你找衣服呢，要看书好歹走远一点啊……我抬头怒视老妈。

但妈妈丝毫不介意，欣慰的对我甜甜一笑。

“……”我不想说什么了。

最终我还是找到了那件衣服。一身收腰长裙，裙摆底部缀着闪亮的星形蓝色亮片。漫天华光般连成一片，绵延又不凌乱，十分精致美观。

`;
  this.is_title = 2;
  if( this.view_type == 2 ) this.view_type = 3;
  break;


  case"音长分析四" :
  this.current_note_markdown = `
请分析下列段落中的几种叙事音长分别是长还是短。

段落如下：

我怔了怔，猛然想起了那张淡色发黄的纸片，年前我整理抽屉时，从最深处把它翻了出来。上面模糊的写着一串地址，字迹幼嫩而又工整。

抓着那张纸片，我的鼻尖甚至若有若无的闻到了桂花香。这么浓烈的香气，就像是在童年的剑道馆外，那一片开得灿灿烂烂的四季桂花海。

有些事情如果不去想，就尘封在记忆的深处，像是落满了灰烬琐屑，再也想不起来。然而只要出现一个线索，就能勾起一大片的回忆来，一幕幕甚至清晰可见。

我见到他是在剑道馆。

在那一片星星点点的纯白桂花前。

时间模糊了那么多记忆，我居然还能想起那时的细节。

也许对于女孩子来说，学习剑道太过辛苦了，所以让我记忆尤深。那时的我，瘦小羸弱，一遍一遍的被打倒在地，挣扎着爬不起来。木质的地板冷冰冰的，汗水和泪水一起在脸上流淌，看着眼前的景物一片模糊。

师父曾经说过，能够一击必杀的时候，绝不要留下一丝余地。于是所有的男孩，都居高临下的看着我在地上挣扎，手上的剑停在我喉咙上，一脸轻蔑。这是对最弱者的鄙视，没有人想跟我练剑。

但是他不一样。他主动来找我。甚至对剑的时候，他会故意把招式放慢三拍，让我跟得上他的步伐。力道也会放缓三分，不轻不重的落在我身上。就算我还是被打倒，也能够很快的爬起来。而他总是弯下腰来，眼睛干净清澈的看着我，小心的问：“要休息吗？”  `;
  this.is_title = 2;
  if( this.view_type == 2 ) this.view_type = 3;
  break;


  case"音长分析五" :
  this.current_note_markdown = `
请分析下列段落中的几种叙事音长分别是长还是短。

段落如下：

安杰找来姐姐安欣帮忙，在江德福一班战友面前表现得无比体贴温柔。江德福高兴之余多喝了几杯，不料把自己每天的 “三洗”改造活动捅了出去。次日，酒醒后的江德福面对战友的各种嘲笑头痛不已。安杰怀孕了，这可把江德福高兴坏了。安杰的姐夫欧阳懿调回本地工作，安家两姐妹从小就在各种事上暗暗较劲，所以在比老公这件事情上，安杰更是严阵以待。拿到欧阳懿送来的请帖后，安杰不仅翻箱倒柜给自己找体面的裙子，更是逼江德福套上了文质彬彬的白西装，饭桌上，安泰一家人对江德福热情有加，安欣夫妇心里不免吃味。
 `;
  this.is_title = 2;
  if( this.view_type == 2 ) this.view_type = 3;
  break;

  case"音长分析六" :
  this.current_note_markdown = `
请分析下列段落中的几种叙事音长分别是长还是短。

段落如下：

但是小孩子总是残忍又健忘，当妈妈告诉我这个地方很远，要长大才能去之后，我慢慢的就把这件事淡忘了。日历一页页的翻过，时间一晃，也十年过去了。如今猛然记起来，寄去的信却没有回音。

就像是脑海中忽然盘旋起的熟悉旋律，却想不起歌名。总是会更加的绞尽脑汁去想，如同走火入魔一般。这个未完成的愿望，变成了一种执念，隐隐的沉在心里，让人很不舒服。

诚然，我是一个很在意诺言的人，但是这怎么跟龙鳞说？就为了小时候的一句话，如今翻天覆地的去找？我犹豫了一会，还是口气平淡的回答：“只是不想欠别人太多人情罢了。”

听到这个答案，龙鳞明显不满意，他幽幽的叹了口气，貌似很失望的抱怨道：“欠我人情就没关系么……好吧……那有消息再联系你吧。薇儿再见。”

跟这家伙还有人情可言？

是忘了我拔剑相助的峥嵘岁月了吗？

我挑了挑眉，“我俩啥关系啊。还有，别叫我……”

话还没说完。咔。这混蛋把电话挂了。

我望着嘟嘟响着忙音的手机，眼角一抽。最终还是看在国际长途和有求于人的份上，忍了。

`;
  this.is_title = 2;
  if( this.view_type == 2 ) this.view_type = 3;
  break;


  case"音长分析七" :
  this.current_note_markdown = `
请分析下列段落中的几种叙事音长分别是长还是短。

段落如下：

屋外风吹着树林沙沙作响。垂下手来，我看看窗外。南方沿海四季炎热，又是桂花开放的季节。若有若无的清幽香气浮沉在飘渺的夜色中。临别时的笑容还历历在目，转眼就十年。

再见面的话……会是怎么样呢。我默默的回身躺在沙发上。

完全想不到啊。
`;
  this.is_title = 2;
  if( this.view_type == 2 ) this.view_type = 3;
  break;

  case"音长分析八" :
  this.current_note_markdown = `
请分析下列段落中的几种叙事音长分别是长还是短。

段落如下：

第二天是个阳光明媚的好天气，门铃如往常一般响起，我叼着面包去开门，边吞咽面包边拉开了房门，婉儿站在门廊的阳光里。树影的光斑，映着她的脸一片明媚。

“凌薇，早啊。”她冲我打招呼，然后仔细看了看我的黑眼圈，“又很晚睡了？”

“还好。”我拿起书包，关上房门，踏进明亮的阳光里。

`;
  this.is_title = 2;
  if( this.view_type == 2 ) this.view_type = 3;
  break;


  case"音长分析九" :
  this.current_note_markdown = `
请分析下列段落中的几种叙事音长分别是长还是短。

段落如下：

今天的新闻主要是关于新来的转学生。婉儿站在公交站台下，水亮的眼睛神采奕奕，“一班又转来了个男生，混血儿诶！长的超好看！”这不是第一次婉儿说一个男生好看了，貌似几周前也说过一次。合着婉儿眼里都是美男啊。我毫无兴致的打了个哈欠。

对比起我的昏昏欲睡，婉儿显得十分兴致勃勃，拉着我说：“今天我们路过一班的时候，去看看吧！”

路过一班？我抬起头，有些讶异的看了婉儿一眼。二班和一班根本不在同一层，还一个西北角，一个东北角。隔着十几级楼梯和长长的走廊。这都能路过的么？

但是迎面撞上了婉儿期待的眼神，我无言的挪了挪步伐，随意的应道：“哦，好啊。看看吧。”

然而我的这个反应还是让婉儿很不满，她瞪着我叫道：“哎？！你这是什么反应。对好看的男生花痴，是女生的天职啊。你这是失职你造吗？！”

“……”

失职大发了。原来花痴是那么正义的事儿吗。我无奈的看着婉儿说：“那你把我开除好了。”

远处电线杆上传来一两声脆脆的鸟鸣，和拍打翅膀的微响。

婉儿听到后，双手比划了个超能力的姿势，对着我叫道：“好啊，看我开除你。”说完就挥着手乱舞一气。

夏日的风悠悠的吹着。公车带着热气开进了站台，缓缓的停在了挥舞双手的婉儿面前。

“……别闹了。公车来了。”

`;
  this.is_title = 2;
  if( this.view_type == 2 ) this.view_type = 3;
  break;

  case"音长分析十" :
  this.current_note_markdown = `
请分析下列段落中的几种叙事音长分别是长还是短。

段落如下：

因为公车的打扰，最终我还是没被从女生行列开除出去。按照婉儿的说法，这个技能被打断了会有很长的技能冷却时间，所以只好放我一马。鉴于我暂时还是女生（我对这个说法表示了抗议）婉儿依然坚守岗位，继续给我灌输各种八卦。

于是午饭的时候，我一边咬着鸡排，一边漫不经心的听婉儿的午间新闻。婉儿吃得很少，只吃了一小碗面以后，就咬着酸奶的吸管，继续绘声绘色的跟我介绍那个男生。

据她说，新来的男生简直就是蓝颜祸水，因为长得太好，刚来没几天就引得女同学纷纷向他表白。甚至引发的学校最大团体“公主团”的内部矛盾，原本昔日姐妹情深，成为情敌翻脸不认人。

还好后来她们统统都被拒绝了，于是矛盾也就烟消云散，她们重新变成了革命好战友……

通过婉儿的科普，我知道公主团是一个女生团体，以一班的于晴为首，势力不仅在高三一班非常强大，甚至蔓延到了整个学校。

以于晴为首，嗯，看来不是什么好团体。

我因为睡得不好有点困倦，有一搭没一搭的听着。听完后我感叹着表示，这男生真是个人物，能引得公主团的内斗，实在是有本事。而且侠肝义胆，除暴安良。的确要去拜会一下，表示感谢。我还没说完，就被婉儿恶狠狠的打断了。

“凌薇，重点是这个男生很帅气啊。”婉儿扔下酸奶，气呼呼的看着我说。

“我的重点也是啊。”我很疑惑，“不然怎么能惹得她们内斗呢？” 说完，我径直起身，拿起两人吃完的饭碗，送到洗碗间。
`;
  this.is_title = 2;
  if( this.view_type == 2 ) this.view_type = 3;
  break;


      //叙事增减
      case"叙事增减一" :
      this.current_note_markdown = `
根据事件本身，自己决定增加多少解说和描写。根据之前的练习，重写写出小说段落。


      `;
      if(localStorage.getItem("单纯讲事一")!=null){
        this.current_note_markdown+=localStorage.getItem("单纯讲事一");
      }
      else{
        this.current_note_markdown+=`
        但单纯讲事一还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"叙事增减二" :
      this.current_note_markdown = `
根据事件本身，自己决定增加多少解说和描写。根据之前的练习，重写写出小说段落。


      `;
      if(localStorage.getItem("单纯讲事二")!=null){
        this.current_note_markdown+=localStorage.getItem("单纯讲事二");
      }
      else{
        this.current_note_markdown+=`
        但单纯讲事二还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"叙事增减三" :
      this.current_note_markdown = `
根据事件本身，自己决定增加多少解说和描写。根据之前的练习，重写写出小说段落。


      `;
      if(localStorage.getItem("单纯讲事三")!=null){
        this.current_note_markdown+=localStorage.getItem("单纯讲事三");
      }
      else{
        this.current_note_markdown+=`
        但单纯讲事三还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"叙事增减四" :
      this.current_note_markdown = `
根据事件本身，自己决定增加多少解说和描写。根据之前的练习，重写写出小说段落。


      `;
      if(localStorage.getItem("单纯讲事四")!=null){
        this.current_note_markdown+=localStorage.getItem("单纯讲事四");
      }
      else{
        this.current_note_markdown+=`
        但单纯讲事四还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"叙事增减五" :
      this.current_note_markdown = `
根据事件本身，自己决定增加多少解说和描写。根据之前的练习，重写写出小说段落。


      `;
      if(localStorage.getItem("单纯讲事五")!=null){
        this.current_note_markdown+=localStorage.getItem("单纯讲事五");
      }
      else{
        this.current_note_markdown+=`
        但单纯讲事五还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"叙事增减六" :
      this.current_note_markdown = `
根据事件本身，自己决定增加多少解说和描写。根据之前的练习，重写写出小说段落。


      `;
      if(localStorage.getItem("单纯讲事六")!=null){
        this.current_note_markdown+=localStorage.getItem("单纯讲事六");
      }
      else{
        this.current_note_markdown+=`
        但单纯讲事六还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"叙事增减七" :
      this.current_note_markdown = `
根据事件本身，自己决定增加多少解说和描写。根据之前的练习，重写写出小说段落。


      `;
      if(localStorage.getItem("单纯讲事七")!=null){
        this.current_note_markdown+=localStorage.getItem("单纯讲事七");
      }
      else{
        this.current_note_markdown+=`
        但单纯讲事七还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"叙事增减八" :
      this.current_note_markdown = `
根据事件本身，自己决定增加多少解说和描写。根据之前的练习，重写写出小说段落。


      `;
      if(localStorage.getItem("单纯讲事八")!=null){
        this.current_note_markdown+=localStorage.getItem("单纯讲事八");
      }
      else{
        this.current_note_markdown+=`
        但单纯讲事八还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"叙事增减九" :
      this.current_note_markdown = `
根据事件本身，自己决定增加多少解说和描写。根据之前的练习，重写写出小说段落。


      `;
      if(localStorage.getItem("单纯讲事九")!=null){
        this.current_note_markdown+=localStorage.getItem("单纯讲事九");
      }
      else{
        this.current_note_markdown+=`
        但单纯讲事九还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"叙事增减十" :
      this.current_note_markdown = `
根据事件本身，自己决定增加多少解说和描写。根据之前的练习，重写写出小说段落。


      `;
      if(localStorage.getItem("单纯讲事十")!=null){
        this.current_note_markdown+=localStorage.getItem("单纯讲事十");
      }
      else{
        this.current_note_markdown+=`
        但单纯讲事十还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;



      //单纯讲事
      case"单纯讲事一" :
      this.current_note_markdown = `
请根据你之前的练习，把事件部分单独抽出来。并用补充满起因，经过，结果，时间，地点，人物六要素的方式，把事件写完整。（如果某部分不清楚，可以自行补充或者写“不详”，但要补充完整。）


      `;
      if(localStorage.getItem("叙事要素一")!=null){
        this.current_note_markdown+=localStorage.getItem("叙事要素一");
      }
      else{
        this.current_note_markdown+=`
        但叙事要素一还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"单纯讲事二" :
      this.current_note_markdown = `
请根据你之前的练习，把事件部分单独抽出来。并用补充满起因，经过，结果，时间，地点，人物六要素的方式，把事件写完整。（如果某部分不清楚，可以自行补充或者写“不详”，但要补充完整。）


      `;
      if(localStorage.getItem("叙事要素二")!=null){
        this.current_note_markdown+=localStorage.getItem("叙事要素二");
      }
      else{
        this.current_note_markdown+=`
        但叙事要素二还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"单纯讲事三" :
      this.current_note_markdown = `
请根据你之前的练习，把事件部分单独抽出来。并用补充满起因，经过，结果，时间，地点，人物六要素的方式，把事件写完整。（如果某部分不清楚，可以自行补充或者写“不详”，但要补充完整。）


      `;
      if(localStorage.getItem("叙事要素三")!=null){
        this.current_note_markdown+=localStorage.getItem("叙事要素三");
      }
      else{
        this.current_note_markdown+=`
        但叙事要素三还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"单纯讲事四" :
      this.current_note_markdown = `
请根据你之前的练习，把事件部分单独抽出来。并用补充满起因，经过，结果，时间，地点，人物六要素的方式，把事件写完整。（如果某部分不清楚，可以自行补充或者写“不详”，但要补充完整。）


      `;
      if(localStorage.getItem("叙事要素四")!=null){
        this.current_note_markdown+=localStorage.getItem("叙事要素四");
      }
      else{
        this.current_note_markdown+=`
        但叙事要素四还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"单纯讲事五" :
      this.current_note_markdown = `
请根据你之前的练习，把事件部分单独抽出来。并用补充满起因，经过，结果，时间，地点，人物六要素的方式，把事件写完整。（如果某部分不清楚，可以自行补充或者写“不详”，但要补充完整。）


      `;
      if(localStorage.getItem("叙事要素五")!=null){
        this.current_note_markdown+=localStorage.getItem("叙事要素五");
      }
      else{
        this.current_note_markdown+=`
        但叙事要素五还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"单纯讲事六" :
      this.current_note_markdown = `
请根据你之前的练习，把事件部分单独抽出来。并用补充满起因，经过，结果，时间，地点，人物六要素的方式，把事件写完整。（如果某部分不清楚，可以自行补充或者写“不详”，但要补充完整。）


      `;
      if(localStorage.getItem("叙事要素六")!=null){
        this.current_note_markdown+=localStorage.getItem("叙事要素六");
      }
      else{
        this.current_note_markdown+=`
        但叙事要素六还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"单纯讲事七" :
      this.current_note_markdown = `
请根据你之前的练习，把事件部分单独抽出来。并用补充满起因，经过，结果，时间，地点，人物六要素的方式，把事件写完整。（如果某部分不清楚，可以自行补充或者写“不详”，但要补充完整。）


      `;
      if(localStorage.getItem("叙事要素七")!=null){
        this.current_note_markdown+=localStorage.getItem("叙事要素七");
      }
      else{
        this.current_note_markdown+=`
        但叙事要素七还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"单纯讲事八" :
      this.current_note_markdown = `
请根据你之前的练习，把事件部分单独抽出来。并用补充满起因，经过，结果，时间，地点，人物六要素的方式，把事件写完整。（如果某部分不清楚，可以自行补充或者写“不详”，但要补充完整。）


      `;
      if(localStorage.getItem("叙事要素八")!=null){
        this.current_note_markdown+=localStorage.getItem("叙事要素八");
      }
      else{
        this.current_note_markdown+=`
        但叙事要素八还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"单纯讲事九" :
      this.current_note_markdown = `
请根据你之前的练习，把事件部分单独抽出来。并用补充满起因，经过，结果，时间，地点，人物六要素的方式，把事件写完整。（如果某部分不清楚，可以自行补充或者写“不详”，但要补充完整。）


      `;
      if(localStorage.getItem("叙事要素九")!=null){
        this.current_note_markdown+=localStorage.getItem("叙事要素九");
      }
      else{
        this.current_note_markdown+=`
        但叙事要素九还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"单纯讲事十" :
      this.current_note_markdown = `
请根据你之前的练习，把事件部分单独抽出来。并用补充满起因，经过，结果，时间，地点，人物六要素的方式，把事件写完整。（如果某部分不清楚，可以自行补充或者写“不详”，但要补充完整。）


      `;
      if(localStorage.getItem("叙事要素十")!=null){
        this.current_note_markdown+=localStorage.getItem("叙事要素十");
      }
      else{
        this.current_note_markdown+=`
        但叙事要素十还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;



   //叙事要素
   case"叙事要素一" :
   this.current_note_markdown = `
请分辨下方段落中，哪些是事件本身，哪些是描写，哪些是解说。

段落如下：

夏日炎炎，蝉声扰扰。年级大会开在体育馆里，没有空调。

同学们在小声的窃窃私语，嘈杂闷热的环境中，我一边用手抹去脸上的汗珠，一边拿着草稿纸演算数学作业中的最后一道题。

题目曲曲折折，纷繁复杂。任我怎么集中精力，还是有一个数字算不对。心中不免得有些烦闷，觉得级长在台上讲的话，更加饶人清静。

笔狠狠的在纸上划出一条分割线。重新来……我咬牙切齿的正打算再算一遍。旁边的婉儿忽然推了我一下，手一歪，划出一条斜线。

“哎！别算了。要宣布排名了。”她小声在我耳边叫道。

我一惊，从数学题中回过神来，抬起头看麦克风前的级长。果然他正经的清了清嗓子：“接下来，表扬一下本次考试成绩优异的同学。”略微的停顿了半秒，才缓缓说道：

   `;
   this.is_title = 2;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

  
   case"叙事要素二" :
   this.current_note_markdown = `
请分辨下方段落中，哪些是事件本身，哪些是描写，哪些是解说。

段落如下：

我刚踏进家门，就被脚底的东西绊了一跤。姿势难看的摔在地板上，我诧异的扫了一眼，发现是一堆杂乱无章的大包小包堆在门口，看上去像是妈妈出差要用的行李。

……这相隔甚远的缝隙，和难以跨越的障碍，做为陷阱实在太浑然天成了。妈妈这方面实在是有天赋。就我这样的运动神经都不免中招。实在是根骨清奇。

我正在感叹，妈妈就已经闻声跑出来了。她看到我摔在地上，心疼的过来扶我起来，连声道歉道：“凌薇对不起啊，我不是故意弄成这样的，刚刚还想着把门口清理一下，结果找衣服一下找忘了啦。”

找……衣……服……？！

我不可思议的瞪着妈妈，看着她羞愧的表情，再往房间里面一瞟，心情几乎是崩溃的。

只见妈妈的房间里，一堆白衣服，层层叠叠的乱扔在地上，房间靠墙摆着三个大衣柜，并着几个小抽屉都被翻得凌乱不堪，床上更是堆满了衣物，连被子都看不到了。一切都被雪白色的布料遮盖住了。

这实在和我预想中的不太一样，我愣愣的看着昨天才打扫干净的房间，出门时还一尘不染，回来已经是满地开花了。反差大的实在有点让我难以接受。这真是……

“真是‘忽如一夜春风来，千树万树梨花开’吧。”妈妈顺着我的眼神看过去，看着一屋子的白色，愉悦的顺口接道。

我抽了抽眼角，一阵无力感蔓上了全身。
   `;
   this.is_title = 2;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"叙事要素三" :
   this.current_note_markdown = `
请分辨下方段落中，哪些是事件本身，哪些是描写，哪些是解说。

段落如下：

妈妈是个生活废，家务一窍不通。连自己都照顾得一塌糊涂，居然忽然脑袋抽风的去领养了孩子。

理由也很莫名。她说她想要一个自己的家，暂时找不到丈夫，就先要一个孩子。

这简直不是正常女人会有的思路……

不过就算领养了孩子，妈妈的生活技能还是没有因为母爱而提升一分一毫，反倒是把我锻炼得家务全能。回忆起以前妈妈煮的稀番茄烂炒蛋混蒜头粥，我就觉得自己能长这么大真是运气昌盛。

我一边埋头在衣服堆里面寻找，一边暗暗抱怨。

找不到衣服这种事发生已经不止一次了，因为妈妈穿衣服奇葩的只喜欢穿白色。

衣柜这么大，衣服何其多。都是一个色调。这得多难找。所以这种事情已经是常态了。

我扒开表层的一堆白衣服，整个人都探进衣柜里去找衣服。跟着我走进房间的妈妈，就随便在旁边找了个地方，翘腿一坐，悠闲的看起书来。

要点脸行吗……我还在这帮你找衣服呢，要看书好歹走远一点啊……我抬头怒视老妈。

但妈妈丝毫不介意，欣慰的对我甜甜一笑。

“……”我不想说什么了。

最终我还是找到了那件衣服。一身收腰长裙，裙摆底部缀着闪亮的星形蓝色亮片。漫天华光般连成一片，绵延又不凌乱，十分精致美观。

`;
   this.is_title = 2;
   if( this.view_type == 2 ) this.view_type = 3;
   break;


   case"叙事要素四" :
   this.current_note_markdown = `
请分辨下方段落中，哪些是事件本身，哪些是描写，哪些是解说。

段落如下：

我怔了怔，猛然想起了那张淡色发黄的纸片，年前我整理抽屉时，从最深处把它翻了出来。上面模糊的写着一串地址，字迹幼嫩而又工整。

抓着那张纸片，我的鼻尖甚至若有若无的闻到了桂花香。这么浓烈的香气，就像是在童年的剑道馆外，那一片开得灿灿烂烂的四季桂花海。

有些事情如果不去想，就尘封在记忆的深处，像是落满了灰烬琐屑，再也想不起来。然而只要出现一个线索，就能勾起一大片的回忆来，一幕幕甚至清晰可见。

我见到他是在剑道馆。

在那一片星星点点的纯白桂花前。

时间模糊了那么多记忆，我居然还能想起那时的细节。

也许对于女孩子来说，学习剑道太过辛苦了，所以让我记忆尤深。那时的我，瘦小羸弱，一遍一遍的被打倒在地，挣扎着爬不起来。木质的地板冷冰冰的，汗水和泪水一起在脸上流淌，看着眼前的景物一片模糊。

师父曾经说过，能够一击必杀的时候，绝不要留下一丝余地。于是所有的男孩，都居高临下的看着我在地上挣扎，手上的剑停在我喉咙上，一脸轻蔑。这是对最弱者的鄙视，没有人想跟我练剑。

但是他不一样。他主动来找我。甚至对剑的时候，他会故意把招式放慢三拍，让我跟得上他的步伐。力道也会放缓三分，不轻不重的落在我身上。就算我还是被打倒，也能够很快的爬起来。而他总是弯下腰来，眼睛干净清澈的看着我，小心的问：“要休息吗？”  `;
   this.is_title = 2;
   if( this.view_type == 2 ) this.view_type = 3;
   break;


   case"叙事要素五" :
   this.current_note_markdown = `
请分辨下方段落中，哪些是事件本身，哪些是描写，哪些是解说。

段落如下：

安杰找来姐姐安欣帮忙，在江德福一班战友面前表现得无比体贴温柔。江德福高兴之余多喝了几杯，不料把自己每天的 “三洗”改造活动捅了出去。次日，酒醒后的江德福面对战友的各种嘲笑头痛不已。安杰怀孕了，这可把江德福高兴坏了。安杰的姐夫欧阳懿调回本地工作，安家两姐妹从小就在各种事上暗暗较劲，所以在比老公这件事情上，安杰更是严阵以待。拿到欧阳懿送来的请帖后，安杰不仅翻箱倒柜给自己找体面的裙子，更是逼江德福套上了文质彬彬的白西装，饭桌上，安泰一家人对江德福热情有加，安欣夫妇心里不免吃味。
  `;
   this.is_title = 2;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"叙事要素六" :
   this.current_note_markdown = `
请分辨下方段落中，哪些是事件本身，哪些是描写，哪些是解说。

段落如下：

但是小孩子总是残忍又健忘，当妈妈告诉我这个地方很远，要长大才能去之后，我慢慢的就把这件事淡忘了。日历一页页的翻过，时间一晃，也十年过去了。如今猛然记起来，寄去的信却没有回音。

就像是脑海中忽然盘旋起的熟悉旋律，却想不起歌名。总是会更加的绞尽脑汁去想，如同走火入魔一般。这个未完成的愿望，变成了一种执念，隐隐的沉在心里，让人很不舒服。

诚然，我是一个很在意诺言的人，但是这怎么跟龙鳞说？就为了小时候的一句话，如今翻天覆地的去找？我犹豫了一会，还是口气平淡的回答：“只是不想欠别人太多人情罢了。”

听到这个答案，龙鳞明显不满意，他幽幽的叹了口气，貌似很失望的抱怨道：“欠我人情就没关系么……好吧……那有消息再联系你吧。薇儿再见。”

跟这家伙还有人情可言？

是忘了我拔剑相助的峥嵘岁月了吗？

我挑了挑眉，“我俩啥关系啊。还有，别叫我……”

话还没说完。咔。这混蛋把电话挂了。

我望着嘟嘟响着忙音的手机，眼角一抽。最终还是看在国际长途和有求于人的份上，忍了。

`;
   this.is_title = 2;
   if( this.view_type == 2 ) this.view_type = 3;
   break;


   case"叙事要素七" :
   this.current_note_markdown = `
请分辨下方段落中，哪些是事件本身，哪些是描写，哪些是解说。

段落如下：

屋外风吹着树林沙沙作响。垂下手来，我看看窗外。南方沿海四季炎热，又是桂花开放的季节。若有若无的清幽香气浮沉在飘渺的夜色中。临别时的笑容还历历在目，转眼就十年。

再见面的话……会是怎么样呢。我默默的回身躺在沙发上。

完全想不到啊。
`;
   this.is_title = 2;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"叙事要素八" :
   this.current_note_markdown = `
请分辨下方段落中，哪些是事件本身，哪些是描写，哪些是解说。

段落如下：

第二天是个阳光明媚的好天气，门铃如往常一般响起，我叼着面包去开门，边吞咽面包边拉开了房门，婉儿站在门廊的阳光里。树影的光斑，映着她的脸一片明媚。

“凌薇，早啊。”她冲我打招呼，然后仔细看了看我的黑眼圈，“又很晚睡了？”
 
“还好。”我拿起书包，关上房门，踏进明亮的阳光里。

`;
   this.is_title = 2;
   if( this.view_type == 2 ) this.view_type = 3;
   break;


   case"叙事要素九" :
   this.current_note_markdown = `
请分辨下方段落中，哪些是事件本身，哪些是描写，哪些是解说。

段落如下：

今天的新闻主要是关于新来的转学生。婉儿站在公交站台下，水亮的眼睛神采奕奕，“一班又转来了个男生，混血儿诶！长的超好看！”这不是第一次婉儿说一个男生好看了，貌似几周前也说过一次。合着婉儿眼里都是美男啊。我毫无兴致的打了个哈欠。

对比起我的昏昏欲睡，婉儿显得十分兴致勃勃，拉着我说：“今天我们路过一班的时候，去看看吧！”

路过一班？我抬起头，有些讶异的看了婉儿一眼。二班和一班根本不在同一层，还一个西北角，一个东北角。隔着十几级楼梯和长长的走廊。这都能路过的么？

但是迎面撞上了婉儿期待的眼神，我无言的挪了挪步伐，随意的应道：“哦，好啊。看看吧。”

然而我的这个反应还是让婉儿很不满，她瞪着我叫道：“哎？！你这是什么反应。对好看的男生花痴，是女生的天职啊。你这是失职你造吗？！”

“……”

失职大发了。原来花痴是那么正义的事儿吗。我无奈的看着婉儿说：“那你把我开除好了。”

远处电线杆上传来一两声脆脆的鸟鸣，和拍打翅膀的微响。

婉儿听到后，双手比划了个超能力的姿势，对着我叫道：“好啊，看我开除你。”说完就挥着手乱舞一气。

夏日的风悠悠的吹着。公车带着热气开进了站台，缓缓的停在了挥舞双手的婉儿面前。

“……别闹了。公车来了。”

`;
   this.is_title = 2;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"叙事要素十" :
   this.current_note_markdown = `
请分辨下方段落中，哪些是事件本身，哪些是描写，哪些是解说。

段落如下：

因为公车的打扰，最终我还是没被从女生行列开除出去。按照婉儿的说法，这个技能被打断了会有很长的技能冷却时间，所以只好放我一马。鉴于我暂时还是女生（我对这个说法表示了抗议）婉儿依然坚守岗位，继续给我灌输各种八卦。

于是午饭的时候，我一边咬着鸡排，一边漫不经心的听婉儿的午间新闻。婉儿吃得很少，只吃了一小碗面以后，就咬着酸奶的吸管，继续绘声绘色的跟我介绍那个男生。

据她说，新来的男生简直就是蓝颜祸水，因为长得太好，刚来没几天就引得女同学纷纷向他表白。甚至引发的学校最大团体“公主团”的内部矛盾，原本昔日姐妹情深，成为情敌翻脸不认人。

还好后来她们统统都被拒绝了，于是矛盾也就烟消云散，她们重新变成了革命好战友……

通过婉儿的科普，我知道公主团是一个女生团体，以一班的于晴为首，势力不仅在高三一班非常强大，甚至蔓延到了整个学校。

以于晴为首，嗯，看来不是什么好团体。

我因为睡得不好有点困倦，有一搭没一搭的听着。听完后我感叹着表示，这男生真是个人物，能引得公主团的内斗，实在是有本事。而且侠肝义胆，除暴安良。的确要去拜会一下，表示感谢。我还没说完，就被婉儿恶狠狠的打断了。

“凌薇，重点是这个男生很帅气啊。”婉儿扔下酸奶，气呼呼的看着我说。

“我的重点也是啊。”我很疑惑，“不然怎么能惹得她们内斗呢？” 说完，我径直起身，拿起两人吃完的饭碗，送到洗碗间。
`;
   this.is_title = 2;
   if( this.view_type == 2 ) this.view_type = 3;
   break;



    //画面选择
    case"画面选择一" :
    this.current_note_markdown = `
请选择画面中最重要的部分，进行详细描写。其他部分可以只描写色彩或光影。

![](https://img.pic88.com/preview/2020/10/06/16019890275f7c69a3477cb.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDEwMDYyMDU3MDYxNzIyMDE=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
    `;
  

    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"画面选择二" :
    this.current_note_markdown = `
请选择画面中最重要的部分，进行详细描写。其他部分可以只描写色彩或光影。

![](https://img.pic88.com/preview/2020/10/01/16015175545f7537f200b69.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDEwMDEwOTU5MTM0MDkxOTg=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
    `;
  

    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"画面选择三" :
    this.current_note_markdown = `
请选择画面中最重要的部分，进行详细描写。其他部分可以只描写色彩或光影。

![](https://img.pic88.com/501204393.jpg?imageMogr2/quality/100!/thumbnail/640|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMTAyMjcxOTI3MjA5MDI2MA==/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
    `;
  

    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"画面选择四" :
    this.current_note_markdown = `
请选择画面中最重要的部分，进行详细描写。其他部分可以只描写色彩或光影。

![](https://img.pic88.com/500863001.jpg?imageMogr2/quality/100!/thumbnail/640|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMTAyMjcxNDU1MzYxMTU1OTE=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
    `;
  

    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"画面选择五" :
    this.current_note_markdown = `
请选择画面中最重要的部分，进行详细描写。其他部分可以只描写色彩或光影。

![](https://img.pic88.com/preview/2020/09/02/1599054823810703.jpg?imageMogr2/quality/100!/thumbnail/640|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA5MDIyMTUzNDUxOTc1NDA=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
    `;
  

    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"画面选择六" :
    this.current_note_markdown = `
请选择画面中最重要的部分，进行详细描写。其他部分可以只描写色彩或光影。

![](https://img.pic88.com/preview/2020/08/05/15966336991454343.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MDUyMDQ5NTcyMDk3MzE=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
    `;
  

    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"画面选择七" :
    this.current_note_markdown = `
请选择画面中最重要的部分，进行详细描写。其他部分可以只描写色彩或光影。

![](https://img.pic88.com/preview/2020/08/05/15966337231454154.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MDUxMjQ5NTMyMDk1NDM=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
    `;
  

    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"画面选择八" :
    this.current_note_markdown = `
请选择画面中最重要的部分，进行详细描写。其他部分可以只描写色彩或光影。

![](https://img.pic88.com/preview/2020/08/05/15966370991432566.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MDUyMDQyMTExODc5NTM=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
    `;
  

    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"画面选择九" :
    this.current_note_markdown = `
请选择画面中最重要的部分，进行详细描写。其他部分可以只描写色彩或光影。

![](https://img.pic88.com/500807486.jpg?imageMogr2/quality/100!/thumbnail/640|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMTAyMjcxNjA5MDE4NzY2MA==/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
    `;
  

    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"画面选择十" :
    this.current_note_markdown = `
请选择画面中最重要的部分，进行详细描写。其他部分可以只描写色彩或光影。

![](https://img.pic88.com/preview/2020/08/05/15966448431369640.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MDUyMDE5MjAxMjUwMjg=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
    `;
  

    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;




    //光影练习
    case"光影练习一" :
    this.current_note_markdown = `
请重点描写图片中的光影。

![](https://img.pic88.com/preview/2020/10/06/16019890275f7c69a3477cb.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDEwMDYyMDU3MDYxNzIyMDE=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
    `;
  

    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"光影练习二" :
    this.current_note_markdown = `
请重点描写图片中的光影。

![](https://img.pic88.com/preview/2020/10/01/16015175545f7537f200b69.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDEwMDEwOTU5MTM0MDkxOTg=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
    `;
  

    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"光影练习三" :
    this.current_note_markdown = `
请重点描写图片中的光影。

![](https://img.pic88.com/501204393.jpg?imageMogr2/quality/100!/thumbnail/640|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMTAyMjcxOTI3MjA5MDI2MA==/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
    `;
  

    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"光影练习四" :
    this.current_note_markdown = `
请重点描写图片中的光影。

![](https://img.pic88.com/500863001.jpg?imageMogr2/quality/100!/thumbnail/640|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMTAyMjcxNDU1MzYxMTU1OTE=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
    `;
  

    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"光影练习五" :
    this.current_note_markdown = `
请重点描写图片中的光影。

![](https://img.pic88.com/preview/2020/09/02/1599054823810703.jpg?imageMogr2/quality/100!/thumbnail/640|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA5MDIyMTUzNDUxOTc1NDA=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
    `;
  

    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"光影练习六" :
    this.current_note_markdown = `
请重点描写图片中的光影。

![](https://img.pic88.com/preview/2020/08/05/15966336991454343.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MDUyMDQ5NTcyMDk3MzE=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
    `;
  

    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"光影练习七" :
    this.current_note_markdown = `
请重点描写图片中的光影。

![](https://img.pic88.com/preview/2020/08/05/15966337231454154.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MDUxMjQ5NTMyMDk1NDM=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
    `;
  

    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"光影练习八" :
    this.current_note_markdown = `
请重点描写图片中的光影。

![](https://img.pic88.com/preview/2020/08/05/15966370991432566.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MDUyMDQyMTExODc5NTM=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
    `;
  

    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"光影练习九" :
    this.current_note_markdown = `
请重点描写图片中的光影。

![](https://img.pic88.com/500807486.jpg?imageMogr2/quality/100!/thumbnail/640|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMTAyMjcxNjA5MDE4NzY2MA==/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
    `;
  

    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"光影练习十" :
    this.current_note_markdown = `
请重点描写图片中的光影。

![](https://img.pic88.com/preview/2020/08/05/15966448431369640.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MDUyMDE5MjAxMjUwMjg=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
    `;
  

    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;




     //形状练习
     case"形状练习一" :
     this.current_note_markdown = `
请重点描写图片中的形状。

![](https://img.pic88.com/preview/2020/10/06/16019890275f7c69a3477cb.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDEwMDYyMDU3MDYxNzIyMDE=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"形状练习二" :
     this.current_note_markdown = `
请重点描写图片中的形状。

![](https://img.pic88.com/preview/2020/10/01/16015175545f7537f200b69.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDEwMDEwOTU5MTM0MDkxOTg=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"形状练习三" :
     this.current_note_markdown = `
请重点描写图片中的形状。

![](https://img.pic88.com/501204393.jpg?imageMogr2/quality/100!/thumbnail/640|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMTAyMjcxOTI3MjA5MDI2MA==/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"形状练习四" :
     this.current_note_markdown = `
请重点描写图片中的形状。

![](https://img.pic88.com/500863001.jpg?imageMogr2/quality/100!/thumbnail/640|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMTAyMjcxNDU1MzYxMTU1OTE=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"形状练习五" :
     this.current_note_markdown = `
请重点描写图片中的形状。

![](https://img.pic88.com/preview/2020/09/02/1599054823810703.jpg?imageMogr2/quality/100!/thumbnail/640|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA5MDIyMTUzNDUxOTc1NDA=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"形状练习六" :
     this.current_note_markdown = `
请重点描写图片中的形状。

![](https://img.pic88.com/preview/2020/08/05/15966336991454343.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MDUyMDQ5NTcyMDk3MzE=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"形状练习七" :
     this.current_note_markdown = `
请重点描写图片中的形状。

![](https://img.pic88.com/preview/2020/08/05/15966337231454154.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MDUxMjQ5NTMyMDk1NDM=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"形状练习八" :
     this.current_note_markdown = `
请重点描写图片中的形状。

![](https://img.pic88.com/preview/2020/08/05/15966370991432566.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MDUyMDQyMTExODc5NTM=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"形状练习九" :
     this.current_note_markdown = `
请重点描写图片中的形状。

![](https://img.pic88.com/500807486.jpg?imageMogr2/quality/100!/thumbnail/640|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMTAyMjcxNjA5MDE4NzY2MA==/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"形状练习十" :
     this.current_note_markdown = `
请重点描写图片中的形状。

![](https://img.pic88.com/preview/2020/08/05/15966448431369640.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MDUyMDE5MjAxMjUwMjg=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;




     //色彩练习
     case"色彩练习一" :
     this.current_note_markdown = `
请重点描写图片中的色彩。

![](https://img.pic88.com/preview/2020/10/06/16019890275f7c69a3477cb.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDEwMDYyMDU3MDYxNzIyMDE=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"色彩练习二" :
     this.current_note_markdown = `
请重点描写图片中的色彩。

![](https://img.pic88.com/preview/2020/10/01/16015175545f7537f200b69.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDEwMDEwOTU5MTM0MDkxOTg=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"色彩练习三" :
     this.current_note_markdown = `
请重点描写图片中的色彩。

![](https://img.pic88.com/501204393.jpg?imageMogr2/quality/100!/thumbnail/640|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMTAyMjcxOTI3MjA5MDI2MA==/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"色彩练习四" :
     this.current_note_markdown = `
请重点描写图片中的色彩。

![](https://img.pic88.com/500863001.jpg?imageMogr2/quality/100!/thumbnail/640|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMTAyMjcxNDU1MzYxMTU1OTE=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"色彩练习五" :
     this.current_note_markdown = `
请重点描写图片中的色彩。

![](https://img.pic88.com/preview/2020/09/02/1599054823810703.jpg?imageMogr2/quality/100!/thumbnail/640|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA5MDIyMTUzNDUxOTc1NDA=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"色彩练习六" :
     this.current_note_markdown = `
请重点描写图片中的色彩。

![](https://img.pic88.com/preview/2020/08/05/15966336991454343.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MDUyMDQ5NTcyMDk3MzE=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"色彩练习七" :
     this.current_note_markdown = `
请重点描写图片中的色彩。

![](https://img.pic88.com/preview/2020/08/05/15966337231454154.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MDUxMjQ5NTMyMDk1NDM=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"色彩练习八" :
     this.current_note_markdown = `
请重点描写图片中的色彩。

![](https://img.pic88.com/preview/2020/08/05/15966370991432566.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MDUyMDQyMTExODc5NTM=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"色彩练习九" :
     this.current_note_markdown = `
请重点描写图片中的色彩。

![](https://img.pic88.com/500807486.jpg?imageMogr2/quality/100!/thumbnail/640|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMTAyMjcxNjA5MDE4NzY2MA==/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"色彩练习十" :
     this.current_note_markdown = `
请重点描写图片中的色彩。

![](https://img.pic88.com/preview/2020/08/05/15966448431369640.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MDUyMDE5MjAxMjUwMjg=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;



     //画面练习
     case"画面练习一" :
     this.current_note_markdown = `
请试着记住下面的画面。仔细看，闭上眼睛回忆。如果确认记住了，就不要看图，凭记忆描写这张图片。

![](https://img.pic88.com/preview/2020/10/06/16019890275f7c69a3477cb.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDEwMDYyMDU3MDYxNzIyMDE=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"画面练习二" :
     this.current_note_markdown = `
请试着记住下面的画面。仔细看，闭上眼睛回忆。如果确认记住了，就不要看图，凭记忆描写这张图片。

![](https://img.pic88.com/preview/2020/10/01/16015175545f7537f200b69.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDEwMDEwOTU5MTM0MDkxOTg=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"画面练习三" :
     this.current_note_markdown = `
请试着记住下面的画面。仔细看，闭上眼睛回忆。如果确认记住了，就不要看图，凭记忆描写这张图片。

![](https://img.pic88.com/501204393.jpg?imageMogr2/quality/100!/thumbnail/640|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMTAyMjcxOTI3MjA5MDI2MA==/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"画面练习四" :
     this.current_note_markdown = `
请试着记住下面的画面。仔细看，闭上眼睛回忆。如果确认记住了，就不要看图，凭记忆描写这张图片。

![](https://img.pic88.com/500863001.jpg?imageMogr2/quality/100!/thumbnail/640|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMTAyMjcxNDU1MzYxMTU1OTE=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"画面练习五" :
     this.current_note_markdown = `
请试着记住下面的画面。仔细看，闭上眼睛回忆。如果确认记住了，就不要看图，凭记忆描写这张图片。

![](https://img.pic88.com/preview/2020/09/02/1599054823810703.jpg?imageMogr2/quality/100!/thumbnail/640|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA5MDIyMTUzNDUxOTc1NDA=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"画面练习六" :
     this.current_note_markdown = `
请试着记住下面的画面。仔细看，闭上眼睛回忆。如果确认记住了，就不要看图，凭记忆描写这张图片。

![](https://img.pic88.com/preview/2020/08/05/15966336991454343.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MDUyMDQ5NTcyMDk3MzE=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"画面练习七" :
     this.current_note_markdown = `
请试着记住下面的画面。仔细看，闭上眼睛回忆。如果确认记住了，就不要看图，凭记忆描写这张图片。

![](https://img.pic88.com/preview/2020/08/05/15966337231454154.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MDUxMjQ5NTMyMDk1NDM=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"画面练习八" :
     this.current_note_markdown = `
请试着记住下面的画面。仔细看，闭上眼睛回忆。如果确认记住了，就不要看图，凭记忆描写这张图片。

![](https://img.pic88.com/preview/2020/08/05/15966370991432566.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MDUyMDQyMTExODc5NTM=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"画面练习九" :
     this.current_note_markdown = `
请试着记住下面的画面。仔细看，闭上眼睛回忆。如果确认记住了，就不要看图，凭记忆描写这张图片。

![](https://img.pic88.com/500807486.jpg?imageMogr2/quality/100!/thumbnail/640|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMTAyMjcxNjA5MDE4NzY2MA==/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"画面练习十" :
     this.current_note_markdown = `
请试着记住下面的画面。仔细看，闭上眼睛回忆。如果确认记住了，就不要看图，凭记忆描写这张图片。

![](https://img.pic88.com/preview/2020/08/05/15966448431369640.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MDUyMDE5MjAxMjUwMjg=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;





      //对话精炼
      case"对话精炼一" :
      this.current_note_markdown = `
请在你的对话中，加入其他描写。能用其他描写代替的，就不要写对话。精简你的对话，把对话当做最后的大招来使用。


      `;
      if(localStorage.getItem("口语练习一")!=null){
        this.current_note_markdown+=localStorage.getItem("口语练习一");
      }
      else{
        this.current_note_markdown+=`
        但口语练习一还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"对话精炼二" :
      this.current_note_markdown = `
请在你的对话中，加入其他描写。能用其他描写代替的，就不要写对话。精简你的对话，把对话当做最后的大招来使用。


      `;
      if(localStorage.getItem("口语练习二")!=null){
        this.current_note_markdown+=localStorage.getItem("口语练习二");
      }
      else{
        this.current_note_markdown+=`
        但口语练习二还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"对话精炼三" :
      this.current_note_markdown = `
请在你的对话中，加入其他描写。能用其他描写代替的，就不要写对话。精简你的对话，把对话当做最后的大招来使用。


      `;
      if(localStorage.getItem("口语练习三")!=null){
        this.current_note_markdown+=localStorage.getItem("口语练习三");
      }
      else{
        this.current_note_markdown+=`
        但口语练习三还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"对话精炼四" :
      this.current_note_markdown = `
请在你的对话中，加入其他描写。能用其他描写代替的，就不要写对话。精简你的对话，把对话当做最后的大招来使用。


      `;
      if(localStorage.getItem("口语练习四")!=null){
        this.current_note_markdown+=localStorage.getItem("口语练习四");
      }
      else{
        this.current_note_markdown+=`
        但口语练习四还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"对话精炼五" :
      this.current_note_markdown = `
请在你的对话中，加入其他描写。能用其他描写代替的，就不要写对话。精简你的对话，把对话当做最后的大招来使用。


      `;
      if(localStorage.getItem("口语练习五")!=null){
        this.current_note_markdown+=localStorage.getItem("口语练习五");
      }
      else{
        this.current_note_markdown+=`
        但口语练习五还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"对话精炼六" :
      this.current_note_markdown = `
请在你的对话中，加入其他描写。能用其他描写代替的，就不要写对话。精简你的对话，把对话当做最后的大招来使用。


      `;
      if(localStorage.getItem("口语练习六")!=null){
        this.current_note_markdown+=localStorage.getItem("口语练习六");
      }
      else{
        this.current_note_markdown+=`
        但口语练习六还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"对话精炼七" :
      this.current_note_markdown = `
请在你的对话中，加入其他描写。能用其他描写代替的，就不要写对话。精简你的对话，把对话当做最后的大招来使用。


      `;
      if(localStorage.getItem("口语练习七")!=null){
        this.current_note_markdown+=localStorage.getItem("口语练习七");
      }
      else{
        this.current_note_markdown+=`
        但口语练习七还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"对话精炼八" :
      this.current_note_markdown = `
请在你的对话中，加入其他描写。能用其他描写代替的，就不要写对话。精简你的对话，把对话当做最后的大招来使用。


      `;
      if(localStorage.getItem("口语练习八")!=null){
        this.current_note_markdown+=localStorage.getItem("口语练习八");
      }
      else{
        this.current_note_markdown+=`
        但口语练习八还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"对话精炼九" :
      this.current_note_markdown = `
请在你的对话中，加入其他描写。能用其他描写代替的，就不要写对话。精简你的对话，把对话当做最后的大招来使用。


      `;
      if(localStorage.getItem("口语练习九")!=null){
        this.current_note_markdown+=localStorage.getItem("口语练习九");
      }
      else{
        this.current_note_markdown+=`
        但口语练习九还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"对话精炼十" :
      this.current_note_markdown = `
请在你的对话中，加入其他描写。能用其他描写代替的，就不要写对话。精简你的对话，把对话当做最后的大招来使用。


      `;
      if(localStorage.getItem("口语练习十")!=null){
        this.current_note_markdown+=localStorage.getItem("口语练习十");
      }
      else{
        this.current_note_markdown+=`
        但口语练习十还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;




      //口语练习
      case"口语练习一" :
      this.current_note_markdown = `
请扮演对话中的人物，大声读出对话。如果有不合适的地方，请进行更改。


      `;
      if(localStorage.getItem("对话练习一")!=null){
        this.current_note_markdown+=localStorage.getItem("对话练习一");
      }
      else{
        this.current_note_markdown+=`
        但对话练习一还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"口语练习二" :
      this.current_note_markdown = `
请扮演对话中的人物，大声读出对话。如果有不合适的地方，请进行更改。


      `;
      if(localStorage.getItem("对话练习二")!=null){
        this.current_note_markdown+=localStorage.getItem("对话练习二");
      }
      else{
        this.current_note_markdown+=`
        但对话练习二还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"口语练习三" :
      this.current_note_markdown = `
请扮演对话中的人物，大声读出对话。如果有不合适的地方，请进行更改。


      `;
      if(localStorage.getItem("对话练习三")!=null){
        this.current_note_markdown+=localStorage.getItem("对话练习三");
      }
      else{
        this.current_note_markdown+=`
        但对话练习三还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"口语练习四" :
      this.current_note_markdown = `
请扮演对话中的人物，大声读出对话。如果有不合适的地方，请进行更改。


      `;
      if(localStorage.getItem("对话练习四")!=null){
        this.current_note_markdown+=localStorage.getItem("对话练习四");
      }
      else{
        this.current_note_markdown+=`
        但对话练习四还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"口语练习五" :
      this.current_note_markdown = `
请扮演对话中的人物，大声读出对话。如果有不合适的地方，请进行更改。


      `;
      if(localStorage.getItem("对话练习五")!=null){
        this.current_note_markdown+=localStorage.getItem("对话练习五");
      }
      else{
        this.current_note_markdown+=`
        但对话练习五还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"口语练习六" :
      this.current_note_markdown = `
请扮演对话中的人物，大声读出对话。如果有不合适的地方，请进行更改。


      `;
      if(localStorage.getItem("对话练习六")!=null){
        this.current_note_markdown+=localStorage.getItem("对话练习六");
      }
      else{
        this.current_note_markdown+=`
        但对话练习六还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"口语练习七" :
      this.current_note_markdown = `
请扮演对话中的人物，大声读出对话。如果有不合适的地方，请进行更改。


      `;
      if(localStorage.getItem("对话练习七")!=null){
        this.current_note_markdown+=localStorage.getItem("对话练习七");
      }
      else{
        this.current_note_markdown+=`
        但对话练习七还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"口语练习八" :
      this.current_note_markdown = `
请扮演对话中的人物，大声读出对话。如果有不合适的地方，请进行更改。


      `;
      if(localStorage.getItem("对话练习八")!=null){
        this.current_note_markdown+=localStorage.getItem("对话练习八");
      }
      else{
        this.current_note_markdown+=`
        但对话练习八还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"口语练习九" :
      this.current_note_markdown = `
请扮演对话中的人物，大声读出对话。如果有不合适的地方，请进行更改。


      `;
      if(localStorage.getItem("对话练习九")!=null){
        this.current_note_markdown+=localStorage.getItem("对话练习九");
      }
      else{
        this.current_note_markdown+=`
        但对话练习九还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"口语练习十" :
      this.current_note_markdown = `
请扮演对话中的人物，大声读出对话。如果有不合适的地方，请进行更改。


      `;
      if(localStorage.getItem("对话练习十")!=null){
        this.current_note_markdown+=localStorage.getItem("对话练习十");
      }
      else{
        this.current_note_markdown+=`
        但对话练习十还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;




   //对话练习
   case"对话练习一" :
   this.current_note_markdown = `
请写出一场这样的对话：夫妻吵架

   `;
   this.is_title = 2;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"对话练习二" :
   this.current_note_markdown = `
请写出这样的对话：亲子拌嘴

   `;
   this.is_title = 2;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"对话练习三" :
   this.current_note_markdown = `
请写出这样的对话：情侣分手

   `;
   this.is_title = 2;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"对话练习四" :
   this.current_note_markdown = `
请写出这样的对话：下属询问自己是否能升职

   `;
   this.is_title = 2;
   if( this.view_type == 2 ) this.view_type = 3;
   break;


   case"对话练习五" :
   this.current_note_markdown = `
请写出这样的对话：长辈教育晚辈，但晚辈不服气。

   `;
   this.is_title = 2;
   if( this.view_type == 2 ) this.view_type = 3;
   break;


   case"对话练习六" :
   this.current_note_markdown = `
请写出这样的对话：父母在医院想向医生问出孩子的性别。

   `;
   this.is_title = 2;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"对话练习七" :
   this.current_note_markdown = `
请写出这样的对话：哥哥向弟弟借钱

   `;
   this.is_title = 2;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"对话练习八" :
   this.current_note_markdown = `
请写出这样的对话：战争中两国谈判

   `;
   this.is_title = 2;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"对话练习九" :
   this.current_note_markdown = `
请写出这样的对话：兄弟姐妹为争夺财产而互相指责

   `;
   this.is_title = 2;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"对话练习十" :
   this.current_note_markdown = `
请写出这样的对话：相亲时的对话

   `;
   this.is_title = 2;
   if( this.view_type == 2 ) this.view_type = 3;
   break;




   //偷听工程
   case"偷听工程一" :
   this.current_note_markdown = `
请记录你日常生活中，听到的精彩对话。

   `;
   this.is_title = 2;
   if( this.view_type == 2 ) this.view_type = 3;
   break;



   case"偷听工程二" :
   this.current_note_markdown = `
请记录你日常生活中，听到的精彩对话。
   `;

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"偷听工程三" :
   this.current_note_markdown = `
请记录你日常生活中，听到的精彩对话。
   `;

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"偷听工程四" :
   this.current_note_markdown = `
请记录你日常生活中，听到的精彩对话。
   `;

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"偷听工程五" :
   this.current_note_markdown = `
请记录你日常生活中，听到的精彩对话。
   `;

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"偷听工程六" :
   this.current_note_markdown = `
请记录你日常生活中，听到的精彩对话。
   `;
   

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"偷听工程七" :
   this.current_note_markdown = `
请记录你日常生活中，听到的精彩对话。
   `;

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"偷听工程八" :
   this.current_note_markdown = `
请记录你日常生活中，听到的精彩对话。
   `;

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"偷听工程九" :
   this.current_note_markdown = `
请记录你日常生活中，听到的精彩对话。
   `;

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;

   case"偷听工程十" :
   this.current_note_markdown = `
请记录你日常生活中，听到的精彩对话。
   `;

   this.is_title = 1;
   if( this.view_type == 2 ) this.view_type = 3;
   break;


    //展示选择
    case"展示选择一" :
    this.current_note_markdown = `
请看下面的电视剧梗概，选择哪些需要重点展示，哪些不要。

梗概如下

海军军官江德福离婚后，恩师丛校长和他的爱人杨书记就没少为江德福的婚事操心。国庆舞会，丛校长硬拽着江德福去碰缘分。贫苦出身的江德福打心底里瞧不上跳舞这种资产阶级的玩意儿，谁知他在舞会碰到了美丽的安杰。安杰是资本家大小姐出身，喜欢看文学名著，渴望的爱情如 《安娜卡列尼娜》中描绘的那样荡气回肠、罗曼蒂克，所以对于江德福这个口袋里插了两支钢笔冒充知识分子的约会对象，几万个看不上，更何况这次舞会简直就是安杰噩梦的开始：本来就扭了脚，结果和江德福跳舞时被踩得更 “瘸”了;第二次见面，被江德福烫伤了大腿;而且自从江德福出现后，不知为什么，所有人都不帮自己说话了，包括朝夕相处的亲人……安杰觉得这个人简直就是自己命里的灾星。江德福却越挫越勇，虽然丛校长和杨书记因为安杰的家庭成分非常反对，战友老丁也不停劝告，他还是铁了心要将安杰拿下。


    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

   
    case"展示选择二" :
    this.current_note_markdown = `
请看下面的电视剧梗概，选择哪些需要重点展示，哪些不要。

梗概如下

江德福为了能配上安杰，一方面抓紧时间练书法，一方面拜托杨书记帮忙牵线搭桥，还贴心地为安杰送去烫伤药。杨书记给安杰下达了请江德福到医院做演讲的 “政治任务”，安杰只好主动打电话给江德福。江德福一场 “漫不经心”的演讲，不仅博得了满堂喝彩，也打动了安杰的心。江德福顺利踏入了安家的门，凭借着插科打诨的幽默和机智，迅速取得了包括大哥安泰在内的安家上下的一致认可，江德福左思右想，坦白了婚史，安杰痛斥江德福是个大骗子。安泰的儿子得了大脑炎，情况危急，安杰为了弄到稀缺的盘尼西林不得不再次找到江德福，但出发前她还是退缩了。

    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"展示选择三" :
    this.current_note_markdown = `
请看下面的电视剧梗概，选择哪些需要重点展示，哪些不要。

梗概如下

安泰亲自求江德福帮忙，江德福二话不说立刻张罗联系。看着江德福忙前忙后，安杰颇为感动。在姐姐安欣的分析和劝说下，安杰终于让步，将江德福请到家里答谢，两个人的关系算是定了下来。但丛校长认为江德福这是在跟自己的前途过不去。如丛校长预计的那样，江德福的结婚申请由于安杰的家庭原因，被组织毫不犹豫地驳了回来。江德福铁了心娶安杰，甚至不惜解甲归田，安杰闻讯后大为感动，明确表示就算跟江德福回家种田也甘之如饴。江德福发誓不争取到最后一刻，绝不放弃。
    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"展示选择四" :
    this.current_note_markdown = `
请看下面的电视剧梗概，选择哪些需要重点展示，哪些不要。

梗概如下

经过丛校长一番游说和基地政委的帮忙，组织上终于同意了二人的婚事。江德福总算不用脱军装了，只是提拔什么的自然也没了他的事。为了不让安杰内疚，他隐瞒了这个事。江德福和安杰结婚了，针对江德福早上不刷牙、饭前不洗手、睡前不洗漱的毛病，安杰对其实施了严密的监控。两个人诸如饮食习惯不同等分歧也在安杰的高压之下统统得到了 “纠正”。对于江德福突然变得文质彬彬起来，老丁很不习惯，但不得不承认很羡慕。为了让老丁更加羡慕，江德福说服安杰在家中设宴，好好招待老丁等战友。意透露老丁等人上门是想看安杰做家务出丑。
    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"展示选择五" :
    this.current_note_markdown = `
请看下面的电视剧梗概，选择哪些需要重点展示，哪些不要。

梗概如下

安杰找来姐姐安欣帮忙，在江德福一班战友面前表现得无比体贴温柔。江德福高兴之余多喝了几杯，不料把自己每天的 “三洗”改造活动捅了出去。次日，酒醒后的江德福面对战友的各种嘲笑头痛不已。安杰怀孕了，这可把江德福高兴坏了。安杰的姐夫欧阳懿调回本地工作，安家两姐妹从小就在各种事上暗暗较劲，所以在比老公这件事情上，安杰更是严阵以待。拿到欧阳懿送来的请帖后，安杰不仅翻箱倒柜给自己找体面的裙子，更是逼江德福套上了文质彬彬的白西装，饭桌上，安泰一家人对江德福热情有加，安欣夫妇心里不免吃味。
   `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"展示选择六" :
    this.current_note_markdown = `
请看下面的电视剧梗概，选择哪些需要重点展示，哪些不要。

梗概如下

安杰回娘家，不小心听到安泰和妻子在议论江德福吃饭吧唧嘴的问题，护短之心大起，当场甩门而去。吃饭时，安杰看着江德福，最后还是忍不住哭了起来。江德福被安杰吓了一大跳，哄了半天才知道来龙去脉，他哭笑不得，不过此后吃饭的确注意了很多。安泰生日，在江德福的极力劝说下，安杰才不情愿地回家替安泰过生日。安泰一来不好意思，二来真心感谢江德福对安家的帮助，饭桌上忍不住大力夸赞了江德福一番。如此一来，同样是妹夫的欧阳懿心里很不是滋味。  `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"展示选择七" :
    this.current_note_markdown = `
请看下面的电视剧梗概，选择哪些需要重点展示，哪些不要。

梗概如下

江德福和安杰的第一个儿子降生，杨书记起名江国庆。对于这个 “土得掉渣”的名字，安杰表示了极大的抗拒，她无比羡慕安欣的双胞胎女儿能有欧阳安然和欧阳安诺这样诗情画意的名字。江德福提议把自己苦命的妹妹江德花接来照顾安杰母子，安杰一想起要和素未谋面的小姑子同处一室，万般不乐意。但江德福先斩后奏，还是把江德花接来了。安杰嫌江德花这个名字太难听，自作主张称她为江德华。姑嫂从刚见面就各种不对盘，安杰觉得江德华粗俗，江德华认为安杰娇气，二人战斗热情日益高涨。

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"展示选择八" :
    this.current_note_markdown = `
请看下面的电视剧梗概，选择哪些需要重点展示，哪些不要。

梗概如下

江德福每天夹在两个女人中间，站也不是坐也不是，只能和稀泥。老丁带着一家大小在江德福隔壁安营扎寨，他的老婆王秀娥和江德华同样是淳朴的农村妇女出身，可谓相见恨晚，二人迅速达成联盟，枪口一致对准安杰。安杰重新回医院上班，江德华才松了一口气，每天带带孩子、做做饭，偶尔去隔壁串个门，日子倒也过得很逍遥。很快一年过去了，国庆刚刚学会走路没多久，安杰发现自己又怀上了第二胎。安杰这一胎的反应比第一胎还大，基本是吃什么吐什么，摊上这么个娇气又难伺候的嫂子，江德华很是无奈。偏偏江德华又从王秀娥口中得知江德福当年为了结婚而前途受阻的事，登时就炸了。


`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"展示选择九" :
    this.current_note_markdown = `
请看下面的电视剧梗概，选择哪些需要重点展示，哪些不要。

梗概如下

对于江德华突如其来 “虐待”安杰的行为，江德福摸不着头脑，但江德华又死活不肯说原因，只是冷嘲热讽安杰是个出身不好的资产阶级小姐。安杰下班回家，看到江德华把食物放进嘴里嚼完了再喂给国庆吃，气不打一处来，姑嫂二人打起了嘴仗，安杰吵不过，气乎乎地回了娘家。江德福硬着头皮三顾安家，但安杰就是不肯回去，无奈之下，江德福只好再次求助于杨书记。安杰从杨书记处得知江德福当初为了自己而被降级，很是内疚，夫妻俩终于和好。为了日后能和平相处，安杰和江德福给小姑子置办了一堆礼物，打算实行怀柔政策。他俩兴冲冲地回家，却发现江德华脱了衣服在奶孩子。

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"展示选择十" :
    this.current_note_markdown = `
请看下面的电视剧梗概，选择哪些需要重点展示，哪些不要。

梗概如下

夫妻二人吓得手足无措，片刻的尴尬后，气愤的安杰收拾了行李又回了娘家。江德华自觉没脸留下来，也收拾了包袱要回老家。对于安杰三天两头往娘家跑的行为，大哥安泰提出了严厉的批评，安杰冷静之后气也消了，等江德福上门来接。江德华一走，谁来照顾怀孕的安杰和年幼的国庆，让江德福非常苦恼，安泰把家中的保姆孙妈借给了安杰。王秀娥请安杰吃饭，告诉安杰是自己教江德华奶孩子，安杰听后很震惊，但也觉得农村人很可爱。江德福很乐意家里有个保姆帮忙打理，但他坚决不同意孙妈称呼安杰为 “小姐”。江德华离开后，王秀娥和孙妈完全没有共同语言，她倍感寂寞。江德华扛着行李又杀回到了江家，她试图说服孙妈反抗，但孙妈懒得搭理她。

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    //展示练习
    case"展示练习一" :
    this.current_note_markdown = `
请把概括的句子内容，用展示的方式表现出来。

段落如下：

这个人是个警察。


    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"展示练习二" :
    this.current_note_markdown = `
请把概括的句子内容，用展示的方式表现出来。

段落如下：

城市被战争破坏了。


    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"展示练习三" :
    this.current_note_markdown = `
请把概括的句子内容，用展示的方式表现出来。

段落如下：

大雨天，我滑了一跤。


    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"展示练习四" :
    this.current_note_markdown = `
请把概括的句子内容，用展示的方式表现出来。

段落如下：

那是一个娇小的少女


    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"展示练习五" :
    this.current_note_markdown = `
请把概括的句子内容，用展示的方式表现出来。

段落如下：

那是一身蓝裙子


    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"展示练习六" :
    this.current_note_markdown = `
请把概括的句子内容，用展示的方式表现出来。

段落如下：

他的声音很动听


    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"展示练习七" :
    this.current_note_markdown = `
请把概括的句子内容，用展示的方式表现出来。

段落如下：

那里站着一个人


    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"展示练习八" :
    this.current_note_markdown = `
请把概括的句子内容，用展示的方式表现出来。

段落如下：

这人看起来不好对付


    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"展示练习九" :
    this.current_note_markdown = `
请把概括的句子内容，用展示的方式表现出来。

段落如下：

人们很痛苦

   `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"展示练习十" :
    this.current_note_markdown = `
请把概括的句子内容，用展示的方式表现出来。

段落如下：

那里一片凌乱


    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    //展示判断
    case"展示判断一" :
    this.current_note_markdown = `
请指出段落中，哪个是展示，哪个是概括。

段落如下：

段落1：这个人是个警察。

段落2：这个人穿着警服，腰间别着枪，走进了警察局里。有其他警察过来跟他说话，他的职位xx区的警官

    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"展示判断二" :
    this.current_note_markdown = `
请指出段落中，哪个是展示，哪个是概括。

段落如下：

段落1：城市被战争破坏了。

段落2：城市中到处都是断壁残垣，尸体充斥在每个角落。断墙后，有幸存的母亲，抱着自己刚出生的婴儿躲在那里，似乎在风中瑟瑟发抖。但是走进一看，母子都已经死去很久了。

    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"展示判断三" :
    this.current_note_markdown = `
请指出段落中，哪个是展示，哪个是概括。

段落如下：

段落1：大雨天，我滑了一跤。

段落2：大雨天,潮湿的地面泥泞不堪,路上行人小心翼翼地走着,生怕身上溅到泥水。雨越下越大，风穿过街道的呜呜声，就像有谁在哭泣。我还是强忍着泪水打开伞，踏进雨里。但眼前模糊一片，于是我踏进了水坑，结结实实的摔了一跤。

    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"展示判断四" :
    this.current_note_markdown = `
请指出段落中，哪个是展示，哪个是概括。

段落如下：

段落1：那是一个娇小的少女

段落2：那是个身量不高的少女，远远看去清丽柔稚。削肩细腰，腿部修长。身材比例协调优美。小巧玲珑的玉足行走之间，像踩在虚空中，腾云驾雾。她皮肤柔嫩莹润，身畔自然的散发着淡淡荧光，在洁白神圣的云层里，整个人看起来近似透明。

    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"展示判断五" :
    this.current_note_markdown = `
请指出段落中，哪个是展示，哪个是概括。

段落如下：

段落1：那是一身蓝裙子

段落2：一袭海蓝色薄纱卷边长裙，裙摆在空中悠然浮动，如华美的海藻浮光。

    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"展示判断六" :
    this.current_note_markdown = `
请指出段落中，哪个是展示，哪个是概括。

段落如下：

段落1：他的声音很动听

段落2：声音悦耳动听。话音飘落，像是深山里传来的阵阵古琴音，如流水般沁入心田。平生仅见，难以忘怀。

    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"展示判断七" :
    this.current_note_markdown = `
请指出段落中，哪个是展示，哪个是概括。

段落如下：

段落1：那里站着一个人

段落2：入口高耸的大门下，一大片宽敞的空地，只站着一个黑发少女。脑后束起的长发，被风吹起，缓缓飘散在漆黑的夜里。

    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"展示判断八" :
    this.current_note_markdown = `
请指出段落中，哪个是展示，哪个是概括。

段落如下：

段落1：这人看起来不好对付

段落2：脸上浓妆扑粉。长眉亮眼，高鼻红唇。乌青的眼影和长长的假睫毛让她抬眼时，有一种盛气凌人的感觉。而她此时，正好微抬眼帘，带着一抹笑看着眼前的猎物们。

    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"展示判断九" :
    this.current_note_markdown = `
请指出段落中，哪个是展示，哪个是概括。

段落如下：

段落1：人们很痛苦

段落2： 耳边狂风呼啸。所有人连喊痛的力气都没有了。艰难的呼吸中，喉咙里都是钝痛。

    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"展示判断十" :
    this.current_note_markdown = `
请指出段落中，哪个是展示，哪个是概括。

段落如下：

段落1：那里一片凌乱

段落2：石壁上遍布着各种攻击痕迹，地板上散乱着泥沙。学生们像是破布玩偶一样被埋在了石块中。大部分面临濒死边缘的心核修复，尸体一般的昏迷着。

    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;




      //心理增减
      case"心理增减一" :
      this.current_note_markdown = `
请更改你的练习段落，增加或减少动作表情，人物感受，内心独白和情绪概念等要素。让描写更加丰富自然。


      `;
      if(localStorage.getItem("心理练习一")!=null){
        this.current_note_markdown+=localStorage.getItem("心理练习一");
      }
      else{
        this.current_note_markdown+=`
        但心理练习一还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"心理增减二" :
      this.current_note_markdown = `
请更改你的练习段落，增加或减少动作表情，人物感受，内心独白和情绪概念等要素。让描写更加丰富自然。


      `;
      if(localStorage.getItem("心理练习二")!=null){
        this.current_note_markdown+=localStorage.getItem("心理练习二");
      }
      else{
        this.current_note_markdown+=`
        但心理练习二还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"心理增减三" :
      this.current_note_markdown = `
请更改你的练习段落，增加或减少动作表情，人物感受，内心独白和情绪概念等要素。让描写更加丰富自然。


      `;
      if(localStorage.getItem("心理练习三")!=null){
        this.current_note_markdown+=localStorage.getItem("心理练习三");
      }
      else{
        this.current_note_markdown+=`
        但心理练习三还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"心理增减四" :
      this.current_note_markdown = `
请更改你的练习段落，增加或减少动作表情，人物感受，内心独白和情绪概念等要素。让描写更加丰富自然。


      `;
      if(localStorage.getItem("心理练习四")!=null){
        this.current_note_markdown+=localStorage.getItem("心理练习四");
      }
      else{
        this.current_note_markdown+=`
        但心理练习四还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"心理增减五" :
      this.current_note_markdown = `
请更改你的练习段落，增加或减少动作表情，人物感受，内心独白和情绪概念等要素。让描写更加丰富自然。


      `;
      if(localStorage.getItem("心理练习五")!=null){
        this.current_note_markdown+=localStorage.getItem("心理练习五");
      }
      else{
        this.current_note_markdown+=`
        但心理练习五还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"心理增减六" :
      this.current_note_markdown = `
请更改你的练习段落，增加或减少动作表情，人物感受，内心独白和情绪概念等要素。让描写更加丰富自然。


      `;
      if(localStorage.getItem("心理练习六")!=null){
        this.current_note_markdown+=localStorage.getItem("心理练习六");
      }
      else{
        this.current_note_markdown+=`
        但心理练习六还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"心理增减七" :
      this.current_note_markdown = `
请更改你的练习段落，增加或减少动作表情，人物感受，内心独白和情绪概念等要素。让描写更加丰富自然。


      `;
      if(localStorage.getItem("心理练习七")!=null){
        this.current_note_markdown+=localStorage.getItem("心理练习七");
      }
      else{
        this.current_note_markdown+=`
        但心理练习七还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"心理增减八" :
      this.current_note_markdown = `
请更改你的练习段落，增加或减少动作表情，人物感受，内心独白和情绪概念等要素。让描写更加丰富自然。


      `;
      if(localStorage.getItem("心理练习八")!=null){
        this.current_note_markdown+=localStorage.getItem("心理练习八");
      }
      else{
        this.current_note_markdown+=`
        但心理练习八还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"心理增减九" :
      this.current_note_markdown = `
请更改你的练习段落，增加或减少动作表情，人物感受，内心独白和情绪概念等要素。让描写更加丰富自然。


      `;
      if(localStorage.getItem("心理练习九")!=null){
        this.current_note_markdown+=localStorage.getItem("心理练习九");
      }
      else{
        this.current_note_markdown+=`
        但心理练习九还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"心理增减十" :
      this.current_note_markdown = `
请更改你的练习段落，增加或减少动作表情，人物感受，内心独白和情绪概念等要素。让描写更加丰富自然。


      `;
      if(localStorage.getItem("心理练习十")!=null){
        this.current_note_markdown+=localStorage.getItem("心理练习十");
      }
      else{
        this.current_note_markdown+=`
        但心理练习十还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;



    //心理要素
    case"心理要素一" :
    this.current_note_markdown = `
请指出段落中，有动作表情，人物感受，内心独白和情绪概念哪几种要素。并都在哪一句。

段落如下：

之前温馨整洁的房间，骤然变成了爆炸火灾后的废墟残局……更令人胆战心惊的是，房间中央有一摊鲜红的血迹，凝结在漆黑的地板上，亮得扎眼刺目。

我的脚一软，跪在了地上。

似乎有什么，在一瞬间把我的心都抽空了，连胸口旁边的皮肤都拉扯得生疼。被刺痛侵袭得不知所措的我，心里就只剩下一个念头。

妹妹……我的妹妹呢？

接下来的事情都是在我头脑一片空白下完成的。
    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"心理要素二" :
    this.current_note_markdown = `
请指出段落中，有动作表情，人物感受，内心独白和情绪概念哪几种要素。并都在哪一句。

段落如下：

“因为影响不好，所以令妹的死亡事件要暂时隐瞒下来，前些天来采访的媒体我们会去打点，希望你配合………………”

那些个警察后面又说了什么，我就再没听清了。耳边只响起一声巨响。过了一阵，我才意识到那是我在喊。

“胡说！胡说八道！！你们这群混蛋！竟敢咒她！你们竟然敢咒她死！”

我摔门而去，再也没有进过这间所谓的专家会诊室。

我妹妹还活着。

颓废与绝望之中，我开始一遍一遍的对自己说。

我妹妹还活着，只是不知道去哪了而已！

他们不帮我找，我自己找！
    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"心理要素三" :
    this.current_note_markdown = `
请指出段落中，有动作表情，人物感受，内心独白和情绪概念哪几种要素。并都在哪一句。

段落如下：

于是我疯了似的找，公园、地铁、学校、菜市场……全都找遍了。却怎么也找不着。

一天、两天。一周、两周。一个月、两个月……

时间就这么残忍又无谓的划过。妹妹一直都没有消息。

剩下的日子，就像是在凌迟。

没有人叫我起床，或者给我盖被子。没有人再听我讲笑话，没有人煮好热腾腾的饭菜等我回家，没有人闹着要我陪她玩，也没有人躺在我怀里撒娇……

我开始不由自主地对着家里的物品发呆。

这个调料盒，有次我不在家的时候，她掂着脚去够，不小心撒了一地胡椒粉和盐。等我回到家时，她已经委屈的快哭了。红着眼睛站在厨房里，等着我骂她，还一边不住地打喷嚏。那噘着嘴，眼泪汪汪，扯着自己的衣角的样子。可爱得让人想把她抱进怀里……

这块地毯，她喜欢趴在上面看书。一边看，一边无意识的用手揪着上面的毛，弄得毛东一搓西一撮的。

厨房，她总是喜欢打扫得干干净净的，现在却一片油腻…

最外面的盘子里，她总是喜欢放上些切好的苹果和剥了皮的沙糖桔。她说饭堂的饭菜太过干燥，叫我多吃点水果……

我当时嫌麻烦总是不肯吃。

现在……却再也不会嫌麻烦了……

有时候难过起来，真的想死了一了百了。但是我又不敢死。我生怕自己死了之后，不知在何处的妹妹会变得无依无靠。

就算只有一点点念想，我也不能放弃。
    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"心理要素四" :
    this.current_note_markdown = `
请指出段落中，有动作表情，人物感受，内心独白和情绪概念哪几种要素。并都在哪一句。

段落如下：

有人给我戴上了手铐脚镣，还蒙上了眼睛。

咔嚓一声。卫兵关上门走了。

眼前一片黑暗，只能听到我的心打鼓一样咚咚的跳个不停。恐惧一股接一股的涌了上来，侵蚀着我的意志。

原来我并不是不害怕，一直以来只是强做镇定罢了。这种镇定在看得见的时候还能勉强维持，一旦陷入黑暗，立刻就支离破碎溃不成军了。

蒙着眼的布条紧紧的箍在脸上，纯黑的厚布遮挡住了一切的光亮。手腕被拷死，背在身后。冰冷的脚镣拖在地上，让我几乎难以动弹。我伤痕累累的右脚，因为长跪而更加的疼了起来。闭着眼感官更加灵敏，我甚至能感到血液缓缓的留出，黏在包扎着的布上。跪在陌生世界的审判厅里，我什么也看不见。脑海中不由自主的开始翻涌着各种恐怖的刑法和死法。那一个个在书里看到过，血肉模糊的画面，排着队闪进我的脑海中。那些可怕的画面，吓得我心惊肉跳，腿脚发软。不知是冷还是怕，身体开始止不住地颤抖起来。
    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"心理要素五" :
    this.current_note_markdown = `
请指出段落中，有动作表情，人物感受，内心独白和情绪概念哪几种要素。并都在哪一句。

段落如下：

我颤抖着埋下头，祈求般的祷告着。希望上苍能让我再见到妹妹，就算只是一面。让我确认她还活着，一切都好。就是这样的念头，让我找了一年，等了一年，又来到了这里。

正无望的想着。耳边忽然听到……前方传来若有若无的脚步声。

心跳像是停了半拍，而后重重的狂跳了起来。这让我几乎再听不到任何声音。又过了几秒，才恢复了听觉。而此时的声音越发的清晰了起来。

的确是脚步声，而且咔哒咔哒的杂乱的响着，不止一个人。

至少有七八个……不……十几个……有一群人吧。

来人众多，来历不明。对未知的恐惧让我想要缩成一团，但我却还是尽力的抬起头，睁着眼往前面看去。

此时的期待浓烈得几乎压过了恐惧。让我即使看不见，也拼命的睁着眼睛。想要越过那层蒙眼的布料，直接透视出前方的景象一样。

小夜……你……在那里面吗……？

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"心理要素六" :
    this.current_note_markdown = `
请指出段落中，有动作表情，人物感受，内心独白和情绪概念哪几种要素。并都在哪一句。

段落如下：

原本以为是好不容易得救了，没想到却落入了更糟糕的境地。监禁又或是死亡……周围的人已经开始用看死人一般的眼神看着我。而巨大的恐惧也一点点从心底渗透了出来。让我不由自主的发起抖来。

但也并不全是害怕。混着疼痛和寒冷的心绪，更多的反而是不甘心。撕心裂肺，就算死了也不瞑目的不甘心。

我怎么可能甘心呢。过了整整一年行尸走肉般的生活。好不容易才碰巧找到了线索。鼓起勇气划破手背，让恶心的黑虫爬满身体。下定了决心，才来到这个世界。结果却连妹妹的一面都没有见到。就因为这世界诡异的规定而死去了？

这种情况下，就算是死了也肯定不会瞑目的。

不行！绝对不行！

我不甘心的喘息着，觉得胸腹都气得痛了起来。就像是在冰天雪地里喝进了一大瓶硫酸，明明是酷烈的严寒，痛感却是辣的。

我觉得自己已经尽力了。不管是警察们信誓旦旦的告诉我妹妹的死讯也好，一年以来毫无线索没有任何希望也好。诡异的黑虫爬在身前也好。我都没有放弃过。

结果最后，却是落得这么一个可笑的结果。

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"心理要素七" :
    this.current_note_markdown = `
请指出段落中，有动作表情，人物感受，内心独白和情绪概念哪几种要素。并都在哪一句。

段落如下：

“彩霞找我？”颜茹雨淡淡的瞟了一眼面前的人，“那跟我有什么关系，又跟你有什么关系？”

“你……？！”柳云气的说不出话来，狠狠的深吸了几口气，才缓了过来，指着颜茹雨愤恨道：“果然，你就是一个冷血动物，亏彩霞喜欢了你那么久，真是瞎了眼了。你就是一个没有感情，也不懂珍惜人的败类！”

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"心理要素八" :
    this.current_note_markdown = `
请指出段落中，有动作表情，人物感受，内心独白和情绪概念哪几种要素。并都在哪一句。

段落如下：

而门里面的女孩说完社长，话题一转，“不过这个学长好像真的很牛逼哄哄哦！从小到大成绩都是第一，还拿奖拿到手软。很多奖项我听都没听过，人家都已经拿了第三次了……所以学校才让他出去交流的，等于公费出国啊！名额超少的，就是那个……那个以外国人命名的项目！还要跟其他学校竞争那个……唉，轮到我们俩，可能就得自己出钱了……”

“……”

颜茹雨轻轻的笑了一声。当面表扬听得多了，偶尔听听这种背后的讨论，感觉也是蛮新鲜的。

大概没有人会不喜欢听别人的夸奖，尤其是这种不知道你在听的类型。

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"心理要素九" :
    this.current_note_markdown = `
请指出段落中，有动作表情，人物感受，内心独白和情绪概念哪几种要素。并都在哪一句。

段落如下：

至于苏婉儿，冲出宿舍之后，忽然陷入了一阵迷茫之中。因为她发现……她不知道去哪儿找颜茹雨。

首先去了颜茹雨宿舍，同学们表示，颜茹雨从大一下半学期开始就不住宿舍了。顺带今天的课，他也不会去听，并且……他似乎也不在实验室。

即使是同个宿舍的人，连他在不在学校里都不确定。

苏婉儿此刻才体会到了，要找颜茹雨有多困难。

这要怎么找……苏婉儿一头雾水的站在校园的喷泉边上，他们昨天路过的地方。一边挠头一边忧愁。

早知道加个联系方式了……

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"心理要素十" :
    this.current_note_markdown = `
请指出段落中，有动作表情，人物感受，内心独白和情绪概念哪几种要素。并都在哪一句。

段落如下：

苏婉儿好不容易才平复下来的心，又开始不规律的跳了起来。

虽然才认识几天。但回忆起之前发生过的一件件事情。

鼓励她，维护她，帮她解围。

就算不提颜茹雨自身带着的光环，也没什么不好的。

甚至他只要站在那儿，就让人觉得安心。

但是……

“他没什么不好。”苏婉儿苦笑道：“是我不好。”

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


      //心理练习
      case"心理练习一" :
      this.current_note_markdown = `
请练习描写这种情绪：开心愉悦
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"心理练习二" :
      this.current_note_markdown = `
请练习描写这种情绪：悲伤哀痛
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"心理练习三" :
      this.current_note_markdown = `
请练习描写这种情绪：愤怒生气
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"心理练习四" :
      this.current_note_markdown = `
请练习描写这种情绪：恐惧害怕
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"心理练习五" :
      this.current_note_markdown = `
请练习描写这种情绪：厌恶恶心
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"心理练习六" :
      this.current_note_markdown = `
请练习描写这种情绪：惊讶意外
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"心理练习七" :
      this.current_note_markdown = `
请练习描写这种情绪：百无聊赖
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"心理练习八" :
      this.current_note_markdown = `
请练习描写这种情绪：消沉失落
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"心理练习九" :
      this.current_note_markdown = `
请练习描写这种情绪：纠结困惑
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"心理练习十" :
      this.current_note_markdown = `
请练习描写这种情绪：兴奋期待
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;





    //情绪类型
    case"情绪类型一" :
    this.current_note_markdown = `
请指出段落中，描写的是哪一种情绪类型。情绪有多强烈。

段落如下：

之前温馨整洁的房间，骤然变成了爆炸火灾后的废墟残局……更令人胆战心惊的是，房间中央有一摊鲜红的血迹，凝结在漆黑的地板上，亮得扎眼刺目。

我的脚一软，跪在了地上。

似乎有什么，在一瞬间把我的心都抽空了，连胸口旁边的皮肤都拉扯得生疼。被刺痛侵袭得不知所措的我，心里就只剩下一个念头。

妹妹……我的妹妹呢？

接下来的事情都是在我头脑一片空白下完成的。
    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"情绪类型二" :
    this.current_note_markdown = `
请指出段落中，描写的是哪一种情绪类型。情绪有多强烈。

段落如下：

“因为影响不好，所以令妹的死亡事件要暂时隐瞒下来，前些天来采访的媒体我们会去打点，希望你配合………………”

那些个警察后面又说了什么，我就再没听清了。耳边只响起一声巨响。过了一阵，我才意识到那是我在喊。

“胡说！胡说八道！！你们这群混蛋！竟敢咒她！你们竟然敢咒她死！”

我摔门而去，再也没有进过这间所谓的专家会诊室。

我妹妹还活着。

颓废与绝望之中，我开始一遍一遍的对自己说。

我妹妹还活着，只是不知道去哪了而已！

他们不帮我找，我自己找！
    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"情绪类型三" :
    this.current_note_markdown = `
请指出段落中，描写的是哪一种情绪类型。情绪有多强烈。

段落如下：

于是我疯了似的找，公园、地铁、学校、菜市场……全都找遍了。却怎么也找不着。

一天、两天。一周、两周。一个月、两个月……

时间就这么残忍又无谓的划过。妹妹一直都没有消息。

剩下的日子，就像是在凌迟。

没有人叫我起床，或者给我盖被子。没有人再听我讲笑话，没有人煮好热腾腾的饭菜等我回家，没有人闹着要我陪她玩，也没有人躺在我怀里撒娇……

我开始不由自主地对着家里的物品发呆。

这个调料盒，有次我不在家的时候，她掂着脚去够，不小心撒了一地胡椒粉和盐。等我回到家时，她已经委屈的快哭了。红着眼睛站在厨房里，等着我骂她，还一边不住地打喷嚏。那噘着嘴，眼泪汪汪，扯着自己的衣角的样子。可爱得让人想把她抱进怀里……

这块地毯，她喜欢趴在上面看书。一边看，一边无意识的用手揪着上面的毛，弄得毛东一搓西一撮的。

厨房，她总是喜欢打扫得干干净净的，现在却一片油腻…

最外面的盘子里，她总是喜欢放上些切好的苹果和剥了皮的沙糖桔。她说饭堂的饭菜太过干燥，叫我多吃点水果……

我当时嫌麻烦总是不肯吃。

现在……却再也不会嫌麻烦了……

有时候难过起来，真的想死了一了百了。但是我又不敢死。我生怕自己死了之后，不知在何处的妹妹会变得无依无靠。

就算只有一点点念想，我也不能放弃。
    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"情绪类型四" :
    this.current_note_markdown = `
请指出段落中，描写的是哪一种情绪类型。情绪有多强烈。

段落如下：

有人给我戴上了手铐脚镣，还蒙上了眼睛。

咔嚓一声。卫兵关上门走了。

眼前一片黑暗，只能听到我的心打鼓一样咚咚的跳个不停。恐惧一股接一股的涌了上来，侵蚀着我的意志。

原来我并不是不害怕，一直以来只是强做镇定罢了。这种镇定在看得见的时候还能勉强维持，一旦陷入黑暗，立刻就支离破碎溃不成军了。

蒙着眼的布条紧紧的箍在脸上，纯黑的厚布遮挡住了一切的光亮。手腕被拷死，背在身后。冰冷的脚镣拖在地上，让我几乎难以动弹。我伤痕累累的右脚，因为长跪而更加的疼了起来。闭着眼感官更加灵敏，我甚至能感到血液缓缓的留出，黏在包扎着的布上。跪在陌生世界的审判厅里，我什么也看不见。脑海中不由自主的开始翻涌着各种恐怖的刑法和死法。那一个个在书里看到过，血肉模糊的画面，排着队闪进我的脑海中。那些可怕的画面，吓得我心惊肉跳，腿脚发软。不知是冷还是怕，身体开始止不住地颤抖起来。
    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"情绪类型五" :
    this.current_note_markdown = `
请指出段落中，描写的是哪一种情绪类型。情绪有多强烈。

段落如下：

我颤抖着埋下头，祈求般的祷告着。希望上苍能让我再见到妹妹，就算只是一面。让我确认她还活着，一切都好。就是这样的念头，让我找了一年，等了一年，又来到了这里。

正无望的想着。耳边忽然听到……前方传来若有若无的脚步声。

心跳像是停了半拍，而后重重的狂跳了起来。这让我几乎再听不到任何声音。又过了几秒，才恢复了听觉。而此时的声音越发的清晰了起来。

的确是脚步声，而且咔哒咔哒的杂乱的响着，不止一个人。

至少有七八个……不……十几个……有一群人吧。

来人众多，来历不明。对未知的恐惧让我想要缩成一团，但我却还是尽力的抬起头，睁着眼往前面看去。

此时的期待浓烈得几乎压过了恐惧。让我即使看不见，也拼命的睁着眼睛。想要越过那层蒙眼的布料，直接透视出前方的景象一样。

小夜……你……在那里面吗……？

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"情绪类型六" :
    this.current_note_markdown = `
请指出段落中，描写的是哪一种情绪类型。情绪有多强烈。

段落如下：

原本以为是好不容易得救了，没想到却落入了更糟糕的境地。监禁又或是死亡……周围的人已经开始用看死人一般的眼神看着我。而巨大的恐惧也一点点从心底渗透了出来。让我不由自主的发起抖来。

但也并不全是害怕。混着疼痛和寒冷的心绪，更多的反而是不甘心。撕心裂肺，就算死了也不瞑目的不甘心。

我怎么可能甘心呢。过了整整一年行尸走肉般的生活。好不容易才碰巧找到了线索。鼓起勇气划破手背，让恶心的黑虫爬满身体。下定了决心，才来到这个世界。结果却连妹妹的一面都没有见到。就因为这世界诡异的规定而死去了？

这种情况下，就算是死了也肯定不会瞑目的。

不行！绝对不行！

我不甘心的喘息着，觉得胸腹都气得痛了起来。就像是在冰天雪地里喝进了一大瓶硫酸，明明是酷烈的严寒，痛感却是辣的。

我觉得自己已经尽力了。不管是警察们信誓旦旦的告诉我妹妹的死讯也好，一年以来毫无线索没有任何希望也好。诡异的黑虫爬在身前也好。我都没有放弃过。

结果最后，却是落得这么一个可笑的结果。

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"情绪类型七" :
    this.current_note_markdown = `
请指出段落中，描写的是哪一种情绪类型。情绪有多强烈。

段落如下：

“彩霞找我？”颜茹雨淡淡的瞟了一眼面前的人，“那跟我有什么关系，又跟你有什么关系？”

“你……？！”柳云气的说不出话来，狠狠的深吸了几口气，才缓了过来，指着颜茹雨愤恨道：“果然，你就是一个冷血动物，亏彩霞喜欢了你那么久，真是瞎了眼了。你就是一个没有感情，也不懂珍惜人的败类！”

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"情绪类型八" :
    this.current_note_markdown = `
请指出段落中，描写的是哪一种情绪类型。情绪有多强烈。

段落如下：

而门里面的女孩说完社长，话题一转，“不过这个学长好像真的很牛逼哄哄哦！从小到大成绩都是第一，还拿奖拿到手软。很多奖项我听都没听过，人家都已经拿了第三次了……所以学校才让他出去交流的，等于公费出国啊！名额超少的，就是那个……那个以外国人命名的项目！还要跟其他学校竞争那个……唉，轮到我们俩，可能就得自己出钱了……”

“……”

颜茹雨轻轻的笑了一声。当面表扬听得多了，偶尔听听这种背后的讨论，感觉也是蛮新鲜的。

大概没有人会不喜欢听别人的夸奖，尤其是这种不知道你在听的类型。

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"情绪类型九" :
    this.current_note_markdown = `
请指出段落中，描写的是哪一种情绪类型。情绪有多强烈。

段落如下：

至于苏婉儿，冲出宿舍之后，忽然陷入了一阵迷茫之中。因为她发现……她不知道去哪儿找颜茹雨。

首先去了颜茹雨宿舍，同学们表示，颜茹雨从大一下半学期开始就不住宿舍了。顺带今天的课，他也不会去听，并且……他似乎也不在实验室。

即使是同个宿舍的人，连他在不在学校里都不确定。

苏婉儿此刻才体会到了，要找颜茹雨有多困难。

这要怎么找……苏婉儿一头雾水的站在校园的喷泉边上，他们昨天路过的地方。一边挠头一边忧愁。

早知道加个联系方式了……

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"情绪类型十" :
    this.current_note_markdown = `
请指出段落中，描写的是哪一种情绪类型。情绪有多强烈。

段落如下：

苏婉儿好不容易才平复下来的心，又开始不规律的跳了起来。

虽然才认识几天。但回忆起之前发生过的一件件事情。

鼓励她，维护她，帮她解围。

就算不提颜茹雨自身带着的光环，也没什么不好的。

甚至他只要站在那儿，就让人觉得安心。

但是……

“他没什么不好。”苏婉儿苦笑道：“是我不好。”

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


      //心理仿写
      case"心理仿写一" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("心理摘抄一")!=null){
        this.current_note_markdown+=localStorage.getItem("心理摘抄一");
      }
      else{
        this.current_note_markdown+=`
        但心理摘抄一还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"心理仿写二" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("心理摘抄二")!=null){
        this.current_note_markdown+=localStorage.getItem("心理摘抄二");
      }
      else{
        this.current_note_markdown+=`
        但心理摘抄二还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"心理仿写三" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("心理摘抄三")!=null){
        this.current_note_markdown+=localStorage.getItem("心理摘抄三");
      }
      else{
        this.current_note_markdown+=`
        但心理摘抄三还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"心理仿写四" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("心理摘抄四")!=null){
        this.current_note_markdown+=localStorage.getItem("心理摘抄四");
      }
      else{
        this.current_note_markdown+=`
        但心理摘抄四还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"心理仿写五" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("心理摘抄五")!=null){
        this.current_note_markdown+=localStorage.getItem("心理摘抄五");
      }
      else{
        this.current_note_markdown+=`
        但心理摘抄五还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"心理仿写六" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("心理摘抄六")!=null){
        this.current_note_markdown+=localStorage.getItem("心理摘抄六");
      }
      else{
        this.current_note_markdown+=`
        但心理摘抄六还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"心理仿写七" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("心理摘抄七")!=null){
        this.current_note_markdown+=localStorage.getItem("心理摘抄七");
      }
      else{
        this.current_note_markdown+=`
        但心理摘抄七还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"心理仿写八" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("心理摘抄八")!=null){
        this.current_note_markdown+=localStorage.getItem("心理摘抄八");
      }
      else{
        this.current_note_markdown+=`
        但心理摘抄八还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"心理仿写九" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("心理摘抄九")!=null){
        this.current_note_markdown+=localStorage.getItem("心理摘抄九");
      }
      else{
        this.current_note_markdown+=`
        但心理摘抄九还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"心理仿写十" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("心理摘抄十")!=null){
        this.current_note_markdown+=localStorage.getItem("心理摘抄十");
      }
      else{
        this.current_note_markdown+=`
        但心理摘抄十还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      //心理摘抄
      case"心理摘抄一" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的心理描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"心理摘抄二" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的心理描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"心理摘抄三" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的心理描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"心理摘抄四" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的心理描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"心理摘抄五" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的心理描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"心理摘抄六" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的心理描写。
      `;
      

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"心理摘抄七" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的心理描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"心理摘抄八" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的心理描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"心理摘抄九" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的心理描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"心理摘抄十" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的心理描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      //转场练习
      case"转场练习一" :
      this.current_note_markdown = `
请更改你的练习片段，选择和增加不同视角，让整个描写看起来更加丰富。


      `;
      if(localStorage.getItem("虚实选择一")!=null){
        this.current_note_markdown+=localStorage.getItem("虚实选择一");
      }
      else{
        this.current_note_markdown+=`
        但虚实选择一还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"转场练习二" :
      this.current_note_markdown = `
请更改你的练习片段，选择和增加不同视角，让整个描写看起来更加丰富。


      `;
      if(localStorage.getItem("虚实选择二")!=null){
        this.current_note_markdown+=localStorage.getItem("虚实选择二");
      }
      else{
        this.current_note_markdown+=`
        但虚实选择二还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"转场练习三" :
      this.current_note_markdown = `
请更改你的练习片段，选择和增加不同视角，让整个描写看起来更加丰富。


      `;
      if(localStorage.getItem("虚实选择三")!=null){
        this.current_note_markdown+=localStorage.getItem("虚实选择三");
      }
      else{
        this.current_note_markdown+=`
        但虚实选择三还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"转场练习四" :
      this.current_note_markdown = `
请更改你的练习片段，选择和增加不同视角，让整个描写看起来更加丰富。


      `;
      if(localStorage.getItem("虚实选择四")!=null){
        this.current_note_markdown+=localStorage.getItem("虚实选择四");
      }
      else{
        this.current_note_markdown+=`
        但虚实选择四还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"转场练习五" :
      this.current_note_markdown = `
请更改你的练习片段，选择和增加不同视角，让整个描写看起来更加丰富。


      `;
      if(localStorage.getItem("虚实选择五")!=null){
        this.current_note_markdown+=localStorage.getItem("虚实选择五");
      }
      else{
        this.current_note_markdown+=`
        但虚实选择五还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"转场练习六" :
      this.current_note_markdown = `
请更改你的练习片段，选择和增加不同视角，让整个描写看起来更加丰富。


      `;
      if(localStorage.getItem("虚实选择六")!=null){
        this.current_note_markdown+=localStorage.getItem("虚实选择六");
      }
      else{
        this.current_note_markdown+=`
        但虚实选择六还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"转场练习七" :
      this.current_note_markdown = `
请更改你的练习片段，选择和增加不同视角，让整个描写看起来更加丰富。


      `;
      if(localStorage.getItem("虚实选择七")!=null){
        this.current_note_markdown+=localStorage.getItem("虚实选择七");
      }
      else{
        this.current_note_markdown+=`
        但虚实选择七还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"转场练习八" :
      this.current_note_markdown = `
请更改你的练习片段，选择和增加不同视角，让整个描写看起来更加丰富。


      `;
      if(localStorage.getItem("虚实选择八")!=null){
        this.current_note_markdown+=localStorage.getItem("虚实选择八");
      }
      else{
        this.current_note_markdown+=`
        但虚实选择八还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"转场练习九" :
      this.current_note_markdown = `
请更改你的练习片段，选择和增加不同视角，让整个描写看起来更加丰富。


      `;
      if(localStorage.getItem("虚实选择九")!=null){
        this.current_note_markdown+=localStorage.getItem("虚实选择九");
      }
      else{
        this.current_note_markdown+=`
        但虚实选择九还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"转场练习十" :
      this.current_note_markdown = `
请更改你的练习片段，选择和增加不同视角，让整个描写看起来更加丰富。


      `;
      if(localStorage.getItem("虚实选择十")!=null){
        this.current_note_markdown+=localStorage.getItem("虚实选择十");
      }
      else{
        this.current_note_markdown+=`
        但虚实选择十还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


    //转场判断
    case"转场判断一" :
    this.current_note_markdown = `
请指出段落中，每一部分是从哪个视角描写的。

段落如下：

“咔！”话音刚落，一只冰箭正中天然卷的保护罩，镶在了离他鼻尖仅十厘米的地方。箭尖森森溢出的寒气，把保护罩表层冻出了一块巴掌大的冰膜。于此同时，整个保护罩瞬间泛红，刺耳的拉响了红色警报。

致命攻击！

天然卷瞪大了眼睛，不可思议的往下看去。只见霜儿正冷着一张脸，目光冰寒的看着他。手中的长弓正闪着白光。

“说话小心点。”她说。
    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"转场判断二" :
    this.current_note_markdown = `
请指出段落中，每一部分是从哪个视角描写的。

段落如下：

“安静了。”霜儿边说着，边淡淡的收起她的连弩。一副云淡风轻的样子，似乎只是打死了只虫子。

冰气慑人。天然卷旁边的辅助系，看着身边硕大的活人冰球，都有些不寒而栗。

“不是说冰属的人都比较冷静么么？”

“……谁知道，吓死个人了。”人们悄悄的议论道。

“可惜了，多漂亮的一个妹子。却这么可怕。”

“当心以后嫁不出去……”

窃窃私语隐约传来。霜儿猛地抬头，扫了他们一眼。

一股寒气油然而生，爬上人们的脊背。

议论顿时戛然而止。全场鸦雀无声。再也没有人敢多说半个字。

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"转场判断三" :
    this.current_note_markdown = `
请指出段落中，每一部分是从哪个视角描写的。

段落如下：

“有悠然在，你们是逃不掉的。所以，不要想着逃跑了，还是乖乖被虐比较好。”

路悠然，2级，召唤属，植物召唤附属，攻击系。

那一层层的藤蔓，把所有人都裹得结结实实。倒刺上轻微的毒性，麻痹了手脚，让人浑身瘫软。

说好的等人多了一起跑呢？

根本跑不掉嘛。

人们心理哀嚎着，睁眼望向说话的人。

火光跳跃中，炎露露微昂着头。眼帘轻垂看向下方。淡声说：“哪个不服气的，等高级点来找我炎露露报仇啊。”纤长的眼睫毛和浓厚眼影，向下看的傲慢姿态，在火光的掩映下尤为嚣张跋扈。

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"转场判断四" :
    this.current_note_markdown = `
请指出段落中，每一部分是从哪个视角描写的。

段落如下：

混乱的场景中，人们什么都看不清。攻击系就只知道顺着识敌标记一个劲的猛打。招式乱飞，尽力输出就是。在杂乱的情况下，忽然有人拼死发出了一招反击，撞到扇阵最前方的保护罩上，激起了警报。

虽然很快就淹没在绚烂极致的攻击中。但炎露露还是有些吃惊的看了一眼那个方向。

2级。空间撕裂。

炎露露迅速判断了出来。

攻击系。

竟然触发了红色警报……

炎露露对一片狼藉的神坛挑眉，“这届有几个怪物啊。”

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"转场判断五" :
    this.current_note_markdown = `
请指出段落中，每一部分是从哪个视角描写的。

段落如下：

忽然一阵强风起，主神坛中心亮起一整片蓝盈盈的彩光。耀眼的炫光中，一百五十六个刚获得能力的学生，凭空出现在中心的空地上。脸上有获得能力的喜悦。颈部是各色崭新的颈纹。标志着不同能力的初生。

但他们的喜悦，还没来得及自然散去，就僵在了脸上。蓝光淡没后，映入他们眼帘的，是一大片橙色的海洋。那是四五百个眼神不善的橙色青年，沿着围墙四面八方的把他们包围了起来。一个个脸上，都露出了玩味的表情。犹如猎人在打量将要到手的猎物。

幽暗凝滞的气氛中，清冷寒风一吹，势单力薄的学生们，顿时有种毛骨悚然的感觉。

所有人都立刻下了个结论。

打不过。

得跑。

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"转场判断六" :
    this.current_note_markdown = `
请指出段落中，每一部分是从哪个视角描写的。

段落如下：

那迅速璀璨的火星划过，有身手敏捷躲过的，但更多的是被直接击中，一片焦黑的倒在了地上。

即使只被高温擦过，便立时皮开肉绽。幸运的没被击中，也被黑烟熏得涕泗横流。

不愧是群攻技能。只一招，就把所有人都“照顾”到了。

还没毕业的学生们，哪里受过这种阵仗。刚从温柔的主神那儿出来，一下就落到了人间地狱。所有人都瞬间丧失了斗志，自乱阵脚。挤的挤，推的推。不知往哪里跑好。三四十人乱哄哄的挤作一团。等流火好不容易散完后。地面上连保护罩都几乎破损殆尽。

只发一招，就完全控场的炎露露，此刻正傲然站在夜里，笑看场上一片狼藉的炎露露。脸上的妆容明丽，笑意悠然。但在人们眼中看来，她已与恶魔无异。而那可怕的女魔头，还在招呼她的同伴。

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


 


    case"转场判断七" :
    this.current_note_markdown = `
请指出段落中，每一部分是从哪个视角描写的。

段落如下：

自然系攻击倾泻而下。招式不停。如果有人在此时抬头，就能看淡暗夜星河下，高达数十米的龙卷风正和着雨水盘旋肆虐。背景是连绵不断的璀璨闪电，如同一条条发光的蛟蛇般直落而下………

壮丽的景色下，炎露露垂着手，悠然的看向神坛中央。一直微笑的眉梢嘴角，神采飞扬。夜雾重重，星光泯灭。她骄傲的神色却一直明媚可见。

不得不说上届毕业生们，给学弟学妹们上了很好的一课。开战几分钟内，几乎囊括了所有自然属的范围攻击。同时攻击连贯，站位适当，配合默契。华丽又有技术含量。甚至最后的活埋，还对应了墓时适宜埋葬。简直都打出了艺术涵养。

只可惜观众们，统统被埋在了土堆里，完全无法欣赏。
`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"转场判断八" :
    this.current_note_markdown = `
请指出段落中，每一部分是从哪个视角描写的。

段落如下：

攻击持续了一刻钟后，终于在炎露露的挥手后停了下来。暗夜清风下，万籁俱寂。主神坛石壁上遍布着各种攻击痕迹，地板上散乱着泥沙。学生们像是破布玩偶一样被埋在了石块中。大部分面临濒死边缘的心核修复，尸体一般的昏迷着。

少数几个还有些许意识，也恐惧的紧闭双眼。在安静的夜色中，他们只能听到自己砰砰乱跳的心核，和炎露露突兀的嗓音。

炎露露：“恢复属给己方加状态，窥探系那个谁，看着点主神那儿。其余人休息，我们等下一批。”说完她长腿一翘，坐在石头上。手中不知从哪摸出来一块巧克力，咔嚓咔嚓的就吃了起来。

“……”

“……”

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"转场判断九" :
    this.current_note_markdown = `
请指出段落中，每一部分是从哪个视角描写的。

段落如下：

果然前人说得好。死不可怕，等死才可怕。深度绝望之下，有人铤而走险的打算逃跑。身边是潮湿的泥土和血腥味，怪异的味道冲鼻而来。有人深吸了一口气。就算机会渺茫，也得赌一把。也许这些人聊得开心，会忘了他们也说不定。

暗夜幽影，有鬼鬼祟祟的人猫腰就跑。冲着一个比较大的开口，悄无声息的挨了过去。但是世上哪有这么简单的事。最后一批的学生还能从眼皮子底下放跑。炎露露就算是徒有虚名了。

那个偷偷摸摸的身影映入眼帘，炎露露扔下点心包装，漫不经心的拍掉手上的碎屑后，随口点名道：“霜儿，西北点射。”

“是。”包围缺口墙边，深蓝色的短发少女，面无表情的应了一声。

话音未落，就是嗖嗖嗖的三支冰箭，呼啸着向西北飞去。咔咔咔三声，冰箭准确的击中那人前胸，瞬间把他冻了个结结实实。他被冻起来时，还保持这奔跑的姿势。就这么凝结在原地，连脸上惊慌恐惧的表情，都僵在了那里。

聊天的人们，暂时停止了说话。抬头一看，就看到主神坛西北边，有一个晶莹剔透的人形冰雕，在暗夜中反射着星光，盈盈可爱。

一招制敌，干脆果敢。

“哇喔！”有人起哄的朝着霜儿鼓掌。

“阿霜就是阿霜~”

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"转场判断十" :
    this.current_note_markdown = `
请指出段落中，每一部分是从哪个视角描写的。

段落如下：

辅助系照例升空避难。绝对的保护让他们瞬间脱离了危险。没保护罩的人已被勒住了四肢脖颈，呈一种怪异的姿态动弹不得。场上只剩下带着淡淡保护罩的防御系。他们还在带着点后怕庆幸着，就听见炎露露听似柔和，实则暗藏尖锐杀气声音。

“自西向东逐个标记，击碎保护罩！”

悠悠的清音，回荡在整个主神坛里。

击碎保护罩！

攻击系们神色一凛。

黑暗的夜色里，阴风四起，枯叶翻飞。最西边的保护罩上，徒然亮起了一个璀璨的光点。那莹莹白光，是辅助系打的识敌标记。

识敌标记，标记上的就是敌人。众人眼里，忽觉标记点上的地方，格外清晰刺眼。

而保护罩里的人，望着自己身前耀眼的光点，徒觉寒气骤起，无比心惊。那人冷汗直流，但却束手无策。只能听着炎露露的号令声接着响起。

“预备，放！”

话音刚落，一道闪电就直劈而下，势如破竹的砸在保护罩上。那玻璃般的薄罩，立刻裂开了一道手臂长的缝隙。里面的人浑身一震，还没来得及反应，铺天盖地的打击已接踵而至。

旋风、石块、火球、刀刃……可怜这个刚锻造完毕的新人只有一级，一级的保护罩哪里受得住这样的集火。瞬间保护罩圆滑的表面已布满裂纹，眼看就是破裂边缘。那人惊恐的瞪大了眼睛。

紧接着一支冰箭袭来。咔，一声。正中靶心。

唰啦。裂纹四处蔓延，保护罩如玻璃渣般，哗啦啦的碎了一地。里面的人受惊之下，后退三步。本以为接着就是自己受到攻击。但那明亮的光点，在保护罩破碎的同时就已经离开了他。像飘移不定的鬼火，缓缓的移动到了下一个保护罩上。

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;




      //虚实选择
      case"虚实选择一" :
      this.current_note_markdown = `
请更改你的练习片段，增加一些更虚的描写或更实的描写。让整体看起来更和谐。


      `;
      if(localStorage.getItem("速度更改一")!=null){
        this.current_note_markdown+=localStorage.getItem("速度更改一");
      }
      else{
        this.current_note_markdown+=`
        但速度更改一还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"虚实选择二" :
      this.current_note_markdown = `
请更改你的练习片段，增加一些更虚的描写或更实的描写。让整体看起来更和谐


      `;
      if(localStorage.getItem("速度更改二")!=null){
        this.current_note_markdown+=localStorage.getItem("速度更改二");
      }
      else{
        this.current_note_markdown+=`
        但速度更改二还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"虚实选择三" :
      this.current_note_markdown = `
请更改你的练习片段，增加一些更虚的描写或更实的描写。让整体看起来更和谐


      `;
      if(localStorage.getItem("速度更改三")!=null){
        this.current_note_markdown+=localStorage.getItem("速度更改三");
      }
      else{
        this.current_note_markdown+=`
        但速度更改三还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"虚实选择四" :
      this.current_note_markdown = `
请更改你的练习片段，增加一些更虚的描写或更实的描写。让整体看起来更和谐


      `;
      if(localStorage.getItem("速度更改四")!=null){
        this.current_note_markdown+=localStorage.getItem("速度更改四");
      }
      else{
        this.current_note_markdown+=`
        但速度更改四还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"虚实选择五" :
      this.current_note_markdown = `
请更改你的练习片段，增加一些更虚的描写或更实的描写。让整体看起来更和谐


      `;
      if(localStorage.getItem("速度更改五")!=null){
        this.current_note_markdown+=localStorage.getItem("速度更改五");
      }
      else{
        this.current_note_markdown+=`
        但速度更改五还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"虚实选择六" :
      this.current_note_markdown = `
请更改你的练习片段，增加一些更虚的描写或更实的描写。让整体看起来更和谐


      `;
      if(localStorage.getItem("速度更改六")!=null){
        this.current_note_markdown+=localStorage.getItem("速度更改六");
      }
      else{
        this.current_note_markdown+=`
        但速度更改六还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"虚实选择七" :
      this.current_note_markdown = `
请更改你的练习片段，增加一些更虚的描写或更实的描写。让整体看起来更和谐


      `;
      if(localStorage.getItem("速度更改七")!=null){
        this.current_note_markdown+=localStorage.getItem("速度更改七");
      }
      else{
        this.current_note_markdown+=`
        但速度更改七还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"虚实选择八" :
      this.current_note_markdown = `
请更改你的练习片段，增加一些更虚的描写或更实的描写。让整体看起来更和谐


      `;
      if(localStorage.getItem("速度更改八")!=null){
        this.current_note_markdown+=localStorage.getItem("速度更改八");
      }
      else{
        this.current_note_markdown+=`
        但速度更改八还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"虚实选择九" :
      this.current_note_markdown = `
请更改你的练习片段，增加一些更虚的描写或更实的描写。让整体看起来更和谐


      `;
      if(localStorage.getItem("速度更改九")!=null){
        this.current_note_markdown+=localStorage.getItem("速度更改九");
      }
      else{
        this.current_note_markdown+=`
        但速度更改九还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"虚实选择十" :
      this.current_note_markdown = `
请更改你的练习片段，增加一些更虚的描写或更实的描写。让整体看起来更和谐


      `;
      if(localStorage.getItem("速度更改十")!=null){
        this.current_note_markdown+=localStorage.getItem("速度更改十");
      }
      else{
        this.current_note_markdown+=`
        但速度更改十还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

    //战斗虚实判断
    case"虚实判断一" :
    this.current_note_markdown = `
请指出段落中，那部分是较虚的描写，那部分是较实的描写。

段落如下：

“咔！”话音刚落，一只冰箭正中天然卷的保护罩，镶在了离他鼻尖仅十厘米的地方。箭尖森森溢出的寒气，把保护罩表层冻出了一块巴掌大的冰膜。于此同时，整个保护罩瞬间泛红，刺耳的拉响了红色警报。

致命攻击！

天然卷瞪大了眼睛，不可思议的往下看去。只见霜儿正冷着一张脸，目光冰寒的看着他。手中的长弓正闪着白光。

“说话小心点。”她说。
    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"虚实判断二" :
    this.current_note_markdown = `
请指出段落中，那部分是较虚的描写，那部分是较实的描写

段落如下：

“安静了。”霜儿边说着，边淡淡的收起她的连弩。一副云淡风轻的样子，似乎只是打死了只虫子。

冰气慑人。天然卷旁边的辅助系，看着身边硕大的活人冰球，都有些不寒而栗。

“不是说冰属的人都比较冷静么么？”

“……谁知道，吓死个人了。”人们悄悄的议论道。

“可惜了，多漂亮的一个妹子。却这么可怕。”

“当心以后嫁不出去……”

窃窃私语隐约传来。霜儿猛地抬头，扫了他们一眼。

一股寒气油然而生，爬上人们的脊背。

议论顿时戛然而止。全场鸦雀无声。再也没有人敢多说半个字。

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"虚实判断三" :
    this.current_note_markdown = `
请指出段落中，那部分是较虚的描写，那部分是较实的描写

段落如下：

“有悠然在，你们是逃不掉的。所以，不要想着逃跑了，还是乖乖被虐比较好。”

路悠然，2级，召唤属，植物召唤附属，攻击系。

那一层层的藤蔓，把所有人都裹得结结实实。倒刺上轻微的毒性，麻痹了手脚，让人浑身瘫软。

说好的等人多了一起跑呢？

根本跑不掉嘛。

人们心理哀嚎着，睁眼望向说话的人。

火光跳跃中，炎露露微昂着头。眼帘轻垂看向下方。淡声说：“哪个不服气的，等高级点来找我炎露露报仇啊。”纤长的眼睫毛和浓厚眼影，向下看的傲慢姿态，在火光的掩映下尤为嚣张跋扈。

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"虚实判断四" :
    this.current_note_markdown = `
请指出段落中，那部分是较虚的描写，那部分是较实的描写

段落如下：

混乱的场景中，人们什么都看不清。攻击系就只知道顺着识敌标记一个劲的猛打。招式乱飞，尽力输出就是。在杂乱的情况下，忽然有人拼死发出了一招反击，撞到扇阵最前方的保护罩上，激起了警报。

虽然很快就淹没在绚烂极致的攻击中。但炎露露还是有些吃惊的看了一眼那个方向。

2级。空间撕裂。

炎露露迅速判断了出来。

攻击系。

竟然触发了红色警报……

炎露露对一片狼藉的神坛挑眉，“这届有几个怪物啊。”

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"虚实判断五" :
    this.current_note_markdown = `
请指出段落中，那部分是较虚的描写，那部分是较实的描写

段落如下：

忽然一阵强风起，主神坛中心亮起一整片蓝盈盈的彩光。耀眼的炫光中，一百五十六个刚获得能力的学生，凭空出现在中心的空地上。脸上有获得能力的喜悦。颈部是各色崭新的颈纹。标志着不同能力的初生。

但他们的喜悦，还没来得及自然散去，就僵在了脸上。蓝光淡没后，映入他们眼帘的，是一大片橙色的海洋。那是四五百个眼神不善的橙色青年，沿着围墙四面八方的把他们包围了起来。一个个脸上，都露出了玩味的表情。犹如猎人在打量将要到手的猎物。

幽暗凝滞的气氛中，清冷寒风一吹，势单力薄的学生们，顿时有种毛骨悚然的感觉。

所有人都立刻下了个结论。

打不过。

得跑。

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"虚实判断六" :
    this.current_note_markdown = `
请指出段落中，那部分是较虚的描写，那部分是较实的描写

段落如下：

那迅速璀璨的火星划过，有身手敏捷躲过的，但更多的是被直接击中，一片焦黑的倒在了地上。

即使只被高温擦过，便立时皮开肉绽。幸运的没被击中，也被黑烟熏得涕泗横流。

不愧是群攻技能。只一招，就把所有人都“照顾”到了。

还没毕业的学生们，哪里受过这种阵仗。刚从温柔的主神那儿出来，一下就落到了人间地狱。所有人都瞬间丧失了斗志，自乱阵脚。挤的挤，推的推。不知往哪里跑好。三四十人乱哄哄的挤作一团。等流火好不容易散完后。地面上连保护罩都几乎破损殆尽。

只发一招，就完全控场的炎露露，此刻正傲然站在夜里，笑看场上一片狼藉的炎露露。脸上的妆容明丽，笑意悠然。但在人们眼中看来，她已与恶魔无异。而那可怕的女魔头，还在招呼她的同伴。

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


 


    case"虚实判断七" :
    this.current_note_markdown = `
请指出段落中，那部分是较虚的描写，那部分是较实的描写

段落如下：

自然系攻击倾泻而下。招式不停。如果有人在此时抬头，就能看淡暗夜星河下，高达数十米的龙卷风正和着雨水盘旋肆虐。背景是连绵不断的璀璨闪电，如同一条条发光的蛟蛇般直落而下………

壮丽的景色下，炎露露垂着手，悠然的看向神坛中央。一直微笑的眉梢嘴角，神采飞扬。夜雾重重，星光泯灭。她骄傲的神色却一直明媚可见。

不得不说上届毕业生们，给学弟学妹们上了很好的一课。开战几分钟内，几乎囊括了所有自然属的范围攻击。同时攻击连贯，站位适当，配合默契。华丽又有技术含量。甚至最后的活埋，还对应了墓时适宜埋葬。简直都打出了艺术涵养。

只可惜观众们，统统被埋在了土堆里，完全无法欣赏。
`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"虚实判断八" :
    this.current_note_markdown = `
请指出段落中，那部分是较虚的描写，那部分是较实的描写

段落如下：

攻击持续了一刻钟后，终于在炎露露的挥手后停了下来。暗夜清风下，万籁俱寂。主神坛石壁上遍布着各种攻击痕迹，地板上散乱着泥沙。学生们像是破布玩偶一样被埋在了石块中。大部分面临濒死边缘的心核修复，尸体一般的昏迷着。

少数几个还有些许意识，也恐惧的紧闭双眼。在安静的夜色中，他们只能听到自己砰砰乱跳的心核，和炎露露突兀的嗓音。

炎露露：“恢复属给己方加状态，窥探系那个谁，看着点主神那儿。其余人休息，我们等下一批。”说完她长腿一翘，坐在石头上。手中不知从哪摸出来一块巧克力，咔嚓咔嚓的就吃了起来。

“……”

“……”

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"虚实判断九" :
    this.current_note_markdown = `
请指出段落中，那部分是较虚的描写，那部分是较实的描写

段落如下：

果然前人说得好。死不可怕，等死才可怕。深度绝望之下，有人铤而走险的打算逃跑。身边是潮湿的泥土和血腥味，怪异的味道冲鼻而来。有人深吸了一口气。就算机会渺茫，也得赌一把。也许这些人聊得开心，会忘了他们也说不定。

暗夜幽影，有鬼鬼祟祟的人猫腰就跑。冲着一个比较大的开口，悄无声息的挨了过去。但是世上哪有这么简单的事。最后一批的学生还能从眼皮子底下放跑。炎露露就算是徒有虚名了。

那个偷偷摸摸的身影映入眼帘，炎露露扔下点心包装，漫不经心的拍掉手上的碎屑后，随口点名道：“霜儿，西北点射。”

“是。”包围缺口墙边，深蓝色的短发少女，面无表情的应了一声。

话音未落，就是嗖嗖嗖的三支冰箭，呼啸着向西北飞去。咔咔咔三声，冰箭准确的击中那人前胸，瞬间把他冻了个结结实实。他被冻起来时，还保持这奔跑的姿势。就这么凝结在原地，连脸上惊慌恐惧的表情，都僵在了那里。

聊天的人们，暂时停止了说话。抬头一看，就看到主神坛西北边，有一个晶莹剔透的人形冰雕，在暗夜中反射着星光，盈盈可爱。

一招制敌，干脆果敢。

“哇喔！”有人起哄的朝着霜儿鼓掌。

“阿霜就是阿霜~”

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"虚实判断十" :
    this.current_note_markdown = `
请指出段落中，那部分是较虚的描写，那部分是较实的描写

段落如下：

辅助系照例升空避难。绝对的保护让他们瞬间脱离了危险。没保护罩的人已被勒住了四肢脖颈，呈一种怪异的姿态动弹不得。场上只剩下带着淡淡保护罩的防御系。他们还在带着点后怕庆幸着，就听见炎露露听似柔和，实则暗藏尖锐杀气声音。

“自西向东逐个标记，击碎保护罩！”

悠悠的清音，回荡在整个主神坛里。

击碎保护罩！

攻击系们神色一凛。

黑暗的夜色里，阴风四起，枯叶翻飞。最西边的保护罩上，徒然亮起了一个璀璨的光点。那莹莹白光，是辅助系打的识敌标记。

识敌标记，标记上的就是敌人。众人眼里，忽觉标记点上的地方，格外清晰刺眼。

而保护罩里的人，望着自己身前耀眼的光点，徒觉寒气骤起，无比心惊。那人冷汗直流，但却束手无策。只能听着炎露露的号令声接着响起。

“预备，放！”

话音刚落，一道闪电就直劈而下，势如破竹的砸在保护罩上。那玻璃般的薄罩，立刻裂开了一道手臂长的缝隙。里面的人浑身一震，还没来得及反应，铺天盖地的打击已接踵而至。

旋风、石块、火球、刀刃……可怜这个刚锻造完毕的新人只有一级，一级的保护罩哪里受得住这样的集火。瞬间保护罩圆滑的表面已布满裂纹，眼看就是破裂边缘。那人惊恐的瞪大了眼睛。

紧接着一支冰箭袭来。咔，一声。正中靶心。

唰啦。裂纹四处蔓延，保护罩如玻璃渣般，哗啦啦的碎了一地。里面的人受惊之下，后退三步。本以为接着就是自己受到攻击。但那明亮的光点，在保护罩破碎的同时就已经离开了他。像飘移不定的鬼火，缓缓的移动到了下一个保护罩上。

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;




      //战斗速度更改
      case"速度更改一" :
      this.current_note_markdown = `
请更改你的练习片段，把速度改得更快或更慢。


      `;
      if(localStorage.getItem("战斗增减一")!=null){
        this.current_note_markdown+=localStorage.getItem("战斗增减一");
      }
      else{
        this.current_note_markdown+=`
        但战斗增减一还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"速度更改二" :
      this.current_note_markdown = `
请更改你的练习片段，把速度改得更快或更慢。


      `;
      if(localStorage.getItem("战斗增减二")!=null){
        this.current_note_markdown+=localStorage.getItem("战斗增减二");
      }
      else{
        this.current_note_markdown+=`
        但战斗增减二还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"速度更改三" :
      this.current_note_markdown = `
请更改你的练习片段，把速度改得更快或更慢。


      `;
      if(localStorage.getItem("战斗增减三")!=null){
        this.current_note_markdown+=localStorage.getItem("战斗增减三");
      }
      else{
        this.current_note_markdown+=`
        但战斗增减三还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"速度更改四" :
      this.current_note_markdown = `
请更改你的练习片段，把速度改得更快或更慢。


      `;
      if(localStorage.getItem("战斗增减四")!=null){
        this.current_note_markdown+=localStorage.getItem("战斗增减四");
      }
      else{
        this.current_note_markdown+=`
        但战斗增减四还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"速度更改五" :
      this.current_note_markdown = `
请更改你的练习片段，把速度改得更快或更慢。


      `;
      if(localStorage.getItem("战斗增减五")!=null){
        this.current_note_markdown+=localStorage.getItem("战斗增减五");
      }
      else{
        this.current_note_markdown+=`
        但战斗增减五还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"速度更改六" :
      this.current_note_markdown = `
请更改你的练习片段，把速度改得更快或更慢。


      `;
      if(localStorage.getItem("战斗增减六")!=null){
        this.current_note_markdown+=localStorage.getItem("战斗增减六");
      }
      else{
        this.current_note_markdown+=`
        但战斗增减六还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"速度更改七" :
      this.current_note_markdown = `
请更改你的练习片段，把速度改得更快或更慢。


      `;
      if(localStorage.getItem("战斗增减七")!=null){
        this.current_note_markdown+=localStorage.getItem("战斗增减七");
      }
      else{
        this.current_note_markdown+=`
        但战斗增减七还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"速度更改八" :
      this.current_note_markdown = `
请更改你的练习片段，把速度改得更快或更慢。


      `;
      if(localStorage.getItem("战斗增减八")!=null){
        this.current_note_markdown+=localStorage.getItem("战斗增减八");
      }
      else{
        this.current_note_markdown+=`
        但战斗增减八还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"速度更改九" :
      this.current_note_markdown = `
请更改你的练习片段，把速度改得更快或更慢。


      `;
      if(localStorage.getItem("战斗增减九")!=null){
        this.current_note_markdown+=localStorage.getItem("战斗增减九");
      }
      else{
        this.current_note_markdown+=`
        但战斗增减九还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"速度更改十" :
      this.current_note_markdown = `
请更改你的练习片段，把速度改得更快或更慢。


      `;
      if(localStorage.getItem("战斗增减十")!=null){
        this.current_note_markdown+=localStorage.getItem("战斗增减十");
      }
      else{
        this.current_note_markdown+=`
        但战斗增减十还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


    //战斗速度判断
    case"战斗速度一" :
    this.current_note_markdown = `
请指出段落中，战斗速度是快还是慢，是由什么因素造成的。

段落如下：

“咔！”话音刚落，一只冰箭正中天然卷的保护罩，镶在了离他鼻尖仅十厘米的地方。箭尖森森溢出的寒气，把保护罩表层冻出了一块巴掌大的冰膜。于此同时，整个保护罩瞬间泛红，刺耳的拉响了红色警报。

致命攻击！

天然卷瞪大了眼睛，不可思议的往下看去。只见霜儿正冷着一张脸，目光冰寒的看着他。手中的长弓正闪着白光。

“说话小心点。”她说。
    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"战斗速度二" :
    this.current_note_markdown = `
请指出段落中，战斗速度是快还是慢，是由什么因素造成的。

段落如下：

“安静了。”霜儿边说着，边淡淡的收起她的连弩。一副云淡风轻的样子，似乎只是打死了只虫子。

冰气慑人。天然卷旁边的辅助系，看着身边硕大的活人冰球，都有些不寒而栗。

“不是说冰属的人都比较冷静么么？”

“……谁知道，吓死个人了。”人们悄悄的议论道。

“可惜了，多漂亮的一个妹子。却这么可怕。”

“当心以后嫁不出去……”

窃窃私语隐约传来。霜儿猛地抬头，扫了他们一眼。

一股寒气油然而生，爬上人们的脊背。

议论顿时戛然而止。全场鸦雀无声。再也没有人敢多说半个字。

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"战斗速度三" :
    this.current_note_markdown = `
请指出段落中，战斗速度是快还是慢，是由什么因素造成的。

段落如下：

“有悠然在，你们是逃不掉的。所以，不要想着逃跑了，还是乖乖被虐比较好。”

路悠然，2级，召唤属，植物召唤附属，攻击系。

那一层层的藤蔓，把所有人都裹得结结实实。倒刺上轻微的毒性，麻痹了手脚，让人浑身瘫软。

说好的等人多了一起跑呢？

根本跑不掉嘛。

人们心理哀嚎着，睁眼望向说话的人。

火光跳跃中，炎露露微昂着头。眼帘轻垂看向下方。淡声说：“哪个不服气的，等高级点来找我炎露露报仇啊。”纤长的眼睫毛和浓厚眼影，向下看的傲慢姿态，在火光的掩映下尤为嚣张跋扈。

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"战斗速度四" :
    this.current_note_markdown = `
请指出段落中，战斗速度是快还是慢，是由什么因素造成的。

段落如下：

混乱的场景中，人们什么都看不清。攻击系就只知道顺着识敌标记一个劲的猛打。招式乱飞，尽力输出就是。在杂乱的情况下，忽然有人拼死发出了一招反击，撞到扇阵最前方的保护罩上，激起了警报。

虽然很快就淹没在绚烂极致的攻击中。但炎露露还是有些吃惊的看了一眼那个方向。

2级。空间撕裂。

炎露露迅速判断了出来。

攻击系。

竟然触发了红色警报……

炎露露对一片狼藉的神坛挑眉，“这届有几个怪物啊。”

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"战斗速度五" :
    this.current_note_markdown = `
请指出段落中，战斗速度是快还是慢，是由什么因素造成的。

段落如下：

忽然一阵强风起，主神坛中心亮起一整片蓝盈盈的彩光。耀眼的炫光中，一百五十六个刚获得能力的学生，凭空出现在中心的空地上。脸上有获得能力的喜悦。颈部是各色崭新的颈纹。标志着不同能力的初生。

但他们的喜悦，还没来得及自然散去，就僵在了脸上。蓝光淡没后，映入他们眼帘的，是一大片橙色的海洋。那是四五百个眼神不善的橙色青年，沿着围墙四面八方的把他们包围了起来。一个个脸上，都露出了玩味的表情。犹如猎人在打量将要到手的猎物。

幽暗凝滞的气氛中，清冷寒风一吹，势单力薄的学生们，顿时有种毛骨悚然的感觉。

所有人都立刻下了个结论。

打不过。

得跑。

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"战斗速度六" :
    this.current_note_markdown = `
请指出段落中，战斗速度是快还是慢，是由什么因素造成的。

段落如下：

那迅速璀璨的火星划过，有身手敏捷躲过的，但更多的是被直接击中，一片焦黑的倒在了地上。

即使只被高温擦过，便立时皮开肉绽。幸运的没被击中，也被黑烟熏得涕泗横流。

不愧是群攻技能。只一招，就把所有人都“照顾”到了。

还没毕业的学生们，哪里受过这种阵仗。刚从温柔的主神那儿出来，一下就落到了人间地狱。所有人都瞬间丧失了斗志，自乱阵脚。挤的挤，推的推。不知往哪里跑好。三四十人乱哄哄的挤作一团。等流火好不容易散完后。地面上连保护罩都几乎破损殆尽。

只发一招，就完全控场的炎露露，此刻正傲然站在夜里，笑看场上一片狼藉的炎露露。脸上的妆容明丽，笑意悠然。但在人们眼中看来，她已与恶魔无异。而那可怕的女魔头，还在招呼她的同伴。

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


 


    case"战斗速度七" :
    this.current_note_markdown = `
请指出段落中，战斗速度是快还是慢，是由什么因素造成的。

段落如下：

自然系攻击倾泻而下。招式不停。如果有人在此时抬头，就能看淡暗夜星河下，高达数十米的龙卷风正和着雨水盘旋肆虐。背景是连绵不断的璀璨闪电，如同一条条发光的蛟蛇般直落而下………

壮丽的景色下，炎露露垂着手，悠然的看向神坛中央。一直微笑的眉梢嘴角，神采飞扬。夜雾重重，星光泯灭。她骄傲的神色却一直明媚可见。

不得不说上届毕业生们，给学弟学妹们上了很好的一课。开战几分钟内，几乎囊括了所有自然属的范围攻击。同时攻击连贯，站位适当，配合默契。华丽又有技术含量。甚至最后的活埋，还对应了墓时适宜埋葬。简直都打出了艺术涵养。

只可惜观众们，统统被埋在了土堆里，完全无法欣赏。
`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"战斗速度八" :
    this.current_note_markdown = `
请指出段落中，战斗速度是快还是慢，是由什么因素造成的。

段落如下：

攻击持续了一刻钟后，终于在炎露露的挥手后停了下来。暗夜清风下，万籁俱寂。主神坛石壁上遍布着各种攻击痕迹，地板上散乱着泥沙。学生们像是破布玩偶一样被埋在了石块中。大部分面临濒死边缘的心核修复，尸体一般的昏迷着。

少数几个还有些许意识，也恐惧的紧闭双眼。在安静的夜色中，他们只能听到自己砰砰乱跳的心核，和炎露露突兀的嗓音。

炎露露：“恢复属给己方加状态，窥探系那个谁，看着点主神那儿。其余人休息，我们等下一批。”说完她长腿一翘，坐在石头上。手中不知从哪摸出来一块巧克力，咔嚓咔嚓的就吃了起来。

“……”

“……”

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"战斗速度九" :
    this.current_note_markdown = `
请指出段落中，战斗速度是快还是慢，是由什么因素造成的。

段落如下：

果然前人说得好。死不可怕，等死才可怕。深度绝望之下，有人铤而走险的打算逃跑。身边是潮湿的泥土和血腥味，怪异的味道冲鼻而来。有人深吸了一口气。就算机会渺茫，也得赌一把。也许这些人聊得开心，会忘了他们也说不定。

暗夜幽影，有鬼鬼祟祟的人猫腰就跑。冲着一个比较大的开口，悄无声息的挨了过去。但是世上哪有这么简单的事。最后一批的学生还能从眼皮子底下放跑。炎露露就算是徒有虚名了。

那个偷偷摸摸的身影映入眼帘，炎露露扔下点心包装，漫不经心的拍掉手上的碎屑后，随口点名道：“霜儿，西北点射。”

“是。”包围缺口墙边，深蓝色的短发少女，面无表情的应了一声。

话音未落，就是嗖嗖嗖的三支冰箭，呼啸着向西北飞去。咔咔咔三声，冰箭准确的击中那人前胸，瞬间把他冻了个结结实实。他被冻起来时，还保持这奔跑的姿势。就这么凝结在原地，连脸上惊慌恐惧的表情，都僵在了那里。

聊天的人们，暂时停止了说话。抬头一看，就看到主神坛西北边，有一个晶莹剔透的人形冰雕，在暗夜中反射着星光，盈盈可爱。

一招制敌，干脆果敢。

“哇喔！”有人起哄的朝着霜儿鼓掌。

“阿霜就是阿霜~”

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"战斗速度十" :
    this.current_note_markdown = `
请指出段落中，战斗速度是快还是慢，是由什么因素造成的。

段落如下：

辅助系照例升空避难。绝对的保护让他们瞬间脱离了危险。没保护罩的人已被勒住了四肢脖颈，呈一种怪异的姿态动弹不得。场上只剩下带着淡淡保护罩的防御系。他们还在带着点后怕庆幸着，就听见炎露露听似柔和，实则暗藏尖锐杀气声音。

“自西向东逐个标记，击碎保护罩！”

悠悠的清音，回荡在整个主神坛里。

击碎保护罩！

攻击系们神色一凛。

黑暗的夜色里，阴风四起，枯叶翻飞。最西边的保护罩上，徒然亮起了一个璀璨的光点。那莹莹白光，是辅助系打的识敌标记。

识敌标记，标记上的就是敌人。众人眼里，忽觉标记点上的地方，格外清晰刺眼。

而保护罩里的人，望着自己身前耀眼的光点，徒觉寒气骤起，无比心惊。那人冷汗直流，但却束手无策。只能听着炎露露的号令声接着响起。

“预备，放！”

话音刚落，一道闪电就直劈而下，势如破竹的砸在保护罩上。那玻璃般的薄罩，立刻裂开了一道手臂长的缝隙。里面的人浑身一震，还没来得及反应，铺天盖地的打击已接踵而至。

旋风、石块、火球、刀刃……可怜这个刚锻造完毕的新人只有一级，一级的保护罩哪里受得住这样的集火。瞬间保护罩圆滑的表面已布满裂纹，眼看就是破裂边缘。那人惊恐的瞪大了眼睛。

紧接着一支冰箭袭来。咔，一声。正中靶心。

唰啦。裂纹四处蔓延，保护罩如玻璃渣般，哗啦啦的碎了一地。里面的人受惊之下，后退三步。本以为接着就是自己受到攻击。但那明亮的光点，在保护罩破碎的同时就已经离开了他。像飘移不定的鬼火，缓缓的移动到了下一个保护罩上。

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;




    //战斗增减
    case"战斗增减一" :
    this.current_note_markdown = `
请更改你所做过的战斗描写练习。增加或减少氛围，解说，打斗的要素比例。



`;

if(localStorage.getItem("大获全胜")!=null){
        this.current_note_markdown+=localStorage.getItem("大获全胜");
      }
      else{
        this.current_note_markdown+=`
        但大获全胜练习还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"战斗增减二" :
    this.current_note_markdown = `
请更改你所做过的战斗描写练习。增加或减少氛围，解说，打斗的要素比例。



`;

if(localStorage.getItem("一败涂地")!=null){
        this.current_note_markdown+=localStorage.getItem("一败涂地");
      }
      else{
        this.current_note_markdown+=`
        但一败涂地练习还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"战斗增减三" :
    this.current_note_markdown = `
请更改你所做过的战斗描写练习。增加或减少氛围，解说，打斗的要素比例。



`;

if(localStorage.getItem("势均力敌")!=null){
        this.current_note_markdown+=localStorage.getItem("势均力敌");
      }
      else{
        this.current_note_markdown+=`
        但势均力敌练习还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"战斗增减四" :
    this.current_note_markdown = `
请更改你所做过的战斗描写练习。增加或减少氛围，解说，打斗的要素比例。



`;

if(localStorage.getItem("偷袭成功")!=null){
        this.current_note_markdown+=localStorage.getItem("偷袭成功");
      }
      else{
        this.current_note_markdown+=`
        但偷袭成功练习还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"战斗增减五" :
    this.current_note_markdown = `
请更改你所做过的战斗描写练习。增加或减少氛围，解说，打斗的要素比例。



`;

if(localStorage.getItem("且战且退")!=null){
        this.current_note_markdown+=localStorage.getItem("且战且退");
      }
      else{
        this.current_note_markdown+=`
        但且战且退练习还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"战斗增减六" :
    this.current_note_markdown = `
请更改你所做过的战斗描写练习。增加或减少氛围，解说，打斗的要素比例。



`;

if(localStorage.getItem("越战越勇")!=null){
        this.current_note_markdown+=localStorage.getItem("越战越勇");
      }
      else{
        this.current_note_markdown+=`
        但越战越勇练习还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"战斗增减七" :
    this.current_note_markdown = `
请更改你所做过的战斗描写练习。增加或减少氛围，解说，打斗的要素比例。



`;

if(localStorage.getItem("点到为止")!=null){
        this.current_note_markdown+=localStorage.getItem("点到为止");
      }
      else{
        this.current_note_markdown+=`
        但点到为止练习还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"战斗增减八" :
    this.current_note_markdown = `
请更改你所做过的战斗描写练习。增加或减少氛围，解说，打斗的要素比例。



`;

if(localStorage.getItem("聚众群殴")!=null){
        this.current_note_markdown+=localStorage.getItem("聚众群殴");
      }
      else{
        this.current_note_markdown+=`
        但聚众群殴练习还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"战斗增减九" :
    this.current_note_markdown = `
请更改你所做过的战斗描写练习。增加或减少氛围，解说，打斗的要素比例。



`;

if(localStorage.getItem("师徒教学")!=null){
        this.current_note_markdown+=localStorage.getItem("师徒教学");
      }
      else{
        this.current_note_markdown+=`
        但师徒教学练习还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"战斗增减十" :
    this.current_note_markdown = `
请更改你所做过的战斗描写练习。增加或减少氛围，解说，打斗的要素比例。



`;

if(localStorage.getItem("车轮战斗")!=null){
        this.current_note_markdown+=localStorage.getItem("车轮战斗");
      }
      else{
        this.current_note_markdown+=`
        但车轮战斗练习还没有完成。
              `;
      }
      break;


    //战斗要素判断
    case"战斗要素一" :
    this.current_note_markdown = `
请指出段落中，包含氛围，解说，打斗中的哪几种要素。并分别在段落中的哪一句。

段落如下：

“咔！”话音刚落，一只冰箭正中天然卷的保护罩，镶在了离他鼻尖仅十厘米的地方。箭尖森森溢出的寒气，把保护罩表层冻出了一块巴掌大的冰膜。于此同时，整个保护罩瞬间泛红，刺耳的拉响了红色警报。

致命攻击！

天然卷瞪大了眼睛，不可思议的往下看去。只见霜儿正冷着一张脸，目光冰寒的看着他。手中的长弓正闪着白光。

“说话小心点。”她说。
    `;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"战斗要素二" :
    this.current_note_markdown = `
请指出段落中，包含氛围，解说，打斗中的哪几种要素。并分别在段落中的哪一句。

段落如下：

“安静了。”霜儿边说着，边淡淡的收起她的连弩。一副云淡风轻的样子，似乎只是打死了只虫子。

冰气慑人。天然卷旁边的辅助系，看着身边硕大的活人冰球，都有些不寒而栗。

“不是说冰属的人都比较冷静么么？”

“……谁知道，吓死个人了。”人们悄悄的议论道。

“可惜了，多漂亮的一个妹子。却这么可怕。”

“当心以后嫁不出去……”

窃窃私语隐约传来。霜儿猛地抬头，扫了他们一眼。

一股寒气油然而生，爬上人们的脊背。

议论顿时戛然而止。全场鸦雀无声。再也没有人敢多说半个字。

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"战斗要素三" :
    this.current_note_markdown = `
请指出段落中，包含氛围，解说，打斗中的哪几种要素。并分别在段落中的哪一句。

段落如下：

“有悠然在，你们是逃不掉的。所以，不要想着逃跑了，还是乖乖被虐比较好。”

路悠然，2级，召唤属，植物召唤附属，攻击系。

那一层层的藤蔓，把所有人都裹得结结实实。倒刺上轻微的毒性，麻痹了手脚，让人浑身瘫软。

说好的等人多了一起跑呢？

根本跑不掉嘛。

人们心理哀嚎着，睁眼望向说话的人。

火光跳跃中，炎露露微昂着头。眼帘轻垂看向下方。淡声说：“哪个不服气的，等高级点来找我炎露露报仇啊。”纤长的眼睫毛和浓厚眼影，向下看的傲慢姿态，在火光的掩映下尤为嚣张跋扈。

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"战斗要素四" :
    this.current_note_markdown = `
请指出段落中，包含氛围，解说，打斗中的哪几种要素。并分别在段落中的哪一句。

段落如下：

混乱的场景中，人们什么都看不清。攻击系就只知道顺着识敌标记一个劲的猛打。招式乱飞，尽力输出就是。在杂乱的情况下，忽然有人拼死发出了一招反击，撞到扇阵最前方的保护罩上，激起了警报。

虽然很快就淹没在绚烂极致的攻击中。但炎露露还是有些吃惊的看了一眼那个方向。

2级。空间撕裂。

炎露露迅速判断了出来。

攻击系。

竟然触发了红色警报……

炎露露对一片狼藉的神坛挑眉，“这届有几个怪物啊。”

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"战斗要素五" :
    this.current_note_markdown = `
请指出段落中，包含氛围，解说，打斗中的哪几种要素。并分别在段落中的哪一句。

段落如下：

忽然一阵强风起，主神坛中心亮起一整片蓝盈盈的彩光。耀眼的炫光中，一百五十六个刚获得能力的学生，凭空出现在中心的空地上。脸上有获得能力的喜悦。颈部是各色崭新的颈纹。标志着不同能力的初生。

但他们的喜悦，还没来得及自然散去，就僵在了脸上。蓝光淡没后，映入他们眼帘的，是一大片橙色的海洋。那是四五百个眼神不善的橙色青年，沿着围墙四面八方的把他们包围了起来。一个个脸上，都露出了玩味的表情。犹如猎人在打量将要到手的猎物。

幽暗凝滞的气氛中，清冷寒风一吹，势单力薄的学生们，顿时有种毛骨悚然的感觉。

所有人都立刻下了个结论。

打不过。

得跑。

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"战斗要素六" :
    this.current_note_markdown = `
请指出段落中，包含氛围，解说，打斗中的哪几种要素。并分别在段落中的哪一句。

段落如下：

那迅速璀璨的火星划过，有身手敏捷躲过的，但更多的是被直接击中，一片焦黑的倒在了地上。

即使只被高温擦过，便立时皮开肉绽。幸运的没被击中，也被黑烟熏得涕泗横流。

不愧是群攻技能。只一招，就把所有人都“照顾”到了。

还没毕业的学生们，哪里受过这种阵仗。刚从温柔的主神那儿出来，一下就落到了人间地狱。所有人都瞬间丧失了斗志，自乱阵脚。挤的挤，推的推。不知往哪里跑好。三四十人乱哄哄的挤作一团。等流火好不容易散完后。地面上连保护罩都几乎破损殆尽。

只发一招，就完全控场的炎露露，此刻正傲然站在夜里，笑看场上一片狼藉的炎露露。脸上的妆容明丽，笑意悠然。但在人们眼中看来，她已与恶魔无异。而那可怕的女魔头，还在招呼她的同伴。

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


 


    case"战斗要素七" :
    this.current_note_markdown = `
请指出段落中，包含氛围，解说，打斗中的哪几种要素。并分别在段落中的哪一句。

段落如下：

自然系攻击倾泻而下。招式不停。如果有人在此时抬头，就能看淡暗夜星河下，高达数十米的龙卷风正和着雨水盘旋肆虐。背景是连绵不断的璀璨闪电，如同一条条发光的蛟蛇般直落而下………

壮丽的景色下，炎露露垂着手，悠然的看向神坛中央。一直微笑的眉梢嘴角，神采飞扬。夜雾重重，星光泯灭。她骄傲的神色却一直明媚可见。

不得不说上届毕业生们，给学弟学妹们上了很好的一课。开战几分钟内，几乎囊括了所有自然属的范围攻击。同时攻击连贯，站位适当，配合默契。华丽又有技术含量。甚至最后的活埋，还对应了墓时适宜埋葬。简直都打出了艺术涵养。

只可惜观众们，统统被埋在了土堆里，完全无法欣赏。
`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"战斗要素八" :
    this.current_note_markdown = `
请指出段落中，包含氛围，解说，打斗中的哪几种要素。并分别在段落中的哪一句。

段落如下：

攻击持续了一刻钟后，终于在炎露露的挥手后停了下来。暗夜清风下，万籁俱寂。主神坛石壁上遍布着各种攻击痕迹，地板上散乱着泥沙。学生们像是破布玩偶一样被埋在了石块中。大部分面临濒死边缘的心核修复，尸体一般的昏迷着。

少数几个还有些许意识，也恐惧的紧闭双眼。在安静的夜色中，他们只能听到自己砰砰乱跳的心核，和炎露露突兀的嗓音。

炎露露：“恢复属给己方加状态，窥探系那个谁，看着点主神那儿。其余人休息，我们等下一批。”说完她长腿一翘，坐在石头上。手中不知从哪摸出来一块巧克力，咔嚓咔嚓的就吃了起来。

“……”

“……”

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"战斗要素九" :
    this.current_note_markdown = `
请指出段落中，包含氛围，解说，打斗中的哪几种要素。并分别在段落中的哪一句。

段落如下：

果然前人说得好。死不可怕，等死才可怕。深度绝望之下，有人铤而走险的打算逃跑。身边是潮湿的泥土和血腥味，怪异的味道冲鼻而来。有人深吸了一口气。就算机会渺茫，也得赌一把。也许这些人聊得开心，会忘了他们也说不定。

暗夜幽影，有鬼鬼祟祟的人猫腰就跑。冲着一个比较大的开口，悄无声息的挨了过去。但是世上哪有这么简单的事。最后一批的学生还能从眼皮子底下放跑。炎露露就算是徒有虚名了。

那个偷偷摸摸的身影映入眼帘，炎露露扔下点心包装，漫不经心的拍掉手上的碎屑后，随口点名道：“霜儿，西北点射。”

“是。”包围缺口墙边，深蓝色的短发少女，面无表情的应了一声。

话音未落，就是嗖嗖嗖的三支冰箭，呼啸着向西北飞去。咔咔咔三声，冰箭准确的击中那人前胸，瞬间把他冻了个结结实实。他被冻起来时，还保持这奔跑的姿势。就这么凝结在原地，连脸上惊慌恐惧的表情，都僵在了那里。

聊天的人们，暂时停止了说话。抬头一看，就看到主神坛西北边，有一个晶莹剔透的人形冰雕，在暗夜中反射着星光，盈盈可爱。

一招制敌，干脆果敢。

“哇喔！”有人起哄的朝着霜儿鼓掌。

“阿霜就是阿霜~”

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"战斗要素十" :
    this.current_note_markdown = `
请指出段落中，包含氛围，解说，打斗中的哪几种要素。并分别在段落中的哪一句。

段落如下：

辅助系照例升空避难。绝对的保护让他们瞬间脱离了危险。没保护罩的人已被勒住了四肢脖颈，呈一种怪异的姿态动弹不得。场上只剩下带着淡淡保护罩的防御系。他们还在带着点后怕庆幸着，就听见炎露露听似柔和，实则暗藏尖锐杀气声音。

“自西向东逐个标记，击碎保护罩！”

悠悠的清音，回荡在整个主神坛里。

击碎保护罩！

攻击系们神色一凛。

黑暗的夜色里，阴风四起，枯叶翻飞。最西边的保护罩上，徒然亮起了一个璀璨的光点。那莹莹白光，是辅助系打的识敌标记。

识敌标记，标记上的就是敌人。众人眼里，忽觉标记点上的地方，格外清晰刺眼。

而保护罩里的人，望着自己身前耀眼的光点，徒觉寒气骤起，无比心惊。那人冷汗直流，但却束手无策。只能听着炎露露的号令声接着响起。

“预备，放！”

话音刚落，一道闪电就直劈而下，势如破竹的砸在保护罩上。那玻璃般的薄罩，立刻裂开了一道手臂长的缝隙。里面的人浑身一震，还没来得及反应，铺天盖地的打击已接踵而至。

旋风、石块、火球、刀刃……可怜这个刚锻造完毕的新人只有一级，一级的保护罩哪里受得住这样的集火。瞬间保护罩圆滑的表面已布满裂纹，眼看就是破裂边缘。那人惊恐的瞪大了眼睛。

紧接着一支冰箭袭来。咔，一声。正中靶心。

唰啦。裂纹四处蔓延，保护罩如玻璃渣般，哗啦啦的碎了一地。里面的人受惊之下，后退三步。本以为接着就是自己受到攻击。但那明亮的光点，在保护罩破碎的同时就已经离开了他。像飘移不定的鬼火，缓缓的移动到了下一个保护罩上。

`;
    this.is_title = 2;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


      //战斗练习
      case"大获全胜" :
      this.current_note_markdown = `
请写一场主角大获全胜的战斗。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"一败涂地" :
      this.current_note_markdown = `
请写一场主角一败涂地的战斗。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"势均力敌" :
      this.current_note_markdown = `
请写一场主角和敌人势均力敌的战斗。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"偷袭成功" :
      this.current_note_markdown = `
请写一场主角偷袭成功的战斗。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"且战且退" :
      this.current_note_markdown = `
请写一场主角且战且退的战斗。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"越战越勇" :
      this.current_note_markdown = `
请写一场主角越战越勇的战斗。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"点到为止" :
      this.current_note_markdown = `
请写一场主角和对手点到为止的战斗。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"聚众群殴" :
      this.current_note_markdown = `
请写一场主角和对手聚众群殴的战斗。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"师徒教学" :
      this.current_note_markdown = `
请写一场主角和对手进行武艺的师徒教学的战斗。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"车轮战斗" :
      this.current_note_markdown = `
请写一场主角和对手进行车轮战的战斗。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      //战斗仿写
      case"战斗仿写一" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("战斗摘抄一")!=null){
        this.current_note_markdown+=localStorage.getItem("战斗摘抄一");
      }
      else{
        this.current_note_markdown+=`
        但战斗摘抄一还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"战斗仿写二" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("战斗摘抄二")!=null){
        this.current_note_markdown+=localStorage.getItem("战斗摘抄二");
      }
      else{
        this.current_note_markdown+=`
        但战斗摘抄二还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"战斗仿写三" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("战斗摘抄三")!=null){
        this.current_note_markdown+=localStorage.getItem("战斗摘抄三");
      }
      else{
        this.current_note_markdown+=`
        但战斗摘抄三还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"战斗仿写四" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("战斗摘抄四")!=null){
        this.current_note_markdown+=localStorage.getItem("战斗摘抄四");
      }
      else{
        this.current_note_markdown+=`
        但战斗摘抄四还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"战斗仿写五" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("战斗摘抄五")!=null){
        this.current_note_markdown+=localStorage.getItem("战斗摘抄五");
      }
      else{
        this.current_note_markdown+=`
        但战斗摘抄五还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"战斗仿写六" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("战斗摘抄六")!=null){
        this.current_note_markdown+=localStorage.getItem("战斗摘抄六");
      }
      else{
        this.current_note_markdown+=`
        但战斗摘抄六还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"战斗仿写七" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("战斗摘抄七")!=null){
        this.current_note_markdown+=localStorage.getItem("战斗摘抄七");
      }
      else{
        this.current_note_markdown+=`
        但战斗摘抄七还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"战斗仿写八" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("战斗摘抄八")!=null){
        this.current_note_markdown+=localStorage.getItem("战斗摘抄八");
      }
      else{
        this.current_note_markdown+=`
        但战斗摘抄八还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"战斗仿写九" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("战斗摘抄九")!=null){
        this.current_note_markdown+=localStorage.getItem("战斗摘抄九");
      }
      else{
        this.current_note_markdown+=`
        但战斗摘抄九还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"战斗仿写十" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("战斗摘抄十")!=null){
        this.current_note_markdown+=localStorage.getItem("战斗摘抄十");
      }
      else{
        this.current_note_markdown+=`
        但战斗摘抄十还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      //战斗摘抄
      case"战斗摘抄一" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的战斗描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"战斗摘抄二" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的战斗描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"战斗摘抄三" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的战斗描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"战斗摘抄四" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的战斗描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"战斗摘抄五" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的战斗描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"战斗摘抄六" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的战斗描写。
      `;
      

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"战斗摘抄七" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的战斗描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"战斗摘抄八" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的战斗描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"战斗摘抄九" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的战斗描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"战斗摘抄十" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的战斗描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


    //体现风格
    case"现代都市" :
    this.current_note_markdown = `
如果你想写现代都市风格题材，或有现代都市特色的人物。

你会怎么描写他的衣着服饰呢？请写出男女各一套现代都市服饰。

    `;
    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"古风古韵" :
    this.current_note_markdown = `
如果你想写古风古韵风格题材，或古风古韵的人物。

你会怎么描写他的衣着服饰呢？请写出男女各一套古风服饰。

    `;
    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;



    case"太空歌剧" :
    this.current_note_markdown = `
如果你想写太空歌剧风格题材，或太空歌剧特色的人物。

你会怎么描写他的衣着服饰呢？请写出男女各一套符合太空歌剧特色的服饰。

    `;
    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"魔法世界" :
    this.current_note_markdown = `
如果你想写魔法世界风格题材，或魔法世界特色的人物。

你会怎么描写他的衣着服饰呢？请写出男女各一套符合魔法世界特色的服饰。

    `;
    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"童话故事" :
    this.current_note_markdown = `
如果你想写童话故事风格题材，或童话故事特色的人物。

你会怎么描写他的衣着服饰呢？请写出男女各一套符合童话故事特色的服饰。

    `;
    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"异域风情" :
    this.current_note_markdown = `
如果你想写少数民族、异国特色风格题材，或有相关特色的人物。

你会怎么描写他的衣着服饰呢？请写出男女各一套符合异域风情特色的服饰。

    `;
    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"玄幻架空" :
    this.current_note_markdown = `
如果你想写玄幻架空题材，或有相关特色的人物。

你会怎么描写他的衣着服饰呢？请写出男女各一套符合玄幻架空特色的服饰。

    `;
    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;



    case"武侠仙侠" :
    this.current_note_markdown = `
如果你想写武侠仙侠题材，或有相关特色的人物。

你会怎么描写他的衣着服饰呢？请写出男女各一套符合武侠仙侠特色的服饰。

    `;
    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"西方奇幻" :
    this.current_note_markdown = `
如果你想写西方奇幻题材，或有相关特色的人物。

你会怎么描写他的衣着服饰呢？请写出男女各一套符合西方奇幻特色的服饰。

    `;
    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"自定风格" :
    this.current_note_markdown = `
请自定一种特殊风格，或有此风格的人物。

设定并描写男女各一套符合此风格的服饰。

    `;
    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;




     //塑造人物
     case"洁癖死板" :
     this.current_note_markdown = `
请设定并描述一个洁癖死板的人物，可能会穿的衣服。

想想服饰如何体现他的人物特点。

     `;
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"懒散邋遢" :
     this.current_note_markdown = `
请设定并描述一个懒散邋遢的人物，可能会穿的衣服。

想想服饰如何体现他的人物特点。

     `;
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"性格懦弱" :
     this.current_note_markdown = `
请设定并描述一个性格懦弱的人物，可能会穿的衣服。

想想服饰如何体现他的人物特点。

     `;
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"热情如火" :
     this.current_note_markdown = `
请设定并描述一个热情如火的人物，可能会穿的衣服。

想想服饰如何体现他的人物特点。

     `;
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"内敛自闭" :
     this.current_note_markdown = `
请设定并描述一个内敛自闭的人物，可能会穿的衣服。

想想服饰如何体现他的人物特点。

     `;
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"嚣张跋扈" :
     this.current_note_markdown = `
请设定并描述一个嚣张跋扈的人物，可能会穿的衣服。

想想服饰如何体现他的人物特点。

     `;
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"虚伪套路" :
     this.current_note_markdown = `
请设定并描述一个虚伪套路的人物，可能会穿的衣服。

想想服饰如何体现他的人物特点。

     `;
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"天真清纯" :
     this.current_note_markdown = `
请设定并描述一个天真清纯的人物，可能会穿的衣服。

想想服饰如何体现他的人物特点。

     `;
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"老谋深算" :
     this.current_note_markdown = `
请设定并描述一个老谋深算的人物，可能会穿的衣服。

想想服饰如何体现他的人物特点。

     `;
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"神经兮兮" :
     this.current_note_markdown = `
请设定并描述一个神经兮兮的人物，可能会穿的衣服。

想想服饰如何体现他的人物特点。

     `;
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"自定性格" :
     this.current_note_markdown = `
请自行设定并描述一个人物，可能会穿的衣服。

想想服饰如何体现他的人物特点。

     `;
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;





     //区别场合
     case"日常打扮" :
     this.current_note_markdown = `
请设定并描述一个人物的日常打扮。

     `;
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"居家睡衣" :
     this.current_note_markdown = `
请设定并描述一个人物的居家睡衣。

     `;
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"重要会见" :
     this.current_note_markdown = `
请设定并描述一个人物在面临重要会见，比如相亲或见伴侣父母时所穿的服饰

     `;
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"职业正装" :
     this.current_note_markdown = `
请设定并描述一个人物在公司时所穿的服饰。

     `;
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"葬礼丧服" :
     this.current_note_markdown = `
请设定并描述一个人物在参加亲人丧礼时所穿的服饰

     `;
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"华丽礼服" :
     this.current_note_markdown = `
请设定并描述一个人物在参加豪华宴会时所穿的服饰

     `;
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"婚礼婚纱" :
     this.current_note_markdown = `
请设定并描述一个人物在参加自己婚礼时所穿的服饰

     `;
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"潮流服饰" :
     this.current_note_markdown = `
请设定并描述一个人物在去潮流场所，比如酒吧和舞厅所穿的服饰

     `;
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"cosplay" :
     this.current_note_markdown = `
请设定并描述一个人物在去参加漫展或cosplay场合所穿的服饰。

     `;
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"自定场合" :
     this.current_note_markdown = `
请设定并描述一个人物在某特殊场合所穿的服饰。

     `;
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     //区别身份
     case"学生校服" :
     this.current_note_markdown = `
服饰有区别身份的作用，请设定一位为学生身份的人物，并为他描写服饰。

可以想象一下他不穿校服时和穿校服时的区别。

     `;
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"军队制服" :
     this.current_note_markdown = `
服饰有区别身份的作用，请设定一位为军官身份的人物，并为他描写服饰。

可以想象一下他不穿制服时和穿制服时的区别。

     `;
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"医院制服" :
     this.current_note_markdown = `
服饰有区别身份的作用，请设定一位为医生或护士身份的人物，并为他描写服饰。

可以想象一下他不穿制服时和穿制服时的区别。

     `;
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"警官制服" :
     this.current_note_markdown = `
服饰有区别身份的作用，请设定一位为警察身份的人物，并为他描写服饰。

可以想象一下他不穿制服时和穿制服时的区别。

     `;
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;



     case"空乘制服" :
     this.current_note_markdown = `
服饰有区别身份的作用，请设定一位为空乘身份的人物，并为他描写服饰。

可以想象一下他不穿制服时和穿制服时的区别。

     `;
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"监狱囚服" :
     this.current_note_markdown = `
服饰有区别身份的作用，请设定一位为囚犯身份的人物，并为他描写服饰。

可以想象一下他不穿囚服时和穿囚服时的区别。

     `;
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"运动队服" :
     this.current_note_markdown = `
服饰有区别身份的作用，请设定一位为运动员身份的人物，并为他描写服饰。

可以想象一下他不穿队服时和穿队服时的区别。

     `;
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"民族服饰" :
     this.current_note_markdown = `
服饰有区别身份的作用，请设定一位为少数民族的人物，并为他描写服饰。

可以想象一下他不穿民族服饰时穿民族服饰时的区别。

     `;
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"贵族打扮" :
     this.current_note_markdown = `
服饰有区别身份的作用，请设定一位为贵族的人物，并为他描写服饰。

可以想象一下他不做贵族打扮时穿和不做贵族打扮时的区别。

     `;
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"自定身份" :
     this.current_note_markdown = `
服饰有区别身份的作用，请设定一种身份，并设定和描述能区别这种身份的服饰。


     `;
     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;



    //服饰增减
    case"服饰增减一" :
    this.current_note_markdown = `
请更改你所做过的服饰描写练习。增加或减少不同的配件，或色彩、质地、样式、效果这几种外貌要素。



`;

if(localStorage.getItem("服饰练习一")!=null){
        this.current_note_markdown+=localStorage.getItem("服饰练习一");
      }
      else{
        this.current_note_markdown+=`
        但服饰练习一还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"服饰增减二" :
    this.current_note_markdown = `
请更改你所做过的服饰描写练习。增加或减少不同的配件，或色彩、质地、样式、效果这几种外貌要素。



`;

if(localStorage.getItem("服饰练习二")!=null){
        this.current_note_markdown+=localStorage.getItem("服饰练习二");
      }
      else{
        this.current_note_markdown+=`
        但服饰练习二还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"服饰增减三" :
    this.current_note_markdown = `
请更改你所做过的服饰描写练习。增加或减少不同的配件，或色彩、质地、样式、效果这几种外貌要素。



`;

if(localStorage.getItem("服饰练习三")!=null){
        this.current_note_markdown+=localStorage.getItem("服饰练习三");
      }
      else{
        this.current_note_markdown+=`
        但服饰练习三还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"服饰增减四" :
    this.current_note_markdown = `
请更改你所做过的服饰描写练习。增加或减少不同的配件，或色彩、质地、样式、效果这几种外貌要素。



`;

if(localStorage.getItem("服饰练习四")!=null){
        this.current_note_markdown+=localStorage.getItem("服饰练习四");
      }
      else{
        this.current_note_markdown+=`
        但服饰练习四还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"服饰增减五" :
    this.current_note_markdown = `
请更改你所做过的服饰描写练习。增加或减少不同的配件，或色彩、质地、样式、效果这几种外貌要素。



`;

if(localStorage.getItem("服饰练习五")!=null){
        this.current_note_markdown+=localStorage.getItem("服饰练习五");
      }
      else{
        this.current_note_markdown+=`
        但服饰练习五还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"服饰增减六" :
    this.current_note_markdown = `
请更改你所做过的服饰描写练习。增加或减少不同的配件，或色彩、质地、样式、效果这几种外貌要素。



`;

if(localStorage.getItem("服饰练习六")!=null){
        this.current_note_markdown+=localStorage.getItem("服饰练习六");
      }
      else{
        this.current_note_markdown+=`
        但服饰练习六还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"服饰增减七" :
    this.current_note_markdown = `
请更改你所做过的服饰描写练习。增加或减少不同的配件，或色彩、质地、样式、效果这几种外貌要素。



`;

if(localStorage.getItem("服饰练习七")!=null){
        this.current_note_markdown+=localStorage.getItem("服饰练习七");
      }
      else{
        this.current_note_markdown+=`
        但服饰练习七还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"服饰增减八" :
    this.current_note_markdown = `
请更改你所做过的服饰描写练习。增加或减少不同的配件，或色彩、质地、样式、效果这几种外貌要素。



`;

if(localStorage.getItem("服饰练习八")!=null){
        this.current_note_markdown+=localStorage.getItem("服饰练习八");
      }
      else{
        this.current_note_markdown+=`
        但服饰练习八还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"服饰增减九" :
    this.current_note_markdown = `
请更改你所做过的服饰描写练习。增加或减少不同的配件，或色彩、质地、样式、效果这几种外貌要素。



`;

if(localStorage.getItem("服饰练习九")!=null){
        this.current_note_markdown+=localStorage.getItem("服饰练习九");
      }
      else{
        this.current_note_markdown+=`
        但服饰练习九还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"服饰增减十" :
    this.current_note_markdown = `
请更改你所做过的服饰描写练习。增加或减少不同的配件，或色彩、质地、样式、效果这几种外貌要素。



`;

if(localStorage.getItem("服饰练习十")!=null){
        this.current_note_markdown+=localStorage.getItem("服饰练习十");
      }
      else{
        this.current_note_markdown+=`
        但服饰练习十还没有完成。
              `;
      }
      break;


     //服饰要素判断
     case"服饰要素一" :
     this.current_note_markdown = `
请指出段落中，包含衣服，裤子，帽子，上衣，下装，鞋袜，背包，披风，围巾，领带，手套，雨伞，腰带，王冠，项链，手链，玉坠等哪些配件。

以及描写配件时，使用了色彩，质地，样式，效果哪几种要素。

段落如下：

寡妇系黑裙，可是丈夫过世多年之后，如有公婆在堂，她可以穿湖色或雪青。裙上的细褶是女人的仪态最严格的试验。家教好的姑娘，莲步姗姗，百褶裙虽不至于纹丝不动，也只限于最轻微的摇颤。不惯穿裙的小家碧玉走起路来便予人以惊风骇浪的印象。


     `;
     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"服饰要素二" :
     this.current_note_markdown = `
请指出段落中，包含衣服，裤子，帽子，上衣，下装，鞋袜，背包，披风，围巾，领带，手套，雨伞，腰带，王冠，项链，手链，玉坠等哪些配件。

以及描写配件时，使用了色彩，质地，样式，效果哪几种要素。

段落如下：

而这位黑裙女人，除了袖口的扣子是白的之外，全身上下，无论是衣服，裙子，鞋子，腰带。甚至连发卡都是黑色的。

她看起来都不像是乌鸦站在白棍子上的。就像是黑色树丛里的一直全黑的乌鸦。只有羽毛上落上的几点雪花，还有一点白色。
     `;
     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"服饰要素三" :
     this.current_note_markdown = `
请指出段落中，包含衣服，裤子，帽子，上衣，下装，鞋袜，背包，披风，围巾，领带，手套，雨伞，腰带，王冠，项链，手链，玉坠等哪些配件。

以及描写配件时，使用了色彩，质地，样式，效果哪几种要素。

段落如下：

妹妹给我的这间斗篷长袍是深棕色的，看起来既宽松又厚实，还不乏美感。斗篷从里到外裹着细细密密的绒毛，只在脖子和腰部有宽带固定，外部点缀着少许金莹的亮片和散珠。看起来既大方又不失俏皮。这件带着妹妹体温的长袍，一下就把我裹得严严实实的。

`;
     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;
           

     case"服饰要素四" :
     this.current_note_markdown = `
请指出段落中，包含衣服，裤子，帽子，上衣，下装，鞋袜，背包，披风，围巾，领带，手套，雨伞，腰带，王冠，项链，手链，玉坠等哪些配件。

以及描写配件时，使用了色彩，质地，样式，效果哪几种要素。

段落如下：

右起第三个女子，穿着十分华丽的淡褐色齐胸襦裙，下身一色艳丽的石榴红裙。披挂深褐色随风飘扬。浓黑秀发梳成高高的波浪状云鬓，上面插满了各色金银首饰，翠绿的翘、金色的雀饰、玉莹的簪子，不一而足，耀眼夺目。

这位女子体型微胖，有一股圆润的风采。背景是一树娇艳盛开的芙蓉花，而她正伸出满载着金手镯和翡翠戒指的圆嫩手指，伸手想采摘一朵鲜花。
`;
     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"服饰要素五" :
     this.current_note_markdown = `
请指出段落中，包含衣服，裤子，帽子，上衣，下装，鞋袜，背包，披风，围巾，领带，手套，雨伞，腰带，王冠，项链，手链，玉坠等哪些配件。

以及描写配件时，使用了色彩，质地，样式，效果哪几种要素。

段落如下：

右起第一个女子，身着大红色的拖地长斗篷，帽檐和衣服边角处绣着金色的凤凰，又添了一圈棕红色的貂毛，耳朵上挂着一只翡翠绿色的精致耳环，在大漠中抚弦清唱的样子，还挺合拍的。
`;
     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"服饰要素六" :
     this.current_note_markdown = `
请指出段落中，包含衣服，裤子，帽子，上衣，下装，鞋袜，背包，披风，围巾，领带，手套，雨伞，腰带，王冠，项链，手链，玉坠等哪些配件。

以及描写配件时，使用了色彩，质地，样式，效果哪几种要素。

段落如下：

她穿着一件很粉嫩的洛丽塔裙子。这件裙子是轻柔的浅橙色，有薄纱从胸部垂下，在上腰处一束，然后散开撑着成为一个圆锥形的裙摆，并不拖地，直到膝盖上方一点就收住。肩部也有相同的散开柔边设计，像花瓣一般柔嫩，却并不层叠。除了轻轻浅浅的淡雅布料，几乎不加任何点缀。裙边一朵一朵盛开着淡黄色的小雏菊花。袖口和裙角露出雪白的蕾丝花边。下身穿着纯白色的丝袜和黑色的扣带小皮鞋，将色彩点缀的又清纯，又妖艳。

她的身材娇小，因此裙子虽然合身，但依然长的盖住了膝盖。因此她走路的时候，会稍微地提起些裙子。以免妨碍自己的步伐。芊芊细步，不卑不亢地走来，看起来非常有贵族的优雅气息。
`;
     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"服饰要素七" :
     this.current_note_markdown = `
请指出段落中，包含衣服，裤子，帽子，上衣，下装，鞋袜，背包，披风，围巾，领带，手套，雨伞，腰带，王冠，项链，手链，玉坠等哪些配件。

以及描写配件时，使用了色彩，质地，样式，效果哪几种要素。

段落如下：

她依然穿着那件深黑色的宽大长袍，肥肥胖胖的袖口和裙摆往外面嚣张地张开，然后松松软润地垂到床上。布料从下小腿处扎紧，扎进的后援就显得胖胖的，像是里面都充满了气体一样，让格瑞斯看起来像一个胖娃娃。长袍通体乌黑，看上去又厚又实。只在领口处流下一缕浅红色的丝线来，浅浅地映着窗外的阳光发亮，淡淡地蜿蜒伸到腰间，盘成了一朵赤色的玫瑰花。
`;
     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"服饰要素八" :
     this.current_note_markdown = `
请指出段落中，包含衣服，裤子，帽子，上衣，下装，鞋袜，背包，披风，围巾，领带，手套，雨伞，腰带，王冠，项链，手链，玉坠等哪些配件。

以及描写配件时，使用了色彩，质地，样式，效果哪几种要素。

段落如下：

她今天依然穿着粗糙的麻布衣服，袖口处因为摩擦的多了，都露出了许多长短不一的线条。膝盖和手肘处打了好几个补丁。补丁的颜色并不一致，但因为洗的次数多了，全都统一的发白发灰，因此身上的颜色也没有变得杂乱，只是全都是淡淡的灰色，看起来有些土气。但穿在汉娜身上，却莫名的显出一种出尘的感觉。

今天这身衣服还是补丁比较少的一件，只在膝盖和手肘这些容易磨破的地方打了几个补丁。之前的某件衣服，身上大大小小的补丁大概有几十个，几乎都看不出衣服原来的样子了。那才是真正的叹为观止呢。

但汉娜无论是穿着多么破旧的衣服，都没有丝毫的不好意思，或者觉得低人一等的感觉，就连走路的时候，也依然是抬头挺胸，大跨步十分自在地往前走去。肩膀稍稍有些外摆，姿势竟有些潇洒奔放的样子。看起来有个十分强大的内心，实在是非常令人佩服。

`;
     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"服饰要素九" :
     this.current_note_markdown = `
请指出段落中，包含衣服，裤子，帽子，上衣，下装，鞋袜，背包，披风，围巾，领带，手套，雨伞，腰带，王冠，项链，手链，玉坠等哪些配件。

以及描写配件时，使用了色彩，质地，样式，效果哪几种要素。

段落如下：

她今天依然穿着粗糙的麻布衣服，袖口处因为摩擦的多了，都露出了许多长短不一的线条。膝盖和手肘处打了好几个补丁。补丁的颜色并不一致，但因为洗的次数多了，全都统一的发白发灰，因此身上的颜色也没有变得杂乱，只是全都是淡淡的灰色，看起来有些土气。但穿在汉娜身上，却莫名的显出一种出尘的感觉。

今天这身衣服还是补丁比较少的一件，只在膝盖和手肘这些容易磨破的地方打了几个补丁。之前的某件衣服，身上大大小小的补丁大概有几十个，几乎都看不出衣服原来的样子了。那才是真正的叹为观止呢。

但汉娜无论是穿着多么破旧的衣服，都没有丝毫的不好意思，或者觉得低人一等的感觉，就连走路的时候，也依然是抬头挺胸，大跨步十分自在地往前走去。肩膀稍稍有些外摆，姿势竟有些潇洒奔放的样子。看起来有个十分强大的内心，实在是非常令人佩服。

`;
     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"服饰要素十" :
     this.current_note_markdown = `
请指出段落中，包含衣服，裤子，帽子，上衣，下装，鞋袜，背包，披风，围巾，领带，手套，雨伞，腰带，王冠，项链，手链，玉坠等哪些配件。

以及描写配件时，使用了色彩，质地，样式，效果哪几种要素。

段落如下：

他今天将头发染成了浅褐色，长长的秀发向四周梳成许许多多根小小的麻花辫，细细的，几乎没有手指粗，一条一条密密麻麻地向下垂下，一直垂到颈部的位置，绕着脸庞垂了一圈，然后剩余的发量向上拉到头顶最中心，用一朵娇艳的牡丹花头饰固定，然后许许多多小串的麻花辫，又分成三股，编成一条巨大的麻花辫子，向下一直垂到脑后。

头发上装饰着金碧辉煌的发饰。头顶一朵娇艳动人的大红色牡丹花，花瓣肆意地向四周伸展开放，像是在炫耀主人的风姿和财富。牡丹花向下吊下两颗巨大的白色珍珠来，轻轻地贴在额头上，在午后的阳光下闪着暖黄色和浅绿色的光泽。牡丹花向两边耳朵延伸的地方，是一圈金银打造的发饰，上面雕刻着做工精巧的繁复花纹，有凤凰飞过嘴里衔着一朵荷花的，有鲤鱼在莲花池里游曳的，有蝴蝶在百花丛中飞舞的，也有云朵一片一片飘散的，一圈一圈精巧繁华地，绕着头顶往下垂下，一直垂到耳朵上方，在耳朵上方的位置固定住。

然后从耳朵上方，直接垂下好几串玛瑙的链子来。大红色莹润的玛瑙上面有着天然的纹路，奇巧诡怪，红色白色黑色和黄色相互交杂，使得链子上面的颜色丰富又不刺眼，华丽而又自然。一串串玛瑙的链子直接从耳朵上方垂下，大约有三四个巴掌的长度，垂到肩部下方。只要一转头，链子们就随着头的摆动，很剧烈地摇动起来，一时间珠子清脆的响声就哗啦啦地响成一片。叮叮咚咚的声音，像是在提醒着别人注意自己的美丽华贵。

在靠头顶的右侧有着一顶纯银打造的小礼帽。小礼帽上面竖起许多片金色蓝色相杂的羽毛来。仔细一看，金色的羽毛是有削的很薄的金片做成的，薄到可以有弹性的在头顶晃动，但依然坚韧，直直地挺立在小礼帽的上方。蓝色的羽毛颜色特别纯净亮丽，非常亮眼，是任何宝石都无法比拟的。这种亮蓝色，总让我疑心和我们世界古代的点翠是否使用了同一种工艺。
`;
     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;





      //配件搭配
      case"清纯少女" :
      this.current_note_markdown = `
请给清纯少女搭配一身服饰，除了衣服裤子之外，还可以搭配包括帽子，上衣，下装，鞋袜，背包，一些配件如披风，围巾，领带，手套，雨伞，腰带，还有各种首饰比如王冠，项链，手链，玉坠等等。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"活力男生" :
      this.current_note_markdown = `
请给活力男生搭配一身服饰，除了衣服裤子之外，还可以搭配包括帽子，上衣，下装，鞋袜，背包，一些配件如披风，围巾，领带，手套，雨伞，腰带，还有各种首饰比如王冠，项链，手链，玉坠等等。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"不良少年" :
      this.current_note_markdown = `
请给不良少年搭配一身服饰，除了衣服裤子之外，还可以搭配包括帽子，上衣，下装，鞋袜，背包，一些配件如披风，围巾，领带，手套，雨伞，腰带，还有各种首饰比如王冠，项链，手链，玉坠等等。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"霸道御姐" :
      this.current_note_markdown = `
请给霸道御姐搭配一身服饰，除了衣服裤子之外，还可以搭配包括帽子，上衣，下装，鞋袜，背包，一些配件如披风，围巾，领带，手套，雨伞，腰带，还有各种首饰比如王冠，项链，手链，玉坠等等。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"邋遢懒汉" :
      this.current_note_markdown = `
请给邋遢懒汉搭配一身服饰，除了衣服裤子之外，还可以搭配包括帽子，上衣，下装，鞋袜，背包，一些配件如披风，围巾，领带，手套，雨伞，腰带，还有各种首饰比如王冠，项链，手链，玉坠等等。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"新暴发户" :
      this.current_note_markdown = `
请给新暴发户搭配一身服饰，除了衣服裤子之外，还可以搭配包括帽子，上衣，下装，鞋袜，背包，一些配件如披风，围巾，领带，手套，雨伞，腰带，还有各种首饰比如王冠，项链，手链，玉坠等等。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"皇家公主" :
      this.current_note_markdown = `
请给皇家公主搭配一身服饰，除了衣服裤子之外，还可以搭配包括帽子，上衣，下装，鞋袜，背包，一些配件如披风，围巾，领带，手套，雨伞，腰带，还有各种首饰比如王冠，项链，手链，玉坠等等。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"白马王子" :
      this.current_note_markdown = `
请给白马王子搭配一身服饰，除了衣服裤子之外，还可以搭配包括帽子，上衣，下装，鞋袜，背包，一些配件如披风，围巾，领带，手套，雨伞，腰带，还有各种首饰比如王冠，项链，手链，玉坠等等。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"临终老人" :
      this.current_note_markdown = `
请给临终老人搭配一身服饰，除了衣服裤子之外，还可以搭配包括帽子，上衣，下装，鞋袜，背包，一些配件如披风，围巾，领带，手套，雨伞，腰带，还有各种首饰比如王冠，项链，手链，玉坠等等。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"八岁小孩" :
      this.current_note_markdown = `
请给八岁小孩搭配一身服饰，除了衣服裤子之外，还可以搭配包括帽子，上衣，下装，鞋袜，背包，一些配件如披风，围巾，领带，手套，雨伞，腰带，还有各种首饰比如王冠，项链，手链，玉坠等等。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;



     //服饰练习
     case"服饰练习一" :
     this.current_note_markdown = `
请试着描写图片中的服饰。

![](https://img.pic88.com/16056485584564.jpg?imageMogr2/quality/100!/thumbnail/640/crop/640x852|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDExMTMxNzM0MTMxMDgxNjE=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"服饰练习二" :
     this.current_note_markdown = `
请试着描写图片中的服饰。

![](https://img.pic88.com/16056487820485.jpg?imageMogr2/quality/100!/thumbnail/640/crop/640x852|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDExMTMxNzM0MTMxMDgxOTQ=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"服饰练习三" :
     this.current_note_markdown = `
请试着描写图片中的服饰。

![](https://img.pic88.com/16056837174470.jpg?imageMogr2/quality/100!/thumbnail/640/crop/640x852|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDExMTMxNzMzMjk5ODg4Ng==/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"服饰练习四" :
     this.current_note_markdown = `
请试着描写图片中的服饰。

![](https://img.pic88.com/16056485477453.jpg?imageMogr2/quality/100!/thumbnail/640/crop/640x852|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDExMTMxNzM0MTMxMDgxNTk=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"服饰练习五" :
     this.current_note_markdown = `
请试着描写图片中的服饰。

![](https://img.pic88.com/16056777563102.jpg?imageMogr2/quality/100!/thumbnail/640/crop/640x852|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDExMTMxNzM0MzUxMTI2MDc=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"服饰练习六" :
     this.current_note_markdown = `
请试着描写图片中的服饰。

![](https://img.pic88.com/16057529517023.jpg?imageMogr2/quality/100!/thumbnail/640/crop/640x852|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDExMTMxNzM0MzQxMTI0NzA=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"服饰练习七" :
     this.current_note_markdown = `
请试着描写图片中的服饰。

![](https://img.pic88.com/preview/2020/10/11/16024207195f82ffef0eadc.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDEwMTEyMDUxNTgyMDYwNjg0/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"服饰练习八" :
     this.current_note_markdown = `
请试着描写图片中的服饰。

![](https://img.pic88.com/preview/2020/08/18/15977586141690250.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MTcwNzQxMDcxOTU3ODY=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"服饰练习九" :
     this.current_note_markdown = `
请试着描写图片中的服饰。

![](https://img.pic88.com/500807486.jpg?imageMogr2/quality/100!/thumbnail/640|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMTAyMjcxNjA5MDE4NzY2MA==/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"服饰练习十" :
     this.current_note_markdown = `
请试着描写图片中的服饰。

![](https://img.pic88.com/preview/2020/09/03/1599068236523347.jpg?imageMogr2/quality/100!/thumbnail/640|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA5MDMwMTM3MTcxMjE5MjU=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

   
      //服饰仿写
      case"服饰仿写一" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("服饰摘抄一")!=null){
        this.current_note_markdown+=localStorage.getItem("服饰摘抄一");
      }
      else{
        this.current_note_markdown+=`
        但服饰摘抄一还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"服饰仿写二" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("服饰摘抄二")!=null){
        this.current_note_markdown+=localStorage.getItem("服饰摘抄二");
      }
      else{
        this.current_note_markdown+=`
        但服饰摘抄二还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"服饰仿写三" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("服饰摘抄三")!=null){
        this.current_note_markdown+=localStorage.getItem("服饰摘抄三");
      }
      else{
        this.current_note_markdown+=`
        但服饰摘抄三还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


 
      case"服饰仿写四" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("服饰摘抄四")!=null){
        this.current_note_markdown+=localStorage.getItem("服饰摘抄四");
      }
      else{
        this.current_note_markdown+=`
        但服饰摘抄四还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"服饰仿写五" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("服饰摘抄五")!=null){
        this.current_note_markdown+=localStorage.getItem("服饰摘抄五");
      }
      else{
        this.current_note_markdown+=`
        但服饰摘抄五还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"服饰仿写六" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("服饰摘抄六")!=null){
        this.current_note_markdown+=localStorage.getItem("服饰摘抄六");
      }
      else{
        this.current_note_markdown+=`
        但服饰摘抄六还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"服饰仿写七" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("服饰摘抄七")!=null){
        this.current_note_markdown+=localStorage.getItem("服饰摘抄七");
      }
      else{
        this.current_note_markdown+=`
        但服饰摘抄七还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"服饰仿写八" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("服饰摘抄八")!=null){
        this.current_note_markdown+=localStorage.getItem("服饰摘抄八");
      }
      else{
        this.current_note_markdown+=`
        但服饰摘抄八还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"服饰仿写九" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("服饰摘抄九")!=null){
        this.current_note_markdown+=localStorage.getItem("服饰摘抄九");
      }
      else{
        this.current_note_markdown+=`
        但服饰摘抄九还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"服饰仿写十" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("服饰摘抄十")!=null){
        this.current_note_markdown+=localStorage.getItem("服饰摘抄十");
      }
      else{
        this.current_note_markdown+=`
        但服饰摘抄十还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;



      //服饰摘抄
      case"服饰摘抄一" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的服饰描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"服饰摘抄二" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的服饰描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"服饰摘抄三" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的服饰描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"服饰摘抄四" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的服饰描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;
       

      case"服饰摘抄五" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的服饰描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"服饰摘抄六" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的服饰描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"服饰摘抄七" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的服饰描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"服饰摘抄八" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的服饰描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;
       

      case"服饰摘抄九" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的服饰描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"服饰摘抄十" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的服饰描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;
       
       


    //群像练习
     case"群像练习一" :
     this.current_note_markdown = `
请试着描写图片中的人群，自行选择重点描写对象和描写顺序。

![](https://img.pic88.com/preview/2020/09/27/16011770295f7005c5e53ea.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA5MjcxMTIzNDkxMTIyNzcx/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"群像练习二" :
     this.current_note_markdown = `
请试着描写图片中的人群，自行选择重点描写对象和描写顺序。

![](https://img.pic88.com/preview/2020/08/05/15966334351456750.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MDUyMDUwNTAyMTIxMzg=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;



     case"群像练习三" :
     this.current_note_markdown = `
请试着描写图片中的人群，自行选择重点描写对象和描写顺序。

![](https://img.pic88.com/preview/2020/08/05/15966341721450793.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MDUxMjQ4MzYyMDYxODM=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"群像练习四" :
     this.current_note_markdown = `
请试着描写图片中的人群，自行选择重点描写对象和描写顺序。

![](https://img.pic88.com/preview/2020/08/05/15966419721395874.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MDUxMjI5MTMxNTEyNjI=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"群像练习五" :
     this.current_note_markdown = `
请试着描写图片中的人群，自行选择重点描写对象和描写顺序。

![](https://img.pic88.com/preview/2020/08/05/15966471701335222.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MDUxMDM5Mzk5MDU4OQ==/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"群像练习六" :
     this.current_note_markdown = `
请试着描写图片中的人群，自行选择重点描写对象和描写顺序。

![](https://img.pic88.com/preview/2020/08/05/15966455021361739.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MDUyMDEyMzUxMTcxMjc=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"群像练习七" :
     this.current_note_markdown = `
请试着描写图片中的人群，自行选择重点描写对象和描写顺序。

![](https://img.pic88.com/preview/2020/08/05/15966456441359694.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MDUyMDExMDAxMTUwODI=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"群像练习八" :
     this.current_note_markdown = `
请试着描写图片中的人群，自行选择重点描写对象和描写顺序。

![](https://img.pic88.com/501661816.jpg?imageMogr2/quality/100!/thumbnail/640|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMTAzMDEyMjAyMDExMjk1OTM=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"群像练习九" :
     this.current_note_markdown = `
请试着描写图片中的人群，自行选择重点描写对象和描写顺序。

![](https://img.pic88.com/501661839.jpg?imageMogr2/quality/100!/thumbnail/640|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMTAyMjgwNDMxMzQxMDA2ODk=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"群像练习十" :
     this.current_note_markdown = `
请试着描写图片中的人群，自行选择重点描写对象和描写顺序。

![](https://img.pic88.com/500574336.jpg?imageMogr2/quality/100!/thumbnail/640|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMTAyMjgxMzQ1MTQxMzg5ODE=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;





    //特增选择
    case"特增选择一" :
    this.current_note_markdown = `
请更改你所做过的外貌描写练习。选择外貌中最重要，最能让人记忆深刻的特征，进行详细描写



`;

if(localStorage.getItem("外貌要素增减一")!=null){
        this.current_note_markdown+=localStorage.getItem("外貌要素增减一");
      }
      else{
        this.current_note_markdown+=`
        但外貌要素增减一还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"特增选择二" :
    this.current_note_markdown = `
请更改你所做过的外貌描写练习。选择外貌中最重要，最能让人记忆深刻的特征，进行详细描写



`;

if(localStorage.getItem("外貌要素增减二")!=null){
        this.current_note_markdown+=localStorage.getItem("外貌要素增减二");
      }
      else{
        this.current_note_markdown+=`
        但外貌要素增减二还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"特增选择三" :
    this.current_note_markdown = `
请更改你所做过的外貌描写练习。选择外貌中最重要，最能让人记忆深刻的特征，进行详细描写



`;

if(localStorage.getItem("外貌要素增减三")!=null){
        this.current_note_markdown+=localStorage.getItem("外貌要素增减三");
      }
      else{
        this.current_note_markdown+=`
        但外貌要素增减三还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"特增选择四" :
    this.current_note_markdown = `
请更改你所做过的外貌描写练习。选择外貌中最重要，最能让人记忆深刻的特征，进行详细描写



`;

if(localStorage.getItem("外貌要素增减四")!=null){
        this.current_note_markdown+=localStorage.getItem("外貌要素增减四");
      }
      else{
        this.current_note_markdown+=`
        但外貌要素增减四还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;    


    case"特增选择五" :
    this.current_note_markdown = `
请更改你所做过的外貌描写练习。选择外貌中最重要，最能让人记忆深刻的特征，进行详细描写



`;

if(localStorage.getItem("外貌要素增减五")!=null){
        this.current_note_markdown+=localStorage.getItem("外貌要素增减五");
      }
      else{
        this.current_note_markdown+=`
        但外貌要素增减五还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;    


    case"特增选择六" :
    this.current_note_markdown = `
请更改你所做过的外貌描写练习。选择外貌中最重要，最能让人记忆深刻的特征，进行详细描写



`;

if(localStorage.getItem("外貌要素增减六")!=null){
        this.current_note_markdown+=localStorage.getItem("外貌要素增减六");
      }
      else{
        this.current_note_markdown+=`
        但外貌要素增减六还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;    


    case"特增选择七" :
    this.current_note_markdown = `
请更改你所做过的外貌描写练习。选择外貌中最重要，最能让人记忆深刻的特征，进行详细描写



`;

if(localStorage.getItem("外貌要素增减七")!=null){
        this.current_note_markdown+=localStorage.getItem("外貌要素增减七");
      }
      else{
        this.current_note_markdown+=`
        但外貌要素增减七还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;    


    case"特增选择八" :
    this.current_note_markdown = `
请更改你所做过的外貌描写练习。选择外貌中最重要，最能让人记忆深刻的特征，进行详细描写



`;

if(localStorage.getItem("外貌要素增减八")!=null){
        this.current_note_markdown+=localStorage.getItem("外貌要素增减八");
      }
      else{
        this.current_note_markdown+=`
        但外貌要素增减八还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;    


    case"特增选择九" :
    this.current_note_markdown = `
请更改你所做过的外貌描写练习。选择外貌中最重要，最能让人记忆深刻的特征，进行详细描写



`;

if(localStorage.getItem("外貌要素增减九")!=null){
        this.current_note_markdown+=localStorage.getItem("外貌要素增减九");
      }
      else{
        this.current_note_markdown+=`
        但外貌要素增减九还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;    

    case"特增选择十" :
    this.current_note_markdown = `
请更改你所做过的外貌描写练习。选择外貌中最重要，最能让人记忆深刻的特征，进行详细描写



`;

if(localStorage.getItem("外貌要素增减十")!=null){
        this.current_note_markdown+=localStorage.getItem("外貌要素增减十");
      }
      else{
        this.current_note_markdown+=`
        但外貌要素增减十还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;    




    //外貌要素增减
    case"外貌要素增减一" :
    this.current_note_markdown = `
请更改你所做过的外貌描写练习。增加或减少面容，身材，姿态，气质这几种外貌要素。



`;

if(localStorage.getItem("外貌练习一")!=null){
        this.current_note_markdown+=localStorage.getItem("外貌练习一");
      }
      else{
        this.current_note_markdown+=`
        但外貌练习一还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"外貌要素增减二" :
    this.current_note_markdown = `
请更改你所做过的外貌描写练习。增加或减少面容，身材，姿态，气质这几种外貌要素。



`;

if(localStorage.getItem("外貌练习二")!=null){
        this.current_note_markdown+=localStorage.getItem("外貌练习二");
      }
      else{
        this.current_note_markdown+=`
        但外貌练习二还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"外貌要素增减三" :
    this.current_note_markdown = `
请更改你所做过的外貌描写练习。增加或减少面容，身材，姿态，气质这几种外貌要素。



`;

if(localStorage.getItem("外貌练习三")!=null){
        this.current_note_markdown+=localStorage.getItem("外貌练习三");
      }
      else{
        this.current_note_markdown+=`
        但外貌练习三还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"外貌要素增减四" :
    this.current_note_markdown = `
请更改你所做过的外貌描写练习。增加或减少面容，身材，姿态，气质这几种外貌要素。



`;

if(localStorage.getItem("外貌练习四")!=null){
        this.current_note_markdown+=localStorage.getItem("外貌练习四");
      }
      else{
        this.current_note_markdown+=`
        但外貌练习四还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"外貌要素增减五" :
    this.current_note_markdown = `
请更改你所做过的外貌描写练习。增加或减少面容，身材，姿态，气质这几种外貌要素。



`;

if(localStorage.getItem("外貌练习五")!=null){
        this.current_note_markdown+=localStorage.getItem("外貌练习五");
      }
      else{
        this.current_note_markdown+=`
        但外貌练习五还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"外貌要素增减六" :
    this.current_note_markdown = `
请更改你所做过的外貌描写练习。增加或减少面容，身材，姿态，气质这几种外貌要素。



`;

if(localStorage.getItem("外貌练习六")!=null){
        this.current_note_markdown+=localStorage.getItem("外貌练习六");
      }
      else{
        this.current_note_markdown+=`
        但外貌练习六还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"外貌要素增减七" :
    this.current_note_markdown = `
请更改你所做过的外貌描写练习。增加或减少面容，身材，姿态，气质这几种外貌要素。



`;

if(localStorage.getItem("外貌练习七")!=null){
        this.current_note_markdown+=localStorage.getItem("外貌练习七");
      }
      else{
        this.current_note_markdown+=`
        但外貌练习七还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"外貌要素增减八" :
    this.current_note_markdown = `
请更改你所做过的外貌描写练习。增加或减少面容，身材，姿态，气质这几种外貌要素。



`;

if(localStorage.getItem("外貌练习八")!=null){
        this.current_note_markdown+=localStorage.getItem("外貌练习八");
      }
      else{
        this.current_note_markdown+=`
        但外貌练习八还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"外貌要素增减九" :
    this.current_note_markdown = `
请更改你所做过的外貌描写练习。增加或减少面容，身材，姿态，气质这几种外貌要素。



`;

if(localStorage.getItem("外貌练习九")!=null){
        this.current_note_markdown+=localStorage.getItem("外貌练习九");
      }
      else{
        this.current_note_markdown+=`
        但外貌练习九还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"外貌要素增减十" :
    this.current_note_markdown = `
请更改你所做过的外貌描写练习。增加或减少面容，身材，姿态，气质这几种外貌要素。



`;

if(localStorage.getItem("外貌练习十")!=null){
        this.current_note_markdown+=localStorage.getItem("外貌练习十");
      }
      else{
        this.current_note_markdown+=`
        但外貌练习十还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;





     //要素判断
     case"神雕侠侣" :
     this.current_note_markdown = `
请指出段落中，包含面容，身材，姿态，气质中的几种外貌描写要素。

并指出分别是什么。段落如下：

杨过见那少女约莫十七八岁年纪，肤色娇嫩，晶莹雪白，眼神清澈，嘴边有粒小小黑痣，容貌甚美。那女郎又格格娇笑。她容貌固也算得甚美，比之小龙女自远远不及，但较之程英之柔、陆无双之俏，似亦不见逊色，杨过心中比较，觉此女清雅，胜于完颜萍。她秀雅脱俗，自有一股清灵之气。
     
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"倚天屠龙记" :
     this.current_note_markdown = `
请指出段落中，包含面容，身材，姿态，气质中的几种外貌描写要素。

并指出分别是什么。段落如下：

舟中书生站起身来，微微一笑，拱手为礼，左手向着上首的座位一伸，请客人坐下。碧纱灯笼照映下，这书生手白胜雪，再看他相貌，玉颊微瘦，眉弯鼻挺，一笑时左颊上浅浅一个梨涡，远观之似是个风流俊俏的公子，这时相向而对，显是个女扮男装的妙龄丽人。
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"红楼梦" :
     this.current_note_markdown = `
请指出段落中，包含面容，身材，姿态，气质中的几种外貌描写要素。

并指出分别是什么。段落如下：

两弯似蹙非蹙眉，一双似喜非喜含情目。态生两靥之愁，娇袭一身之病。泪光点点，娇喘微微。闲静时如姣花照水，行动处似弱柳扶风。心较比干多一窍，病如西子胜三分。 
    `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"羊脂球" :
     this.current_note_markdown = `
请指出段落中，包含面容，身材，姿态，气质中的几种外貌描写要素。

并指出分别是什么。段落如下：

矮矮的身材，满身各部分全是滚圆的，胖得像是肥膘，手指头儿全是丰满之至的，丰满得在每一节小骨和另一节接合的地方都箍出了一个圈，简直像是一串短短儿的香肠似的：皮肤是光润而且绷紧了的，胸脯丰满得在裙袍里突出来，然而她始终被人垂涎又被人追逐，她的鲜润气色教人看了多么顺眼。她的脸蛋儿像一个发红的苹果，一朵将要开花的芍药；脸蛋儿上半段，睁着一双活溜溜的黑眼睛，四周深而密的睫毛向内部映出一圈阴影；下半段，一张妩媚的嘴，窄窄儿的和润泽得使人想去亲吻，内部露出一排闪光而且非常纤细的牙齿。

`;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"边城" :
     this.current_note_markdown = `
请指出段落中，包含面容，身材，姿态，气质中的几种外貌描写要素。

并指出分别是什么。段落如下：

翠翠在风日里长养着，把皮肤变得黑黑的，触目的青山绿水，一对眸子清明如水晶，自然既长养她且教育她。为人天真活泼，处处俨如一只小兽物。人又那么乖，和山头黄麂一样，从不想到残忍事情，从不发愁，从不动气。平时在渡船上遇陌生人对她有所注意时，便把光光的眼睛瞅着那陌生人，作成随时皆可举步逃入深山的神气，但明白了人无机心后，就又从从容容在水边玩耍了。


`;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"一念永恒" :
     this.current_note_markdown = `
请指出段落中，包含面容，身材，姿态，气质中的几种外貌描写要素。

并指出分别是什么。段落如下：

清晨，村庄的大门前，整个村子里的乡亲，正为一个十五六岁的少年送别，这少年瘦弱，但却白白净净，看起来很是乖巧，衣着尽管是寻常的青衫，可却洗的泛白，穿在这少年的身上，与他目中的纯净搭配在一起，透出一股子灵动。


`;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"玄界之门" :
     this.current_note_markdown = `
请指出段落中，包含面容，身材，姿态，气质中的几种外貌描写要素。

并指出分别是什么。段落如下：

石牧盯着眼前的青衫老者，缓缓问道。

年纪不过十四的他，因为常年皮肤微微黑红，但浓眉大眼，个头比一般同龄人高出小半个头去，破旧衬衫内，更隐约现出凸起的一块块精壮肌肉，目光深沉，给人一种充满野性的桀骜不驯感觉。

`;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"禁代夏微寒-外貌" :
     this.current_note_markdown = `
请指出段落中，包含面容，身材，姿态，气质中的几种外貌描写要素。

并指出分别是什么。段落如下：

即使周围有些喧闹，这声音还是清晰的传入耳里，我回头一看，一个梳着双马尾的女生，相貌精致，嘴唇略薄，正迈着高傲的步子朝我走来。

站定在我跟前，她仔细的看了我一会，意味深长的补了一句，“你朋友说的对，你对竞争对手太不上心了。
`;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"天之落英-外貌" :
     this.current_note_markdown = `
请指出段落中，包含面容，身材，姿态，气质中的几种外貌描写要素。

并指出分别是什么。段落如下：

浅浅灰蓝色的天空下，星辰闪耀。只见一个白发的男子，在空中缓缓显形。身姿轻柔的飘落下来。

他看起来很年轻，皮肤细腻，白如鹅纸，容貌不到百岁。细如柳叶的长眉下，是一双明媚的丹凤眼。鼻梁高翘，弧度优美。嘴唇轻薄，下巴平滑。左眼下一点泪痣，让他笑起来时，莫名多了一种妖艳的气质。

披散下的长发，衬着绣金边的红色长袍在风中飘摇。红的衣，白的发。一时艳丽无双。

`;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"禁代心医师-外貌" :
     this.current_note_markdown = `
请指出段落中，包含面容，身材，姿态，气质中的几种外貌描写要素。

并指出分别是什么。段落如下：

我转过头，一个八九岁的女孩穿着简陋的格子裙，带着微笑蹲在我身边。苍白的皮肤，加上黑发灰鞋淡色格子裙。一身单调的颜色，唯一的亮彩，是装饰在她头发上的粉色发带。衬在灰黑色的房间里。色彩反差得有些刺眼。
`;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;





     //外貌练习
     case"外貌练习一" :
     this.current_note_markdown = `
请试着描写图片中的外貌。

![](https://img.pic88.com/preview/2020/08/05/15966341471451042.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MDUyMDQ4NDIyMDY0Mjc=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"外貌练习二" :
     this.current_note_markdown = `
请试着描写图片中的外貌。

![](https://img.pic88.com/preview/2020/08/05/15966341441451072.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MDUyMDQ4NDMyMDY0NjA=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"外貌练习三" :
     this.current_note_markdown = `
请试着描写图片中的外貌。

![](https://img.pic88.com/preview/2020/08/05/15966453601364027.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MDUyMDE0MTkxMTk0MTU=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"外貌练习四" :
     this.current_note_markdown = `
请试着描写图片中的外貌。

![](https://img.pic88.com/preview/2020/08/05/15966341521450987.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MDUxMjQ4NDEyMDYzNzc=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"外貌练习五" :
     this.current_note_markdown = `
请试着描写图片中的外貌。

![](https://img.pic88.com/preview/2020/08/05/15966333081458213.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MDUxMjUxMjUyMTM2MDM=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"外貌练习六" :
     this.current_note_markdown = `
请试着描写图片中的外貌。

![](https://img.pic88.com/preview/2020/08/01/15962767851202655.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA3MjMwMDQzNDE5OTk4MA==/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"外貌练习七" :
     this.current_note_markdown = `
请试着描写图片中的外貌。

![](https://img.pic88.com/preview/2020/08/05/15966341431451090.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MDUxMjQ4NDQyMDY0Nzk=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"外貌练习八" :
     this.current_note_markdown = `
请试着描写图片中的外貌。

![](https://img.pic88.com/preview/2020/08/05/15966388611420062.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MDUyMDM3MzUxNzU0NTA=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"外貌练习九" :
     this.current_note_markdown = `
请试着描写图片中的外貌。

![](https://img.pic88.com/preview/2020/08/05/15966341491451019.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MDUxMjQ4NDIyMDY0MDc=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"外貌练习十" :
     this.current_note_markdown = `
请试着描写图片中的外貌。

![](https://img.pic88.com/preview/2020/08/05/15966356541440716.jpg?imageMogr2/quality/100!/crop/!640x-0-20|watermark/3/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvcGljODgtd2F0ZXIucG5n/gravity/Center/dissolve/100/dx/0/dy/10/image/aHR0cHM6Ly9qcy5waWM4OC5jb20vd3d3L2NvbW1vbi9pbWcvd2gyMzBiZy5wbmc=/dx/0/dy/25/text/SUTvvJoxMjAyMDA4MDUyMDQ1MDIxOTYxMDM=/fill/I0ZGRkZGRg==/fontsize/320/dx/30/dy/30)
     `;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;



     //外貌仿写
     case"外貌仿写一" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("外貌摘抄一")!=null){
       this.current_note_markdown+=localStorage.getItem("外貌摘抄一");
     }
     else{
       this.current_note_markdown+=`
       但外貌摘抄一还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"外貌仿写二" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("外貌摘抄二")!=null){
       this.current_note_markdown+=localStorage.getItem("外貌摘抄二");
     }
     else{
       this.current_note_markdown+=`
       但外貌摘抄二还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"外貌仿写三" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("外貌摘抄三")!=null){
       this.current_note_markdown+=localStorage.getItem("外貌摘抄三");
     }
     else{
       this.current_note_markdown+=`
       但外貌摘抄三还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"外貌仿写四" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("外貌摘抄四")!=null){
       this.current_note_markdown+=localStorage.getItem("外貌摘抄四");
     }
     else{
       this.current_note_markdown+=`
       但外貌摘抄四还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"外貌仿写五" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("外貌摘抄五")!=null){
       this.current_note_markdown+=localStorage.getItem("外貌摘抄五");
     }
     else{
       this.current_note_markdown+=`
       但外貌摘抄五还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;



     case"外貌仿写六" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("外貌摘抄六")!=null){
       this.current_note_markdown+=localStorage.getItem("外貌摘抄六");
     }
     else{
       this.current_note_markdown+=`
       但外貌摘抄六还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"外貌仿写七" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("外貌摘抄七")!=null){
       this.current_note_markdown+=localStorage.getItem("外貌摘抄七");
     }
     else{
       this.current_note_markdown+=`
       但外貌摘抄七还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"外貌仿写八" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("外貌摘抄八")!=null){
       this.current_note_markdown+=localStorage.getItem("外貌摘抄八");
     }
     else{
       this.current_note_markdown+=`
       但外貌摘抄八还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"外貌仿写九" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("外貌摘抄九")!=null){
       this.current_note_markdown+=localStorage.getItem("外貌摘抄九");
     }
     else{
       this.current_note_markdown+=`
       但外貌摘抄九还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"外貌仿写十" :
     this.current_note_markdown = `
请仿写你所摘抄过的段落。


     `;
     if(localStorage.getItem("外貌摘抄十")!=null){
       this.current_note_markdown+=localStorage.getItem("外貌摘抄十");
     }
     else{
       this.current_note_markdown+=`
       但外貌摘抄十还没有完成。
             `;
     }

     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

      //外貌摘抄
      case"外貌摘抄一" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的外貌描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"外貌摘抄二" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的外貌描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"外貌摘抄三" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的外貌描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"外貌摘抄四" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的外貌描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"外貌摘抄五" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的外貌描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"外貌摘抄六" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的外貌描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"外貌摘抄七" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的外貌描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"外貌摘抄八" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的外貌描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"外貌摘抄九" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的外貌描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"外貌摘抄十" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的外貌描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;




     //场景切换
     case"场景切换一" :
     this.current_note_markdown = `
 请在你做过的练习之后，增加内容，从当前场景切换到其他场景去。
 
 
 
 `;
 
 if(localStorage.getItem("更改顺序一")!=null){
         this.current_note_markdown+=localStorage.getItem("更改顺序一");
       }
       else{
         this.current_note_markdown+=`
         但更改顺序一还没有完成。
               `;
       }
 
   
 
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"场景切换二" :
     this.current_note_markdown = `
 请在你做过的练习之后，增加内容，从当前场景切换到其他场景去。
 
 
 
 `;
 
 if(localStorage.getItem("更改顺序二")!=null){
         this.current_note_markdown+=localStorage.getItem("更改顺序二");
       }
       else{
         this.current_note_markdown+=`
         但更改顺序二还没有完成。
               `;
       }
 
   
 
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"场景切换三" :
     this.current_note_markdown = `
 请在你做过的练习之后，增加内容，从当前场景切换到其他场景去。
 
 
 
 `;
 
 if(localStorage.getItem("更改顺序三")!=null){
         this.current_note_markdown+=localStorage.getItem("更改顺序三");
       }
       else{
         this.current_note_markdown+=`
         但更改顺序三还没有完成。
               `;
       }
 
   
 
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"场景切换四" :
     this.current_note_markdown = `
 请在你做过的练习之后，增加内容，从当前场景切换到其他场景去。
 
 
 
 `;
 
 if(localStorage.getItem("更改顺序四")!=null){
         this.current_note_markdown+=localStorage.getItem("更改顺序四");
       }
       else{
         this.current_note_markdown+=`
         但更改顺序四还没有完成。
               `;
       }
 
   
 
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"场景切换五" :
     this.current_note_markdown = `
 请在你做过的练习之后，增加内容，从当前场景切换到其他场景去。
 
 
 
 `;
 
 if(localStorage.getItem("更改顺序五")!=null){
         this.current_note_markdown+=localStorage.getItem("更改顺序五");
       }
       else{
         this.current_note_markdown+=`
         但更改顺序五还没有完成。
               `;
       }
 
   
 
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;




     case"场景切换六" :
     this.current_note_markdown = `
 请在你做过的练习之后，增加内容，从当前场景切换到其他场景去。
 
 
 
 `;
 
 if(localStorage.getItem("更改顺序六")!=null){
         this.current_note_markdown+=localStorage.getItem("更改顺序六");
       }
       else{
         this.current_note_markdown+=`
         但更改顺序六还没有完成。
               `;
       }
 
   
 
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"场景切换七" :
     this.current_note_markdown = `
 请在你做过的练习之后，增加内容，从当前场景切换到其他场景去。
 
 
 
 `;
 
 if(localStorage.getItem("更改顺序七")!=null){
         this.current_note_markdown+=localStorage.getItem("更改顺序七");
       }
       else{
         this.current_note_markdown+=`
         但更改顺序七还没有完成。
               `;
       }
 
   
 
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"场景切换八" :
     this.current_note_markdown = `
 请在你做过的练习之后，增加内容，从当前场景切换到其他场景去。
 
 
 
 `;
 
 if(localStorage.getItem("更改顺序八")!=null){
         this.current_note_markdown+=localStorage.getItem("更改顺序八");
       }
       else{
         this.current_note_markdown+=`
         但更改顺序八还没有完成。
               `;
       }
 
   
 
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"场景切换九" :
     this.current_note_markdown = `
 请在你做过的练习之后，增加内容，从当前场景切换到其他场景去。
 
 
 
 `;
 
 if(localStorage.getItem("更改顺序九")!=null){
         this.current_note_markdown+=localStorage.getItem("更改顺序九");
       }
       else{
         this.current_note_markdown+=`
         但更改顺序九还没有完成。
               `;
       }
 
   
 
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"场景切换十" :
     this.current_note_markdown = `
 请在你做过的练习之后，增加内容，从当前场景切换到其他场景去。
 
 
 
 `;
 
 if(localStorage.getItem("更改顺序十")!=null){
         this.current_note_markdown+=localStorage.getItem("更改顺序十");
       }
       else{
         this.current_note_markdown+=`
         但更改顺序十还没有完成。
               `;
       }
 
   
 
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;





     //更改顺序
     case"更改顺序一" :
     this.current_note_markdown = `
 请更改你所做过的场景描写练习。选择一种描写顺序进行排列。
 
 
 
 `;
 
 if(localStorage.getItem("要素增减一")!=null){
         this.current_note_markdown+=localStorage.getItem("要素增减一");
       }
       else{
         this.current_note_markdown+=`
         但要素增减一还没有完成。
               `;
       }
 
   
 
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"更改顺序二" :
     this.current_note_markdown = `
 请更改你所做过的场景描写练习。选择一种描写顺序进行排列。
 
 
 
 `;
 
 if(localStorage.getItem("要素增减二")!=null){
         this.current_note_markdown+=localStorage.getItem("要素增减二");
       }
       else{
         this.current_note_markdown+=`
         但要素增减二还没有完成。
               `;
       }
 
   
 
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;



     case"更改顺序三" :
     this.current_note_markdown = `
 请更改你所做过的场景描写练习。选择一种描写顺序进行排列。
 
 
 
 `;
 
 if(localStorage.getItem("要素增减三")!=null){
         this.current_note_markdown+=localStorage.getItem("要素增减三");
       }
       else{
         this.current_note_markdown+=`
         但要素增减三还没有完成。
               `;
       }
 
   
 
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"更改顺序四" :
     this.current_note_markdown = `
 请更改你所做过的场景描写练习。选择一种描写顺序进行排列。
 
 
 
 `;
 
 if(localStorage.getItem("要素增减四")!=null){
         this.current_note_markdown+=localStorage.getItem("要素增减四");
       }
       else{
         this.current_note_markdown+=`
         但要素增减四还没有完成。
               `;
       }
 
   
 
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"更改顺序五" :
     this.current_note_markdown = `
 请更改你所做过的场景描写练习。选择一种描写顺序进行排列。
 
 
 
 `;
 
 if(localStorage.getItem("要素增减五")!=null){
         this.current_note_markdown+=localStorage.getItem("要素增减五");
       }
       else{
         this.current_note_markdown+=`
         但要素增减五还没有完成。
               `;
       }
 
   
 
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"更改顺序六" :
     this.current_note_markdown = `
 请更改你所做过的场景描写练习。选择一种描写顺序进行排列。
 
 
 
 `;
 
 if(localStorage.getItem("要素增减六")!=null){
         this.current_note_markdown+=localStorage.getItem("要素增减六");
       }
       else{
         this.current_note_markdown+=`
         但要素增减六还没有完成。
               `;
       }
 
   
 
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"更改顺序七" :
     this.current_note_markdown = `
 请更改你所做过的场景描写练习。选择一种描写顺序进行排列。
 
 
 
 `;
 
 if(localStorage.getItem("要素增减七")!=null){
         this.current_note_markdown+=localStorage.getItem("要素增减七");
       }
       else{
         this.current_note_markdown+=`
         但要素增减七还没有完成。
               `;
       }
 
   
 
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"更改顺序八" :
     this.current_note_markdown = `
 请更改你所做过的场景描写练习。选择一种描写顺序进行排列。
 
 
 
 `;
 
 if(localStorage.getItem("要素增减八")!=null){
         this.current_note_markdown+=localStorage.getItem("要素增减八");
       }
       else{
         this.current_note_markdown+=`
         但要素增减八还没有完成。
               `;
       }
 
   
 
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"更改顺序九" :
     this.current_note_markdown = `
 请更改你所做过的场景描写练习。选择一种描写顺序进行排列。
 
 
 
 `;
 
 if(localStorage.getItem("要素增减九")!=null){
         this.current_note_markdown+=localStorage.getItem("要素增减九");
       }
       else{
         this.current_note_markdown+=`
         但要素增减九还没有完成。
               `;
       }
 
   
 
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"更改顺序十" :
     this.current_note_markdown = `
 请更改你所做过的场景描写练习。选择一种描写顺序进行排列。
 
 
 
 `;
 
 if(localStorage.getItem("要素增减十")!=null){
         this.current_note_markdown+=localStorage.getItem("要素增减十");
       }
       else{
         this.current_note_markdown+=`
         但要素增减十还没有完成。
               `;
       }
 
   
 
     this.is_title = 1;
     if( this.view_type == 2 ) this.view_type = 3;
     break;
 



     //顺序判断
     case"螭龙传顺序" :
     this.current_note_markdown = `
请指出段落中，场景中描写了什么，是以什么顺序描写的。

段落如下：

头上有些冰凉的东西落下来，我渐渐苏醒过来。又是一场难得的大雨。

久眠而醒我不知道这一觉又睡了多久，也不知道睡到了什么时候。我的视线清晰过来，滂沱的大雨使全世界都笼置在了一层水幕之中。我又闭上了眼睛沐雨而立。

那么，她在哪里?在近我之途，还是远我之路?

`;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"变成女孩的我不可能这么可爱顺序" :
     this.current_note_markdown = `
请指出段落中，场景中描写了什么，是以什么顺序描写的。

段落如下：

天阴沉沉的，周围冰冷的空气里弥漫着一股淡淡的哀愁。女孩默默的望着空，苍弯之下，云墨翻涌狂风四散。

一道闪雷划过天际，终于，下雨了。

狂风呼啸着穿过山谷，掠过森林，如同鬼魅一般嬉笑着，最后汇集到悬崖方，诡异地扭动，交错升腾。

倾盆的雨幕狠狠的压在女孩瘦弱的肩上，浸湿了她的衣发。狂风狠狠的拍打着那单薄的身影，像是要将她推下悬崖，彻底撕碎。

女孩静静的伫立在雨幕里。任由风雨来袭，鬼魅哭嚎，她弱小的身影在雨幕里晃动着，似乎随时都会倒下。

该隐就在她身后，静静的看着。

`;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"天之落英顺序" :
     this.current_note_markdown = `
请指出段落中，场景中描写了什么，是以什么顺序描写的。

段落如下：

天水城，位于梅里雪山东南边，常住人口2800人，是天之落英第一大主城。最有特色的便是城周自然形成的护城河。从雪山上奔腾而下的流水，顺着地形绕了天水城一周，而后几乎是从来的方向流开，造就了近乎圆形的河道奇观。又因着天水城在冲积平原上，城内便土壤肥沃。并着气候温和，水源充足，致使天水城山清水秀，一年五季花繁似锦，连年美不胜收。

此时，正值一年之初的诞生季，大朵大朵的双子花点缀在城内，或蓝或紫，幼嫩鲜艳。趁着天边的一轮血月都不免柔和了起来。而枫叶和红豆一落地，便是站在了城主府的门口，近十米宽的阶梯蜿蜒而上，道旁遍挂金桔，植满香木。微风拂来，便带着阵阵浓郁的花香果香。伴随簌簌叶响与阵阵鸟鸣，都众星拱月般的捧着那高立在台阶顶端的城主府。

阶梯上端空无一人，没有卫兵侍者，只有洒扫得干干净净的台阶，雕刻着简单的水纹。天水城的功过祠，则立在阶梯右侧，仿佛在为城主府看家护院。

落地后，那小小的城主欢脱的跑快几步，站在阶梯前敞开双臂，回首想枫叶笑道，“欢迎来到天水城！”

`;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"时间旅人顺序" :
     this.current_note_markdown = `
请指出段落中，场景中描写了什么，是以什么顺序描写的。

段落如下：

你所看见的最远的距离是多远?

这次我来的地方是这个地方一个有名的画家的房子。

这是一栋位于一座山下的别墅。

如果不是走进去你都不会发现这里有这么大一栋房子。

从外面看房子的外壁都是白色没有一丁点的瑕疵，而在绿草和鲜花的映衬下，这里看起就像，没错，看起来就是天堂。

我来到了铁门的外面。

“请问有人在家吗?”我对着里面喊道。

片刻后，随着脚踩在草地上传来的悉悉索索的声音，我眼前出现了一个身穿碎花裙的女子，一头黑色的长发就这么随着微风轻轻飘扬。她随机微笑着说道：“我就是这里唯一的人，请问先生有什么事吗?”
`;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"天之落英2顺序" :
     this.current_note_markdown = `
请指出段落中，场景中描写了什么，是以什么顺序描写的。

段落如下：

古色古香的木门被推开。发出一声沉闷的响。那雕了四大神兽衔枝贺礼的门扇敞了开来，露出了里面宽阔的正厅。

光线从门外投了进去。里面迎面便是一屏半壁石雕。刀工深深，横贯正厅。

上面也没绘什么九龙戏珠之类的浮华图案，而只是一棵参天大树。枝繁叶茂的举枝相望。交错纵横的枝条，参差着贯穿了整个石壁。

叶形圆滑，子叶成双。根系发达，盘虬卧龙。无细刻，无浮雕。它如同一副苍穹有力的水墨画，猛地映入眼来，便透着一股放荡不羁的神气。

命义树……吗。

纸蓉从未见过那么大棵的命义树，也未曾见过拿命义树做石雕摆件的。

命义无端不由人，世上之事不如意的总是十有八九。命义树因着某种难解的原因，虽不算是树木中最高的，却是最常被落雷击中的。因而就算它平日里枝繁叶茂的，看着郁郁葱葱。人们依然觉得这树不太吉利，富贵人家也总是避讳着，不愿种它。

如今这树，却摆在这正厅的入壁上，也真是怪了……

“……”枫叶不动声色的推了纸蓉一把。纸蓉才回过神来，发现自己对着这石壁愣神太久了，赶忙转开了眼神。

在偌大的石壁前，是两树盆栽，并一张正椅。正椅两侧，有两排副椅，于石壁呈九十度直角延伸开来。一边十张，加起来二十张。

副椅之间有茶几，香炉，杯具摆设等一应俱全。椅背把手上，有光滑磨痕，似乎很有一些年份了。看起来这就是平常的议事正厅了。

白衣侍者把众人领进去后，一福身就转身离去了。

`;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"天之落英3顺序" :
     this.current_note_markdown = `
请指出段落中，场景中描写了什么，是以什么顺序描写的。

段落如下：

远处灯火璀璨，星星点点。光斑浮在幽深的海面上，像是晨星布上镶嵌着的朵朵亮色金片。今夜渔船客舟深夜下海，尽情歌舞，在海水中漾出一圈圈的华光来。

主君停灵的最后一天，主君下葬前夜。并非肃穆哀痛禁丝竹，反而要歌舞大宴，无眠喧闹，这是习俗。

因此今夜冥海上，鼓弦声乐，歌舞不休。有把酒临风，横槊赋诗。有投壶对酒，欢唱笑闹。暖风吹轻帐，酒酣人意满。但这大悲的时刻要做出欢喜的姿态。对提灯城主来说何其难。而她原本就是沉默寡言的人，便没有上船。只守在渔船码头，时不时吩咐监管一下歌舞乐宴。

`;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"禁代心医师顺序" :
     this.current_note_markdown = `
请指出段落中，场景中描写了什么，是以什么顺序描写的。

段落如下：

我正迷茫的时候，视线里多出一只白嫩的小手。并着掌心里的精致糕点。层层叠叠的包装纸已经撕去，露出奶黄色的表皮。

然后我听到欢快的声音清晰的响在耳边，“这儿。”

我转过头，一个八九岁的女孩穿着简陋的格子裙，带着微笑蹲在我身边。苍白的皮肤，加上黑发灰鞋淡色格子裙。一身单调的颜色，唯一的亮彩，是装饰在她头发上的粉色发带。衬在灰黑色的房间里。色彩反差得有些刺眼。

`;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"禁代夏微寒顺序" :
     this.current_note_markdown = `
请指出段落中，场景中描写了什么，是以什么顺序描写的。

段落如下：

下午教学楼拉出很长的阴影，我一个人背着包往剑道馆走。天边的云朵五彩缤纷，西斜的太阳依旧明亮。剑道馆前的木槿开的正好，灿灿烂烂的。所谓不是冤家不聚头，在木槿花海的旁边，我又遇见了中午见到的男生，他带着剑站在门口，正要进去的样子。我回忆了一下剑道社的社员名单，似乎没有这个奇葩。
`;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"幻世青衣抄顺序" :
     this.current_note_markdown = `
请指出段落中，场景中描写了什么，是以什么顺序描写的。

段落如下：

我感到这个世界在起雾，大雾吞没了我和青灯，但是灯笼的光线依然那么明亮，明亮得那么漂亮，那么干净。我感觉自己脚下的地面不再是青石的地板，而是更柔软的土地，我大喊停下，但抓住我的那只白哲纤细的手却越来越紧。

我看见雾的那片出现了无数光点，有红色、有绿色、有黄色、有紫色，那些光点移动着，闪耀着，如同夜空的繁星，如同时光长河里埋藏的金沙。

然后雾散去了。

我和青灯站在人流中，空气里烟雾的热气弥散，食物的香气弥漫，各式华贵的灯笼挂在木杆上。小贩们的哈喝声此起彼伏，高高的木阁楼上妖艳的女子在唱着悠长的调子，矮小的孩子们拿着糖葫芦从我们旁边跑过。

夜色里，灯红酒绿，车水马龙。

“玩的开心，青衣。”

有人说。
`;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"祝死顺序" :
     this.current_note_markdown = `
请指出段落中，场景中描写了什么，并【更改】描写顺序。

段落如下：

喝，这倒还真是你平时的作风。”周转注视着外面的铁路。

原本应该透明无色的玻璃墙，因为八年漫长的时光而变成了灰色。

曾经光洁白亮的停泊站台，也早就被拆去了表面的白砖。

破碎的弯顶，杂乱的坐椅，不会再发出通知的音响还有如同行尸走肉的人。

看不见星光的深黑夜晚，破损的白炽灯泡发出虚假的黄光。

两道光柱从深黑色的夜空里照射过来，周转仔细听着、那里还有轻轻的蒸汽声。庞大的金属怪物在夜色之海中向它们这些可口的饵食靠近。

叽一一一叽一一一滋一一一

一阵提神醒脑的尖利摩擦声，宣告着它的到来。

车站里，人们抱着各自不同的心思拽紧了自己的行李纷纷扰扰的向同一个方向进发。

周和罗也混在其中，好像忘掉了自己来的目的。

当然，其实俩个人都没有忘掉。
`;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;




    //要素增减
    case"要素增减一" :
    this.current_note_markdown = `
请更改你所做过的场景描写练习。增加或减少近景，远景，人物，味道，声音，触觉这几种场景要素。



`;

if(localStorage.getItem("场景练习一")!=null){
        this.current_note_markdown+=localStorage.getItem("场景练习一");
      }
      else{
        this.current_note_markdown+=`
        但场景练习一还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"要素增减二" :
    this.current_note_markdown = `
请更改你所做过的场景描写练习。增加或减少近景，远景，人物，味道，声音，触觉这几种场景要素。



`;

if(localStorage.getItem("场景练习二")!=null){
        this.current_note_markdown+=localStorage.getItem("场景练习二");
      }
      else{
        this.current_note_markdown+=`
        但场景练习二还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"要素增减三" :
    this.current_note_markdown = `
请更改你所做过的场景描写练习。增加或减少近景，远景，人物，味道，声音，触觉这几种场景要素。



`;

if(localStorage.getItem("场景练习三")!=null){
        this.current_note_markdown+=localStorage.getItem("场景练习三");
      }
      else{
        this.current_note_markdown+=`
        但场景练习三还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"要素增减四" :
    this.current_note_markdown = `
请更改你所做过的场景描写练习。增加或减少近景，远景，人物，味道，声音，触觉这几种场景要素。



`;

if(localStorage.getItem("场景练习四")!=null){
        this.current_note_markdown+=localStorage.getItem("场景练习四");
      }
      else{
        this.current_note_markdown+=`
        但场景练习四还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"要素增减五" :
    this.current_note_markdown = `
请更改你所做过的场景描写练习。增加或减少近景，远景，人物，味道，声音，触觉这几种场景要素。



`;

if(localStorage.getItem("场景练习五")!=null){
        this.current_note_markdown+=localStorage.getItem("场景练习五");
      }
      else{
        this.current_note_markdown+=`
        但场景练习五还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;

    case"要素增减六" :
    this.current_note_markdown = `
请更改你所做过的场景描写练习。增加或减少近景，远景，人物，味道，声音，触觉这几种场景要素。



`;

if(localStorage.getItem("场景练习六")!=null){
        this.current_note_markdown+=localStorage.getItem("场景练习六");
      }
      else{
        this.current_note_markdown+=`
        但场景练习六还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"要素增减七" :
    this.current_note_markdown = `
请更改你所做过的场景描写练习。增加或减少近景，远景，人物，味道，声音，触觉这几种场景要素。



`;

if(localStorage.getItem("场景练习七")!=null){
        this.current_note_markdown+=localStorage.getItem("场景练习七");
      }
      else{
        this.current_note_markdown+=`
        但场景练习七还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;



    case"要素增减八" :
    this.current_note_markdown = `
请更改你所做过的场景描写练习。增加或减少近景，远景，人物，味道，声音，触觉这几种场景要素。



`;

if(localStorage.getItem("场景练习八")!=null){
        this.current_note_markdown+=localStorage.getItem("场景练习八");
      }
      else{
        this.current_note_markdown+=`
        但场景练习八还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;



    case"要素增减九" :
    this.current_note_markdown = `
请更改你所做过的场景描写练习。增加或减少近景，远景，人物，味道，声音，触觉这几种场景要素。



`;

if(localStorage.getItem("场景练习九")!=null){
        this.current_note_markdown+=localStorage.getItem("场景练习九");
      }
      else{
        this.current_note_markdown+=`
        但场景练习九还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;


    case"要素增减十" :
    this.current_note_markdown = `
请更改你所做过的场景描写练习。增加或减少近景，远景，人物，味道，声音，触觉这几种场景要素。



`;

if(localStorage.getItem("场景练习十")!=null){
        this.current_note_markdown+=localStorage.getItem("场景练习十");
      }
      else{
        this.current_note_markdown+=`
        但场景练习十还没有完成。
              `;
      }

  

    this.is_title = 1;
    if( this.view_type == 2 ) this.view_type = 3;
    break;




     //要素判断
     case"幻世青衣抄" :
     this.current_note_markdown = `
请指出段落中，包含近景，远景，人物，味道，声音，触觉。中的几种场景描写要素。

并指出分别是什么。段落如下：

流萤断续光，一明一灭一尺间，寂寞何以堪—立花北枝

连绵的阴雨天气不禁让人心生倦意店里的生意也变得比前些日子冷清了许多。

店里还没有顾客。我坐在靠着书架的椅子上。默默打着盹。曾扬站在吧台后习慢性地擦着瓷杯，白钰与他小声地聊着天。

`;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"天之落英" :
     this.current_note_markdown = `
请指出段落中，包含近景，远景，人物，味道，声音，触觉。中的几种场景描写要素。

并指出分别是什么。段落如下：

便是新年新月的五日。新时的钟声刚响过。从世界尽头的冥海翻涌着，吹来了一大片黑压压的雾气。原本晴朗明亮的天色骤然灰黑。方才还耀眼夺目的红月，也只在天边，悄悄的露了个头，看起来跟墓时没什么两样了。


天圆地方。大陆东西南北四角的降生口处，有几百个新生婴儿，次第接连的呱呱坠地。随着水汽的蔓延，一个连一个的落在降生口里。白白嫩嫩的婴儿，掉在黑石板上，凉飕飕的风一吹，立刻哇哇乱哭起来。惊得十数个训练有素的导师们，同时开始忙碌。
`;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"全世界的妹我只控一个" :
     this.current_note_markdown = `
请指出段落中，包含近景，远景，人物，味道，声音，触觉。中的几种场景描写要素。

并指出分别是什么。段落如下：

视野中的景物在极速的奔跑中剧烈地抖动着，如果是在现实中的话，一定能够听到掠过耳际的呼呼风声。

敌方的旗子所在地—一栋矮小的两层楼房，就在不远处了房子的大门毫无防备地开着;周围一个人也没有。看起来像是发动了总攻动员了所有人员去强攻我们的旗子所在地了呢。

  
此刻我方防线也如想象中的一样已经溃不成军，不断有突破防线的敌人冲过封锁线朝藏着旗子的地方跑去。不过队友也有做一定的安排，分两条防线，所以此刻冲过第一防线的敌人仍然会遭遇第二防线的队友的阻击。


`;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"螭龙传" :
     this.current_note_markdown = `
请指出段落中，包含近景，远景，人物，味道，声音，触觉。中的几种场景描写要素。

并指出分别是什么。段落如下：

头上有些冰凉的东西落下来，我渐渐苏醒过来。又是一场难得的大雨。

久眠而醒我不知道这一觉又睡了多久，也不知道睡到了什么时候。我的视线清晰过来，滂沱的大雨使全世界都笼置在了一层水幕之中。我又闭上了眼睛沐雨而立。

那么，她在哪里?在近我之途，还是远我之路?

`;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"女大学生的校园日常" :
     this.current_note_markdown = `
请指出段落中，包含近景，远景，人物，味道，声音，触觉。中的几种场景描写要素。

并指出分别是什么。段落如下：

阳台面朝西方，正对着不远处大片的麦田，麦田里的麦子荡漾着金黄色的波浪。几台收割机来来回回，如同画卷上的点睛之笔，轰鸣声传到遥远的彼方。

从麦田里吹来的风带着一股清甜的香味，太阳西斜暖暖的黄光照亮整个空间。

令人感到舒适的风景。

但是……天快黑了。

美好的感觉总是一纵即逝，浓云一旦掩住太阳，四周便暗下来。

双手扶栏杆看着看着突然后背感到一阵异常的凉，我不禁打了个哆嗦头上竟出了些冷汗。

`;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"桃花债" :
     this.current_note_markdown = `
请指出段落中，包含近景，远景，人物，味道，声音，触觉。中的几种场景描写要素。

并指出分别是什么。段落如下：

现在虽然立了秋，中午的日头丝毫不比三伏天的弱。秋蝉扯着嗓子叫，地上的热气烘得脚酸。
`;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;

     case"三生三世十里桃花" :
     this.current_note_markdown = `
请指出段落中，包含近景，远景，人物，味道，声音，触觉。中的几种场景描写要素。

并指出分别是什么。段落如下：

狐狸洞出现在眼底时，我放缓了步子。很久不从正门走，不留神洞旁三年前种下的桃树已开得十分繁盛。青的山，绿的树，碧色的潭水，三年来，我头一回看清了青丘的色彩。

日光透过云层照下来，青山碧水中的一树桃花，犹如九天之上长明不灭的璀璨烟霞。

那一树烟霞底下立着的黑袍青年，正微微探身，修长手指轻抚跟前立着的墓碑。

就像是一个梦境。

我屏着呼吸往前挪了两步，生怕动作一大，眼前的情景便一概不在了。

他转过头来，风拂过，树上的烟霞起伏成一波红色的海浪。他微微一笑，仍是初见的模样，如画的眉眼，漆黑的发。红色的海浪中飘下几朵花瓣，天地间再没有其他的色彩，也没有其他的声音了。

他伸手轻声道：“浅浅，过来。”

`;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"香蜜沉沉烬如霜" :
     this.current_note_markdown = `
请指出段落中，包含近景，远景，人物，味道，声音，触觉。中的几种场景描写要素。

并指出分别是什么。段落如下：

一阵夜风过，殿外树影婆娑，将月色筛成一地零落的碎玉。殿中央，水色的纱帘轻轻摇摆，似帘内人起伏微弱的气息。

`;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;


     case"禁代夏微寒" :
     this.current_note_markdown = `
请指出段落中，包含近景，远景，人物，味道，声音，触觉。中的几种场景描写要素。

并指出分别是什么。段落如下：

妈妈的背影消失后，不大的房子里现在只有我一个人了，白炽灯寂静的照着地板。空空荡荡的带着荒凉的黑色。透过落地窗，可以看到悬挂着月亮的夜空,黑的很淡雅。窗外的云染上了夜色，淡淡的紫色时卷时舒。我看着寂静的夜空，纵使神经大条，也不免得有些伤感。

又剩我一个人了呢。

总是这样。
`;
   

     this.is_title = 2;
     if( this.view_type == 2 ) this.view_type = 3;
     break;





      //场景练习
      case"场景练习一" :
      this.current_note_markdown = `
请试着描写图片中的场景。

![](https://cdn.pixabay.com/photo/2021/03/22/21/04/home-6115719_960_720.jpg)
      `;
    

      this.is_title = 2;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      

      case"场景练习二" :
      this.current_note_markdown = `
请试着描写图片中的场景。

![](https://cdn.pixabay.com/photo/2021/01/27/06/55/nova-scotia-duck-tolling-retriever-5953889_1280.jpg)
      `;
    

      this.is_title = 2;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"场景练习三" :
      this.current_note_markdown = `
请试着描写图片中的场景。

![](https://cdn.pixabay.com/photo/2021/01/21/09/11/river-5936684_1280.jpg)
      `;
    

      this.is_title = 2;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"场景练习四" :
      this.current_note_markdown = `
请试着描写图片中的场景。

![](https://cdn.pixabay.com/photo/2020/12/15/01/43/cyclist-5832393_960_720.jpg)
      `;
    

      this.is_title = 2;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"场景练习五" :
      this.current_note_markdown = `
请试着描写图片中的场景。

![](https://cdn.pixabay.com/photo/2018/06/10/13/41/rice-3466518_1280.jpg)
      `;
    

      this.is_title = 2;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"场景练习六" :
      this.current_note_markdown = `
请试着描写图片中的场景。

![](https://cdn.pixabay.com/photo/2021/03/08/17/08/fog-6079632_1280.jpg)
      `;
    

      this.is_title = 2;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"场景练习七" :
      this.current_note_markdown = `
请试着描写图片中的场景。

![](https://cdn.pixabay.com/photo/2021/02/07/18/32/shops-5992277_1280.jpg)
      `;
    

      this.is_title = 2;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"场景练习八" :
      this.current_note_markdown = `
请试着描写图片中的场景。

![](https://cdn.pixabay.com/photo/2021/02/07/09/11/lake-5990540_1280.jpg)
      `;
    

      this.is_title = 2;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"场景练习九" :
      this.current_note_markdown = `
请试着描写图片中的场景。

![](https://cdn.pixabay.com/photo/2021/01/11/19/14/windmill-5909414_1280.jpg)
      `;
    

      this.is_title = 2;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"场景练习十" :
      this.current_note_markdown = `
请试着描写图片中的场景。

![](https://cdn.pixabay.com/photo/2021/02/03/17/36/river-5978743_1280.jpg)
      `;
    

      this.is_title = 2;
      if( this.view_type == 2 ) this.view_type = 3;
      break;




      //场景仿写
      case"场景仿写一" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("场景摘抄一")!=null){
        this.current_note_markdown+=localStorage.getItem("场景摘抄一");
      }
      else{
        this.current_note_markdown+=`
        但场景摘抄一还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"场景仿写二" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("场景摘抄二")!=null){
        this.current_note_markdown+=localStorage.getItem("场景摘抄二");
      }
      else{
        this.current_note_markdown+=`
        但场景摘抄二还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"场景仿写三" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("场景摘抄三")!=null){
        this.current_note_markdown+=localStorage.getItem("场景摘抄三");
      }
      else{
        this.current_note_markdown+=`
        但场景摘抄三还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"场景仿写四" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("场景摘抄四")!=null){
        this.current_note_markdown+=localStorage.getItem("场景摘抄四");
      }
      else{
        this.current_note_markdown+=`
        但场景摘抄四还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"场景仿写五" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("场景摘抄五")!=null){
        this.current_note_markdown+=localStorage.getItem("场景摘抄五");
      }
      else{
        this.current_note_markdown+=`
        但场景摘抄五还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"场景仿写六" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("场景摘抄六")!=null){
        this.current_note_markdown+=localStorage.getItem("场景摘抄六");
      }
      else{
        this.current_note_markdown+=`
        但场景摘抄六还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"场景仿写七" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("场景摘抄七")!=null){
        this.current_note_markdown+=localStorage.getItem("场景摘抄七");
      }
      else{
        this.current_note_markdown+=`
        但场景摘抄七还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"场景仿写八" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("场景摘抄八")!=null){
        this.current_note_markdown+=localStorage.getItem("场景摘抄八");
      }
      else{
        this.current_note_markdown+=`
        但场景摘抄八还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"场景仿写九" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("场景摘抄九")!=null){
        this.current_note_markdown+=localStorage.getItem("场景摘抄九");
      }
      else{
        this.current_note_markdown+=`
        但场景摘抄九还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"场景仿写十" :
      this.current_note_markdown = `
请仿写你所摘抄过的段落。


      `;
      if(localStorage.getItem("场景摘抄十")!=null){
        this.current_note_markdown+=localStorage.getItem("场景摘抄十");
      }
      else{
        this.current_note_markdown+=`
        但场景摘抄十还没有完成。
              `;
      }

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      //场景摘抄
      case"场景摘抄一" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的场景描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"场景摘抄二" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的场景描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"场景摘抄三" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的场景描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"场景摘抄四" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的场景描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"场景摘抄五" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的场景描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"场景摘抄六" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的场景描写。
      `;
      

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"场景摘抄七" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的场景描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"场景摘抄八" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的场景描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"场景摘抄九" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的场景描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"场景摘抄十" :
      this.current_note_markdown = `
请在此摘抄你觉得不错的场景描写。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      //戏剧化开头
      case"死后的朋友" :
      this.current_note_markdown = `戏剧化开头是以一个戏剧化的情节作为开头，续写之后事件的练习。

更多脑洞可以访问Reddit的Writingprompts板块

故事开头是这样的：

在你死亡之后，你发现自己没有上天堂，也不是下地狱。

你在一个6岁小女孩的房间中，她正邀请你来和她玩过家家，你突然意识到：你是她想象中的朋友。

请写出后续故事。
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"善良的超级反派" :
      this.current_note_markdown = `戏剧化开头是以一个戏剧化的情节作为开头，续写之后事件的练习。

更多脑洞可以访问Reddit的Writingprompts板块

故事开头是这样的：

你是个超级反派。你的能力能让身边所有人、任何人都能与你感受到相同的情绪，但100倍加强。

大多数时间，你都会用这个超能力强迫其他人把毕生积蓄倾家荡产地捐给慈善机构，超级英雄也不知道该如何处置你。

请写出后续故事。
`;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"纹身帮派斗争" :
      this.current_note_markdown = `戏剧化开头是以一个戏剧化的情节作为开头，续写之后事件的练习。

更多脑洞可以访问Reddit的Writingprompts板块

故事开头是这样的：

突然之间，所有有纹身的人都获得了和纹身相关的超能力。

纹身是火焰，你就可以控制火。

纹身是壁虎，你就可以在墙上爬。

所有纹着同样纹身的人，都会自然地团结起来，成为一股势力。

请写出后续故事。

`;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"怪异排名" :
      this.current_note_markdown = `戏剧化开头是以一个戏剧化的情节作为开头，续写之后事件的练习。

更多脑洞可以访问Reddit的Writingprompts板块

故事开头是这样的：

当你到18岁，大数据就会对你进行各个不同的分类排名，比如，全世界杀虫数排行第207145名；

不过，你一直住在自家农场，从来没用过这项科技，

但在你18岁之后，你进城时却发现所有人都在盯看你，你最终决定，去看一下这个大数据排名。

请写出后续故事。
`;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"超自然监护人" :
      this.current_note_markdown = `戏剧化开头是以一个戏剧化的情节作为开头，续写之后事件的练习。

更多脑洞可以访问Reddit的Writingprompts板块

故事开头是这样的：

令堂是个欺诈师，专骗超自然生物。

她向多个传说里的生物承诺，用她第一个出生的孩子换她想要的东西。

现在，你由三个恶魔，一个妖精和一个心怀不满的女巫共同监护。

请写出后续故事。
`;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"时间旅行者" :
      this.current_note_markdown = `戏剧化开头是以一个戏剧化的情节作为开头，续写之后事件的练习。

更多脑洞可以访问Reddit的Writingprompts板块

故事开头是这样的：

你和朋友约定，如果你们中的一个人发明了时间旅行，就回到这一刻。

当你们握手约定时，一个更老、受伤的你出现了，对你朋友的脑袋开了枪。 

请写出后续故事。
`;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"被召唤的恶魔" :
      this.current_note_markdown = `戏剧化开头是以一个戏剧化的情节作为开头，续写之后事件的练习。

更多脑洞可以访问Reddit的Writingprompts板块

故事开头是这样的：

恶魔站在被你炸毁的厨房里尖叫着

“怎么可能？？你怎么可能可以把我召唤出来？？？！”

你惊慌的站在角落，飞速翻看你奶奶留给你的烹饪书，也在惊叫。

“我不知道！我本来只是想做个鸡汤！！”

请写出后续故事。
`;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"爱人或犯人" :
      this.current_note_markdown = `戏剧化开头是以一个戏剧化的情节作为开头，续写之后事件的练习。

更多脑洞可以访问Reddit的Writingprompts板块

故事开头是这样的：

你出生时，身上就纹了两个名字。

一个是你的灵魂伴侣，而另一个是将会杀害你的凶手。

你无法分辨他们哪一个是哪一个。

请写出后续故事。
`;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"不死女王" :
      this.current_note_markdown = `戏剧化开头是以一个戏剧化的情节作为开头，续写之后事件的练习。

更多脑洞可以访问Reddit的Writingprompts板块

故事开头是这样的：

2050年，女王仍然健在。

人们开始起疑心了。

请写出后续故事。
`;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"你的母语" :
      this.current_note_markdown = `戏剧化开头是以一个戏剧化的情节作为开头，续写之后事件的练习。

更多脑洞可以访问Reddit的Writingprompts板块

故事开头是这样的：

只要你开口，和你说话的人，都会以为他听到了自己的母语。

大多数人都对此感到惊讶，也很高兴。

但刚刚与你交谈的麦当劳收银员忽然开口说

已经有几千年，没有人说过这种语言了。

请写出后续故事。
`;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"另一物种" :
      this.current_note_markdown = `戏剧化开头是以一个戏剧化的情节作为开头，续写之后事件的练习。

更多脑洞可以访问Reddit的Writingprompts板块

故事开头是这样的：

“所以你们的眼睛真的只能看到三原色？”外星人问道。

“对啊。”

“那你们怎么和GHOOSHA交流啊？？”

“和什么……？”我困惑的回复道。

“你们这个星球上的另一种主要种族啊。”

请写出后续故事。
`;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;




      //轻小说开头
      case"同班同学的吸血鬼之旅" :
      this.current_note_markdown = `随机轻小说练习，是以用随机产生的书名写小说的练习方式

请：以同班同学的吸血鬼之旅为题来写一篇小说。

更多轻小说练习练习，可以上网搜索轻小说书名产生器
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"说谎的委员长变成我的专属女仆" :
      this.current_note_markdown = `随机轻小说练习，是以用随机产生的书名写小说的练习方式

请：以说谎的委员长变成我的专属女仆为题来写一篇小说。

更多轻小说练习练习，可以上网搜索轻小说书名产生器
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"其中一个弟弟是侵略者？！" :
      this.current_note_markdown = `随机轻小说练习，是以用随机产生的书名写小说的练习方式

请：以其中一个弟弟是侵略者？！为题来写一篇小说。

更多轻小说练习练习，可以上网搜索轻小说书名产生器
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"我的奶奶来自异世界" :
      this.current_note_markdown = `随机轻小说练习，是以用随机产生的书名写小说的练习方式

请：以我的奶奶来自异世界为题来写一篇小说。

更多轻小说练习练习，可以上网搜索轻小说书名产生器
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"只有神知道的王子的消失" :
      this.current_note_markdown = `随机轻小说练习，是以用随机产生的书名写小说的练习方式

请：以只有神知道的王子的消失为题来写一篇小说。

更多轻小说练习练习，可以上网搜索轻小说书名产生器
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;


      case"左眼的勇者大人爱被吐槽" :
      this.current_note_markdown = `随机轻小说练习，是以用随机产生的书名写小说的练习方式

请：以左眼的勇者大人爱被吐槽为题来写一篇小说。

更多轻小说练习练习，可以上网搜索轻小说书名产生器
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"传说中的社长出任务" :
      this.current_note_markdown = `随机轻小说练习，是以用随机产生的书名写小说的练习方式

请：以传说中的社长出任务为题来写一篇小说。

更多轻小说练习练习，可以上网搜索轻小说书名产生器
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"蔷薇的偶像杀人事件" :
      this.current_note_markdown = `随机轻小说练习，是以用随机产生的书名写小说的练习方式

请：以蔷薇的偶像杀人事件为题来写一篇小说。

更多轻小说练习练习，可以上网搜索轻小说书名产生器
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"中年总统的忧郁" :
      this.current_note_markdown = `随机轻小说练习，是以用随机产生的书名写小说的练习方式

请：以中年总统的忧郁为题来写一篇小说。

更多轻小说练习练习，可以上网搜索轻小说书名产生器
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      case"坏掉的儿子读了彼得拉克的管理学" :
      this.current_note_markdown = `随机轻小说练习，是以用随机产生的书名写小说的练习方式

请：以坏掉的儿子读了彼得拉克的管理学为题来写一篇小说。

更多轻小说练习练习，可以上网搜索轻小说书名产生器
      `;

      this.is_title = 1;
      if( this.view_type == 2 ) this.view_type = 3;
      break;

      
   

       //三题作文
       case"狡猾，泳装，鲁迅全集" :
       this.current_note_markdown = `三题作文，是以三种不相干的要素，混合起来写小说的练习方式

请：以狡猾，泳装，鲁迅全集来写一篇小说。

更多三题作文练习，可以上网搜索三题作文生成器
       `;

       this.is_title = 1;
       if( this.view_type == 2 ) this.view_type = 3;
       break;


       case"无尽的，秦淮河，下雪" :
       this.current_note_markdown = `三题作文，是以三种不相干的要素，混合起来写小说的练习方式

请：以无尽的，秦淮河，下雪来写一篇小说。

更多三题作文练习，可以上网搜索三题作文生成器
       `;

       this.is_title = 1;
       if( this.view_type == 2 ) this.view_type = 3;
       break;

       case"坏掉的，漂浮，打报告" :
       this.current_note_markdown = `三题作文，是以三种不相干的要素，混合起来写小说的练习方式

请：以坏掉的，漂浮，打报告来写一篇小说。

更多三题作文练习，可以上网搜索三题作文生成器
       `;

       this.is_title = 1;
       if( this.view_type == 2 ) this.view_type = 3;
       break;

       case"传纸条，狐狸，流浪" :
       this.current_note_markdown = `三题作文，是以三种不相干的要素，混合起来写小说的练习方式

请：以传纸条，狐狸，流浪来写一篇小说。

更多三题作文练习，可以上网搜索三题作文生成器
       `;

       this.is_title = 1;
       if( this.view_type == 2 ) this.view_type = 3;
       break;

       case"老鼠，退位，月光" :
       this.current_note_markdown = `三题作文，是以三种不相干的要素，混合起来写小说的练习方式

请：以老鼠，退位，月光来写一篇小说。

更多三题作文练习，可以上网搜索三题作文生成器
       `;

       this.is_title = 1;
       if( this.view_type == 2 ) this.view_type = 3;
       break;


       case"魔法师，一战，蓝色的" :
       this.current_note_markdown = `三题作文，是以三种不相干的要素，混合起来写小说的练习方式

请：以魔法师，一战，蓝色的来写一篇小说。

更多三题作文练习，可以上网搜索三题作文生成器
       `;

       this.is_title = 1;
       if( this.view_type == 2 ) this.view_type = 3;
       break;


       case"桔梗，未成年，破破烂烂" :
       this.current_note_markdown = `三题作文，是以三种不相干的要素，混合起来写小说的练习方式

请：以桔梗，未成年，破破烂烂来写一篇小说。

更多三题作文练习，可以上网搜索三题作文生成器
       `;

       this.is_title = 1;
       if( this.view_type == 2 ) this.view_type = 3;
       break;


       case"晕车，海盗，花语" :
       this.current_note_markdown = `三题作文，是以三种不相干的要素，混合起来写小说的练习方式

请：以晕车，海盗，花语来写一篇小说。

更多三题作文练习，可以上网搜索三题作文生成器
       `;

       this.is_title = 1;
       if( this.view_type == 2 ) this.view_type = 3;
       break;


       case"大钟，亡灵，亲吻" :
       this.current_note_markdown = `三题作文，是以三种不相干的要素，混合起来写小说的练习方式

请：以大钟，亡灵，亲吻来写一篇小说。

更多三题作文练习，可以上网搜索三题作文生成器
       `;

       this.is_title = 1;
       if( this.view_type == 2 ) this.view_type = 3;
       break;

       case"文艺青年，麦田，比目鱼" :
       this.current_note_markdown = `三题作文，是以三种不相干的要素，混合起来写小说的练习方式

请：以文艺青年，麦田，比目鱼来写一篇小说。

更多三题作文练习，可以上网搜索三题作文生成器
       `;

       this.is_title = 1;
       if( this.view_type == 2 ) this.view_type = 3;
       break;

      


       //乌合之众
       case"狂热宗教" :
       this.current_note_markdown = `乌合之众的故事冲突，怪异甚至很可能是错误的众人，和不认可他们的主角之间的矛盾
       
小故事讲述在一个怪异的群体中中，被迫待在其中的人物身上所发生的事。
       
在狂热宗教中，人物发现自己身处一个越来越狂热，甚至可能是邪教的宗教中。

请：

1，设定和描述一个狂热的宗教组织。

2，设定和描述流落其中的人物。

3，请写出之后发生的事。
       `;

       this.is_title = 1;
       if( this.view_type == 2 ) this.view_type = 3;
       break;


       case"封建迷信" :
       this.current_note_markdown = `乌合之众的故事冲突，怪异甚至很可能是错误的众人，和不认可他们的主角之间的矛盾
       
小故事讲述在一个怪异的群体中中，被迫待在其中的人物身上所发生的事。
       
在封建迷信中，人物身处一个充满迷信的村落之中。所有事都要用迷信来解决。

请：

1，设定和描述一个迷信落后的村落。

2，设定和描述流落其中的人物。

3，请写出之后发生的事。
       `;

       this.is_title = 1;
       if( this.view_type == 2 ) this.view_type = 3;
       break;


       case"迷幻奇药" :
       this.current_note_markdown = `乌合之众的故事冲突，怪异甚至很可能是错误的众人，和不认可他们的主角之间的矛盾
       
小故事讲述在一个怪异的群体中中，被迫待在其中的人物身上所发生的事。
       
在迷幻奇药中，一群人都中了迷幻奇药而行为怪异，只有主角一人没有受到影响。

请：

1，设定和描述一群中了迷幻奇药的人群。

2，设定和描述流落其中的人物。

3，请写出之后发生的事。
       `;

       this.is_title = 1;
       if( this.view_type == 2 ) this.view_type = 3;
       break;


       case"灾难预言" :
       this.current_note_markdown = `乌合之众的故事冲突，怪异甚至很可能是错误的众人，和不认可他们的主角之间的矛盾
       
小故事讲述在一个怪异的群体中中，被迫待在其中的人物身上所发生的事。
       
在灾难预言中，主角因为某种原因能预言到将来会发生一场大灾难，但没有人相信他。

请：

1，设定和描述一场大灾难，以及主角能预知他的原因。

2，设定和描述一群不信任主角的亲友。

3，请写出之后发生的事。
       `;

       this.is_title = 1;
       if( this.view_type == 2 ) this.view_type = 3;
       break;


       case"黑帮成员" :
       this.current_note_markdown = `乌合之众的故事冲突，怪异甚至很可能是错误的众人，和不认可他们的主角之间的矛盾
       
小故事讲述在一个怪异的群体中中，被迫待在其中的人物身上所发生的事。
       
在黑帮成员中，主角是黑帮成员，但厌恶了黑帮这套规矩。

请：

1，设定和描述一个规矩森严的黑帮组织

2，设定和描述一个不愿意待下去的人物。

3，请写出之后发生的事。
       `;

       this.is_title = 1;
       if( this.view_type == 2 ) this.view_type = 3;
       break;


       case"自定众人" :
       this.current_note_markdown = `乌合之众的故事冲突，怪异甚至很可能是错误的众人，和不认可他们的主角之间的矛盾
       
小故事讲述在一个怪异的群体中中，被迫待在其中的人物身上所发生的事。
       

请：

1，设定和描述一个怪异的群体。

2，设定和描述一个不愿意待下去，但目前依然被迫待在里面的人物。

3，请写出之后发生的事。
       `;

       this.is_title = 1;
       if( this.view_type == 2 ) this.view_type = 3;
       break;




        //异国他乡
        case"沙漠村落" :
        this.current_note_markdown = `异国他乡的故事冲突，源于难以适应的怪异环境和人物之间的冲突。
        
小故事讲述在一个怪异的异国他乡中，被迫待在其中的人物身上所发生的事。
        
在沙漠村落中，人物流落到一个沙漠中的孤立村落中，里面的习俗似乎很古怪。

请：

1，设定和描述一个古怪的，与世隔绝的沙漠村落。

2，设定和描述流落其中的人物。

3，请写出之后发生的事。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"地底洞穴" :
        this.current_note_markdown = `异国他乡的故事冲突，源于难以适应的怪异环境和人物之间的冲突。
        
小故事讲述在一个怪异的异国他乡中，被迫待在其中的人物身上所发生的事。
        
在地底洞穴中，有一群生活在地底的人，人物不小心闯入其中。

请：

1，设定和描述一个古怪的，与世隔绝的地底洞穴村落。

2，设定和描述流落其中的人物。

3，请写出之后发生的事。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"闺房之训" :
        this.current_note_markdown = `异国他乡的故事冲突，源于难以适应的怪异环境和人物之间的冲突。
        
小故事讲述在一个怪异的异国他乡中，被迫待在其中的人物身上所发生的事。
        
在闺房之训中，被收养的现代女子回到传统家族，发现有众多怪异的规则要遵守。

请：

1，设定和描述一个传统家族和离开传统家族很久的现代女子。

2，设定和描述她被迫回到传统家族的原因。

3，请写出之后发生的事。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"战场求生" :
        this.current_note_markdown = `异国他乡的故事冲突，源于难以适应的怪异环境和人物之间的冲突。
        
小故事讲述在一个怪异的异国他乡中，被迫待在其中的人物身上所发生的事。
        
在战场求生中，人物被迫进入战斗激烈的战场。

请：

1，设定和描述一场激烈的战争。

2，设定和描述一个被迫进入战场的人物。

3，请写出之后发生的事。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;

        case"种族歧视" :
        this.current_note_markdown = `异国他乡的故事冲突，源于难以适应的怪异环境和人物之间的冲突。
        
小故事讲述在一个怪异的异国他乡中，被迫待在其中的人物身上所发生的事。
        
在种族歧视中，某个种族的人，被迫进入一个歧视此种族的地方。

请：

1，设定和描述一个人物，可以普通但要有特点。

2，设定和描述他进入歧视他种族的地方。

3，请写出之后发生的事。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"自定他乡" :
        this.current_note_markdown = `异国他乡的故事冲突，源于难以适应的怪异环境和人物之间的冲突。
        
小故事讲述在一个怪异的异国他乡中，被迫待在其中的人物身上所发生的事。
        

请：

1，设定和描述一个人物，可以普通但要有特点。

2，设定和描述他进入一个非常怪异的环境。

3，请写出之后发生的事。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        


        //竞技赛场
        case"比赛舞台" :
        this.current_note_markdown = `竞技赛场的故事冲突，源于人物争夺赛场奖品之间的冲突。
        
小故事讲述在一个竞技赛场中，各种人物尽自己努力，获得胜利的故事。
        
在比赛舞台中，由一个主办方举行了盛大的比赛或搭建了宏大的舞台，让人物在上面角逐第一。

请：

1，设定和描述一个盛大的比赛场地。

2，设定和描述一些想要争取比赛胜利的人物。

3，请写出之后发生的事。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;



        case"权谋王室" :
        this.current_note_markdown = `竞技赛场的故事冲突，源于人物争夺赛场奖品之间的冲突。
        
小故事讲述在一个竞技赛场中，各种人物尽自己努力，获得胜利的故事。
        
在权谋王室中，只有最后当成皇帝的人物才能君临天下，其他可能都会死无葬身之地。

请：

1，设定和描述一个斗争激烈的王室。

2，设定和描述一些想要获得胜利的人物。

3，请写出之后发生的事。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;

        case"孤岛生存" :
        this.current_note_markdown = `竞技赛场的故事冲突，源于人物争夺赛场奖品之间的冲突。
        
小故事讲述在一个竞技赛场中，各种人物尽自己努力，获得胜利的故事。
        
在孤岛生存中，孤岛上只有某地有某种有限的资源，得不到的人物就无法活下去。

请：

1，设定和描述一个孤岛，并且让它的资源非常有限。

2，设定和描述一些想要活下去的人物。

3，请写出之后发生的事。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"比武招亲" :
        this.current_note_markdown = `竞技赛场的故事冲突，源于人物争夺赛场奖品之间的冲突。
        
小故事讲述在一个竞技赛场中，各种人物尽自己努力，获得胜利的故事。
        
在比武招亲中，只有一个人能获得美人的欢心。

请：

1，设定和描述一个大家都想要求亲的美人，以及打动她的方式。

2，设定和描述一些求亲的人物。

3，请写出之后发生的事。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"独裁王国" :
        this.current_note_markdown = `竞技赛场的故事冲突，源于人物争夺赛场奖品之间的冲突。
        
小故事讲述在一个竞技赛场中，各种人物尽自己努力，获得胜利的故事。

在独裁王国中，君主拥有极端的独裁权力。只有获得他的信任才能活得下去。
        
请：

1，设定和描述一个独裁王国，里面有人拥有极端的权力。

2，设定和描述一些想要获得君主信任或欢心的人物。

3，请写出之后发生的事。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;



        case"自定赛场" :
        this.current_note_markdown = `竞技赛场的故事冲突，源于人物争夺赛场奖品之间的冲突。
        
小故事讲述在一个竞技赛场中，各种人物尽自己努力，获得胜利的故事。
        
请：

1，设定和描述一个比赛场地、竞争的规矩和最后的奖品。

2，设定和描述一些想要获胜的人物。

3，请写出之后发生的事。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;



        
        //屋中怪物
        case"大白鲨鱼" :
        this.current_note_markdown = `屋中怪物的故事冲突，源于封闭的环境中，要杀死人物的怪物，与人物的求生意愿中的冲突。
        
小故事讲述在一个封闭的小屋中，出现一个可怕的怪物，以及后续的故事。
        
在大白鲨鱼中，封闭的小岛上出现可怕的野兽。

请：

1，设定和描述一个封闭的小岛以及里面的人物。

2，设定和描述一个凶猛的杀人野兽。

3，请写出之后发生的事。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"鬼魂索命" :
        this.current_note_markdown = `屋中怪物的故事冲突，源于封闭的环境中，要杀死人物的怪物，与人物的求生意愿中的冲突。
        
小故事讲述在一个封闭的小屋中，出现一个可怕的怪物，以及后续的故事。
        
在鬼魂索命中，在逃不出去的街道中，出现了索命的鬼怪。

请：

1，设定和描述一个封闭的街道以及里面的人物。

2，设定和描述一个残忍索命的鬼怪。

3，请写出之后发生的事。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;

        case"残忍君主" :
        this.current_note_markdown = `屋中怪物的故事冲突，源于封闭的环境中，要杀死人物的怪物，与人物的求生意愿中的冲突。
        
小故事讲述在一个封闭的小屋中，出现一个可怕的怪物，以及后续的故事。
        
在残忍君主中，在封闭城池中，出现拿人物性命取乐的独裁君主。

请：

1，设定和描述一个封闭的城池以及里面的人物。

2，设定和描述一个拿人物的性命取乐，每天要杀人的君主。

3，请写出之后发生的事。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"无名凶手" :
        this.current_note_markdown = `屋中怪物的故事冲突，源于封闭的环境中，要杀死人物的怪物，与人物的求生意愿中的冲突。
        
小故事讲述在一个封闭的小屋中，出现一个可怕的怪物，以及后续的故事。
        
在无名凶手中，在封闭城堡中，出现暗地里屠杀人物的凶手。

请：

1，设定和描述一个封闭的城堡以及里面的人物。

2，设定和描述一个不知名的杀人凶手。经常作案。

3，请写出之后发生的事。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"外星坏蛋" :
        this.current_note_markdown = `屋中怪物的故事冲突，源于封闭的环境中，要杀死人物的怪物，与人物的求生意愿中的冲突。
        
小故事讲述在一个封闭的小屋中，出现一个可怕的怪物，以及后续的故事。
        
在外星坏蛋中，外星人绑架了一些人物，并残忍的对待他们。

请：

1，设定和描述一个外星监狱，里面都是抓来的人。

2，设定和描述一个原因，会让这些人慢慢死去或生不如死。

3，请写出之后发生的事。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"自定怪物" :
        this.current_note_markdown = `屋中怪物的故事冲突，源于封闭的环境中，要杀死人物的怪物，与人物的求生意愿中的冲突。
        
小故事讲述在一个封闭的小屋中，出现一个可怕的怪物，以及后续的故事。
        

请：

1，设定和描述一个封闭环境，以及里面的人物。

2，设定和描述一个可怕的怪物，出现在环境中。

3，请写出之后发生的事。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;






        //入侵破坏
        case"刺杀帝王" :
        this.current_note_markdown = `入侵破坏的故事冲突，来自稳定的环境，和想破坏环境的人物之间的冲突。
        
小故事讲述在一个稳定的环境中，人物想方设法破坏他，以及后续所发生的事件。
        
在刺杀帝王中，人物想要刺杀某位当权的君主。

请：

1，设定和描述一个实力强盛的帝王。

2，设定和描述一个想要刺杀他的人物和刺杀的理由。

3，请写出之后发生的事。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;

        case"挑逗旧爱" :
        this.current_note_markdown = `入侵破坏的故事冲突，来自稳定的环境，和想破坏环境的人物之间的冲突。
        
小故事讲述在一个稳定的环境中，人物想方设法破坏他，以及后续所发生的事件。
        
在挑逗旧爱中，人物想要插足旧爱的家庭。

请：

1，设定和描述一个人物的旧爱，他已经结婚成家。

2，设定和描述一个非常想和旧爱重归于好的人物。

3，请写出之后发生的事。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"抢劫银行" :
        this.current_note_markdown = `入侵破坏的故事冲突，来自稳定的环境，和想破坏环境的人物之间的冲突。
        
小故事讲述在一个稳定的环境中，人物想方设法破坏他，以及后续所发生的事件。
        
在抢劫银行中，人物想要入侵银行或珠宝店进行抢劫。

请：

1，设定和描述一个银行或珠宝店。防守严密。

2，设定和描述一个想要入侵抢劫的人物。

3，请写出之后发生的事。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;

        case"夺取高位" :
        this.current_note_markdown = `入侵破坏的故事冲突，来自稳定的环境，和想破坏环境的人物之间的冲突。
        
小故事讲述在一个稳定的环境中，人物想方设法破坏他，以及后续所发生的事件。
        
在夺取高位中，人物想要打破原有的权力秩序，爬上高位。

请：

1，设定和描述一个等级森严的权力组织，可能是国家也可能是公司。

2，设定和描述一个毫无权势，却想要爬上高位的人物。

3，请写出之后发生的事。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;

        case"英雄救美" :
        this.current_note_markdown = `入侵破坏的故事冲突，来自稳定的环境，和想破坏环境的人物之间的冲突。
        
小故事讲述在一个稳定的环境中，人物想方设法破坏他，以及后续所发生的事件。
        
在英雄救美中，人物想要把美人从糟糕的环境中救出来。

请：

1，设定和描述一个囚禁美人的糟糕环境。

2，设定和描述一个想要把美人救出来的人物。

3，请写出之后发生的事。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;

        case"自定破坏" :
        this.current_note_markdown = `入侵破坏的故事冲突，来自稳定的环境，和想破坏环境的人物之间的冲突。
        
小故事讲述在一个稳定的环境中，人物想方设法破坏他，以及后续所发生的事件。
        

请：

1，设定和描述一个比较稳定的环境。

2，设定和描述一个想要破坏环境的人物。

3，请写出之后发生的事。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;





        //临近崩塌
        case"将破之城" :
        this.current_note_markdown = `临近崩塌的故事冲突，源于摇摇欲坠的环境中，破坏力量和维持原状之间的冲突。
        
小故事讲述在一个环境中，破坏力量越来越强大，人物却想要维持现状的故事。  
        
在将破之城中，强大的敌军兵临城下，城池快要受不住了。

请：

1，设定和描述一个力量单薄，孤悬海外的城池。

2，设定和描述一个攻打它的强大敌军。

3，请写出在这座城中发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;

        case"孤岛破屋" :
        this.current_note_markdown = `临近崩塌的故事冲突，源于摇摇欲坠的环境中，破坏力量和维持原状之间的冲突。
        
小故事讲述在一个环境中，破坏力量越来越强大，人物却想要维持现状的故事。  
        
在孤岛破屋中，人们在孤岛上好不容易建起了一座小破屋，但暴风雨很快要来了。

请：

1，设定和描述流落此地的人们，努力建起不算坚固的破屋。

2，设定和描述一个即将来临的天灾，可以毁灭所有的建筑。

3，请写出在这间屋子中发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;

        case"血脉独苗" :
        this.current_note_markdown = `临近崩塌的故事冲突，源于摇摇欲坠的环境中，破坏力量和维持原状之间的冲突。
        
小故事讲述在一个环境中，破坏力量越来越强大，人物却想要维持现状的故事。  
        
在血脉独苗中，从远古传承至今的特殊血脉，只剩下唯一一个继承人，眼看也有断绝的危险。

请：

1，设定和描述一种特殊的，必须延续血脉。

2，设定和描述血脉唯一的继承人，可能将要病死或离开了。

3，请写出在这个宗族中发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"争斗王室" :
        this.current_note_markdown = `临近崩塌的故事冲突，源于摇摇欲坠的环境中，破坏力量和维持原状之间的冲突。
        
小故事讲述在一个环境中，破坏力量越来越强大，人物却想要维持现状的故事。  
        
在争斗王室中，原本就不强大的国家，王室中还在不断的斗争。内忧外患将要导致亡国。

请：

1，设定和描述一个弱小，王室眼光短浅的国家。

2，设定和描述看到国家即将灭亡，但不甘于此的成员。

3，请写出在这个王国中发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;

        case"危机公司" :
        this.current_note_markdown = `临近崩塌的故事冲突，源于摇摇欲坠的环境中，破坏力量和维持原状之间的冲突。
        
小故事讲述在一个环境中，破坏力量越来越强大，人物却想要维持现状的故事。  
        
在危机公司中，一个濒临破产的公司中，有人想要挽救它。

请：

1，设定和描述一个濒临破产的公司或工厂。

2，设定和描述接手的人想要挽救它。

3，请写出在这个公司中发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"家庭出轨" :
        this.current_note_markdown = `临近崩塌的故事冲突，源于摇摇欲坠的环境中，破坏力量和维持原状之间的冲突。
        
小故事讲述在一个环境中，破坏力量越来越强大，人物却想要维持现状的故事。  
        
在家庭出轨中，家庭成员发现某个成员可能出轨了。

请：

1，设定和描述并不算和谐的家庭。

2，设定和描述某位家庭成员，发现有个成员可能出轨了。

3，请写出在这个家庭中发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"自定危机" :
        this.current_note_markdown = `临近崩塌的故事冲突，源于摇摇欲坠的环境中，破坏力量和维持原状之间的冲突。
        
小故事讲述在一个环境中，破坏力量越来越强大，人物却想要维持现状的故事。  
        

请：

1，设定和描述一个摇摇欲坠的环境。

2，设定和描述某个人物试图挽救这个环境。

3，请写出在这个环境中发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        //天降横祸
        case"被人陷害" :
        this.current_note_markdown = `天降横祸的故事冲突，源于出现的灾祸和不愿被灾祸打倒的人物之间的冲突。
        
小故事讲述灾祸忽然出现在某人身上，以及后续发生的一系列事件。  
        
在被人陷害中，主角被仇敌陷害，可能招来杀身之祸。

请：

1，设定和描述一个主角，以及他心狠手辣的仇敌

2，设定和描述仇敌处心积虑布局，陷害了他。

3，请写出接下来发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;

        case"替罪羔羊" :
        this.current_note_markdown = `天降横祸的故事冲突，源于出现的灾祸和不愿被灾祸打倒的人物之间的冲突。
        
小故事讲述灾祸忽然出现在某人身上，以及后续发生的一系列事件。  
        
在替罪羔羊中，无辜的主角，被选成某个坏人的替罪羔羊。

请：

1，设定和描述一个无辜的小人物主角。

2，设定和描述一个要受罚或受罪的人，打算让主角替他受过。

3，请写出接下来发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"重病缠身" :
        this.current_note_markdown = `天降横祸的故事冲突，源于出现的灾祸和不愿被灾祸打倒的人物之间的冲突。
        
小故事讲述灾祸忽然出现在某人身上，以及后续发生的一系列事件。  
        
在重病缠身中，原本健康，有各种梦想的主角，忽然得知自己得了绝症。

请：

1，设定和描述健康，有许多愿望没实现的主角。

2，设定和描述他忽然发现自己患上了绝症。

3，请写出接下来发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"病娇情人" :
        this.current_note_markdown = `天降横祸的故事冲突，源于出现的灾祸和不愿被灾祸打倒的人物之间的冲突。
        
小故事讲述灾祸忽然出现在某人身上，以及后续发生的一系列事件。  
        
在病娇情人中，普通的主角，被一个心理变态的人看上了。

请：

1，设定和描述普通，但有特点的主角。

2，设定和描述他被一个心理变态，不正常的人喜欢上了。

3，请写出接下来发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"科学实验" :
        this.current_note_markdown = `天降横祸的故事冲突，源于出现的灾祸和不愿被灾祸打倒的人物之间的冲突。
        
小故事讲述灾祸忽然出现在某人身上，以及后续发生的一系列事件。  
        
在科学实验中，普通的主角，成为了科学实验的试验品。

请：

1，设定和描述普通，但有特点的主角。

2，设定和描述他忽然发现，一个冷血科学家一直秘密对他进行科学实验。

3，请写出接下来发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;

        case"成为猎物" :
        this.current_note_markdown = `天降横祸的故事冲突，源于出现的灾祸和不愿被灾祸打倒的人物之间的冲突。
        
小故事讲述灾祸忽然出现在某人身上，以及后续发生的一系列事件。  
        
在成为猎物中，普通的主角，成为一个组织的猎物或比赛的奖品。

请：

1，设定和描述普通，但有特点的主角。

2，设定和描述一个组织，或一个比赛，把他当成猎物或获胜的条件。

3，请写出接下来发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"自定灾祸" :
        this.current_note_markdown = `天降横祸的故事冲突，源于出现的灾祸和不愿被灾祸打倒的人物之间的冲突。
        
小故事讲述灾祸忽然出现在某人身上，以及后续发生的一系列事件。  
        

请：

1，设定和描述普通，但有特点的主角。

2，设定和描述一个巨大的灾难发生在他身上。

3，请写出接下来发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;



        //如愿以偿
        case"一夜暴富" :
        this.current_note_markdown = `如愿以偿的故事冲突，源于忽然实现的愿望，和愿望伴随而来的束缚。
        
小故事讲述一个人的愿望忽然实现，以及后续发生的一系列事件。  
        
在一夜暴富中，主角忽然获得了非常多的钱财。

请：

1，设定和描述一个主角，因为某种原因忽然暴富。

2，设定和描述一个规则，他必须遵循这个规则才能保持财富。

3，请写出接下来发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"忽然成名" :
        this.current_note_markdown = `如愿以偿的故事冲突，源于忽然实现的愿望，和愿望伴随而来的束缚。
        
小故事讲述一个人的愿望忽然实现，以及后续发生的一系列事件。  
        
在忽然成名中，主角忽然成为了举世瞩目的名人。

请：

1，设定和描述一个主角，因为某种原因忽然成名。

2，设定和描述一个规则，他必须遵循这个规则才能保持名望。

3，请写出接下来发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"旧爱回头" :
        this.current_note_markdown = `如愿以偿的故事冲突，源于忽然实现的愿望，和愿望伴随而来的束缚。
        
小故事讲述一个人的愿望忽然实现，以及后续发生的一系列事件。  
        
在旧爱回头中，主角心心念念的旧爱回来要求复合。

请：

1，设定和描述一个主角，他心心念念的旧爱，以及旧爱忽然回来找他求复合。

2，设定和描述一个原因，他必须牺牲某些事，才能和旧爱重归于好。

3，请写出接下来发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"人生重来" :
        this.current_note_markdown = `如愿以偿的故事冲突，源于忽然实现的愿望，和愿望伴随而来的束缚。
        
小故事讲述一个人的愿望忽然实现，以及后续发生的一系列事件。  
        
在人生重来中，主角失败的人生，因为某种原因重新来过了。

请：

1，设定和描述一个主角，他很失败，或者人生有很多遗憾。

2，设定和描述他回到了童年，决心不再像原来那样生活。

3，请写出接下来发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"如愿登顶" :
        this.current_note_markdown = `如愿以偿的故事冲突，源于忽然实现的愿望，和愿望伴随而来的束缚。
        
小故事讲述一个人的愿望忽然实现，以及后续发生的一系列事件。  
        
在如愿登顶中，主角在心心念念的比赛，舞台或职位中如愿登顶了。

请：

1，设定和描述一个主角，他成功的得到了他梦寐以求的冠军或职位。

2，设定和描述这个职位并不光鲜亮丽，和他想象中不同的部分。

3，请写出接下来发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;

        case"武功秘籍" :
        this.current_note_markdown = `如愿以偿的故事冲突，源于忽然实现的愿望，和愿望伴随而来的束缚。
        
小故事讲述一个人的愿望忽然实现，以及后续发生的一系列事件。  
        
在武功秘籍中，主角获得了某种神秘功法，因此能力大涨。

请：

1，设定和描述一个主角，他偶然间获得了某种让能力快速进步的方法。

2，设定和描述这种功法的代价和限制。或者练习的方式。

3，请写出接下来发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;

        case"自定愿望" :
        this.current_note_markdown = `如愿以偿的故事冲突，源于忽然实现的愿望，和愿望伴随而来的束缚。
        
小故事讲述一个人的愿望忽然实现，以及后续发生的一系列事件。  

请：

1，设定和描述一个主角，他忽然实现了某个愿望。

2，设定和描述这种愿望实现的代价，或保持现状需要遵循的规则。

3，请写出接下来发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;




        //未解之谜 
        case"寻找凶手" :
        this.current_note_markdown = `未解之谜的故事冲突，来自难解的谜团和人物必须解开之间的矛盾。
        
小故事讲述人物努力解谜时，所发生的一系列事件。
        
在寻找凶手中，主角要在众多嫌疑人中找到杀人凶手。

请：

1，设定和描述一个杀人案件，没有人知道杀人凶手是谁。

2，设定和描述一个人物，是侦探或和案件有关，要来调查案件。

3，请写出人物寻找凶手的过程。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"谁是卧底" :
        this.current_note_markdown = `未解之谜的故事冲突，来自难解的谜团和人物必须解开之间的矛盾。
        
小故事讲述人物努力解谜时，所发生的一系列事件。
        
在谁是卧底中，主角所在的帮派中出现了卧底，要寻找卧底是谁。

请：

1，设定和描述一个帮派或组织，所做的事需要严格保密。但最近秘密经常泄露。

2，设定和描述一个人物，来找寻卧底。

3，请写出人物寻找卧底的过程。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"旧事惨案" :
        this.current_note_markdown = `未解之谜的故事冲突，来自难解的谜团和人物必须解开之间的矛盾。
        
小故事讲述人物努力解谜时，所发生的一系列事件。
        
在旧事惨案中，几十年前发生过一件大家都讳莫如深的事。主角要探寻这件事的真相。

请：

1，设定和描述一个几十年前发生过的，造成惨重后果，且没人肯提的大事。

2，设定和描述一个人物，因为某种原因想知道这件事的真相。

3，请写出人物探寻旧事的过程。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"遗书谜团" :
        this.current_note_markdown = `未解之谜的故事冲突，来自难解的谜团和人物必须解开之间的矛盾。
        
小故事讲述人物努力解谜时，所发生的一系列事件。
        
在遗书谜团中，家族的老人去世了，却有好几个人手里有不同版本的遗书。

请：

1，设定和描述一个庞大的，人物关系复杂的家族。

2，设定和描述老人死后，有不同的人声称手里有遗书，版本却完全不同。

3，请写出人物找寻遗书真相的故事。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"宝藏真假" :
        this.current_note_markdown = `未解之谜的故事冲突，来自难解的谜团和人物必须解开之间的矛盾。
        
小故事讲述人物努力解谜时，所发生的一系列事件。
        
在宝藏在哪中，传言中某地有传奇宝藏，主角要去探寻事情真伪。

请：

1，设定和描述一个传言，活灵活现的描述某地有某种宝藏。

2，设定和描述一个不信传言，但不得不考察事情真伪的主角。

3，请写出人物探寻事情真伪的过程。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"神秘仪式" :
        this.current_note_markdown = `未解之谜的故事冲突，来自难解的谜团和人物必须解开之间的矛盾。
        
小故事讲述人物努力解谜时，所发生的一系列事件。
        
在神秘仪式中，主角因故流落到某乡村，发现他们在举行某种神秘仪式。

请：

1，设定和描述一个原始仪式，和一个经常举行它的村落。

2，设定和描述一个偶然流落到此的主角，发现这仪式有点古怪。

3，请写出人物探寻事情真相的过程。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"自定谜团" :
        this.current_note_markdown = `未解之谜的故事冲突，来自难解的谜团和人物必须解开之间的矛盾。
        
小故事讲述人物努力解谜时，所发生的一系列事件。
        

请：

1，设定和描述一个谜团。

2，设定和描述一个必须要解开谜团的主角。

3，请写出人物探寻事情真相的过程。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;

        //寻宝故事
        case"拯救公主" :
        this.current_note_markdown = `寻宝故事讲述人物在找寻某种宝藏的过程中，所经历的事。
             
在拯救公主中，英雄要去找回被恶龙带走的公主。

请：

1，设定和描述消失或被抢走的公主或仙女。

2，设定和描述一位找寻和拯救她的英雄。

3，请写出拯救公主的过程。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"寻不死药" :
        this.current_note_markdown = `寻宝故事讲述人物在找寻某种宝藏的过程中，所经历的事。
             
在寻不死药中，人物要去找寻让人长生不死的仙丹。

请：

1，设定和描述一种能让人长生不死的秘药或功法。

2，设定和描述一个找寻它的人物或队伍。

3，请写出寻不死药的过程。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"盗墓笔记" :
        this.current_note_markdown = `寻宝故事讲述人物在找寻某种宝藏的过程中，所经历的事。
             
在盗墓笔记中，人物要挖掘偷盗墓葬中的宝物。

请：

1，设定和描述一个神秘且重要的墓穴。

2，设定和描述一个找寻它的人物或队伍。

3，请写出盗墓的过程。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"西天取经" :
        this.current_note_markdown = `寻宝故事讲述人物在找寻某种宝藏的过程中，所经历的事。
             
在西天取经中，人物要去遥远的国度完成自己的使命。

请：

1，设定和描述一个要去遥远国度才能完成的使命。

2，设定和描述一个长途跋涉完成它的人物或队伍。

3，请写出完成使命的过程。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"找寻自己" :
        this.current_note_markdown = `寻宝故事讲述人物在找寻某种宝藏的过程中，所经历的事。
             
在找寻自己中，无名无姓的人物要解开自己的身世之谜。

请：

1，设定和描述一个被秘密养大，不知道自己身世的主角。

2，设定和描述一个他身世被隐瞒的重要原因。

3，请写出他解开身世之谜并重新回归的经过。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"自定宝藏" :
        this.current_note_markdown = `寻宝故事讲述人物在找寻某种宝藏的过程中，所经历的事。
             

请：

1，设定和描述一个重要的宝藏。

2，设定和描述一个寻找宝藏的主角。

3，请写出寻找宝藏的过程。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;

        //忽起变化
        case"破产风波" :
        this.current_note_markdown = `忽起变化指的是在平静的生活中，忽然有了重大变化
        
小故事讲述变化发生之后，所引发的一系列事件。
        
在破产风波中，原本花天酒地酒池肉林的家族忽然破产了。

请：

1，设定和描述富有的家族，以及其中的一个成员作为主人公。

2，设定和描述一个原因，让他一早起来，忽然发现家里破产了。

3，请写出之后所发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"不速之客" :
        this.current_note_markdown = `忽起变化指的是在平静的生活中，忽然有了重大变化
        
小故事讲述变化发生之后，所引发的一系列事件。
        
在不速之客中，独自生活的主角，遇到了一个不速之客。

请：

1，设定和描述一个孤独的主角，他因为种种原因离群索居。

2，设定和描述一个不速之客，他忽然闯进主角的生活，并赖着不走。

3，请写出之后所发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"风暴来袭" :
        this.current_note_markdown = `忽起变化指的是在平静的生活中，忽然有了重大变化
        
小故事讲述变化发生之后，所引发的一系列事件。
        
在风暴来袭中，一场天灾降临在宁静祥和的村落。

请：

1，设定和描述一个乡村，部落或城市。

2，设定和描述他们没有见过的天灾，忽然发生在这里。

3，请写出之后所发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"撞破秘密" :
        this.current_note_markdown = `忽起变化指的是在平静的生活中，忽然有了重大变化
        
小故事讲述变化发生之后，所引发的一系列事件。
        
在撞破秘密中，主角忽然发现了身边人的惊天大秘密。

请：

1，设定和描述一个单纯善良，不知世事的主角。

2，设定和描述他恰巧撞破了身边人努力隐瞒的惊天大秘密。

3，请写出之后所发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"超能力者" :
        this.current_note_markdown = `忽起变化指的是在平静的生活中，忽然有了重大变化
        
小故事讲述变化发生之后，所引发的一系列事件。
        
在超能力者中，主角偶然间获得了某种超能力。

请：

1，设定和描述一个人物，他可以普通，但要有特点。

2，设定和描述他偶然间获得了某种超能力。

3，请写出之后所发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"LGBT" :
        this.current_note_markdown = `忽起变化指的是在平静的生活中，忽然有了重大变化
        
小故事讲述变化发生之后，所引发的一系列事件。
        
在LGBT中，在传统的村落中，忽然有人宣称自己是同性恋（或者变性了）

请：

1，设定和描述一个人物，他可以普通，但要有特点。

2，设定和描述他关系最好的朋友，忽然出柜或变性了。

3，请写出之后所发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;



        case"自定变化" :
        this.current_note_markdown = `忽起变化指的是在平静的生活中，忽然有了重大变化
        
小故事讲述变化发生之后，所引发的一系列事件。
        

请：

1，设定和描述一个人物，他可以普通，但要有特点。

2，设定和描述他的生活中发生了一个非常大的变化。

3，请写出之后所发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;

        //爱而不得 
        case"家族不合" :
        this.current_note_markdown = `爱而不得的故事冲突，来自两个人物想要在一起的愿望，与现实不允许的障碍。
        
小故事讲述天生一对的两个人物，因为现实阻碍而无法在一起的抗争故事。
        
在家族不合中，两人因家族间的仇怨无法结合。

请：

1，设定和描述人物一，他有严重的性格或生理缺陷。

2，设定和描述人物二，他刚好可以弥补人物一的缺陷。

3，请写出他们相识相知，互相爱慕但因为家族不合无法在一起的抗争过程。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;

        case"战争之隔" :
        this.current_note_markdown = `爱而不得的故事冲突，来自两个人物想要在一起的愿望，与现实不允许的障碍。
        
小故事讲述天生一对的两个人物，因为现实阻碍而无法在一起的抗争故事。
        
在战争之隔中，两人因国家间的战争不得不分离。

请：

1，设定和描述人物一，他有严重的性格或生理缺陷。

2，设定和描述人物二，他刚好可以弥补人物一的缺陷。

3，请写出他们相识相知，互相爱慕但因为战争之隔无法在一起的抗争过程。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;

        case"病痛分离" :
        this.current_note_markdown = `爱而不得的故事冲突，来自两个人物想要在一起的愿望，与现实不允许的障碍。
        
小故事讲述天生一对的两个人物，因为现实阻碍而无法在一起的抗争故事。
        
在病痛分离中，两人因病痛的原因（如白血病）无法在一起。

请：

1，设定和描述人物一，他有严重的性格或生理缺陷。

2，设定和描述人物二，他刚好可以弥补人物一的缺陷。

3，请写出他们相识相知，互相爱慕但因为病痛分离无法在一起的抗争过程。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"权力斗争" :
        this.current_note_markdown = `爱而不得的故事冲突，来自两个人物想要在一起的愿望，与现实不允许的障碍。
        
小故事讲述天生一对的两个人物，因为现实阻碍而无法在一起的抗争故事。
        
在权力斗争中，两人因分属不同的权谋集团，或因为权力阻碍而无法在一起。

请：

1，设定和描述人物一，他有严重的性格或生理缺陷。

2，设定和描述人物二，他刚好可以弥补人物一的缺陷。

3，请写出他们相识相知，互相爱慕但因为权力斗争无法在一起的抗争过程。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;

        case"已有家室" :
        this.current_note_markdown = `爱而不得的故事冲突，来自两个人物想要在一起的愿望，与现实不允许的障碍。
        
小故事讲述天生一对的两个人物，因为现实阻碍而无法在一起的抗争故事。
        
在已有家室中，因一方或双方已经成家而无法在一起。

请：

1，设定和描述人物一，他有严重的性格或生理缺陷。

2，设定和描述人物二，他刚好可以弥补人物一的缺陷。

3，请写出他们相识相知，互相爱慕但因为已有家室无法在一起的抗争过程。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;

        case"门户不当" :
        this.current_note_markdown = `爱而不得的故事冲突，来自两个人物想要在一起的愿望，与现实不允许的障碍。
        
小故事讲述天生一对的两个人物，因为现实阻碍而无法在一起的抗争故事。
        
在门户不当中，因双方门不当户不对，因为经济，父母，观点等障碍无法在一起。

请：

1，设定和描述人物一，他有严重的性格或生理缺陷。

2，设定和描述人物二，他刚好可以弥补人物一的缺陷。

3，请写出他们相识相知，互相爱慕但因为门户不当无法在一起的抗争过程。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;

  
        case"一方有隐" :
        this.current_note_markdown = `爱而不得的故事冲突，来自两个人物想要在一起的愿望，与现实不允许的障碍。
        
小故事讲述天生一对的两个人物，因为现实阻碍而无法在一起的抗争故事。
        
在一方有隐中，因一方或双方隐瞒了关键信息（比如外貌），害怕被揭露而无法在一起。

请：

1，设定和描述人物一，他有严重的性格或生理缺陷。

2，设定和描述人物二，他刚好可以弥补人物一的缺陷。

3，请写出他们相识相知，互相爱慕但因为一方有隐无法在一起的抗争过程。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;

        case"使命背离" :
        this.current_note_markdown = `爱而不得的故事冲突，来自两个人物想要在一起的愿望，与现实不允许的障碍。
        
小故事讲述天生一对的两个人物，因为现实阻碍而无法在一起的抗争故事。
        
在使命背离中，因一方或双方拥有特殊使命，而无法和对方在一起。

请：

1，设定和描述人物一，他有严重的性格或生理缺陷。

2，设定和描述人物二，他刚好可以弥补人物一的缺陷。

3，请写出他们相识相知，互相爱慕但因为使命背离无法在一起的抗争过程。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;

        case"自定障碍" :
        this.current_note_markdown = `爱而不得的故事冲突，来自两个人物想要在一起的愿望，与现实不允许的障碍。
        
小故事讲述天生一对的两个人物，因为现实阻碍而无法在一起的抗争故事。       

请：

1，设定和描述人物一，他有严重的性格或生理缺陷。

2，设定和描述人物二，他刚好可以弥补人物一的缺陷。

3，请写出他们相识相知，互相爱慕但因为某种障碍无法在一起的抗争过程。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;

        //敌对关系  
        case"继女庶女" :
        this.current_note_markdown = `敌对关系的故事冲突，来自两个人物之间的愿望冲突。
        
小故事讲述两个拥有相反或矛盾愿望的人物，相互斗争的故事。
        
在继女庶女中，她们都没有正统的财产继承权，但要争夺遗产或家族产业。

请：

1，设定和描述一下人物A，她是被过继来的孩子。

2，设定和描述一下人物B，她是私生子或庶出的孩子。

3，请写出她们在富贵家族中争夺地位或财产的过程。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"副总之争" :
        this.current_note_markdown = `敌对关系的故事冲突，来自两个人物之间的愿望冲突。
        
小故事讲述两个拥有相反或矛盾愿望的人物，相互斗争的故事。
        
在副总之争中，两位副总要争夺公司老总的位置

请：

1，设定和描述一下两个人物，他们是一家企业的两位副总

2，公司总裁即将退休或临时出事，需要在两个副总中选一个上任。但有相关的考核和评价标准。

3，请写出他们争夺总裁位置的过程。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"杀父之仇" :
        this.current_note_markdown = `敌对关系的故事冲突，来自两个人物之间的愿望冲突。
        
小故事讲述两个拥有相反或矛盾愿望的人物，相互斗争的故事。
        
在杀父之仇中，人物之间有血海深仇，在某个时限内必须了结。

请：

1，设定和描述一下两个人物，他们可以普通，但要有特点。

2，设定和描述一下过去的事，两人结下了夺妻杀父之类的血海深仇。

3，其中一人，有必须要在三天内报仇的理由。请写下报仇过程。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"误会越深" :
        this.current_note_markdown = `敌对关系的故事冲突，来自两个人物之间的愿望冲突。
        
小故事讲述两个拥有相反或矛盾愿望的人物，相互斗争的故事。
        
在误会越深中，人物之间有某种误会，一人想要解开，误会却越积越深。

请：

1，设定和描述一下两个人物，他们可以普通，但要有特点。

2，设定和描述一下过去的事，两人因机缘巧合产生了误会。

3，其中一人，努力解开误会，但误会却牵连众多，并不好解。请写出原因和经过。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"欠债还钱" :
        this.current_note_markdown = `敌对关系的故事冲突，来自两个人物之间的愿望冲突。
        
小故事讲述两个拥有相反或矛盾愿望的人物，相互斗争的故事。
        
在欠债还钱中，一人欠债不想还，一人急需要债成功。

请：

1，设定和描述一下两个人物，他们可以普通，但要有特点。

2，设定和描述一下欠债的过去，以及必须现在还和现在还不了的原因。

3，请写出两人要债和推脱的博弈过程。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;

        case"情敌争锋" :
        this.current_note_markdown = `敌对关系的故事冲突，来自两个人物之间的愿望冲突。
        
小故事讲述两个拥有相反或矛盾愿望的人物，相互斗争的故事。
        
在情敌争锋中，两人为争夺理想伴侣的欢心而争斗不休。

请：

1，设定和描述一下两个人物，他们可以普通，但要有特点。

2，设定和描述一下他们同时看上的理想伴侣，以及伴侣犹豫不定的态度。

3，请写出两人努力争夺伴侣的过程。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;

        case"刺客受命" :
        this.current_note_markdown = `敌对关系的故事冲突，来自两个人物之间的愿望冲突。
        
小故事讲述两个拥有相反或矛盾愿望的人物，相互斗争的故事。
        
在刺客受命中，刺客接受任务要去刺杀某人。而对方不想被杀。

请：

1，设定和描述一下被刺杀的人，以及被刺杀的理由。

2，设定和描述一下刺客接受任务，打算去刺杀他。

3，请写出刺杀的过程。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"保镖劫难" :
        this.current_note_markdown = `敌对关系的故事冲突，来自两个人物之间的愿望冲突。
        
小故事讲述两个拥有相反或矛盾愿望的人物，相互斗争的故事。
        
在保镖劫难中，保镖需要保护某人的生命，但对方不想活了。

请：

1，设定和描述一下被保护的人，以及被保护的理由。

2，设定和描述一下保镖接受任务，需要去保护他。

3，请写出保护的过程。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;

        case"自定冤仇" :
        this.current_note_markdown = `敌对关系的故事冲突，来自两个人物之间的愿望冲突。
        
小故事讲述两个拥有相反或矛盾愿望的人物，相互斗争的故事。
        

请：

1，设定和描述一下主角一以及他的愿望

2，设定和描述一下主角二以及他的愿望

3，请写出两人的愿望冲突的过程。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;

  
        //格格不入    
        case"在逃公主" :
        this.current_note_markdown = `格格不入的故事冲突，来自于人物和与之格格不入的环境。
        
小故事讲述人物出现在他平常绝不会出现的地方。所发生的故事。
        
在在逃公主中，尊贵的公主被迫流落民间。

请：

1，设定和描述一下你的人物。他可能是贵族或富豪。

2，设定并描述一个原因，他被迫流浪或入狱或成为贫民。

3，请写出他与环境格格不入时所发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;

        case"刘姥姥进园" :
        this.current_note_markdown = `格格不入的故事冲突，来自于人物和与之格格不入的环境。
        
小故事讲述人物出现在他平常绝不会出现的地方。所发生的故事。
        
在刘姥姥进园中，见识短浅或贫穷的人要进入上流社会。

请：

1，设定和描述一下你的人物。他可能是穷人或有缺陷的人。

2，设定并描述一个原因，他必须进入上流社会。

3，请写出他与环境格格不入时所发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;
  
        case"穿越过去" :
        this.current_note_markdown = `格格不入的故事冲突，来自于人物和与之格格不入的环境。
        
小故事讲述人物出现在他平常绝不会出现的地方。所发生的故事。
        
在穿越过去中，现代人穿越到了古代。

请：

1，设定和描述一下你的人物。他可以普通但要有特点。

2，设定并描述一个遥远或近的过去，让人物穿越过去。

3，请写出他与环境格格不入时所发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;

        case"外星之旅" :
        this.current_note_markdown = `格格不入的故事冲突，来自于人物和与之格格不入的环境。
        
小故事讲述人物出现在他平常绝不会出现的地方。所发生的故事。
        
在外星之旅中，地球人出现在了外星球。

请：

1，设定和描述一下你的人物。他可以普通但要有特点。

2，设定并描述一个外星世界，让主角出现在那。

3，请写出他与环境格格不入时所发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"书呆子劫难" :
        this.current_note_markdown = `格格不入的故事冲突，来自于人物和与之格格不入的环境。
        
小故事讲述人物出现在他平常绝不会出现的地方。所发生的故事。
        
在书呆子劫难中，高学历或知识渊博的人，被迫应对野蛮或不需要知识的环境。

请：

1，设定和描述一下你的人物。他是高学历，或有知识的人。

2，设定并描述一个野蛮、原始或只需要手工等具体技能的环境。

3，请写出他与环境格格不入时所发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"傻瓜中举" :
        this.current_note_markdown = `格格不入的故事冲突，来自于人物和与之格格不入的环境。
        
小故事讲述人物出现在他平常绝不会出现的地方。所发生的故事。
        
在傻瓜中举中，没有能力的傻瓜，进入了高等学府。

请：

1，设定和描述一下你的人物。他是一个不太聪明，也不太会读书的人。

2，设定并描述一个原因，他被迫进入高等学府、科学院或高科技公司。

3，请写出他与环境格格不入时所发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


        case"女儿国奇遇" :
        this.current_note_markdown = `格格不入的故事冲突，来自于人物和与之格格不入的环境。
        
小故事讲述人物出现在他平常绝不会出现的地方。所发生的故事。
        
在女儿国奇遇中，一个男生或女生，进入全是异性的国度。

请：

1，设定和描述一下你的人物。他是个普通的男生或女生。

2，设定并描述一个只有异性的国度，并让人物出现在那。

3，请写出他与环境格格不入时所发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;

        case"自定际遇" :
        this.current_note_markdown = `格格不入的故事冲突，来自于人物和与之格格不入的环境。
        
小故事讲述人物出现在他平常绝不会出现的地方。所发生的故事。    

请：

1，设定和描述一下你的人物。他有显著特点和特定的生活环境。

2，设定并描述一个平常他绝对不会去的地方，让他出现在那。

3，请写出他与环境格格不入时所发生的事情。
        `;

        this.is_title = 1;
        if( this.view_type == 2 ) this.view_type = 3;
        break;


  //………………………………………人物夙愿……………………………………
         case"平民逃生" :
         this.current_note_markdown = `人物夙愿的故事冲突，来自于人物愿望和与之违背的现实。
         
小故事讲述人物追求心中愿望，最后成功或失败的故事。
         
在平民逃生中，人物的愿望是活下去。

请：

1，设定和描述一下你的人物。可以普通，但不能毫无特点。

2，设定并描述一个灾难，很可能会让他立刻死亡。

3，他打算对此进行抗争，请写出抗争经过。
         `;

         this.is_title = 1;
         if( this.view_type == 2 ) this.view_type = 3;
         break;

         case"王子复仇" :
         this.current_note_markdown = `人物夙愿的故事冲突，来自于人物愿望和与之违背的现实。
         
小故事讲述人物追求心中愿望，最后成功或失败的故事。
         
在王子复仇中，人物的愿望是复仇。

请：

1，设定和描述一下你的人物。他可能是个贵族。

2，设定并描述结仇事件，让人物失去重要的东西。

3，他打算对此进行复仇，请写出复仇经过。
         `;

         this.is_title = 1;
         if( this.view_type == 2 ) this.view_type = 3;
         break;

         case"救援亲人" :
         this.current_note_markdown = `人物夙愿的故事冲突，来自于人物愿望和与之违背的现实。
         
小故事讲述人物追求心中愿望，最后成功或失败的故事。
         
在救援亲人中，人物的愿望是亲人活下来。

请：

1，设定和描述一下你的人物。并描述他的一个至亲。

2，设定并描述一个场景，他至亲的生命正在流逝。

3，他打算对此进行救援，请写出救援经过。
         `;

         this.is_title = 1;
         if( this.view_type == 2 ) this.view_type = 3;
         break;

         case"攀上高枝" :
         this.current_note_markdown = `人物夙愿的故事冲突，来自于人物愿望和与之违背的现实。
         
小故事讲述人物追求心中愿望，最后成功或失败的故事。
         
在攀上高枝中，人物的愿望是出人头地。

请：

1，设定和描述一下你的人物。他有强烈的成功愿望。

2，设定并描述一个场景，他出人头地的机会似乎到了。

3，他打算努力抓住这个机会，请写出努力的经过。
         `;

         this.is_title = 1;
         if( this.view_type == 2 ) this.view_type = 3;
         break;

         case"追求挚爱" :
         this.current_note_markdown = `人物夙愿的故事冲突，来自于人物愿望和与之违背的现实。
         
小故事讲述人物追求心中愿望，最后成功或失败的故事。
         
在追求挚爱中，人物的愿望是追求伴侣。

请：

1，设定和描述一下你的人物。他有朝思暮想的挚爱。

2，设定并描述一个困难，阻挡他和挚爱在一起。

3，他打算克服这个困难，请写出克服的经过。
         `;

         this.is_title = 1;
         if( this.view_type == 2 ) this.view_type = 3;
         break;

         case"自定愿望" :
         this.current_note_markdown = `人物夙愿的故事冲突，来自于人物愿望和与之违背的现实。
         
小故事讲述人物追求心中愿望，最后成功或失败的故事。
         

请：

1，设定和描述一下你的人物。

2，为他设定一个愿望，和阻碍愿望的现实。

3，描述他努力实现愿望，跨越障碍的过程。
         `;

         this.is_title = 1;
         if( this.view_type == 2 ) this.view_type = 3;
         break;



         case "狡猾，泳装，鲁迅全集":
         this.current_note_markdown = `这是第一篇三题作文！！`;
          this.is_title = 1;
          if( this.view_type == 2 ) this.view_type = 3;
           break;
       }
     }

     @action getnotepagechange(_nodePath){
      switch(_nodePath[0]){
        case 0 :
                //[0,0]简要介绍
              switch(_nodePath[1]){
              case 0 :
                this.current_note_markdown = `简要介绍：
                
这是小说研究所的练习APP,提供小故事、文笔、套路、结构方面的种种具体练习。

也在练习前给出练习所需的理论讲解，帮助大家更能理解练习内容。
                
希望通过这些练习方式，帮助大家提高写作技巧。

…………



练习APP分为以下几大部分：




1，小故事篇。

面向从零开始的初学者。你可以从人物，情节，环境三个方向，从无到有写出自己的故事。

也可以使用三题作文，随机轻小说练习和戏剧化开头，获得灵感。试着进行故事练习。

2，文笔篇

面向写作有难度，尤其是描写比较苦手的写作者。

包括场景、外貌、服饰、战斗、心理等专题练习。

以及展示、对话、画面感、叙事、节奏、象征等更为通用的文笔技巧练习。

3，套路篇

面向情节构思有难度，写的内容不够有趣，或者写的情节达不到想要效果。

设计让人哭，读者却哭不出来。想要让人笑，读者却笑不出来。

想要学习这部分技巧的写作者。

套路篇拥有爽文套路和言情套路作为具体的套路练习。

以及愤怒，恐惧，泪点，笑点等更为抽象的情绪调动理论及练习。

4，结构篇

面向对人物设定，故事整体有更高要求的写作者。

从故事宏观的故事线，代入感等技巧，到悬疑，反常，开头等具体的技巧练习。

帮助大家查缺补漏，增加故事整体的设计能力。

…………

使用指南：
1，小故事、文笔篇、套路篇等文件夹下，是理论或套路练习。

2.理论讲解文件前，有绿色的文件图标。练习文件前，有蓝色的编辑图标。

3，点开练习文件，是练习列表。每种练习都有1~10个练习题目可以进行练习。

4，在练习列表中选择练习题目，点击灰色的编辑按钮后，开始练习。

5，练习完毕后，间隔24小时，再回来点击打分按钮进行打分。

6，打分完毕后，分数会显示在练习列表和目录的右边。以星星和不同颜色的√来表示。满分为五颗星或两个绿色的√

祝大家使用愉快~

…………


参考资料：

                
你可以选择喜欢的,想要成长的方向进行练习（并不需要按顺序，也不需要全部都练习）

为了更好的练习效果，练习之前，请确定你使用过小说研究所的向导APP，或看过橙色海写作教程，或有过一定的写作经验。

如果你需要下载向导APP，或者学习橙色海写作教程，请下面的链接

向导app：https://www.bilibili.com/video/BV1P64y1f7me

橙色海写作教程：https://zhuanlan.zhihu.com/p/70963887

想要联系教程作者，请关注公众号过雨红素。


                `;
                this.is_title = 0;
                if( this.view_type == 1 ){
                  this.view_type = 3;
              this.isrecommend = true;}
                
              break;
              }
        break;

        //文笔篇
        case 1 :
                switch(_nodePath[1]){
                        //[1,0]场景描写
                        case 0 :

                                //[1,0,0]理论讲解
                                switch(_nodePath[2]){
                                        case 0 :
                                                this.current_note_markdown = `

请点击：

https://mp.weixin.qq.com/s?__biz=MzI3NjY2OTQwMg==&mid=2247485013&idx=1&sn=5eee7975abb885506cb3077916dba4f2&chksm=eb70b0e0dc0739f6fcfd28ed3416c1027a4c9f701c2cd72ee9185006106e9880f93ba9c653a3&token=1304626804&lang=zh_CN#rd


         `;
                                                this.is_title = 0;
                                                if( this.view_type == 1 ){
                                                  this.view_type = 3;
                                              this.isrecommend = true;}
                                        break;
                                }
                        break;

                       // [1,1]外貌描写
                        case 1 :
                                switch(_nodePath[2]){
                                        //[1,1,0]理论讲解
                                        case 0 :
                                                this.current_note_markdown = `

请点击：
                                                
https://mp.weixin.qq.com/s?__biz=MzI3NjY2OTQwMg==&mid=2247485066&idx=1&sn=b38a17ede68439c11ed09542cbb5e37d&scene=19#wechat_redirect
                                                
                                                
                                                         `;
                                                                                                this.is_title = 0;
                                                                                                if( this.view_type == 1 ){
                                                                                                  this.view_type = 3;
                                                                                              this.isrecommend = true;}
                                        break;
                                }
                        break;
                        // [1,2]服饰描写
                        case 2:
                                switch(_nodePath[2]){
                                        //[1,2,0]理论讲解
                                        case 0 :
                                                this.current_note_markdown = `

请点击：
                                                
https://mp.weixin.qq.com/s?__biz=MzI3NjY2OTQwMg==&mid=2247485224&idx=1&sn=8ad3ce34bb691a2d0ff900ead0bb072c&scene=19#wechat_redirect
                                                
                                                
                                                         `;
                                                                                                this.is_title = 0;
                                                                                                if( this.view_type == 1 ){
                                                                                                  this.view_type = 3;
                                                                                              this.isrecommend = true;}
                                        break;
                                }
                        break;

                         // [1,3]战斗描写
                         case 3:
                                switch(_nodePath[2]){
                                        //[1,3,0]理论讲解
                                        case 0 :
                                                this.current_note_markdown = `

请点击：
                                                
https://mp.weixin.qq.com/s?__biz=MzI3NjY2OTQwMg==&mid=2247485234&idx=1&sn=3d164ae95c0bc4881bdfb368a33ad8b3&scene=19#wechat_redirect
                                                
                                                
                                                         `;
                                                                                                this.is_title = 0;
                                                                                                if( this.view_type == 1 ){
                                                                                                  this.view_type = 3;
                                                                                              this.isrecommend = true;}
                                        break;
                                }
                        break;

                        // [1,4]心理描写
                        case 4 :
                                switch(_nodePath[2]){
                                        //[1,4,0]理论讲解
                                        case 0 :
                                                this.current_note_markdown = `

请点击：（虽然标题写着战斗，但其实是心理描写）
                                                
https://mp.weixin.qq.com/s?__biz=MzI3NjY2OTQwMg==&mid=2247485252&idx=1&sn=041c998c1b83a2a74469b38ba00d7bb5&scene=19#wechat_redirect
                                                
                                                
                                                         `;
                                                                                                this.is_title = 0;
                                                                                                if( this.view_type == 1 ){
                                                                                                  this.view_type = 3;
                                                                                              this.isrecommend = true;}
                                        break;
                                }
                        break;

                        // [1,5]展示
                        case 5 :
                              switch(_nodePath[2]){
                                    //[1,5,0]理论讲解
                                    case 0 :
                                            this.current_note_markdown = `

请点击：
                                            
https://mp.weixin.qq.com/s?__biz=MzI3NjY2OTQwMg==&mid=2247484969&idx=1&sn=954af415006d71a996ae979993730bdc&scene=19#wechat_redirect
                                            
                                            
                                                     `;
                                                                                            this.is_title = 0;
                                                                                            if( this.view_type == 1 ){
                                                                                              this.view_type = 3;
                                                                                          this.isrecommend = true;}
                                    break;
                            }

                        break;


                         // [1,6]对话
                         case 6 :
                              switch(_nodePath[2]){
                                    //[1,6,0]理论讲解
                                    case 0 :
                                            this.current_note_markdown = `

请点击：
                                            
https://mp.weixin.qq.com/s?__biz=MzI3NjY2OTQwMg==&mid=2247485008&idx=1&sn=70b1eecc735bf8142608405af874e1a9&scene=19#wechat_redirect

                                            
                                            
                                                     `;
                                                                                            this.is_title = 0;
                                                                                            if( this.view_type == 1 ){
                                                                                              this.view_type = 3;
                                                                                          this.isrecommend = true;}
                                    break;
                            }

                        break;

                        // [1,7]画面感
                        case 7 :
                              switch(_nodePath[2]){
                                    //[1,7,0]理论讲解
                                    case 0 :
                                            this.current_note_markdown = `

请点击：
                                            
https://mp.weixin.qq.com/s?__biz=MzI3NjY2OTQwMg==&mid=2247484999&idx=1&sn=25e89c6e48b52e02b158d38c584b0ae7&scene=19#wechat_redirect


                                            
                                            
                                                     `;
                                                                                            this.is_title = 0;
                                                                                            if( this.view_type == 1 ){
                                                                                              this.view_type = 3;
                                                                                          this.isrecommend = true;}
                                    break;
                            }

                        break;


                        // [1,8]叙事
                        case 8 :
                              switch(_nodePath[2]){
                                    //[1,8,0]理论讲解
                                    case 0 :
                                            this.current_note_markdown = `

请点击：
                                            
https://mp.weixin.qq.com/s?__biz=MzI3NjY2OTQwMg==&mid=2247484975&idx=1&sn=4f0de1ad6c36b585a26f1a1b3a79f6af&scene=19#wechat_redirect


                                            
                                            
                                                     `;
                                                                                            this.is_title = 0;
                                                                                            if( this.view_type == 1 ){
                                                                                              this.view_type = 3;
                                                                                          this.isrecommend = true;}
                                    break;
                            }

                        break;

                        // [1,9]节奏
                        case 9 :
                              switch(_nodePath[2]){
                                    //[1,9,0]理论讲解
                                    case 0 :
                                            this.current_note_markdown = `

请点击：
                                            
https://mp.weixin.qq.com/s?__biz=MzI3NjY2OTQwMg==&mid=2247484986&idx=1&sn=867794e2182f401cc1a17d4c599b0594&scene=19#wechat_redirect



                                            
                                            
                                                     `;
                                                                                            this.is_title = 0;
                                                                                            if( this.view_type == 1 ){
                                                                                              this.view_type = 3;
                                                                                          this.isrecommend = true;}
                                    break;
                            }

                        break;


                        // [1,10]象征
                        case 10 :
                              switch(_nodePath[2]){
                                    //[1,10,0]理论讲解
                                    case 0 :
                                            this.current_note_markdown = `

请点击：
                                            
https://mp.weixin.qq.com/s?__biz=MzI3NjY2OTQwMg==&mid=2247484995&idx=1&sn=f809a6f44430715643e0a0838903edf5&scene=19#wechat_redirect




                                            
                                            
                                                     `;
                                                                                            this.is_title = 0;
                                                                                            if( this.view_type == 1 ){
                                                                                              this.view_type = 3;
                                                                                          this.isrecommend = true;}
                                    break;
                            }

                        break;
                }
        break;


        //套路篇
        case 2:
          switch(_nodePath[1]){

            //[2,0]爽文套路
            case 0 :

              
              switch(_nodePath[2]){
                //[2,0,0]爽文概述
                      case 0 :
                              this.current_note_markdown = `

请点击：

https://zhuanlan.zhihu.com/p/29708199

`;
                              this.is_title = 0;
                              if( this.view_type == 1 ){
                                this.view_type = 3;
                            this.isrecommend = true;}
                      break;


                       //[2,0,1]显摆
                      case 1 :
                        switch(_nodePath[3]){
                          //[2,0,1,0]理论讲解
                          case 0 :
                            this.current_note_markdown = `

请点击：

https://zhuanlan.zhihu.com/p/29741673

`;
                            this.is_title = 0;
                            if( this.view_type == 1 ){
                              this.view_type = 3;
                          this.isrecommend = true;}
                    break;

                        }
                      break;

                       //[2,0,2]获得
                       case 2 :
                        switch(_nodePath[3]){
                          //[2,0,2,0]理论讲解
                          case 0 :
                            this.current_note_markdown = `

请点击：

https://zhuanlan.zhihu.com/p/62330707

`;
                            this.is_title = 0;
                            if( this.view_type == 1 ){
                              this.view_type = 3;
                          this.isrecommend = true;}
                    break;

                        }
                      break;


                        //[2,0,3]打脸
                       case 3 :
                        switch(_nodePath[3]){
                          //[2,0,3,0]理论讲解
                          case 0 :
                            this.current_note_markdown = `

请点击：

https://zhuanlan.zhihu.com/p/29945546

`;
                            this.is_title = 0;
                            if( this.view_type == 1 ){
                              this.view_type = 3;
                          this.isrecommend = true;}
                    break;

                        }
                      break;

                       //[2,0,4]英雄救美
                       case 4 :
                        switch(_nodePath[3]){
                          //[2,0,4,0]理论讲解
                          case 0 :
                            this.current_note_markdown = `

请点击：

https://zhuanlan.zhihu.com/p/61653898

`;
                            this.is_title = 0;
                            if( this.view_type == 1 ){
                              this.view_type = 3;
                          this.isrecommend = true;}
                    break;

                        }
                      break;


                       //[2,0,5]两虎相争
                       case 5 :
                        switch(_nodePath[3]){
                          //[2,0,5,0]理论讲解
                          case 0 :
                            this.current_note_markdown = `

请点击：

https://zhuanlan.zhihu.com/p/86254601

`;
                            this.is_title = 0;
                            if( this.view_type == 1 ){
                              this.view_type = 3;
                          this.isrecommend = true;}
                    break;

                        }
                      break;


//[2,0,6]预言
case 6 :
  switch(_nodePath[3]){
    //[2,0,6,0]理论讲解
    case 0 :
      this.current_note_markdown = `

请点击：

https://zhuanlan.zhihu.com/p/69279248

`;
      this.is_title = 0;
      if( this.view_type == 1 ){
        this.view_type = 3;
    this.isrecommend = true;}
break;

  }
break;


//[2,0,7]密谋
case 7 :
  switch(_nodePath[3]){
    //[2,0,7,0]理论讲解
    case 0 :
      this.current_note_markdown = `

请点击：

https://zhuanlan.zhihu.com/p/71517542


`;
      this.is_title = 0;
      if( this.view_type == 1 ){
        this.view_type = 3;
    this.isrecommend = true;}
break;

  }
break;


//[2,0,8]赌注
case 8 :
  switch(_nodePath[3]){
    //[2,0,8,0]理论讲解
    case 0 :
      this.current_note_markdown = `

请点击：

https://zhuanlan.zhihu.com/p/64361467



`;
      this.is_title = 0;
      if( this.view_type == 1 ){
        this.view_type = 3;
    this.isrecommend = true;}
break;

  }
break;


//[2,0,9]冤枉
case 9 :
  switch(_nodePath[3]){
    //[2,0,9,0]理论讲解
    case 0 :
      this.current_note_markdown = `

请点击：

https://zhuanlan.zhihu.com/p/80556411


`;
      this.is_title = 0;
      if( this.view_type == 1 ){
        this.view_type = 3;
    this.isrecommend = true;}
break;

  }
break;

//[2,0,10]经典铺垫
case 10 :
  switch(_nodePath[3]){
    //[2,0,10,0]理论讲解
    case 0 :
      this.current_note_markdown = `

请点击：

https://zhuanlan.zhihu.com/p/79628796


`;
      this.is_title = 0;
      if( this.view_type == 1 ){
        this.view_type = 3;
    this.isrecommend = true;}
break;

  }
break;


//[2,0,11]站上舞台
case 11 :
  switch(_nodePath[3]){
    //[2,0,11,0]理论讲解
    case 0 :
      this.current_note_markdown = `

请点击：

https://zhuanlan.zhihu.com/p/77479133


`;
      this.is_title = 0;
      if( this.view_type == 1 ){
        this.view_type = 3;
    this.isrecommend = true;}
break;

  }
break;

//[2,0,12]预先提名
case 12 :
  switch(_nodePath[3]){
    //[2,0,12,0]理论讲解
    case 0 :
      this.current_note_markdown = `

请点击：

https://zhuanlan.zhihu.com/p/82455168


`;
      this.is_title = 0;
      if( this.view_type == 1 ){
        this.view_type = 3;
    this.isrecommend = true;}
break;

  }
break;


//[2,0,13]先败为敬
case 13 :
  switch(_nodePath[3]){
    //[2,0,13,0]理论讲解
    case 0 :
      this.current_note_markdown = `

请点击：

https://zhuanlan.zhihu.com/p/84537253


`;
      this.is_title = 0;
      if( this.view_type == 1 ){
        this.view_type = 3;
    this.isrecommend = true;}
break;

  }
break;


//[2,0,14]倒计时
case 14 :
  switch(_nodePath[3]){
    //[2,0,14,0]理论讲解
    case 0 :
      this.current_note_markdown = `

请点击：

https://zhuanlan.zhihu.com/p/73417257


`;
      this.is_title = 0;
      if( this.view_type == 1 ){
        this.view_type = 3;
    this.isrecommend = true;}
break;

  }
break;


//[2,0,15]反常
case 15 :
  switch(_nodePath[3]){
    //[2,0,15,0]理论讲解
    case 0 :
      this.current_note_markdown = `

请点击：

https://zhuanlan.zhihu.com/p/87446775


`;
      this.is_title = 0;
      if( this.view_type == 1 ){
        this.view_type = 3;
    this.isrecommend = true;}
break;

  }
break;

//[2,0,16]表态
case 16 :
  switch(_nodePath[3]){
    //[2,0,16,0]理论讲解
    case 0 :
      this.current_note_markdown = `

请点击：

https://zhuanlan.zhihu.com/p/89743530


`;
      this.is_title = 0;
      if( this.view_type == 1 ){
        this.view_type = 3;
    this.isrecommend = true;}
break;

  }
break;

//[2,0,17]征服
case 17 :
  switch(_nodePath[3]){
    //[2,0,17,0]理论讲解
    case 0 :
      this.current_note_markdown = `

请点击：

https://zhuanlan.zhihu.com/p/65549261


`;
      this.is_title = 0;
      if( this.view_type == 1 ){
        this.view_type = 3;
    this.isrecommend = true;}
break;

  }
break;

//[2,0,18]扮猪吃虎
case 18 :
  switch(_nodePath[3]){
    //[2,0,18,0]理论讲解
    case 0 :
      this.current_note_markdown = `

请点击：

https://zhuanlan.zhihu.com/p/75400051


`;
      this.is_title = 0;
      if( this.view_type == 1 ){
        this.view_type = 3;
    this.isrecommend = true;}
break;

  }
break;


//[2,0,19]神器认主
case 19 :
  switch(_nodePath[3]){
    //[2,0,19,0]理论讲解
    case 0 :
      this.current_note_markdown = `

请点击：

https://zhuanlan.zhihu.com/p/32532431


`;
      this.is_title = 0;
      if( this.view_type == 1 ){
        this.view_type = 3;
    this.isrecommend = true;}
break;

  }
break;

//[2,0,20]明星聚光
case 20 :
  switch(_nodePath[3]){
    //[2,0,20,0]理论讲解
    case 0 :
      this.current_note_markdown = `

请点击：

https://zhuanlan.zhihu.com/p/61223462


`;
      this.is_title = 0;
      if( this.view_type == 1 ){
        this.view_type = 3;
    this.isrecommend = true;}
break;

  }
break;
























              }
      break;
      //言情套路
      case 1 :
        switch(_nodePath[2]){
          //[2,1,0]言情概述
                case 0 :
                        this.current_note_markdown = `

请点击：

https://zhuanlan.zhihu.com/p/67178099

`;
                        this.is_title = 0;
                        if( this.view_type == 1 ){
                          this.view_type = 3;
                      this.isrecommend = true;}
                break;

                //[2,1,1]在意
                case 1:
                  switch(_nodePath[3]){
                    //[2,1,1,0]理论讲解
                    case 0 :
                      this.current_note_markdown = `
                
请点击：
                
https://zhuanlan.zhihu.com/p/114960684
                
                
                `;
                      this.is_title = 0;
                      if( this.view_type == 1 ){
                        this.view_type = 3;
                    this.isrecommend = true;}
                break;
                
                  }
                  
                break;

                //[2,1,2]欣赏
                case 2:
                  switch(_nodePath[3]){
                    //[2,1,2,0]理论讲解
                    case 0 :
                      this.current_note_markdown = `
                
请点击：
                
https://zhuanlan.zhihu.com/p/173962236
                
                
                `;
                      this.is_title = 0;
                      if( this.view_type == 1 ){
                        this.view_type = 3;
                    this.isrecommend = true;}
                break;
                
                  }
                  
                break;

                //[2,1,3]长情
                case 3:
                  switch(_nodePath[3]){
                    //[2,1,3,0]理论讲解
                    case 0 :
                      this.current_note_markdown = `
                
请点击：
                
https://zhuanlan.zhihu.com/p/102243143
                
                
                `;
                      this.is_title = 0;
                      if( this.view_type == 1 ){
                        this.view_type = 3;
                    this.isrecommend = true;}
                break;
                
                  }
                  
                break;


                //[2,1,4]竞争
                case 4:
                  switch(_nodePath[3]){
                    //[2,1,4,0]理论讲解
                    case 0 :
                      this.current_note_markdown = `
                
请点击：
                
https://zhuanlan.zhihu.com/p/103962478
                
                
                `;
                      this.is_title = 0;
                      if( this.view_type == 1 ){
                        this.view_type = 3;
                    this.isrecommend = true;}
                break;
                
                  }
                  
                break;


                //[2,1,5]吹嘘
                case 5:
                  switch(_nodePath[3]){
                    //[2,1,5,0]理论讲解
                    case 0 :
                      this.current_note_markdown = `
                
请点击：
                
https://zhuanlan.zhihu.com/p/124799906
                
                
                `;
                      this.is_title = 0;
                      if( this.view_type == 1 ){
                        this.view_type = 3;
                    this.isrecommend = true;}
                break;
                
                  }
                  
                break;

                //[2,1,6]占有欲
                case 6:
                  switch(_nodePath[3]){
                    //[2,1,6,0]理论讲解
                    case 0 :
                      this.current_note_markdown = `
                
请点击：
                
https://zhuanlan.zhihu.com/p/105702869
                
                
                `;
                      this.is_title = 0;
                      if( this.view_type == 1 ){
                        this.view_type = 3;
                    this.isrecommend = true;}
                break;
                
                  }
                  
                break;

                //[2,1,7]言情英雄救美
                case 7:
                  switch(_nodePath[3]){
                    //[2,1,7,0]理论讲解
                    case 0 :
                      this.current_note_markdown = `
                
请点击：
                
https://zhuanlan.zhihu.com/p/92074191
                
                
                `;
                      this.is_title = 0;
                      if( this.view_type == 1 ){
                        this.view_type = 3;
                    this.isrecommend = true;}
                break;
                
                  }
                  
                break;


                //[2,1,8]共度危机
                case 8:
                  switch(_nodePath[3]){
                    //[2,1,8,0]理论讲解
                    case 0 :
                      this.current_note_markdown = `
                
请点击：
                
https://zhuanlan.zhihu.com/p/163694037
                
                
                `;
                      this.is_title = 0;
                      if( this.view_type == 1 ){
                        this.view_type = 3;
                    this.isrecommend = true;}
                break;
                
                  }
                  
                break;


                //[2,1,9]禁忌
                case 9:
                  switch(_nodePath[3]){
                    //[2,1,9,0]理论讲解
                    case 0 :
                      this.current_note_markdown = `
                
请点击：
                
https://zhuanlan.zhihu.com/p/108408941
                
                
                `;
                      this.is_title = 0;
                      if( this.view_type == 1 ){
                        this.view_type = 3;
                    this.isrecommend = true;}
                break;
                
                  }
                  
                break;


                //[2,1,10]契约
                case 10:
                  switch(_nodePath[3]){
                    //[2,1,9,0]理论讲解
                    case 0 :
                      this.current_note_markdown = `
                
请点击：
                
https://zhuanlan.zhihu.com/p/111500131
                
                
                `;
                      this.is_title = 0;
                      if( this.view_type == 1 ){
                        this.view_type = 3;
                    this.isrecommend = true;}
                break;
                
                  }
                  
                break;

                //[2,1,11]误会
                case 11:
                  switch(_nodePath[3]){
                    //[2,1,11,0]理论讲解
                    case 0 :
                      this.current_note_markdown = `
                
请点击：
                
https://zhuanlan.zhihu.com/p/148093557
                
                
                `;
                      this.is_title = 0;
                      if( this.view_type == 1 ){
                        this.view_type = 3;
                    this.isrecommend = true;}
                break;
                
                  }
                  
                break;


                //[2,1,12]秘密
                case 12:
                  switch(_nodePath[3]){
                    //[2,1,12,0]理论讲解
                    case 0 :
                      this.current_note_markdown = `
                
请点击：
                
https://zhuanlan.zhihu.com/p/158778551
                
                
                `;
                      this.is_title = 0;
                      if( this.view_type == 1 ){
                        this.view_type = 3;
                    this.isrecommend = true;}
                break;
                
                  }
                  
                break;

                //[2,1,13]黯然神伤
                case 13:
                  switch(_nodePath[3]){
                    //[2,1,13,0]理论讲解
                    case 0 :
                      this.current_note_markdown = `
                
请点击：
                
https://zhuanlan.zhihu.com/p/99883029
                
                
                `;
                      this.is_title = 0;
                      if( this.view_type == 1 ){
                        this.view_type = 3;
                    this.isrecommend = true;}
                break;
                
                  }
                  
                break;


                //[2,1,14]牺牲
                case 14:
                  switch(_nodePath[3]){
                    //[2,1,14,0]理论讲解
                    case 0 :
                      this.current_note_markdown = `
                
请点击：
                
https://zhuanlan.zhihu.com/p/97487143
                
                
                `;
                      this.is_title = 0;
                      if( this.view_type == 1 ){
                        this.view_type = 3;
                    this.isrecommend = true;}
                break;
                
                  }
                  
                break;


                //[2,1,15]神秘
                case 15:
                  switch(_nodePath[3]){
                    //[2,1,15,0]理论讲解
                    case 0 :
                      this.current_note_markdown = `
                
请点击：
                
https://zhuanlan.zhihu.com/p/144758819
                
                
                `;
                      this.is_title = 0;
                      if( this.view_type == 1 ){
                        this.view_type = 3;
                    this.isrecommend = true;}
                break;
                
                  }
                  
                break;


                //[2,1,16]身体接触
                case 16:
                  switch(_nodePath[3]){
                    //[2,1,16,0]理论讲解
                    case 0 :
                      this.current_note_markdown = `
                
请点击：
                
https://zhuanlan.zhihu.com/p/141442005
                
                
                `;
                      this.is_title = 0;
                      if( this.view_type == 1 ){
                        this.view_type = 3;
                    this.isrecommend = true;}
                break;
                
                  }
                  
                break;

                //[2,1,17]告白
                case 17:
                  switch(_nodePath[3]){
                    //[2,1,17,0]理论讲解
                    case 0 :
                      this.current_note_markdown = `
                
请点击：
                
https://zhuanlan.zhihu.com/p/133148833
                
                
                `;
                      this.is_title = 0;
                      if( this.view_type == 1 ){
                        this.view_type = 3;
                    this.isrecommend = true;}
                break;
                
                  }
                  
                break;

                //[2,1,18]失而复得
                case 18:
                  switch(_nodePath[3]){
                    //[2,1,18,0]理论讲解
                    case 0 :
                      this.current_note_markdown = `
                
请点击：
                
https://zhuanlan.zhihu.com/p/137770775
                
                
                `;
                      this.is_title = 0;
                      if( this.view_type == 1 ){
                        this.view_type = 3;
                    this.isrecommend = true;}
                break;
                
                  }
                  
                break;

                //[2,1,19]意料之外
                case 19:
                  switch(_nodePath[3]){
                    //[2,1,19,0]理论讲解
                    case 0 :
                      this.current_note_markdown = `
                
请点击：
                
https://zhuanlan.zhihu.com/p/150973500
                
                
                `;
                      this.is_title = 0;
                      if( this.view_type == 1 ){
                        this.view_type = 3;
                    this.isrecommend = true;}
                break;
                
                  }
                  
                break;

                //[2,1,20]对你与众不同
                case 20:
                  switch(_nodePath[3]){
                    //[2,1,20,0]理论讲解
                    case 0 :
                      this.current_note_markdown = `
                
请点击：
                
https://zhuanlan.zhihu.com/p/94432132
                
                
                `;
                      this.is_title = 0;
                      if( this.view_type == 1 ){
                        this.view_type = 3;
                    this.isrecommend = true;}
                break;
                
                  }
                  
                break;






















                }

      break;
      // 恐惧情绪
      case 2 :
                
        switch(_nodePath[2]){
          //[2,2,0]理论讲解
          case 0 :
            this.current_note_markdown = `
      
请点击：
      
https://zhuanlan.zhihu.com/p/139319220
      
      `;
            this.is_title = 0;
            if( this.view_type == 1 ){
              this.view_type = 3;
          this.isrecommend = true;}
      break;
      
        }
      break;

      // 愤怒情绪
      case 3 :
                
        switch(_nodePath[2]){
          //[2,3,0]理论讲解
          case 0 :
            this.current_note_markdown = `
      
请点击：
      
https://zhuanlan.zhihu.com/p/146359180
      
      
      `;
            this.is_title = 0;
            if( this.view_type == 1 ){
              this.view_type = 3;
          this.isrecommend = true;}
      break;
      
        }
      break;

        // 泪点
        case 4 :
                
          switch(_nodePath[2]){
            //[2,4,0]理论讲解
            case 0 :
              this.current_note_markdown = `
        
  请点击：
        
  https://zhuanlan.zhihu.com/p/156090735
        
        
        `;
              this.is_title = 0;
              if( this.view_type == 1 ){
                this.view_type = 3;
            this.isrecommend = true;}
        break;
        
          }
        break;

        // 笑点
        case 5 :
                
          switch(_nodePath[2]){
            //[2,5,0]理论讲解
            case 0 :
              this.current_note_markdown = `
        
  请点击：
        
  https://zhuanlan.zhihu.com/p/165911720
        
        
        `;
              this.is_title = 0;
              if( this.view_type == 1 ){
                this.view_type = 3;
            this.isrecommend = true;}
        break;
        
          }
        break;







      //套路概述
      case 6 :
        this.current_note_markdown = `
                
请点击：
                
https://zhuanlan.zhihu.com/p/29674354
                
                
                `;
                      this.is_title = 0;
                      if( this.view_type == 1 ){
                        this.view_type = 3;
                    this.isrecommend = true;}
      break;



          }

        break;


        //结构篇
        case 3 :

          switch(_nodePath[1]){
            //[3,0]事件
            case 0 :

                    //[3,0,0]理论讲解
                    switch(_nodePath[2]){
                            case 0 :
                                    this.current_note_markdown = `

请点击：

https://mp.weixin.qq.com/s?__biz=MzI3NjY2OTQwMg==&mid=2247485406&idx=1&sn=91255a8aa5ed8abb2e41ff4d8596d617&chksm=eb70b16bdc07387dafa3d8d7616ea019a883bb62c4d8ed6d0601f62ab845669b2ba1848a80d6&token=289432915&lang=zh_CN#rd


`;
                                    this.is_title = 0;
                                    if( this.view_type == 1 ){
                                      this.view_type = 3;
                                  this.isrecommend = true;}
                            break;
                    }
            break;

             //[3,1]故事线
             case 1 :

              //[3,1,0]理论讲解
              switch(_nodePath[2]){
                      case 0 :
                              this.current_note_markdown = `

请点击：

https://zhuanlan.zhihu.com/p/31233620

英雄之旅：https://zhuanlan.zhihu.com/p/31821166

双线穿梭：https://zhuanlan.zhihu.com/p/33562768

三线合一：https://zhuanlan.zhihu.com/p/35753813

串珠子：https://zhuanlan.zhihu.com/p/37320342





`;
                              this.is_title = 0;
                              if( this.view_type == 1 ){
                                this.view_type = 3;
                            this.isrecommend = true;}
                      break;
              }
      break;


      //[3,2]人物功能
      case 2 :

        //[3,2,0]理论讲解
        switch(_nodePath[2]){
                case 0 :
                        this.current_note_markdown = `

请点击：

https://zhuanlan.zhihu.com/p/38411880


https://zhuanlan.zhihu.com/p/38702659







`;
                        this.is_title = 0;
                        if( this.view_type == 1 ){
                          this.view_type = 3;
                      this.isrecommend = true;}
                break;
        }
break;

      //[3,3]代入感
      case 3 :

        //[3,3,0]理论讲解
        switch(_nodePath[2]){
                case 0 :
                        this.current_note_markdown = `

请点击：

https://zhuanlan.zhihu.com/p/63174232








`;
                        this.is_title = 0;
                        if( this.view_type == 1 ){
                          this.view_type = 3;
                      this.isrecommend = true;}
                break;
        }
break;


      //[3,4]人称与视角
      case 4 :

        //[3,4,0]理论讲解
        switch(_nodePath[2]){
                case 0 :
                        this.current_note_markdown = `

请点击：

https://zhuanlan.zhihu.com/p/61900296








`;
                        this.is_title = 0;
                        if( this.view_type == 1 ){
                          this.view_type = 3;
                      this.isrecommend = true;}
                break;
        }
break;



          //[3,5]对话
      case 5 :

        //[3,5,0]理论讲解
        switch(_nodePath[2]){
                case 0 :
                        this.current_note_markdown = `

请点击：

https://zhuanlan.zhihu.com/p/74430059








`;
                        this.is_title = 0;
                        if( this.view_type == 1 ){
                          this.view_type = 3;
                      this.isrecommend = true;}
                break;
        }
break;


 //[3,6]冲突
 case 6 :

  //[3,6,0]理论讲解
  switch(_nodePath[2]){
          case 0 :
                  this.current_note_markdown = `

请点击：

https://zhuanlan.zhihu.com/p/29563332








`;
                  this.is_title = 0;
                  if( this.view_type == 1 ){
                    this.view_type = 3;
                this.isrecommend = true;}
          break;
  }
break;

 //[3,7]开头
 case 7 :

  //[3,7,0]理论讲解
  switch(_nodePath[2]){
          case 0 :
                  this.current_note_markdown = `

请点击：

https://zhuanlan.zhihu.com/p/42924431








`;
                  this.is_title = 0;
                  if( this.view_type == 1 ){
                    this.view_type = 3;
                this.isrecommend = true;}
          break;
  }
break;



//[3,8]铺垫
case 8 :

  //[3,8,0]理论讲解
  switch(_nodePath[2]){
          case 0 :
                  this.current_note_markdown = `

请点击：

https://zhuanlan.zhihu.com/p/85242950









`;
                  this.is_title = 0;
                  if( this.view_type == 1 ){
                    this.view_type = 3;
                this.isrecommend = true;}
          break;
  }
break;



//[3,9]反常
case 9 :

  //[3,9,0]理论讲解
  switch(_nodePath[2]){
          case 0 :
                  this.current_note_markdown = `

请点击：

https://zhuanlan.zhihu.com/p/51886124










`;
                  this.is_title = 0;
                  if( this.view_type == 1 ){
                    this.view_type = 3;
                this.isrecommend = true;}
          break;
  }
break;



//[3,10]悬疑
case 10 :

  //[3,10,0]理论讲解
  switch(_nodePath[2]){
          case 0 :
                  this.current_note_markdown = `

请点击：

https://zhuanlan.zhihu.com/p/53008562










`;
                  this.is_title = 0;
                  if( this.view_type == 1 ){
                    this.view_type = 3;
                this.isrecommend = true;}
          break;
  }
break;



//[3,11]节奏
case 11 :

  //[3,11,0]理论讲解
  switch(_nodePath[2]){
          case 0 :
                  this.current_note_markdown = `

请点击：

https://zhuanlan.zhihu.com/p/88578961











`;
                  this.is_title = 0;
                  if( this.view_type == 1 ){
                    this.view_type = 3;
                this.isrecommend = true;}
          break;
  }
break;



//[3,12]鸿沟
case 12 :

  //[3,12,0]理论讲解
  switch(_nodePath[2]){
          case 0 :
                  this.current_note_markdown = `

请点击：

https://zhuanlan.zhihu.com/p/29640218











`;
                  this.is_title = 0;
                  if( this.view_type == 1 ){
                    this.view_type = 3;
                this.isrecommend = true;}
          break;
  }
break;


//[3,13]信息扣押
case 13 :

  //[3,13,0]理论讲解
  switch(_nodePath[2]){
          case 0 :
                  this.current_note_markdown = `

请点击：

https://zhuanlan.zhihu.com/p/72448085











`;
                  this.is_title = 0;
                  if( this.view_type == 1 ){
                    this.view_type = 3;
                this.isrecommend = true;}
          break;
  }
break;





























            }

        break;



            }
          
     }

    
    @observable current_note_list = [
      
    ];

    @observable current_note_parctise = '这就是练习区域~~~';

     @observable current_note_markdown =  `简要介绍：
                
这是小说研究所的练习APP,提供小故事、文笔、套路、结构方面的种种具体练习。
     
也在练习前给出练习所需的理论讲解，帮助大家更能理解练习内容。
                     
希望通过这些练习方式，帮助大家提高写作技巧。
     
…………
     
     
     
练习APP分为以下几大部分：
     
     
     
     
1，小故事篇。
     
面向从零开始的初学者。你可以从人物，情节，环境三个方向，从无到有写出自己的故事。
     
也可以使用三题作文，随机轻小说练习和戏剧化开头，获得灵感。试着进行故事练习。
     
2，文笔篇
     
面向写作有难度，尤其是描写比较苦手的写作者。
     
包括场景、外貌、服饰、战斗、心理等专题练习。
     
以及展示、对话、画面感、叙事、节奏、象征等更为通用的文笔技巧练习。
     
3，套路篇
     
面向情节构思有难度，写的内容不够有趣，或者写的情节达不到想要效果。
     
设计让人哭，读者却哭不出来。想要让人笑，读者却笑不出来。
     
想要学习这部分技巧的写作者。
     
套路篇拥有爽文套路和言情套路作为具体的套路练习。
     
以及愤怒，恐惧，泪点，笑点等更为抽象的情绪调动理论及练习。
     
4，结构篇
     
面向对人物设定，故事整体有更高要求的写作者。
     
从故事宏观的故事线，代入感等技巧，到悬疑，反常，开头等具体的技巧练习。
     
帮助大家查缺补漏，增加故事整体的设计能力。
     
…………
     
使用指南：

1，小故事、文笔篇、套路篇等文件夹下，是理论或套路练习。
     
2.理论讲解文件前，有绿色的文件图标。练习文件前，有蓝色的编辑图标。
     
3，点开练习文件，是练习列表。每种练习都有1~10个练习题目可以进行练习。
     
4，在练习列表中选择练习题目，点击灰色的编辑按钮后，开始练习。
     
5，练习完毕后，间隔24小时，再回来点击打分按钮进行打分。
     
6，打分完毕后，分数会显示在练习列表和目录的右边。以星星和不同颜色的√来表示。满分为五颗星或两个绿色的√
     
祝大家使用愉快~
     
…………
     
     
参考资料：
     
                     
你可以选择喜欢的,想要成长的方向进行练习（并不需要按顺序，也不需要全部都练习）
     
为了更好的练习效果，练习之前，请确定你使用过小说研究所的向导APP，或看过橙色海写作教程，或有过一定的写作经验。
     
如果你需要下载向导APP，或者学习橙色海写作教程，请下面的链接
     
向导app：https://www.bilibili.com/video/BV1P64y1f7me
     
橙色海写作教程：https://zhuanlan.zhihu.com/p/70963887
     
想要联系教程作者，请关注公众号过雨红素。 `;
     




}

export default new AppState();